var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const BASE64URL_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
const BASE64URL_LOOKUP = (() => {
  const lookup = {};
  for (let i = 0; i < BASE64URL_ALPHABET.length; i += 1) {
    lookup[BASE64URL_ALPHABET[i]] = i;
  }
  return lookup;
})();
const BYTES_PER_BASE64_GROUP = 3;
const CHARS_PER_BASE64_GROUP = 4;
const BASE64_MASK = 63;
const BYTE_MASK = 255;
function encodeBase64Url(bytes) {
  let result = "";
  let i = 0;
  while (i + BYTES_PER_BASE64_GROUP <= bytes.length) {
    const b0 = bytes[i];
    const b1 = bytes[i + 1];
    const b2 = bytes[i + 2];
    result += BASE64URL_ALPHABET[b0 >> 2] + BASE64URL_ALPHABET[(b0 & 3) << 4 | b1 >> 4] + BASE64URL_ALPHABET[(b1 & 15) << 2 | b2 >> 6] + BASE64URL_ALPHABET[b2 & BASE64_MASK];
    i += BYTES_PER_BASE64_GROUP;
  }
  const remaining = bytes.length - i;
  if (remaining === 1) {
    const b0 = bytes[i];
    result += BASE64URL_ALPHABET[b0 >> 2] + BASE64URL_ALPHABET[(b0 & 3) << 4];
  } else if (remaining === 2) {
    const b0 = bytes[i];
    const b1 = bytes[i + 1];
    result += BASE64URL_ALPHABET[b0 >> 2] + BASE64URL_ALPHABET[(b0 & 3) << 4 | b1 >> 4] + BASE64URL_ALPHABET[(b1 & 15) << 2];
  }
  return result;
}
function decodeBase64Url(input) {
  const normalized = input.replace(/=+$/u, "").replace(/\+/gu, "-").replace(/\//gu, "_");
  const length = normalized.length;
  const fullGroups = Math.floor(length / CHARS_PER_BASE64_GROUP);
  const remaining = length - fullGroups * CHARS_PER_BASE64_GROUP;
  let byteLength = fullGroups * BYTES_PER_BASE64_GROUP;
  if (remaining === 2) {
    byteLength += 1;
  } else if (remaining === 3) {
    byteLength += 2;
  } else if (remaining === 1) {
    throw new Error("decodeBase64Url: invalid length");
  }
  const bytes = new Uint8Array(byteLength);
  let outIndex = 0;
  const charAt = (pos) => {
    const v = BASE64URL_LOOKUP[normalized[pos]];
    if (v === void 0) {
      throw new Error(`decodeBase64Url: invalid character at ${pos}`);
    }
    return v;
  };
  for (let group = 0; group < fullGroups; group += 1) {
    const pos = group * CHARS_PER_BASE64_GROUP;
    const c0 = charAt(pos);
    const c1 = charAt(pos + 1);
    const c2 = charAt(pos + 2);
    const c3 = charAt(pos + 3);
    bytes[outIndex] = (c0 << 2 | c1 >> 4) & BYTE_MASK;
    bytes[outIndex + 1] = ((c1 & 15) << 4 | c2 >> 2) & BYTE_MASK;
    bytes[outIndex + 2] = ((c2 & 3) << 6 | c3) & BYTE_MASK;
    outIndex += BYTES_PER_BASE64_GROUP;
  }
  if (remaining === 2) {
    const pos = fullGroups * CHARS_PER_BASE64_GROUP;
    const c0 = charAt(pos);
    const c1 = charAt(pos + 1);
    bytes[outIndex] = (c0 << 2 | c1 >> 4) & BYTE_MASK;
  } else if (remaining === 3) {
    const pos = fullGroups * CHARS_PER_BASE64_GROUP;
    const c0 = charAt(pos);
    const c1 = charAt(pos + 1);
    const c2 = charAt(pos + 2);
    bytes[outIndex] = (c0 << 2 | c1 >> 4) & BYTE_MASK;
    bytes[outIndex + 1] = ((c1 & 15) << 4 | c2 >> 2) & BYTE_MASK;
  }
  return bytes;
}
function isPlainObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
var ApplicationDefinitionEncodingVersion = /* @__PURE__ */ ((ApplicationDefinitionEncodingVersion2) => {
  ApplicationDefinitionEncodingVersion2["V1"] = "v1";
  return ApplicationDefinitionEncodingVersion2;
})(ApplicationDefinitionEncodingVersion || {});
const APPLICATION_DEFINITION_SEGMENT_COUNT = 3;
const UNDEFINED_SENTINEL_PROPERTY_COUNT = 1;
function createUndefinedSentinel() {
  return {
    [
      "_"
      /* Value */
    ]: "u"
    /* Undefined */
  };
}
function isUndefinedSentinel(value) {
  return isPlainObject(value) && Object.keys(value).length === UNDEFINED_SENTINEL_PROPERTY_COUNT && value[
    "_"
    /* Value */
  ] === "u";
}
function toPackedStructuralKey(key) {
  switch (key) {
    case "capabilities":
      return "c";
    case "ui":
      return "ui";
    case "components":
      return "co";
    case "componentId":
      return "ci";
    case "props":
      return "p";
    case "rule":
      return "r";
    case "status":
      return "t";
    case "flagKeys":
      return "f";
    case "gatedBy":
      return "g";
    case "permissions":
      return "pm";
    case "unavailableBehavior":
      return "u";
    case "subCapabilities":
      return "s";
    case "paywallRoles":
      return "pr";
    default:
      return key;
  }
}
function toStructuralKey(key) {
  switch (key) {
    case "c":
      return "capabilities";
    case "ui":
      return "ui";
    case "co":
      return "components";
    case "ci":
      return "componentId";
    case "p":
      return "props";
    case "r":
      return "rule";
    case "t":
      return "status";
    case "f":
      return "flagKeys";
    case "g":
      return "gatedBy";
    case "pm":
      return "permissions";
    case "u":
      return "unavailableBehavior";
    case "s":
      return "subCapabilities";
    case "pr":
      return "paywallRoles";
    default:
      return key;
  }
}
function packNode(value) {
  if (value === void 0) {
    return createUndefinedSentinel();
  }
  if (value === null || typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((entry) => packNode(entry));
  }
  if (!isPlainObject(value)) {
    throw new Error("Unsupported application definition value encountered during encoding");
  }
  const packedObject = {};
  for (const [key, entryValue] of Object.entries(value)) {
    packedObject[toPackedStructuralKey(key)] = packNode(entryValue);
  }
  return packedObject;
}
function unpackNode(value) {
  if (isUndefinedSentinel(value)) {
    return void 0;
  }
  if (value === null || typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((entry) => unpackNode(entry));
  }
  if (!isPlainObject(value)) {
    throw new Error("Unsupported packed application definition value encountered during decoding");
  }
  const unpackedObject = {};
  for (const [key, entryValue] of Object.entries(value)) {
    unpackedObject[toStructuralKey(key)] = unpackNode(entryValue);
  }
  return unpackedObject;
}
const TEXT_ENCODER$1 = new TextEncoder();
const TEXT_DECODER = new TextDecoder();
function parseEncodedApplicationDefinition(encodedApplicationDefinition) {
  const segments = encodedApplicationDefinition.split(
    ":"
    /* Segment */
  );
  if (segments.length !== APPLICATION_DEFINITION_SEGMENT_COUNT || segments[0] !== "ad") {
    throw new Error("Invalid application definition encoding prefix");
  }
  if (segments[1] !== "v1") {
    throw new Error("Unsupported application definition encoding version");
  }
  const payload = segments[2];
  if (!payload) {
    throw new Error("Missing application definition encoded payload");
  }
  return payload;
}
function isEncodedApplicationDefinition(value) {
  return value.startsWith(
    `${"ad"}${":"}${"v1"}${":"}`
  );
}
function encodeApplicationDefinition(applicationDefinition) {
  const packedDefinition = packNode(applicationDefinition);
  const packedJson = JSON.stringify(packedDefinition);
  const encodedPayload = encodeBase64Url(TEXT_ENCODER$1.encode(packedJson));
  return `${"ad"}${":"}${"v1"}${":"}${encodedPayload}`;
}
function decodeApplicationDefinition(encodedApplicationDefinition) {
  const payload = parseEncodedApplicationDefinition(encodedApplicationDefinition);
  let decodedBytes;
  try {
    decodedBytes = decodeBase64Url(payload);
  } catch {
    throw new Error("Invalid base64 application definition payload");
  }
  const packedJson = TEXT_DECODER.decode(decodedBytes);
  const parsedPayload = JSON.parse(packedJson);
  const unpackedDefinition = unpackNode(parsedPayload);
  if (!isPlainObject(unpackedDefinition)) {
    throw new Error("Decoded application definition must be an object");
  }
  return unpackedDefinition;
}
function tryDecodeApplicationDefinition(encodedApplicationDefinition) {
  try {
    return decodeApplicationDefinition(encodedApplicationDefinition);
  } catch {
    return void 0;
  }
}
const discover = { "rule": { "status": "enabled" }, "subCapabilities": { "discover.filterDefinitionSize": { "rule": { "status": "enabled" } }, "discover.filterFeatures": { "rule": { "status": "enabled", "flagKeys": { "web": "filter_features_web", "native": "filter_features_native" } } }, "discover.filtersV2": { "rule": { "status": "enabled", "flagKeys": { "web": "filters_v2_web" } } }, "discover.filterLanguage": { "rule": { "status": "enabled" } }, "discover.filterGroups": { "rule": { "status": "enabled" } }, "discover.blockCreators": { "rule": { "status": "enabled" } } } };
const lorebook = { "rule": { "status": "enabled" }, "subCapabilities": { "lorebook.manage": { "rule": { "status": "enabled" } }, "lorebook.characterAttach": { "rule": { "status": "enabled" } }, "lorebook.import": { "rule": { "status": "enabled", "flagKeys": { "web": "lorebook_import" } } }, "lorebook.publicSharing": { "rule": { "status": "enabled", "flagKeys": { "web": "lorebook_public_web" } } }, "lorebook.publicDiscovery": { "rule": { "status": "enabled", "flagKeys": { "web": "lorebook_discover_public_web" } } }, "lorebook.detail": { "rule": { "status": "enabled", "flagKeys": { "web": "NX-5637-lorebook-web" } } }, "lorebook.shareLink": { "rule": { "status": "enabled" } } } };
const rulebook = { "rule": { "status": "enabled", "flagKeys": { "web": "rulebook", "backend": "rulebook" } }, "subCapabilities": { "rulebook.chatHud": { "rule": { "status": "enabled" } }, "rulebook.manage": { "rule": { "status": "enabled" } }, "rulebook.characterAttach": { "rule": { "status": "enabled" } }, "rulebook.personaAttach": { "rule": { "status": "enabled" } }, "rulebook.conversationAttach": { "rule": { "status": "enabled" } }, "rulebook.publicSharing": { "rule": { "status": "enabled" } }, "rulebook.publicDiscovery": { "rule": { "status": "enabled" } } } };
const tts = { "rule": { "status": "enabled" }, "subCapabilities": { "tts.manageCustomVoice": { "rule": { "status": "enabled" } }, "tts.characterAttach": { "rule": { "status": "enabled" } } } };
const nsfw = { "rule": { "status": "enabled" }, "subCapabilities": { "nsfw.image": { "rule": { "status": "enabled" } }, "nsfw.chat": { "rule": { "status": "enabled" } }, "nsfw.characterManage": { "rule": { "status": "enabled" } }, "nsfw.userToggle": { "rule": { "status": "enabled" } }, "nsfw.characterDiscovery": { "rule": { "status": "enabled" } } } };
const groupChat = { "rule": { "status": "enabled" }, "subCapabilities": { "groupChat.manage": { "rule": { "status": "enabled" } }, "groupChat.content": { "rule": { "status": "enabled" } }, "groupChat.autoResponse": { "rule": { "status": "enabled" } } } };
const chat = { "rule": { "status": "enabled" }, "subCapabilities": { "chat.generationSettings": { "rule": { "status": "enabled" } }, "chat.generationSettingsAdvanced": { "rule": { "status": "enabled" } }, "chat.generationChangeModel": { "rule": { "status": "enabled" } }, "chat.modelTier": { "rule": { "status": "enabled" } }, "chat.contextCap": { "rule": { "status": "enabled" } }, "chat.storyMode": { "rule": { "status": "enabled" } }, "chat.memoryManager": { "rule": { "status": "enabled" } }, "chat.memoryAutoCreate": { "rule": { "status": "enabled" } }, "chat.uploadImage": { "rule": { "status": "enabled" } }, "chat.openaiModel": { "rule": { "status": "enabled" } }, "chat.multilanguage": { "rule": { "status": "enabled" } } } };
const chatImage = { "rule": { "status": "enabled" }, "subCapabilities": { "chatImage.imageTraining": { "rule": { "status": "enabled" } }, "chatImage.imageGeneration": { "rule": { "status": "enabled" } }, "chatImage.imageGenerationSettings": { "rule": { "status": "enabled" } }, "chatImage.openMediaDetails": { "rule": { "status": "disabled" } } } };
const character = { "rule": { "status": "enabled" }, "unavailableBehavior": "show_paywall", "subCapabilities": { "character.manage": { "rule": { "status": "enabled" } }, "character.createPublic": { "rule": { "status": "enabled" } }, "character.uploadAvatar": { "rule": { "status": "enabled" } }, "character.importCard": { "rule": { "status": "enabled" } }, "character.shareLink": { "rule": { "status": "enabled" } }, "character.translate": { "rule": { "status": "enabled" } } } };
const persona = { "rule": { "status": "enabled" }, "subCapabilities": { "persona.manage": { "rule": { "status": "enabled" } }, "persona.uploadAvatar": { "rule": { "status": "enabled" } } } };
const site = { "rule": { "status": "enabled" }, "subCapabilities": { "site.multilanguage": { "rule": { "status": "enabled" } } } };
const billing = { "rule": { "status": "enabled" }, "subCapabilities": { "billing.quarterlyPlan": { "rule": { "status": "enabled" } } } };
const onboarding = { "rule": { "status": "enabled" }, "subCapabilities": { "onboarding.ftueModal": { "rule": { "status": "enabled" } } } };
const waitingRoom = { "rule": { "status": "enabled" } };
const creatorAnalytics = { "rule": { "status": "enabled" } };
const gallery = { "rule": { "status": "disabled" }, "subCapabilities": { "gallery.myGallery": { "rule": { "status": "disabled" } }, "gallery.publicGallery": { "rule": { "status": "disabled" } }, "gallery.mediaNavigation": { "rule": { "status": "disabled" } }, "gallery.openMediaDetails": { "rule": { "status": "disabled" } } } };
const media = { "rule": { "status": "disabled" }, "subCapabilities": { "media.mediaPage": { "rule": { "status": "disabled" } }, "media.download": { "rule": { "status": "disabled" } }, "media.relatedEntity": { "rule": { "status": "disabled" } }, "media.viewGenerationDetails": { "rule": { "status": "disabled" } }, "media.keep": { "rule": { "status": "disabled" } }, "media.makePublic": { "rule": { "status": "disabled" } } } };
const discoveryPage = { "rule": { "status": "enabled", "flagKeys": { "web": "release_discovery_page_web", "native": "release_discovery_page_native", "backend": "release_discovery_page_backend" } } };
const profile = { "rule": { "status": "enabled" }, "subCapabilities": { "profile.uploadAvatar": { "rule": { "status": "enabled" } } } };
const defaultCapabilitiesConfig = {
  discover,
  lorebook,
  rulebook,
  tts,
  nsfw,
  groupChat,
  chat,
  chatImage,
  character,
  persona,
  site,
  billing,
  onboarding,
  waitingRoom,
  creatorAnalytics,
  gallery,
  media,
  discoveryPage,
  profile
};
function initializeCapabilityMaps(capabilities) {
  const subCapabilityParentMap = {};
  const subCapabilityDefaults = {};
  const subCapabilityKeysByParent = {};
  for (const [capabilityKey, config] of Object.entries(capabilities)) {
    const typedCapabilityKey = capabilityKey;
    if (config.subCapabilities) {
      subCapabilityKeysByParent[typedCapabilityKey] = [];
      for (const [subKey, subConfig] of Object.entries(config.subCapabilities)) {
        subCapabilityParentMap[subKey] = typedCapabilityKey;
        subCapabilityDefaults[subKey] = subConfig;
        subCapabilityKeysByParent[typedCapabilityKey].push(subKey);
      }
    }
  }
  return {
    SUB_CAPABILITY_PARENT_MAP: subCapabilityParentMap,
    SUB_CAPABILITY_DEFAULTS: subCapabilityDefaults,
    SUB_CAPABILITY_KEYS_BY_PARENT: subCapabilityKeysByParent
  };
}
const DEFAULT_CAPABILITIES = defaultCapabilitiesConfig;
const { SUB_CAPABILITY_PARENT_MAP, SUB_CAPABILITY_DEFAULTS, SUB_CAPABILITY_KEYS_BY_PARENT } = initializeCapabilityMaps(DEFAULT_CAPABILITIES);
const DEFAULT_APPLICATION_CONFIG = {
  capabilities: DEFAULT_CAPABILITIES
};
function isDeepEqual(left, right) {
  if (Array.isArray(left) || Array.isArray(right)) {
    if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) {
      return false;
    }
    return left.every((entry, index) => isDeepEqual(entry, right[index]));
  }
  if (isPlainObject(left) && isPlainObject(right)) {
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) {
      return false;
    }
    return leftKeys.every((key) => Object.hasOwn(right, key) && isDeepEqual(left[key], right[key]));
  }
  return Object.is(left, right);
}
function compactDeep(value, defaultValue) {
  if (isDeepEqual(value, defaultValue)) {
    return void 0;
  }
  if (Array.isArray(value) || Array.isArray(defaultValue)) {
    return value;
  }
  if (!isPlainObject(value) || !isPlainObject(defaultValue)) {
    return value;
  }
  const valueEntries = value;
  const defaultEntries = defaultValue;
  const compactedResult = {};
  for (const key of Object.keys(valueEntries)) {
    if (isDeepEqual(valueEntries[key], defaultEntries[key])) {
      continue;
    }
    compactedResult[key] = compactDeep(valueEntries[key], defaultEntries[key]);
  }
  return Object.keys(compactedResult).length > 0 ? compactedResult : void 0;
}
const compactApplicationDefinitionFull = (applicationDefinition) => {
  return compactDeep(applicationDefinition, DEFAULT_APPLICATION_CONFIG) ?? {};
};
const compactApplicationDefinition = (applicationDefinition) => {
  if (!applicationDefinition) {
    return {};
  }
  const compactedDefinition = compactDeep(applicationDefinition, DEFAULT_APPLICATION_CONFIG);
  return isPlainObject(compactedDefinition) ? compactedDefinition : {};
};
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["ANY"] = "any";
  UserRole2["ONLY_REGISTERED_USER"] = "only_registered_user";
  UserRole2["COMPLIMENTARY_PAID_BASIC"] = "complementary-paid-basic";
  UserRole2["COMPLIMENTARY_PAID_PREMIUM"] = "complimentary-premium";
  UserRole2["EMPLOYEE"] = "employee";
  UserRole2["BETA_USER"] = "beta_user";
  UserRole2["COMPLETE_RESTRICTION"] = "restriction_full";
  UserRole2["LIMITED_ACCESS"] = "restriction_limited";
  UserRole2["TEMPORARY_SHADOWBAN"] = "restriction_full_time";
  UserRole2["TRANSLATOR"] = "translator";
  UserRole2["ADMIN"] = "admin";
  UserRole2["MODERATOR"] = "moderator";
  UserRole2["SUPPORT"] = "support";
  UserRole2["GUEST"] = "guest";
  UserRole2["REGULAR_FREE"] = "regular";
  UserRole2["FREE"] = "free_tier";
  UserRole2["AD_SUPPORTED"] = "ad_supported";
  UserRole2["PAID_MINIMAL"] = "paid_minimal";
  UserRole2["PAID_BASIC"] = "paid_basic";
  UserRole2["PAID_PREMIUM"] = "paid_premium";
  UserRole2["CREATOR"] = "creator";
  UserRole2["SM_BASIC"] = "sm_basic";
  UserRole2["SM_PREMIUM"] = "sm_premium";
  UserRole2["PARTNER_PREMIUM"] = "premium";
  UserRole2["PARTNER_REGULAR"] = "regular";
  UserRole2["PARTNER_ADMIN"] = "admin";
  return UserRole2;
})(UserRole || {});
var CapabilityRuleStatus = /* @__PURE__ */ ((CapabilityRuleStatus2) => {
  CapabilityRuleStatus2["ENABLED"] = "enabled";
  CapabilityRuleStatus2["DISABLED"] = "disabled";
  return CapabilityRuleStatus2;
})(CapabilityRuleStatus || {});
var CapabilityTargetPlatform = /* @__PURE__ */ ((CapabilityTargetPlatform2) => {
  CapabilityTargetPlatform2["WEB"] = "web";
  CapabilityTargetPlatform2["NATIVE"] = "native";
  CapabilityTargetPlatform2["BACKEND"] = "backend";
  return CapabilityTargetPlatform2;
})(CapabilityTargetPlatform || {});
var CapabilityUnavailableBehavior = /* @__PURE__ */ ((CapabilityUnavailableBehavior2) => {
  CapabilityUnavailableBehavior2["HIDE"] = "hide";
  CapabilityUnavailableBehavior2["SHOW_DISABLED"] = "show_disabled";
  CapabilityUnavailableBehavior2["SHOW_PAYWALL"] = "show_paywall";
  return CapabilityUnavailableBehavior2;
})(CapabilityUnavailableBehavior || {});
var ApplicationComponentSlot = /* @__PURE__ */ ((ApplicationComponentSlot2) => {
  ApplicationComponentSlot2["Header"] = "header";
  ApplicationComponentSlot2["Footer"] = "footer";
  ApplicationComponentSlot2["CharacterCard"] = "characterCard";
  return ApplicationComponentSlot2;
})(ApplicationComponentSlot || {});
const UI_KEY_COMPONENTS = "components";
const UI_KEY_COMPONENT_ID = "componentId";
const UI_KEY_PROPS = "props";
const MESSAGE_EXPECTED_UI_OBJECT = "Expected ui to be an object";
const MESSAGE_EXPECTED_COMPONENTS_OBJECT = "Expected components to be an object";
const MESSAGE_EXPECTED_COMPONENT_CONFIG_OBJECT = "Expected component config to be an object";
const MESSAGE_EXPECTED_COMPONENT_ID = "Expected componentId to be a string";
const MESSAGE_EXPECTED_PROPS_OBJECT = "Expected props to be an object";
const MESSAGE_UNEXPECTED_PROPERTY = "Unexpected property";
const UI_KEYS = /* @__PURE__ */ new Set([UI_KEY_COMPONENTS]);
const COMPONENT_CONFIG_KEYS = /* @__PURE__ */ new Set([UI_KEY_COMPONENT_ID, UI_KEY_PROPS]);
const APPLICATION_COMPONENT_SLOT_VALUES = new Set(Object.values(ApplicationComponentSlot));
function createPath$1(basePath, key) {
  return basePath ? `${basePath}.${key}` : key;
}
function reportUnexpectedKeys$1(value, path, allowedKeys, issues) {
  for (const key of Object.keys(value)) {
    if (!allowedKeys.has(key)) {
      issues.push({
        path: createPath$1(path, key),
        message: MESSAGE_UNEXPECTED_PROPERTY
      });
    }
  }
}
function sanitizeUiOverride(ui) {
  if (!isPlainObject(ui)) {
    return void 0;
  }
  const componentsValue = ui[UI_KEY_COMPONENTS];
  if (!isPlainObject(componentsValue)) {
    return void 0;
  }
  const sanitizedEntries = Object.entries(componentsValue).map(([slot, config]) => {
    if (!APPLICATION_COMPONENT_SLOT_VALUES.has(slot) || !isPlainObject(config)) {
      return void 0;
    }
    const componentId = config[UI_KEY_COMPONENT_ID];
    if (typeof componentId !== "string") {
      return void 0;
    }
    const sanitizedConfig = {
      [UI_KEY_COMPONENT_ID]: componentId
    };
    const props = config[UI_KEY_PROPS];
    if (props !== void 0 && props !== null && isPlainObject(props)) {
      sanitizedConfig[UI_KEY_PROPS] = props;
    }
    return [slot, sanitizedConfig];
  }).filter((entry) => entry !== void 0);
  if (sanitizedEntries.length === 0) {
    return void 0;
  }
  return {
    [UI_KEY_COMPONENTS]: Object.fromEntries(sanitizedEntries)
  };
}
function validateUiOverride(ui, path, issues) {
  if (!isPlainObject(ui)) {
    issues.push({ path, message: MESSAGE_EXPECTED_UI_OBJECT });
    return;
  }
  reportUnexpectedKeys$1(ui, path, UI_KEYS, issues);
  const components = ui[UI_KEY_COMPONENTS];
  if (components === void 0) {
    return;
  }
  if (!isPlainObject(components)) {
    issues.push({
      path: createPath$1(path, UI_KEY_COMPONENTS),
      message: MESSAGE_EXPECTED_COMPONENTS_OBJECT
    });
    return;
  }
  for (const [slot, config] of Object.entries(components)) {
    const slotPath = createPath$1(createPath$1(path, UI_KEY_COMPONENTS), slot);
    if (!APPLICATION_COMPONENT_SLOT_VALUES.has(slot)) {
      issues.push({ path: slotPath, message: MESSAGE_UNEXPECTED_PROPERTY });
      continue;
    }
    if (!isPlainObject(config)) {
      issues.push({
        path: slotPath,
        message: MESSAGE_EXPECTED_COMPONENT_CONFIG_OBJECT
      });
      continue;
    }
    reportUnexpectedKeys$1(config, slotPath, COMPONENT_CONFIG_KEYS, issues);
    if (typeof config[UI_KEY_COMPONENT_ID] !== "string") {
      issues.push({
        path: createPath$1(slotPath, UI_KEY_COMPONENT_ID),
        message: MESSAGE_EXPECTED_COMPONENT_ID
      });
    }
    const props = config[UI_KEY_PROPS];
    if (props !== void 0 && props !== null && !isPlainObject(props)) {
      issues.push({
        path: createPath$1(slotPath, UI_KEY_PROPS),
        message: MESSAGE_EXPECTED_PROPS_OBJECT
      });
    }
  }
}
const ApplicationDefinitionValidationKey = {
  Capabilities: "capabilities",
  Ui: "ui",
  Rule: "rule",
  Status: "status",
  FlagKeys: "flagKeys",
  GatedBy: "gatedBy",
  PaywallRoles: "paywallRoles",
  Permissions: "permissions",
  Roles: "roles",
  UnavailableBehavior: "unavailableBehavior",
  SubCapabilities: "subCapabilities",
  All: "all"
};
const CAPABILITY_RULE_STATUS_VALUES = new Set(Object.values(CapabilityRuleStatus));
const CAPABILITY_UNAVAILABLE_BEHAVIOR_VALUES = new Set(Object.values(CapabilityUnavailableBehavior));
const CAPABILITY_TARGET_PLATFORM_VALUES = new Set(Object.values(CapabilityTargetPlatform));
const USER_ROLE_VALUES = new Set(Object.values(UserRole));
const VALID_FLAG_KEYS = /* @__PURE__ */ new Set([ApplicationDefinitionValidationKey.All, ...CAPABILITY_TARGET_PLATFORM_VALUES]);
const CAPABILITY_CONFIG_KEYS = /* @__PURE__ */ new Set([
  ApplicationDefinitionValidationKey.Rule,
  ApplicationDefinitionValidationKey.UnavailableBehavior,
  ApplicationDefinitionValidationKey.SubCapabilities
]);
const CAPABILITY_RULE_KEYS = /* @__PURE__ */ new Set([
  ApplicationDefinitionValidationKey.Status,
  ApplicationDefinitionValidationKey.FlagKeys,
  ApplicationDefinitionValidationKey.GatedBy,
  ApplicationDefinitionValidationKey.PaywallRoles
]);
const GATED_BY_KEYS = /* @__PURE__ */ new Set([ApplicationDefinitionValidationKey.Permissions, ApplicationDefinitionValidationKey.Roles]);
const APPLICATION_DEFINITION_KEYS = /* @__PURE__ */ new Set([ApplicationDefinitionValidationKey.Capabilities, ApplicationDefinitionValidationKey.Ui]);
function createPath(basePath, key) {
  return basePath ? `${basePath}.${key}` : key;
}
function formatInvalidValueMessage(message, value) {
  return `${message}: ${JSON.stringify(value)}`;
}
function reportUnexpectedKeys(value, path, allowedKeys, issues) {
  for (const key of Object.keys(value)) {
    if (!allowedKeys.has(key)) {
      issues.push({
        path: createPath(path, key),
        message: "Unexpected property"
        /* UnexpectedProperty */
      });
    }
  }
}
function sanitizeGatedBy(gatedBy) {
  if (!isPlainObject(gatedBy)) {
    return void 0;
  }
  const permissions = gatedBy[ApplicationDefinitionValidationKey.Permissions];
  const roles = gatedBy[ApplicationDefinitionValidationKey.Roles];
  const isValidPermissions = Array.isArray(permissions) && permissions.every((permission) => typeof permission === "string");
  const isValidRoles = Array.isArray(roles) && roles.every((role) => typeof role === "string");
  if (!isValidPermissions && !isValidRoles) {
    return void 0;
  }
  const result = {};
  if (isValidPermissions) {
    result[ApplicationDefinitionValidationKey.Permissions] = permissions;
  }
  if (isValidRoles) {
    result[ApplicationDefinitionValidationKey.Roles] = roles;
  }
  return result;
}
function sanitizeFlagKeys(flagKeys) {
  if (flagKeys === null || flagKeys === void 0) {
    return void 0;
  }
  if (!isPlainObject(flagKeys)) {
    return void 0;
  }
  const sanitizedFlagKeys = Object.fromEntries(
    Object.entries(flagKeys).filter(([flagKey, flagValue]) => VALID_FLAG_KEYS.has(flagKey) && typeof flagValue === "string")
  );
  return Object.keys(sanitizedFlagKeys).length > 0 ? sanitizedFlagKeys : void 0;
}
function sanitizeCapabilityRule(rule) {
  if (!isPlainObject(rule)) {
    return void 0;
  }
  const status = rule[ApplicationDefinitionValidationKey.Status];
  if (typeof status !== "string" || !CAPABILITY_RULE_STATUS_VALUES.has(status)) {
    return void 0;
  }
  const sanitizedRule = {
    [ApplicationDefinitionValidationKey.Status]: status
  };
  const sanitizedFlagKeys = sanitizeFlagKeys(rule[ApplicationDefinitionValidationKey.FlagKeys]);
  if (sanitizedFlagKeys) {
    sanitizedRule[ApplicationDefinitionValidationKey.FlagKeys] = sanitizedFlagKeys;
  }
  const sanitizedGatedBy = sanitizeGatedBy(rule[ApplicationDefinitionValidationKey.GatedBy]);
  if (sanitizedGatedBy) {
    sanitizedRule[ApplicationDefinitionValidationKey.GatedBy] = sanitizedGatedBy;
  }
  const paywallRoles = rule[ApplicationDefinitionValidationKey.PaywallRoles];
  if (Array.isArray(paywallRoles) && paywallRoles.every((role) => typeof role === "string" && USER_ROLE_VALUES.has(role))) {
    sanitizedRule[ApplicationDefinitionValidationKey.PaywallRoles] = paywallRoles;
  }
  return sanitizedRule;
}
function sanitizeCapabilityConfig(config) {
  const sanitizedRule = sanitizeCapabilityRule(config[ApplicationDefinitionValidationKey.Rule]);
  const subCapabilitiesValue = config[ApplicationDefinitionValidationKey.SubCapabilities];
  let sanitizedSubCapabilities;
  if (isPlainObject(subCapabilitiesValue)) {
    const sanitizedEntries = Object.entries(subCapabilitiesValue).map(([subCapabilityKey, subCapabilityValue]) => {
      if (!isPlainObject(subCapabilityValue)) {
        return void 0;
      }
      const sanitizedSubCapability = sanitizeCapabilityConfig(subCapabilityValue);
      return Object.keys(sanitizedSubCapability).length > 0 ? [subCapabilityKey, sanitizedSubCapability] : void 0;
    }).filter((entry) => entry !== void 0);
    if (sanitizedEntries.length > 0) {
      sanitizedSubCapabilities = Object.fromEntries(sanitizedEntries);
    }
  }
  const unavailableBehavior = config[ApplicationDefinitionValidationKey.UnavailableBehavior];
  const sanitizedUnavailableBehavior = typeof unavailableBehavior === "string" && CAPABILITY_UNAVAILABLE_BEHAVIOR_VALUES.has(unavailableBehavior) ? unavailableBehavior : void 0;
  const sanitizedConfig = {};
  if (sanitizedRule) {
    sanitizedConfig[ApplicationDefinitionValidationKey.Rule] = sanitizedRule;
  }
  if (sanitizedUnavailableBehavior) {
    sanitizedConfig[ApplicationDefinitionValidationKey.UnavailableBehavior] = sanitizedUnavailableBehavior;
  }
  if (sanitizedSubCapabilities) {
    sanitizedConfig[ApplicationDefinitionValidationKey.SubCapabilities] = sanitizedSubCapabilities;
  }
  return sanitizedConfig;
}
function sanitizeApplicationDefinitionOverride(applicationDefinition) {
  const capabilitiesValue = applicationDefinition[ApplicationDefinitionValidationKey.Capabilities];
  let sanitizedCapabilities;
  const sanitizedUi = sanitizeUiOverride(applicationDefinition[ApplicationDefinitionValidationKey.Ui]);
  if (isPlainObject(capabilitiesValue)) {
    const sanitizedEntries = Object.entries(capabilitiesValue).map(([capabilityKey, capabilityValue]) => {
      if (!isPlainObject(capabilityValue)) {
        return void 0;
      }
      const sanitizedCapability = sanitizeCapabilityConfig(capabilityValue);
      return Object.keys(sanitizedCapability).length > 0 ? [capabilityKey, sanitizedCapability] : void 0;
    }).filter((entry) => entry !== void 0);
    if (sanitizedEntries.length > 0) {
      sanitizedCapabilities = Object.fromEntries(sanitizedEntries);
    }
  }
  return {
    ...sanitizedCapabilities !== void 0 ? { [ApplicationDefinitionValidationKey.Capabilities]: sanitizedCapabilities } : {},
    ...sanitizedUi !== void 0 ? { [ApplicationDefinitionValidationKey.Ui]: sanitizedUi } : {}
  };
}
function validateRuleStatus(rule, path, issues) {
  const status = rule[ApplicationDefinitionValidationKey.Status];
  if (typeof status !== "string" || !CAPABILITY_RULE_STATUS_VALUES.has(status)) {
    issues.push({
      path: createPath(path, ApplicationDefinitionValidationKey.Status),
      message: formatInvalidValueMessage("Invalid rule status", status)
    });
  }
}
function validateCapabilityRule(rule, path, issues) {
  if (rule === void 0) {
    issues.push({
      path,
      message: "Missing required rule"
      /* MissingRule */
    });
    return;
  }
  if (!isPlainObject(rule)) {
    issues.push({
      path,
      message: "Expected rule to be an object"
      /* ExpectedRuleObject */
    });
    return;
  }
  reportUnexpectedKeys(rule, path, CAPABILITY_RULE_KEYS, issues);
  validateRuleStatus(rule, path, issues);
  const flagKeys = rule[ApplicationDefinitionValidationKey.FlagKeys];
  if (flagKeys !== void 0) {
    if (flagKeys !== null && !isPlainObject(flagKeys)) {
      issues.push({
        path: createPath(path, ApplicationDefinitionValidationKey.FlagKeys),
        message: "Expected flagKeys to be an object"
        /* ExpectedFlagKeysObject */
      });
    } else if (flagKeys !== null) {
      for (const [flagKey, flagValue] of Object.entries(flagKeys)) {
        if (!VALID_FLAG_KEYS.has(flagKey) || typeof flagValue !== "string") {
          issues.push({
            path: createPath(createPath(path, ApplicationDefinitionValidationKey.FlagKeys), flagKey),
            message: "Invalid flag key value"
            /* InvalidFlagKeyValue */
          });
        }
      }
    }
  }
  const gatedBy = rule[ApplicationDefinitionValidationKey.GatedBy];
  if (gatedBy !== void 0) {
    if (!isPlainObject(gatedBy)) {
      issues.push({
        path: createPath(path, ApplicationDefinitionValidationKey.GatedBy),
        message: "Expected gatedBy to be an object"
        /* ExpectedGatedByObject */
      });
    } else {
      reportUnexpectedKeys(gatedBy, createPath(path, ApplicationDefinitionValidationKey.GatedBy), GATED_BY_KEYS, issues);
      const permissions = gatedBy[ApplicationDefinitionValidationKey.Permissions];
      const roles = gatedBy[ApplicationDefinitionValidationKey.Roles];
      const isValidPermissions = Array.isArray(permissions) && permissions.every((permission) => typeof permission === "string");
      const isValidRoles = Array.isArray(roles) && roles.every((role) => typeof role === "string");
      if (permissions !== void 0 && !isValidPermissions) {
        issues.push({
          path: createPath(createPath(path, ApplicationDefinitionValidationKey.GatedBy), ApplicationDefinitionValidationKey.Permissions),
          message: "Expected permissions to be a string array"
          /* ExpectedPermissionsArray */
        });
      }
      if (roles !== void 0 && !isValidRoles) {
        issues.push({
          path: createPath(createPath(path, ApplicationDefinitionValidationKey.GatedBy), ApplicationDefinitionValidationKey.Roles),
          message: "Expected roles to be a string array"
          /* ExpectedRolesArray */
        });
      }
      if (!isValidPermissions && !isValidRoles) {
        issues.push({
          path: createPath(path, ApplicationDefinitionValidationKey.GatedBy),
          message: "gatedBy must have at least permissions or roles"
          /* MissingGateType */
        });
      }
    }
  }
  const paywallRoles = rule[ApplicationDefinitionValidationKey.PaywallRoles];
  if (paywallRoles !== void 0) {
    if (!Array.isArray(paywallRoles) || !paywallRoles.every((role) => typeof role === "string" && USER_ROLE_VALUES.has(role))) {
      issues.push({
        path: createPath(path, ApplicationDefinitionValidationKey.PaywallRoles),
        message: "Expected paywallRoles to be an array of valid user roles"
        /* ExpectedPaywallRolesArray */
      });
    }
  }
}
function validateCapabilityConfig(config, path, issues) {
  if (!isPlainObject(config)) {
    issues.push({
      path,
      message: "Expected object"
      /* ExpectedObject */
    });
    return;
  }
  reportUnexpectedKeys(config, path, CAPABILITY_CONFIG_KEYS, issues);
  validateCapabilityRule(config[ApplicationDefinitionValidationKey.Rule], createPath(path, ApplicationDefinitionValidationKey.Rule), issues);
  const unavailableBehavior = config[ApplicationDefinitionValidationKey.UnavailableBehavior];
  if (unavailableBehavior !== void 0 && (typeof unavailableBehavior !== "string" || !CAPABILITY_UNAVAILABLE_BEHAVIOR_VALUES.has(unavailableBehavior))) {
    issues.push({
      path: createPath(path, ApplicationDefinitionValidationKey.UnavailableBehavior),
      message: "Invalid unavailableBehavior"
      /* InvalidUnavailableBehavior */
    });
  }
  const subCapabilities = config[ApplicationDefinitionValidationKey.SubCapabilities];
  if (subCapabilities !== void 0) {
    if (!isPlainObject(subCapabilities)) {
      issues.push({
        path: createPath(path, ApplicationDefinitionValidationKey.SubCapabilities),
        message: "Expected subCapabilities to be an object"
        /* ExpectedSubCapabilitiesObject */
      });
    } else {
      for (const [subCapabilityKey, subCapabilityValue] of Object.entries(subCapabilities)) {
        if (subCapabilityValue === void 0) {
          continue;
        }
        validateCapabilityConfig(
          subCapabilityValue,
          createPath(createPath(path, ApplicationDefinitionValidationKey.SubCapabilities), subCapabilityKey),
          issues
        );
      }
    }
  }
}
function validateCapabilities(capabilities, path, issues) {
  if (!isPlainObject(capabilities)) {
    issues.push({
      path,
      message: "Expected capabilities to be an object"
      /* ExpectedCapabilitiesObject */
    });
    return;
  }
  for (const [capabilityKey, capabilityValue] of Object.entries(capabilities)) {
    if (capabilityValue === void 0) {
      continue;
    }
    validateCapabilityConfig(capabilityValue, createPath(path, capabilityKey), issues);
  }
}
function validateApplicationDefinitionOverride(applicationDefinition) {
  const issues = [];
  if (!isPlainObject(applicationDefinition)) {
    return {
      success: false,
      issues: [{
        path: "",
        message: "Expected object"
        /* ExpectedObject */
      }]
    };
  }
  reportUnexpectedKeys(applicationDefinition, "", APPLICATION_DEFINITION_KEYS, issues);
  const capabilities = applicationDefinition[ApplicationDefinitionValidationKey.Capabilities];
  if (capabilities !== void 0) {
    validateCapabilities(capabilities, ApplicationDefinitionValidationKey.Capabilities, issues);
  }
  const ui = applicationDefinition[ApplicationDefinitionValidationKey.Ui];
  if (ui !== void 0) {
    validateUiOverride(ui, ApplicationDefinitionValidationKey.Ui, issues);
  }
  return {
    success: issues.length === 0,
    issues
  };
}
function isValidApplicationDefinitionOverride(applicationDefinition) {
  return validateApplicationDefinitionOverride(applicationDefinition).success;
}
function validateApplicationDefinitionConfig(config) {
  const result = validateApplicationDefinitionOverride(config);
  if (!result.success) {
    const errorMsg = result.issues.map((issue2) => `${issue2.path}: ${issue2.message}`).join(", ");
    throw new Error(`Invalid application definition: ${errorMsg}`);
  }
}
const normalizedDefinitionCache = /* @__PURE__ */ new WeakMap();
function mergeDeep(defaultValue, overrideValue) {
  if (overrideValue === void 0) {
    return defaultValue;
  }
  if (Array.isArray(defaultValue) || Array.isArray(overrideValue)) {
    return overrideValue;
  }
  if (!isPlainObject(defaultValue) || !isPlainObject(overrideValue)) {
    return overrideValue;
  }
  const defaultEntries = defaultValue;
  const overrideEntries = overrideValue;
  const mergedResult = {};
  const mergedKeys = /* @__PURE__ */ new Set([...Object.keys(defaultEntries), ...Object.keys(overrideEntries)]);
  for (const key of mergedKeys) {
    const defaultEntry = defaultEntries[key];
    const overrideEntry = overrideEntries[key];
    if (overrideEntry === void 0) {
      mergedResult[key] = defaultEntry;
      continue;
    }
    if (defaultEntry === void 0) {
      mergedResult[key] = overrideEntry;
      continue;
    }
    mergedResult[key] = mergeDeep(defaultEntry, overrideEntry);
  }
  return mergedResult;
}
function normalizeApplicationDefinition(applicationDefinition) {
  const cachedDefinition = normalizedDefinitionCache.get(applicationDefinition);
  if (cachedDefinition) {
    return cachedDefinition;
  }
  const normalizedDefinition = mergeDeep(DEFAULT_APPLICATION_CONFIG, applicationDefinition);
  validateApplicationDefinitionConfig({ capabilities: normalizedDefinition.capabilities });
  normalizedDefinitionCache.set(applicationDefinition, normalizedDefinition);
  return normalizedDefinition;
}
var CapabilityResolution = /* @__PURE__ */ ((CapabilityResolution2) => {
  CapabilityResolution2["ALLOWED"] = "allowed";
  CapabilityResolution2["DISABLED_BY_CONFIG"] = "disabled_by_config";
  CapabilityResolution2["DISABLED_BY_FLAG"] = "disabled_by_flag";
  CapabilityResolution2["DENIED_BY_PERMISSION"] = "denied_by_permission";
  CapabilityResolution2["DENIED_BY_ROLE"] = "denied_by_role";
  return CapabilityResolution2;
})(CapabilityResolution || {});
function getUnavailableBehavior(config) {
  return config.unavailableBehavior ?? CapabilityUnavailableBehavior.HIDE;
}
function resolveIsPaywall({ allowed, unavailableBehavior }) {
  return !allowed && unavailableBehavior === CapabilityUnavailableBehavior.SHOW_PAYWALL;
}
function hasRequiredPermissions(required, userPermissions) {
  return required.every((perm) => userPermissions.includes(perm));
}
function hasRequiredRole(required, userRoles) {
  return required.some((role) => userRoles.includes(role));
}
function evaluatePlatformFlags(flagKeys, platform, featureFlags) {
  if (!flagKeys) {
    return true;
  }
  const platformFlagKey = flagKeys[platform] ?? flagKeys.all;
  if (!platformFlagKey) {
    return true;
  }
  return featureFlags.isOn(platformFlagKey);
}
function resolveRule(config, viewer, featureFlags, platform) {
  const { rule } = config;
  if (rule.status === CapabilityRuleStatus.DISABLED) {
    return {
      allowed: false,
      resolution: CapabilityResolution.DISABLED_BY_CONFIG
    };
  }
  const isFlagAllowed = evaluatePlatformFlags(rule.flagKeys, platform, featureFlags);
  if (!isFlagAllowed) {
    return {
      allowed: false,
      resolution: CapabilityResolution.DISABLED_BY_FLAG
    };
  }
  if ("gatedBy" in rule && rule.gatedBy) {
    const { permissions, roles } = rule.gatedBy;
    if (permissions && permissions.length > 0) {
      if (!hasRequiredPermissions(permissions, viewer.permissions)) {
        return {
          allowed: false,
          resolution: CapabilityResolution.DENIED_BY_PERMISSION
        };
      }
    }
    if (roles && roles.length > 0) {
      if (!hasRequiredRole(roles, viewer.roles)) {
        return {
          allowed: false,
          resolution: CapabilityResolution.DENIED_BY_ROLE
        };
      }
    }
  }
  return {
    allowed: true,
    resolution: CapabilityResolution.ALLOWED
  };
}
function resolveConfig(config, viewer, featureFlags, platform, options) {
  const { allowed, resolution } = resolveRule(config, viewer, featureFlags, platform);
  const unavailableBehavior = getUnavailableBehavior(config);
  const paywallRoles = "paywallRoles" in config.rule ? config.rule.paywallRoles : void 0;
  let subCapabilities;
  if (!(options == null ? void 0 : options.shallow) && config.subCapabilities) {
    subCapabilities = {};
    for (const [key, subConfig] of Object.entries(config.subCapabilities)) {
      if (!subConfig) {
        continue;
      }
      const isParentAllowed = allowed;
      const subResolved = resolveConfig(subConfig, viewer, featureFlags, platform);
      if (!isParentAllowed) {
        subCapabilities[key] = {
          allowed: false,
          isPaywall: resolveIsPaywall({ allowed: false, unavailableBehavior: subResolved.unavailableBehavior }),
          resolution: subResolved.resolution,
          unavailableBehavior: subResolved.unavailableBehavior,
          paywallRoles: subResolved.paywallRoles,
          subCapabilities: subResolved.subCapabilities
        };
      } else {
        subCapabilities[key] = subResolved;
      }
    }
  }
  return {
    allowed,
    isPaywall: resolveIsPaywall({ allowed, unavailableBehavior }),
    resolution,
    unavailableBehavior,
    paywallRoles,
    subCapabilities
  };
}
function evaluateCapability(capabilityKey, context, options) {
  const config = context.applicationDefinition.capabilities[capabilityKey];
  if (!config) {
    return null;
  }
  return resolveConfig(config, context.viewer, context.featureFlags, context.platform, options);
}
function evaluateSubCapability(capabilityKey, subCapabilityKey, context) {
  var _a;
  const parentConfig = context.applicationDefinition.capabilities[capabilityKey];
  if (!parentConfig) {
    return null;
  }
  const subConfig = (_a = parentConfig.subCapabilities) == null ? void 0 : _a[subCapabilityKey];
  if (!subConfig) {
    return null;
  }
  const { allowed: isParentAllowed } = resolveRule(parentConfig, context.viewer, context.featureFlags, context.platform);
  const subResolved = resolveConfig(subConfig, context.viewer, context.featureFlags, context.platform, { shallow: true });
  if (!isParentAllowed) {
    return {
      allowed: false,
      isPaywall: resolveIsPaywall({ allowed: false, unavailableBehavior: subResolved.unavailableBehavior }),
      resolution: subResolved.resolution,
      unavailableBehavior: subResolved.unavailableBehavior,
      paywallRoles: subResolved.paywallRoles,
      subCapabilities: subResolved.subCapabilities
    };
  }
  return subResolved;
}
function evaluateCapabilities(applicationDefinition, viewer, featureFlags, platform) {
  const capabilities = applicationDefinition.capabilities;
  const result = {};
  for (const key in capabilities) {
    if (Object.prototype.hasOwnProperty.call(capabilities, key)) {
      const capabilityKey = key;
      result[capabilityKey] = resolveConfig(capabilities[capabilityKey], viewer, featureFlags, platform);
    }
  }
  return result;
}
var CapabilityKey = /* @__PURE__ */ ((CapabilityKey2) => {
  CapabilityKey2["Discover"] = "discover";
  CapabilityKey2["DiscoveryPage"] = "discoveryPage";
  CapabilityKey2["Lorebook"] = "lorebook";
  CapabilityKey2["Rulebook"] = "rulebook";
  CapabilityKey2["Tts"] = "tts";
  CapabilityKey2["Nsfw"] = "nsfw";
  CapabilityKey2["GroupChat"] = "groupChat";
  CapabilityKey2["Chat"] = "chat";
  CapabilityKey2["ChatImage"] = "chatImage";
  CapabilityKey2["Character"] = "character";
  CapabilityKey2["Persona"] = "persona";
  CapabilityKey2["Site"] = "site";
  CapabilityKey2["Billing"] = "billing";
  CapabilityKey2["Onboarding"] = "onboarding";
  CapabilityKey2["WaitingRoom"] = "waitingRoom";
  CapabilityKey2["CreatorAnalytics"] = "creatorAnalytics";
  CapabilityKey2["Gallery"] = "gallery";
  CapabilityKey2["Media"] = "media";
  CapabilityKey2["Profile"] = "profile";
  return CapabilityKey2;
})(CapabilityKey || {});
var SubCapabilityKey = /* @__PURE__ */ ((SubCapabilityKey2) => {
  SubCapabilityKey2["DiscoverFilterDefinitionSize"] = "discover.filterDefinitionSize";
  SubCapabilityKey2["DiscoverFilterFeatures"] = "discover.filterFeatures";
  SubCapabilityKey2["DiscoverFiltersV2"] = "discover.filtersV2";
  SubCapabilityKey2["DiscoverFilterLanguage"] = "discover.filterLanguage";
  SubCapabilityKey2["DiscoverFilterGroups"] = "discover.filterGroups";
  SubCapabilityKey2["DiscoverBlockCreators"] = "discover.blockCreators";
  SubCapabilityKey2["LorebookManage"] = "lorebook.manage";
  SubCapabilityKey2["LorebookCharacterAttach"] = "lorebook.characterAttach";
  SubCapabilityKey2["LorebookImport"] = "lorebook.import";
  SubCapabilityKey2["LorebookPublicSharing"] = "lorebook.publicSharing";
  SubCapabilityKey2["LorebookPublicDiscovery"] = "lorebook.publicDiscovery";
  SubCapabilityKey2["LorebookDetail"] = "lorebook.detail";
  SubCapabilityKey2["LorebookShareLink"] = "lorebook.shareLink";
  SubCapabilityKey2["RulebookChatHud"] = "rulebook.chatHud";
  SubCapabilityKey2["RulebookManage"] = "rulebook.manage";
  SubCapabilityKey2["RulebookCharacterAttach"] = "rulebook.characterAttach";
  SubCapabilityKey2["RulebookPersonaAttach"] = "rulebook.personaAttach";
  SubCapabilityKey2["RulebookConversationAttach"] = "rulebook.conversationAttach";
  SubCapabilityKey2["RulebookPublicSharing"] = "rulebook.publicSharing";
  SubCapabilityKey2["RulebookPublicDiscovery"] = "rulebook.publicDiscovery";
  SubCapabilityKey2["TtsManageCustomVoice"] = "tts.manageCustomVoice";
  SubCapabilityKey2["TtsCharacterAttach"] = "tts.characterAttach";
  SubCapabilityKey2["NsfwImage"] = "nsfw.image";
  SubCapabilityKey2["NsfwChat"] = "nsfw.chat";
  SubCapabilityKey2["NsfwCharacterDiscovery"] = "nsfw.characterDiscovery";
  SubCapabilityKey2["NsfwCharacterManage"] = "nsfw.characterManage";
  SubCapabilityKey2["NsfwUserToggle"] = "nsfw.userToggle";
  SubCapabilityKey2["GroupChatManage"] = "groupChat.manage";
  SubCapabilityKey2["GroupChatContent"] = "groupChat.content";
  SubCapabilityKey2["GroupChatAutoResponse"] = "groupChat.autoResponse";
  SubCapabilityKey2["ChatGenerationSettings"] = "chat.generationSettings";
  SubCapabilityKey2["ChatGenerationSettingsAdvanced"] = "chat.generationSettingsAdvanced";
  SubCapabilityKey2["ChatGenerationChangeModel"] = "chat.generationChangeModel";
  SubCapabilityKey2["ChatModelTier"] = "chat.modelTier";
  SubCapabilityKey2["ChatContextCap"] = "chat.contextCap";
  SubCapabilityKey2["ChatStoryMode"] = "chat.storyMode";
  SubCapabilityKey2["ChatMemoryManager"] = "chat.memoryManager";
  SubCapabilityKey2["ChatMemoryAutoCreate"] = "chat.memoryAutoCreate";
  SubCapabilityKey2["ChatUploadImage"] = "chat.uploadImage";
  SubCapabilityKey2["ChatOpenaiModel"] = "chat.openaiModel";
  SubCapabilityKey2["ChatMultilanguage"] = "chat.multilanguage";
  SubCapabilityKey2["ChatImageImageTraining"] = "chatImage.imageTraining";
  SubCapabilityKey2["ChatImageImageGeneration"] = "chatImage.imageGeneration";
  SubCapabilityKey2["ChatImageImageGenerationSettings"] = "chatImage.imageGenerationSettings";
  SubCapabilityKey2["ChatImageOpenMediaDetails"] = "chatImage.openMediaDetails";
  SubCapabilityKey2["CharacterManage"] = "character.manage";
  SubCapabilityKey2["CharacterCreatePublic"] = "character.createPublic";
  SubCapabilityKey2["CharacterUploadAvatar"] = "character.uploadAvatar";
  SubCapabilityKey2["CharacterImportCard"] = "character.importCard";
  SubCapabilityKey2["CharacterShareLink"] = "character.shareLink";
  SubCapabilityKey2["CharacterTranslate"] = "character.translate";
  SubCapabilityKey2["PersonaManage"] = "persona.manage";
  SubCapabilityKey2["PersonaUploadAvatar"] = "persona.uploadAvatar";
  SubCapabilityKey2["GalleryMyGallery"] = "gallery.myGallery";
  SubCapabilityKey2["GalleryPublicGallery"] = "gallery.publicGallery";
  SubCapabilityKey2["GalleryMediaNavigation"] = "gallery.mediaNavigation";
  SubCapabilityKey2["GalleryOpenMediaDetails"] = "gallery.openMediaDetails";
  SubCapabilityKey2["MediaMediaPage"] = "media.mediaPage";
  SubCapabilityKey2["MediaDownload"] = "media.download";
  SubCapabilityKey2["MediaRelatedEntity"] = "media.relatedEntity";
  SubCapabilityKey2["MediaViewGenerationDetails"] = "media.viewGenerationDetails";
  SubCapabilityKey2["MediaKeep"] = "media.keep";
  SubCapabilityKey2["MediaMakePublic"] = "media.makePublic";
  SubCapabilityKey2["SiteMultilanguage"] = "site.multilanguage";
  SubCapabilityKey2["BillingQuarterlyPlan"] = "billing.quarterlyPlan";
  SubCapabilityKey2["OnboardingFtueModal"] = "onboarding.ftueModal";
  SubCapabilityKey2["ProfileUploadAvatar"] = "profile.uploadAvatar";
  return SubCapabilityKey2;
})(SubCapabilityKey || {});
function isAllowed(capability) {
  return (capability == null ? void 0 : capability.allowed) ?? false;
}
function capitalizeSegment(segment) {
  return `${segment.charAt(0).toUpperCase()}${segment.slice(1)}`;
}
function toCapabilityFlagName(path) {
  return `canUse${path.map((segment, index) => {
    if (index > 0 && segment.includes(".")) {
      const [, suffix] = segment.split(".");
      return capitalizeSegment(suffix);
    }
    return capitalizeSegment(segment);
  }).join("")}`;
}
function getSubCapabilityKeys(capabilityKey) {
  return SUB_CAPABILITY_KEYS_BY_PARENT[capabilityKey] ?? [];
}
function createEmptyCapabilityFlags() {
  const flags = {};
  for (const capabilityKey of Object.values(CapabilityKey)) {
    flags[toCapabilityFlagName([capabilityKey])] = false;
    for (const subCapabilityKey of getSubCapabilityKeys(capabilityKey)) {
      flags[toCapabilityFlagName([capabilityKey, subCapabilityKey])] = false;
    }
  }
  return flags;
}
function appendCapabilityFlags(flags, capabilityEntries, path = []) {
  for (const [key, capability] of capabilityEntries) {
    const nextPath = [...path, key];
    flags[toCapabilityFlagName(nextPath)] = isAllowed(capability);
    if (capability.subCapabilities) {
      appendCapabilityFlags(flags, Object.entries(capability.subCapabilities), nextPath);
    }
  }
}
function toEffectiveCapabilityFlags(flags) {
  return flags;
}
const toCapabilityFlags = (capabilities) => {
  const flags = createEmptyCapabilityFlags();
  appendCapabilityFlags(flags, Object.entries(capabilities));
  return toEffectiveCapabilityFlags(flags);
};
const evaluateCapabilityFlags = (applicationDefinition, viewer, featureFlags, platform) => {
  return toCapabilityFlags(evaluateCapabilities(applicationDefinition, viewer, featureFlags, platform));
};
var ApplicationFeatureFlagKey = /* @__PURE__ */ ((ApplicationFeatureFlagKey2) => {
  ApplicationFeatureFlagKey2["LorebookImport"] = "lorebook_import";
  ApplicationFeatureFlagKey2["LorebookPublicWeb"] = "lorebook_public_web";
  ApplicationFeatureFlagKey2["LorebookDiscoverPublicWeb"] = "lorebook_discover_public_web";
  ApplicationFeatureFlagKey2["LorebookDetail"] = "NX-5637-lorebook-web";
  ApplicationFeatureFlagKey2["Rulebook"] = "rulebook";
  ApplicationFeatureFlagKey2["FilterFeaturesWeb"] = "filter_features_web";
  ApplicationFeatureFlagKey2["FilterFeaturesNative"] = "filter_features_native";
  ApplicationFeatureFlagKey2["FiltersV2Web"] = "filters_v2_web";
  ApplicationFeatureFlagKey2["ReleaseDiscoveryPageWeb"] = "release_discovery_page_web";
  ApplicationFeatureFlagKey2["ReleaseDiscoveryPageNative"] = "release_discovery_page_native";
  ApplicationFeatureFlagKey2["ReleaseDiscoveryPageBackend"] = "release_discovery_page_backend";
  return ApplicationFeatureFlagKey2;
})(ApplicationFeatureFlagKey || {});
function createAllowlistGuard(allowedValues) {
  return (value) => typeof value === "string" && allowedValues.includes(value);
}
var DiscoveryFilterKey = /* @__PURE__ */ ((DiscoveryFilterKey2) => {
  DiscoveryFilterKey2["TAGS"] = "tags";
  DiscoveryFilterKey2["DEFINITION"] = "definition";
  DiscoveryFilterKey2["LANGUAGE"] = "language";
  DiscoveryFilterKey2["CHAT_SIZE"] = "chatSize";
  return DiscoveryFilterKey2;
})(DiscoveryFilterKey || {});
const DISCOVERY_FILTER_KEYS = Object.values(DiscoveryFilterKey);
const isDiscoveryFilterKey = createAllowlistGuard(DISCOVERY_FILTER_KEYS);
var CapabilityKeySource = /* @__PURE__ */ ((CapabilityKeySource2) => {
  CapabilityKeySource2["DefaultConfiguration"] = "defaultConfiguration";
  CapabilityKeySource2["ContentfulOverride"] = "contentfulOverride";
  return CapabilityKeySource2;
})(CapabilityKeySource || {});
var CapabilityKeyReference = /* @__PURE__ */ ((CapabilityKeyReference2) => {
  CapabilityKeyReference2["CapabilityKeyType"] = "CapabilityKey";
  CapabilityKeyReference2["SubCapabilityKeyType"] = "SubCapabilityKey";
  CapabilityKeyReference2["DefaultConfiguration"] = "defaultConfiguration";
  return CapabilityKeyReference2;
})(CapabilityKeyReference || {});
var CapabilityKeyIssueKind = /* @__PURE__ */ ((CapabilityKeyIssueKind2) => {
  CapabilityKeyIssueKind2["Unknown"] = "unknown";
  CapabilityKeyIssueKind2["Missing"] = "missing";
  return CapabilityKeyIssueKind2;
})(CapabilityKeyIssueKind || {});
const CAPABILITY_KEYS = new Set(Object.values(CapabilityKey));
const SUB_CAPABILITY_KEYS = new Set(Object.values(SubCapabilityKey));
function readSubCapabilities(capability) {
  if (!isPlainObject(capability)) {
    return {};
  }
  const subCapabilities = capability["subCapabilities"];
  return isPlainObject(subCapabilities) ? subCapabilities : {};
}
function collectDefaultTopLevelIssues(configKeys) {
  const issues = [];
  for (const capabilityKey of CAPABILITY_KEYS) {
    if (!configKeys.includes(capabilityKey)) {
      issues.push({
        key: capabilityKey,
        kind: "missing",
        source: "defaultConfiguration",
        reference: "CapabilityKey"
        /* CapabilityKeyType */
      });
    }
  }
  for (const capabilityKey of configKeys) {
    if (!CAPABILITY_KEYS.has(capabilityKey)) {
      issues.push({
        key: capabilityKey,
        kind: "unknown",
        source: "defaultConfiguration",
        reference: "CapabilityKey"
        /* CapabilityKeyType */
      });
    }
  }
  return issues;
}
function collectUnknownSubCapabilityKeyIssues(capabilitiesConfig) {
  const issues = [];
  for (const capability of Object.values(capabilitiesConfig)) {
    const unknownSubKeys = Object.keys(readSubCapabilities(capability)).filter((subKey) => !SUB_CAPABILITY_KEYS.has(subKey));
    for (const subKey of unknownSubKeys) {
      issues.push({
        key: subKey,
        kind: "unknown",
        source: "defaultConfiguration",
        reference: "SubCapabilityKey"
        /* SubCapabilityKeyType */
      });
    }
  }
  return issues;
}
function collectMissingSubCapabilityIssues(defaultCapabilitiesConfig2) {
  const issues = [];
  for (const subKey of SUB_CAPABILITY_KEYS) {
    const [parentKey] = subKey.split(".");
    const parentCapability = parentKey === void 0 ? void 0 : defaultCapabilitiesConfig2[parentKey];
    if (readSubCapabilities(parentCapability)[subKey] === void 0) {
      issues.push({
        key: subKey,
        kind: "missing",
        source: "defaultConfiguration",
        reference: "SubCapabilityKey"
        /* SubCapabilityKeyType */
      });
    }
  }
  return issues;
}
function collectDefaultCapabilityKeyIssues(defaultCapabilitiesConfig2) {
  return [
    ...collectDefaultTopLevelIssues(Object.keys(defaultCapabilitiesConfig2)),
    ...collectUnknownSubCapabilityKeyIssues(defaultCapabilitiesConfig2),
    ...collectMissingSubCapabilityIssues(defaultCapabilitiesConfig2)
  ];
}
function collectOverrideSubCapabilityIssues(capability, defaultCapability) {
  const issues = [];
  const defaultSubCapabilities = readSubCapabilities(defaultCapability);
  for (const subKey of Object.keys(readSubCapabilities(capability))) {
    if (!SUB_CAPABILITY_KEYS.has(subKey)) {
      issues.push({
        key: subKey,
        kind: "unknown",
        source: "contentfulOverride",
        reference: "SubCapabilityKey"
        /* SubCapabilityKeyType */
      });
    }
    if (defaultCapability !== void 0 && !Object.hasOwn(defaultSubCapabilities, subKey)) {
      issues.push({
        key: subKey,
        kind: "unknown",
        source: "contentfulOverride",
        reference: "defaultConfiguration"
        /* DefaultConfiguration */
      });
    }
  }
  return issues;
}
function collectOverrideCapabilityKeyIssues({
  capabilities,
  defaultCapabilitiesConfig: defaultCapabilitiesConfig2
}) {
  if (!isPlainObject(capabilities)) {
    return [];
  }
  const issues = [];
  for (const [capabilityKey, capability] of Object.entries(capabilities)) {
    if (!CAPABILITY_KEYS.has(capabilityKey)) {
      issues.push({
        key: capabilityKey,
        kind: "unknown",
        source: "contentfulOverride",
        reference: "CapabilityKey"
        /* CapabilityKeyType */
      });
    }
    const defaultCapability = Object.hasOwn(defaultCapabilitiesConfig2, capabilityKey) ? defaultCapabilitiesConfig2[capabilityKey] : void 0;
    if (defaultCapability === void 0) {
      issues.push({
        key: capabilityKey,
        kind: "unknown",
        source: "contentfulOverride",
        reference: "defaultConfiguration"
        /* DefaultConfiguration */
      });
    }
    issues.push(...collectOverrideSubCapabilityIssues(capability, defaultCapability));
  }
  return issues;
}
const CLICK_ID_TYPES = [
  "fbclid",
  "gclid",
  "gbraid",
  "wbraid",
  "ttclid",
  "rdt_cid",
  "twclid",
  "msclkid",
  "sccid",
  "epik",
  "click_id",
  "tap_click_id",
  "aff_click_id",
  "crak_click_id"
];
const isClickIdType = createAllowlistGuard(CLICK_ID_TYPES);
const NETWORKS = [
  "meta",
  "google",
  "tiktok",
  "reddit",
  "x",
  "microsoft",
  "snap",
  "pinterest",
  "exoclick",
  "trafficstars",
  "clickadu",
  "juicyads",
  "email",
  "referral",
  "affiliate",
  "organic",
  "direct",
  "unknown"
];
const NON_ROUTABLE_NETWORKS = /* @__PURE__ */ new Set(["unknown", "organic", "direct", "affiliate"]);
const isNetwork = createAllowlistGuard(NETWORKS);
const CURRENT_ATTRIBUTION_VERSION = 1;
const CURRENT_HANDOFF_VERSION = 1;
const MAX_ENVELOPE_SIZE_BYTES = 10240;
const ATTRIBUTION_STORAGE_KEY = "ad_ctx_v1";
const ATTRIBUTION_HANDOFF_PARAM = "ad_h";
const CLICK_ID_DEFINITIONS = [
  { type: "fbclid", urlParam: "fbclid", network: "meta", isAffiliate: false },
  { type: "gclid", urlParam: "gclid", network: "google", isAffiliate: false },
  { type: "gbraid", urlParam: "gbraid", network: "google", isAffiliate: false },
  { type: "wbraid", urlParam: "wbraid", network: "google", isAffiliate: false },
  { type: "ttclid", urlParam: "ttclid", network: "tiktok", isAffiliate: false },
  { type: "rdt_cid", urlParam: "rdt_cid", network: "reddit", isAffiliate: false },
  { type: "twclid", urlParam: "twclid", network: "x", isAffiliate: false },
  { type: "msclkid", urlParam: "msclkid", network: "microsoft", isAffiliate: false },
  { type: "sccid", urlParam: "sccid", network: "snap", isAffiliate: false },
  { type: "epik", urlParam: "epik", network: "pinterest", isAffiliate: false },
  { type: "click_id", urlParam: "click_id", network: "unknown", isAffiliate: false },
  { type: "tap_click_id", urlParam: "tap_click_id", network: "affiliate", isAffiliate: true },
  { type: "aff_click_id", urlParam: "aff_click_id", network: "affiliate", isAffiliate: true },
  { type: "crak_click_id", urlParam: "crak_click_id", network: "affiliate", isAffiliate: true }
];
const CLICK_ID_PARAM_TO_TYPE = Object.freeze(
  Object.fromEntries(CLICK_ID_DEFINITIONS.map((definition) => [definition.urlParam, definition.type]))
);
const UTM_PARAM_NAMES = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const PLATFORM_DETAILS_PARAM_MAP = {
  adId: ["ad_id", "creative_id"],
  adName: ["ad_name", "creative_name"],
  adGroupId: ["adset_id", "ad_group_id", "adgroupid"],
  adGroupName: ["adset_name", "ad_group_name"],
  campaignId: ["campaign_id", "campaignid"],
  campaignName: ["campaign_name"],
  placement: ["placement"],
  source: ["site_source_name", "csite", "ad_source"],
  accountId: ["account_id", "advertiser_id", "customer_id"]
};
const OPTIONAL_STRING_FIELDS$1 = [
  "adId",
  "adName",
  "adGroupId",
  "adGroupName",
  "campaignId",
  "campaignName",
  "placement",
  "source",
  "accountId"
];
function isPlatformDetails(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const [key, entry] of Object.entries(value)) {
    if (key === "extraParams") {
      if (!isStringRecord(entry)) {
        return false;
      }
      continue;
    }
    if (!OPTIONAL_STRING_FIELDS$1.includes(key)) {
      return false;
    }
    if (typeof entry !== "string") {
      return false;
    }
  }
  return true;
}
function isStringRecord(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const entry of Object.values(value)) {
    if (typeof entry !== "string") {
      return false;
    }
  }
  return true;
}
const UTM_FIELDS = ["source", "medium", "campaign", "term", "content"];
const NETWORK_ID_FIELDS = ["adId", "adGroupId", "campaignId", "accountId"];
const PRIMARY_CLICK_REF_FIELDS = ["type", "value"];
const PIXEL_ID_FIELDS = ["fbp", "fbc", "gclAu", "ttp", "rdtUuid", "scid"];
const OPTIONAL_STRING_FIELDS = ["referrer", "landingUrl", "sessionId", "funnelId"];
const TOUCH_POINT_KEYS = /* @__PURE__ */ new Set([
  "capturedAt",
  "network",
  "clickIds",
  "primaryClickRef",
  "utm",
  "platformDetails",
  "networkIds",
  "pixelIds",
  "referrer",
  "landingUrl",
  "sessionId",
  "funnelId"
]);
function isTouchPoint(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const key of Object.keys(value)) {
    if (!TOUCH_POINT_KEYS.has(key)) {
      return false;
    }
  }
  const capturedAt = value["capturedAt"];
  if (typeof capturedAt !== "number" || !Number.isFinite(capturedAt)) {
    return false;
  }
  if (!isNetwork(value["network"])) {
    return false;
  }
  if (!isClickIdMap(value["clickIds"])) {
    return false;
  }
  const primaryClickRef = value["primaryClickRef"];
  if (primaryClickRef !== void 0 && !isPrimaryClickRef(primaryClickRef)) {
    return false;
  }
  const utm = value["utm"];
  if (utm !== void 0 && !isUtmBlock(utm)) {
    return false;
  }
  const platformDetails = value["platformDetails"];
  if (platformDetails !== void 0 && !isPlatformDetails(platformDetails)) {
    return false;
  }
  const networkIds = value["networkIds"];
  if (networkIds !== void 0 && !isNetworkIds(networkIds)) {
    return false;
  }
  const pixelIds = value["pixelIds"];
  if (pixelIds !== void 0 && !isPixelIds(pixelIds)) {
    return false;
  }
  if (!hasOnlyStringOptionalFields(value, OPTIONAL_STRING_FIELDS)) {
    return false;
  }
  return true;
}
function isClickIdMap(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const [key, entry] of Object.entries(value)) {
    if (!isClickIdType(key)) {
      return false;
    }
    if (typeof entry !== "string") {
      return false;
    }
  }
  return true;
}
function isPrimaryClickRef(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const key of Object.keys(value)) {
    if (!PRIMARY_CLICK_REF_FIELDS.includes(key)) {
      return false;
    }
  }
  return isClickIdType(value["type"]) && typeof value["value"] === "string";
}
function isUtmBlock(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const [key, entry] of Object.entries(value)) {
    if (!UTM_FIELDS.includes(key)) {
      return false;
    }
    if (typeof entry !== "string") {
      return false;
    }
  }
  return true;
}
function isNetworkIds(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const [key, entry] of Object.entries(value)) {
    if (!NETWORK_ID_FIELDS.includes(key)) {
      return false;
    }
    if (typeof entry !== "string") {
      return false;
    }
  }
  return true;
}
function isPixelIds(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const [key, entry] of Object.entries(value)) {
    if (!PIXEL_ID_FIELDS.includes(key)) {
      return false;
    }
    if (typeof entry !== "string") {
      return false;
    }
  }
  return true;
}
function hasOnlyStringOptionalFields(value, fields) {
  for (const field of fields) {
    const fieldValue = value[field];
    if (fieldValue !== void 0 && typeof fieldValue !== "string") {
      return false;
    }
  }
  return true;
}
const PARTNERS_FIELDS = ["tapVid", "affiliateId", "crakRevenueClickId", "partner"];
const CONSENT_FIELDS = ["at", "adUserData", "adPersonalization", "source"];
const CONSENT_SOURCES = ["default", "ui", "imported"];
const ATTRIBUTION_CONTEXT_KEYS = /* @__PURE__ */ new Set([
  "version",
  "anonymousId",
  "capturedAt",
  "firstTouch",
  "lastTouch",
  "partners",
  "consent"
]);
function isAttributionContext(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const key of Object.keys(value)) {
    if (!ATTRIBUTION_CONTEXT_KEYS.has(key)) {
      return false;
    }
  }
  const version = value["version"];
  if (typeof version !== "number" || !Number.isFinite(version)) {
    return false;
  }
  const anonymousId = value["anonymousId"];
  if (typeof anonymousId !== "string" || anonymousId === "") {
    return false;
  }
  const capturedAt = value["capturedAt"];
  if (typeof capturedAt !== "number" || !Number.isFinite(capturedAt)) {
    return false;
  }
  const firstTouch = value["firstTouch"];
  if (firstTouch !== void 0 && !isTouchPoint(firstTouch)) {
    return false;
  }
  const lastTouch = value["lastTouch"];
  if (lastTouch !== void 0 && !isTouchPoint(lastTouch)) {
    return false;
  }
  const partners = value["partners"];
  if (partners !== void 0 && !isPartnersBlock(partners)) {
    return false;
  }
  const consent = value["consent"];
  if (consent !== void 0 && !isConsentBlock(consent)) {
    return false;
  }
  return true;
}
function isPartnersBlock(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const [key, entry] of Object.entries(value)) {
    if (!PARTNERS_FIELDS.includes(key)) {
      return false;
    }
    if (typeof entry !== "string") {
      return false;
    }
  }
  return true;
}
function isConsentBlock(value) {
  if (!isPlainObject(value)) {
    return false;
  }
  for (const key of Object.keys(value)) {
    if (!CONSENT_FIELDS.includes(key)) {
      return false;
    }
  }
  if (typeof value["at"] !== "number" || !Number.isFinite(value["at"])) {
    return false;
  }
  if (typeof value["adUserData"] !== "boolean") {
    return false;
  }
  if (typeof value["adPersonalization"] !== "boolean") {
    return false;
  }
  if (typeof value["source"] !== "string" || !CONSENT_SOURCES.includes(value["source"])) {
    return false;
  }
  return true;
}
function applyConsent(prev, input) {
  const consent = {
    at: input.now,
    adUserData: input.adUserData,
    adPersonalization: input.adPersonalization,
    source: input.source ?? "ui"
  };
  return { ...prev, consent };
}
const FORWARDED_CLICK_ID_DEFINITIONS = CLICK_ID_DEFINITIONS.filter((definition) => !definition.isAffiliate);
const UTM_FIELD_TO_PARAM = {
  source: "utm_source",
  medium: "utm_medium",
  campaign: "utm_campaign",
  term: "utm_term",
  content: "utm_content"
};
const PLATFORM_DETAILS_FIELD_TO_PARAM = {
  adId: "ad_id",
  adName: "ad_name",
  adGroupId: "adset_id",
  adGroupName: "adset_name",
  campaignId: "campaign_id",
  campaignName: "campaign_name",
  placement: "placement",
  source: "site_source_name"
};
function buildHandoffUrl(destUrl, context, encodedHandoff, options = {}) {
  const url = new URL(destUrl);
  url.searchParams.set(ATTRIBUTION_HANDOFF_PARAM, encodedHandoff);
  const shouldIncludeTrackingParams = options.includeOriginalTrackingParams ?? true;
  if (shouldIncludeTrackingParams && isAdUserDataConsented(context)) {
    appendTrackingParams(url, context);
  }
  return url.toString();
}
function isAdUserDataConsented(context) {
  if (context.consent === void 0) {
    return true;
  }
  return context.consent.adUserData;
}
function appendPlatformDetailsParams(url, platformDetails) {
  if (platformDetails === void 0) {
    return;
  }
  for (const [field, paramName] of Object.entries(PLATFORM_DETAILS_FIELD_TO_PARAM)) {
    const value = platformDetails[field];
    const isAliasPresent = PLATFORM_DETAILS_PARAM_MAP[field].some((alias) => url.searchParams.has(alias));
    if (value !== void 0 && value !== "" && !isAliasPresent) {
      url.searchParams.set(paramName, value);
    }
  }
}
function appendTrackingParams(url, context) {
  const lastTouch = context.lastTouch;
  if (lastTouch === void 0) {
    return;
  }
  const isNetworkRoutable = lastTouch.network !== void 0 && !NON_ROUTABLE_NETWORKS.has(lastTouch.network);
  for (const definition of FORWARDED_CLICK_ID_DEFINITIONS) {
    if (definition.network === "unknown" && !isNetworkRoutable) {
      continue;
    }
    const value = lastTouch.clickIds[definition.type];
    if (value !== void 0 && value !== "" && !url.searchParams.has(definition.urlParam)) {
      url.searchParams.set(definition.urlParam, value);
    }
  }
  const { network } = lastTouch;
  if (network !== void 0 && !NON_ROUTABLE_NETWORKS.has(network) && !url.searchParams.has("network")) {
    url.searchParams.set("network", network);
  }
  if (lastTouch.sessionId !== void 0 && lastTouch.sessionId !== "" && !url.searchParams.has("session_id")) {
    url.searchParams.set("session_id", lastTouch.sessionId);
  }
  if (lastTouch.funnelId !== void 0 && lastTouch.funnelId !== "" && !url.searchParams.has("funnel_id")) {
    url.searchParams.set("funnel_id", lastTouch.funnelId);
  }
  appendPlatformDetailsParams(url, lastTouch.platformDetails);
  const utm = lastTouch.utm;
  if (utm === void 0) {
    return;
  }
  for (const [field, paramName] of Object.entries(UTM_FIELD_TO_PARAM)) {
    const value = utm[field];
    if (value !== void 0 && value !== "" && !url.searchParams.has(paramName)) {
      url.searchParams.set(paramName, value);
    }
  }
}
function extractClickIdsFromUrl(params) {
  const clickIds = {};
  for (const [paramName, clickIdType] of Object.entries(CLICK_ID_PARAM_TO_TYPE)) {
    const value = params.get(paramName);
    if (value !== null && value !== "") {
      clickIds[clickIdType] = value;
    }
  }
  return clickIds;
}
const PIXEL_ID_COOKIE_NAMES = {
  fbp: "_fbp",
  fbc: "_fbc",
  gclAu: "_gcl_au",
  ttp: "_ttp",
  rdtUuid: "_rdt_uuid",
  scid: "_scid"
};
function parseCookieHeader(rawCookie) {
  const result = {};
  if (rawCookie === "") {
    return result;
  }
  for (const entry of rawCookie.split(";")) {
    const trimmed = entry.trim();
    const eqIndex = trimmed.indexOf("=");
    if (eqIndex <= 0) {
      continue;
    }
    const name = trimmed.slice(0, eqIndex);
    const value = trimmed.slice(eqIndex + 1);
    try {
      result[name] = decodeURIComponent(value);
    } catch {
      result[name] = value;
    }
  }
  return result;
}
function extractPixelIdsFromCookies(cookies) {
  const pixelIds = {};
  let hasAny = false;
  for (const [field, cookieName] of Object.entries(PIXEL_ID_COOKIE_NAMES)) {
    const value = cookies[cookieName];
    if (value !== void 0 && value !== "") {
      pixelIds[field] = value;
      hasAny = true;
    }
  }
  return hasAny ? pixelIds : void 0;
}
function extractPlatformDetailsFromUrl(params, options = {}) {
  const details = {};
  const consumedParams = /* @__PURE__ */ new Set();
  let hasAny = false;
  for (const [field, candidates] of Object.entries(PLATFORM_DETAILS_PARAM_MAP)) {
    for (const paramName of candidates) {
      const value = params.get(paramName);
      if (value !== null && value !== "") {
        details[field] = value;
        consumedParams.add(paramName);
        hasAny = true;
        break;
      }
    }
  }
  if (options.captureExtras) {
    const extraParams = {};
    let hasExtras = false;
    for (const [key, value] of params.entries()) {
      if (consumedParams.has(key) || value === "") {
        continue;
      }
      if (key.startsWith("utm_") || key === "ad_h" || key === "aff_id" || key === "ref" || key === "network" || key === "session_id" || key === "funnel_id") {
        continue;
      }
      if (Object.hasOwn(CLICK_ID_PARAM_TO_TYPE, key)) {
        continue;
      }
      extraParams[key] = value;
      hasExtras = true;
    }
    if (hasExtras) {
      details.extraParams = extraParams;
      hasAny = true;
    }
  }
  return hasAny ? details : void 0;
}
function extractUtmFromUrl(params) {
  const utm = {};
  let hasAny = false;
  for (const paramName of UTM_PARAM_NAMES) {
    const value = params.get(paramName);
    if (value !== null && value !== "") {
      const shortKey = paramName.slice("utm_".length);
      utm[shortKey] = value;
      hasAny = true;
    }
  }
  return hasAny ? utm : void 0;
}
const NON_AD_NETWORKS = /* @__PURE__ */ new Set([...NON_ROUTABLE_NETWORKS, "referral", "email"]);
function inferNetwork(clickIds, utmSource, explicitNetwork) {
  if (isPresent(explicitNetwork) && isNetwork(explicitNetwork)) {
    return explicitNetwork;
  }
  for (const definition of CLICK_ID_DEFINITIONS) {
    if (definition.network === "unknown" || definition.isAffiliate) {
      continue;
    }
    if (isPresent(clickIds[definition.type])) {
      return definition.network;
    }
  }
  if (isPresent(clickIds.click_id) && isPresent(utmSource)) {
    const utmNetwork = mapUtmSourceToNetwork(utmSource);
    if (!NON_AD_NETWORKS.has(utmNetwork)) {
      return utmNetwork;
    }
  }
  for (const definition of CLICK_ID_DEFINITIONS) {
    if (definition.isAffiliate && isPresent(clickIds[definition.type])) {
      return "affiliate";
    }
  }
  if (isPresent(utmSource)) {
    return mapUtmSourceToNetwork(utmSource);
  }
  return "unknown";
}
function isPresent(value) {
  return value !== void 0 && value !== "";
}
function mapUtmSourceToNetwork(utmSource) {
  const normalized = utmSource.toLowerCase();
  if (normalized.includes("facebook") || normalized.includes("instagram") || normalized === "meta" || normalized === "fb" || normalized === "ig") {
    return "meta";
  }
  if (normalized.includes("google") || normalized === "adwords") {
    return "google";
  }
  if (normalized.includes("tiktok") || normalized === "tt") {
    return "tiktok";
  }
  if (normalized.includes("reddit")) {
    return "reddit";
  }
  if (normalized.includes("twitter") || normalized === "x") {
    return "x";
  }
  if (normalized.includes("bing") || normalized.includes("microsoft")) {
    return "microsoft";
  }
  if (normalized.includes("snap")) {
    return "snap";
  }
  if (normalized.includes("pinterest")) {
    return "pinterest";
  }
  if (normalized.includes("exoclick")) {
    return "exoclick";
  }
  if (normalized.includes("trafficstars")) {
    return "trafficstars";
  }
  if (normalized.includes("clickadu")) {
    return "clickadu";
  }
  if (normalized.includes("juicyads")) {
    return "juicyads";
  }
  if (normalized === "email" || normalized === "newsletter") {
    return "email";
  }
  return "referral";
}
function inferPrimaryClickRef(clickIds) {
  for (const definition of CLICK_ID_DEFINITIONS) {
    const value = clickIds[definition.type];
    if (value !== void 0 && value !== "") {
      return { type: definition.type, value };
    }
  }
  return void 0;
}
function buildTouchPointFromInputs(inputs) {
  const { params, landingUrl, referrer, cookies, capturedAt, captureExtras = true } = inputs;
  const clickIds = extractClickIdsFromUrl(params);
  const utm = extractUtmFromUrl(params);
  const platformDetails = extractPlatformDetailsFromUrl(params, { captureExtras });
  const explicitNetwork = params.get("network") ?? void 0;
  const network = inferNetwork(clickIds, utm == null ? void 0 : utm.source, explicitNetwork);
  const primaryClickRef = inferPrimaryClickRef(clickIds);
  const networkIds = deriveNetworkIds(platformDetails);
  const pixelIds = cookies !== void 0 ? extractPixelIdsFromCookies(cookies) : void 0;
  const touchPoint = {
    capturedAt,
    network,
    clickIds
  };
  if (primaryClickRef !== void 0) {
    touchPoint.primaryClickRef = primaryClickRef;
  }
  if (utm !== void 0) {
    touchPoint.utm = utm;
  }
  if (platformDetails !== void 0) {
    touchPoint.platformDetails = platformDetails;
  }
  if (networkIds !== void 0) {
    touchPoint.networkIds = networkIds;
  }
  if (pixelIds !== void 0) {
    touchPoint.pixelIds = pixelIds;
  }
  if (referrer !== void 0 && referrer !== "") {
    touchPoint.referrer = referrer;
  }
  if (landingUrl !== void 0 && landingUrl !== "") {
    touchPoint.landingUrl = landingUrl;
  }
  const sessionId = params.get("session_id") ?? void 0;
  if (sessionId !== void 0 && sessionId !== "") {
    touchPoint.sessionId = sessionId;
  }
  const funnelId = params.get("funnel_id") ?? void 0;
  if (funnelId !== void 0 && funnelId !== "") {
    touchPoint.funnelId = funnelId;
  }
  return touchPoint;
}
function deriveNetworkIds(platformDetails) {
  if (platformDetails === void 0) {
    return void 0;
  }
  const ids = {};
  let hasAny = false;
  if (platformDetails.adId !== void 0) {
    ids.adId = platformDetails.adId;
    hasAny = true;
  }
  if (platformDetails.adGroupId !== void 0) {
    ids.adGroupId = platformDetails.adGroupId;
    hasAny = true;
  }
  if (platformDetails.campaignId !== void 0) {
    ids.campaignId = platformDetails.campaignId;
    hasAny = true;
  }
  if (platformDetails.accountId !== void 0) {
    ids.accountId = platformDetails.accountId;
    hasAny = true;
  }
  return hasAny ? ids : void 0;
}
function canonicalJsonStringify(value) {
  return JSON.stringify(sortKeys(value));
}
function sortKeys(value) {
  if (value === null || typeof value !== "object") {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(sortKeys);
  }
  const source = value;
  const keys = Object.keys(source).sort();
  const sorted = {};
  for (const key of keys) {
    const child = source[key];
    if (child !== void 0) {
      sorted[key] = sortKeys(child);
    }
  }
  return sorted;
}
function isRecognizedAcquisitionHit(touch) {
  if (hasAnyNonEmptyStringValue(touch.clickIds)) {
    return true;
  }
  if (touch.utm !== void 0 && hasAnyNonEmptyStringValue(touch.utm)) {
    return true;
  }
  if (touch.platformDetails !== void 0 && hasRecognizedPlatformDetail(touch.platformDetails)) {
    return true;
  }
  return false;
}
function hasRecognizedPlatformDetail(platformDetails) {
  for (const [key, value] of Object.entries(platformDetails)) {
    if (key === "extraParams") {
      continue;
    }
    if (typeof value === "string" && value !== "") {
      return true;
    }
  }
  return false;
}
function hasAnyNonEmptyStringValue(record) {
  for (const value of Object.values(record)) {
    if (typeof value === "string" && value !== "") {
      return true;
    }
  }
  return false;
}
function isNewerRecognizedHit(candidate, current) {
  if (!isRecognizedAcquisitionHit(candidate)) {
    return false;
  }
  if (current === void 0) {
    return true;
  }
  return candidate.capturedAt > current.capturedAt;
}
const UTM_IDENTITY_FIELDS = ["medium", "campaign", "term", "content"];
const PLATFORM_IDENTITY_FIELDS = ["adId", "adGroupId", "campaignId", "accountId"];
function mergeAttribution(current, candidate) {
  const merged = {
    version: current.version,
    anonymousId: current.anonymousId,
    capturedAt: current.capturedAt
  };
  if (current.firstTouch !== void 0) {
    merged.firstTouch = current.firstTouch;
  } else if (isRecognizedAcquisitionHit(candidate)) {
    merged.firstTouch = withRederivedPrimaryClickRef(candidate);
  }
  if (isNewerRecognizedHit(candidate, current.lastTouch)) {
    merged.lastTouch = withRederivedPrimaryClickRef(withRetainedClickIds(candidate, current.lastTouch));
  } else if (current.lastTouch !== void 0) {
    merged.lastTouch = current.lastTouch;
  }
  if (current.partners !== void 0) {
    merged.partners = current.partners;
  }
  if (current.consent !== void 0) {
    merged.consent = current.consent;
  }
  return merged;
}
function mergePartners(current, patch) {
  const existing = current.partners ?? {};
  const merged = { ...existing };
  for (const [key, value] of Object.entries(patch)) {
    if (value !== void 0 && value !== "") {
      merged[key] = value;
    }
  }
  return { ...current, partners: merged };
}
function withRetainedClickIds(candidate, previous) {
  if (previous === void 0 || hasClickIds(candidate) || !hasClickIds(previous) || candidate.network !== previous.network || !hasMatchingUtm(candidate, previous) && !hasMatchingPlatformDetails(candidate, previous)) {
    return candidate;
  }
  return { ...candidate, clickIds: previous.clickIds };
}
function hasClickIds(touch) {
  return Object.values(touch.clickIds).some((value) => value !== void 0 && value !== "");
}
function hasMatchingUtm(candidate, previous) {
  if (candidate.utm === void 0 || previous.utm === void 0 || candidate.utm.source !== previous.utm.source) {
    return false;
  }
  let hasMatchingIdentityField = false;
  for (const field of UTM_IDENTITY_FIELDS) {
    const candidateValue = candidate.utm[field];
    const previousValue = previous.utm[field];
    if (candidateValue !== void 0 && previousValue !== void 0) {
      if (candidateValue !== previousValue) {
        return false;
      }
      hasMatchingIdentityField = true;
    }
  }
  return hasMatchingIdentityField;
}
function hasMatchingPlatformDetails(candidate, previous) {
  if (candidate.platformDetails === void 0 || previous.platformDetails === void 0) {
    return false;
  }
  let hasMatchingIdentityField = false;
  for (const field of PLATFORM_IDENTITY_FIELDS) {
    const candidateValue = candidate.platformDetails[field];
    const previousValue = previous.platformDetails[field];
    if (candidateValue !== void 0 && previousValue !== void 0) {
      if (candidateValue !== previousValue) {
        return false;
      }
      hasMatchingIdentityField = true;
    }
  }
  return hasMatchingIdentityField;
}
function withRederivedPrimaryClickRef(touch) {
  const primaryClickRef = inferPrimaryClickRef(touch.clickIds);
  if (primaryClickRef === void 0) {
    const rest = { ...touch };
    delete rest.primaryClickRef;
    return rest;
  }
  return { ...touch, primaryClickRef };
}
function captureIntoContext(prev, input) {
  const touchPoint = buildTouchPointFromInputs({
    params: input.params,
    landingUrl: input.landingUrl,
    referrer: input.referrer,
    cookies: input.cookies,
    capturedAt: input.now
  });
  const isFirstCapture = prev === void 0;
  const base = prev ?? {
    version: CURRENT_ATTRIBUTION_VERSION,
    anonymousId: input.anonymousId,
    capturedAt: input.now
  };
  let next = mergeAttribution(base, touchPoint);
  if (input.legacyPartners !== void 0) {
    next = mergePartners(next, input.legacyPartners);
  }
  return { next, isFirstCapture };
}
function mergeAttributionContexts(current, incoming, options = {}) {
  if (current === void 0 || incoming === void 0) {
    return current ?? incoming;
  }
  if (current.version !== incoming.version) {
    return incoming;
  }
  let merged = {
    ...current,
    capturedAt: Math.min(current.capturedAt, incoming.capturedAt)
  };
  if (incoming.firstTouch !== void 0) {
    const firstTouchMerged = mergeAttribution(merged, incoming.firstTouch);
    if (merged.firstTouch === void 0 && firstTouchMerged.firstTouch !== void 0) {
      merged = { ...merged, firstTouch: firstTouchMerged.firstTouch };
    }
  }
  if (incoming.lastTouch !== void 0) {
    merged = mergeAttribution(merged, incoming.lastTouch);
  }
  if (incoming.partners !== void 0) {
    merged = mergePartners(merged, incoming.partners);
  }
  merged = options.funnelIdentifiers === "current" ? preserveCurrentFunnelIdentifiers(merged, incoming.lastTouch) : preserveIncomingFunnelIdentifiers(merged, incoming.lastTouch);
  const currentConsent = current.consent;
  const incomingConsent = incoming.consent;
  if (options.consent !== "current" && incomingConsent !== void 0 && (currentConsent === void 0 || incomingConsent.at > currentConsent.at)) {
    merged = { ...merged, consent: incomingConsent };
  }
  return merged;
}
function preserveIncomingFunnelIdentifiers(current, incomingLastTouch) {
  const incomingSessionId = incomingLastTouch == null ? void 0 : incomingLastTouch.sessionId;
  const incomingFunnelId = incomingLastTouch == null ? void 0 : incomingLastTouch.funnelId;
  const hasIncomingFunnelIdentifier = incomingSessionId !== void 0 && incomingSessionId !== "" || incomingFunnelId !== void 0 && incomingFunnelId !== "";
  if (!hasIncomingFunnelIdentifier) {
    return current;
  }
  if (current.lastTouch === void 0) {
    return { ...current, lastTouch: incomingLastTouch };
  }
  const lastTouch = { ...current.lastTouch };
  if (incomingSessionId !== void 0 && incomingSessionId !== "") {
    lastTouch.sessionId = incomingSessionId;
  } else {
    delete lastTouch.sessionId;
  }
  if (incomingFunnelId !== void 0 && incomingFunnelId !== "") {
    lastTouch.funnelId = incomingFunnelId;
  } else {
    delete lastTouch.funnelId;
  }
  return { ...current, lastTouch };
}
function preserveCurrentFunnelIdentifiers(current, incomingLastTouch) {
  const incomingSessionId = incomingLastTouch == null ? void 0 : incomingLastTouch.sessionId;
  const incomingFunnelId = incomingLastTouch == null ? void 0 : incomingLastTouch.funnelId;
  const shouldCopySessionId = incomingSessionId !== void 0 && incomingSessionId !== "";
  const shouldCopyFunnelId = incomingFunnelId !== void 0 && incomingFunnelId !== "";
  if (!shouldCopySessionId && !shouldCopyFunnelId) {
    return current;
  }
  if (current.lastTouch === void 0) {
    return { ...current, lastTouch: incomingLastTouch };
  }
  const lastTouch = { ...current.lastTouch };
  let hasChanged = false;
  if (shouldCopySessionId && (lastTouch.sessionId === void 0 || lastTouch.sessionId === "")) {
    lastTouch.sessionId = incomingSessionId;
    hasChanged = true;
  }
  if (shouldCopyFunnelId && (lastTouch.funnelId === void 0 || lastTouch.funnelId === "")) {
    lastTouch.funnelId = incomingFunnelId;
    hasChanged = true;
  }
  return hasChanged ? { ...current, lastTouch } : current;
}
const TEXT_ENCODER = new TextEncoder();
const TEXT_DECODER_LAX = new TextDecoder("utf-8", { fatal: false });
const TEXT_DECODER_STRICT = new TextDecoder("utf-8", { fatal: true });
function encodeUtf8(input) {
  return TEXT_ENCODER.encode(input);
}
function decodeUtf8(bytes) {
  return TEXT_DECODER_LAX.decode(bytes);
}
function decodeUtf8Strict(bytes) {
  return TEXT_DECODER_STRICT.decode(bytes);
}
function parseHandoffParam(encoded) {
  let bytes;
  try {
    bytes = decodeBase64Url(encoded);
  } catch {
    return null;
  }
  if (bytes.length > MAX_ENVELOPE_SIZE_BYTES) {
    return null;
  }
  let parsed;
  try {
    parsed = JSON.parse(decodeUtf8Strict(bytes));
  } catch {
    return null;
  }
  if (!isHandoffShape(parsed)) {
    return null;
  }
  if (!isAttributionContext(parsed.d)) {
    return null;
  }
  return parsed;
}
function isHandoffShape(value) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return false;
  }
  const record = value;
  for (const key of Object.keys(record)) {
    if (key !== "v" && key !== "d" && key !== "s") {
      return false;
    }
  }
  if (typeof record["v"] !== "number" || !Number.isFinite(record["v"])) {
    return false;
  }
  if (typeof record["d"] !== "object" || record["d"] === null || Array.isArray(record["d"])) {
    return false;
  }
  if (record["s"] !== void 0 && typeof record["s"] !== "string") {
    return false;
  }
  return true;
}
async function verifyHandoffPayload(payload, verify) {
  if (payload.s === void 0 || payload.s === "") {
    return false;
  }
  let signatureBytes;
  try {
    signatureBytes = decodeBase64Url(payload.s);
  } catch {
    return false;
  }
  const canonicalContextBytes = encodeUtf8(canonicalJsonStringify(payload.d));
  return verify(canonicalContextBytes, signatureBytes);
}
async function consumeHandoffIntoContext(prev, encoded, options = {}) {
  const parsed = parseHandoffParam(encoded);
  if (parsed === null) {
    return void 0;
  }
  if (parsed.v !== CURRENT_HANDOFF_VERSION) {
    return void 0;
  }
  if (parsed.d.version !== CURRENT_ATTRIBUTION_VERSION) {
    return void 0;
  }
  const isSignatureVerified = options.verifier !== void 0 ? await verifyHandoffPayload(parsed, options.verifier) : false;
  const current = prev ?? {
    version: parsed.d.version,
    anonymousId: parsed.d.anonymousId,
    capturedAt: parsed.d.capturedAt
  };
  const next = mergeAttributionContexts(current, parsed.d, {
    funnelIdentifiers: "current",
    consent: "current"
  });
  if (next === void 0) {
    return void 0;
  }
  return { next, isSignatureVerified, handoffAnonymousId: parsed.d.anonymousId };
}
async function serializeHandoffParam(context, sign) {
  const canonicalContextJson = canonicalJsonStringify(context);
  const canonicalContextBytes = encodeUtf8(canonicalContextJson);
  const payload = {
    v: CURRENT_HANDOFF_VERSION,
    d: context
  };
  if (sign !== void 0) {
    const signatureBytes = await sign(canonicalContextBytes);
    payload.s = encodeBase64Url(signatureBytes);
  }
  const payloadJson = canonicalJsonStringify(payload);
  const payloadBytes = encodeUtf8(payloadJson);
  if (payloadBytes.length > MAX_ENVELOPE_SIZE_BYTES) {
    throw new Error(`serializeHandoffParam: envelope exceeds ${MAX_ENVELOPE_SIZE_BYTES}-byte limit (got ${payloadBytes.length})`);
  }
  return {
    encoded: encodeBase64Url(payloadBytes),
    sizeBytes: payloadBytes.length
  };
}
var MediaFileConnectionType = /* @__PURE__ */ ((MediaFileConnectionType2) => {
  MediaFileConnectionType2["CHARACTER"] = "character";
  MediaFileConnectionType2["PERSONA"] = "persona";
  MediaFileConnectionType2["USER"] = "user";
  MediaFileConnectionType2["LOREBOOK"] = "lorebook";
  return MediaFileConnectionType2;
})(MediaFileConnectionType || {});
var MediaFileSource = /* @__PURE__ */ ((MediaFileSource2) => {
  MediaFileSource2["GENERATED"] = "generated";
  MediaFileSource2["UPLOADED"] = "uploaded";
  return MediaFileSource2;
})(MediaFileSource || {});
var MediaFileStatus = /* @__PURE__ */ ((MediaFileStatus2) => {
  MediaFileStatus2["AVAILABLE"] = "available";
  MediaFileStatus2["BANNED"] = "banned";
  MediaFileStatus2["DELETED"] = "deleted";
  MediaFileStatus2["EXPIRED"] = "expired";
  MediaFileStatus2["EXPIRING"] = "expiring";
  return MediaFileStatus2;
})(MediaFileStatus || {});
var MediaFileUsedAs = /* @__PURE__ */ ((MediaFileUsedAs2) => {
  MediaFileUsedAs2["CHARACTER_AVATAR"] = "character_avatar";
  MediaFileUsedAs2["PERSONA_AVATAR"] = "persona_avatar";
  MediaFileUsedAs2["USER_AVATAR"] = "user_avatar";
  MediaFileUsedAs2["CONVERSATION_IMAGE"] = "conversation_image";
  MediaFileUsedAs2["CHARACTER_MEDIA_ASSETS"] = "character_media_assets";
  MediaFileUsedAs2["LOREBOOK_AVATAR"] = "lorebook_avatar";
  return MediaFileUsedAs2;
})(MediaFileUsedAs || {});
var MediaFileVisibility = /* @__PURE__ */ ((MediaFileVisibility2) => {
  MediaFileVisibility2["PUBLIC"] = "public";
  MediaFileVisibility2["PRIVATE"] = "private";
  return MediaFileVisibility2;
})(MediaFileVisibility || {});
var MediaSortOrder = /* @__PURE__ */ ((MediaSortOrder2) => {
  MediaSortOrder2["LATEST"] = "latest";
  MediaSortOrder2["OLDEST"] = "oldest";
  MediaSortOrder2["MOST_KEPT"] = "most_kept";
  MediaSortOrder2["RECENTLY_ADDED"] = "recently_added";
  return MediaSortOrder2;
})(MediaSortOrder || {});
const ADMIN_EDITS_MAX_KEPT = 100;
function appendAdminEdits(existing, added) {
  return [...existing ?? [], ...added].slice(-ADMIN_EDITS_MAX_KEPT);
}
function currentAdminEdit(edits, path, currentText) {
  const latest = [...edits ?? []].reverse().find((edit) => edit.path === path);
  if (!latest || latest.after === void 0 || latest.after !== currentText) {
    return void 0;
  }
  return latest;
}
function originalTextBeforeAdminEdits(edits, path, currentText) {
  const latest = currentAdminEdit(edits, path, currentText);
  if (!latest) {
    return void 0;
  }
  const forPath = (edits ?? []).filter((edit) => edit.path === path);
  let original = latest.before;
  for (let idx = forPath.lastIndexOf(latest) - 1; idx >= 0; idx -= 1) {
    const earlier = forPath[idx];
    if ((earlier == null ? void 0 : earlier.after) !== original) {
      break;
    }
    original = earlier.before;
  }
  return original;
}
function formatModerationTextLabel(text) {
  return [text.groupLabel, text.fieldLabel].filter((part) => part.trim().length > 0).join(" · ");
}
function indexModerationTexts(texts) {
  return new Map(texts.map((text) => [text.path, text]));
}
const IMAGE_MODERATION_SCORES = ["minor", "sexual_activity", "sexual_display", "erotica"];
const imageScoresOverThreshold = (signals) => IMAGE_MODERATION_SCORES.filter((score) => {
  const value = signals.scores[score];
  return value !== void 0 && value > signals.thresholds[score];
});
const UNDER_AGE_CATEGORY = "under_age";
function dropOverlappingHits(hits) {
  const byPriority = [...hits].sort((left, right) => right.end - right.start - (left.end - left.start) || left.start - right.start);
  const kept = [];
  for (const hit of byPriority) {
    if (!kept.some((other) => hit.start < other.end && other.start < hit.end)) {
      kept.push(hit);
    }
  }
  return kept.sort((left, right) => left.start - right.start);
}
function dropOverlappingHitsPerCategory(hits) {
  const byCategory = /* @__PURE__ */ new Map();
  for (const hit of hits) {
    byCategory.set(hit.category, [...byCategory.get(hit.category) ?? [], hit]);
  }
  return [...byCategory.values()].flatMap(dropOverlappingHits).sort((left, right) => left.start - right.start || right.end - left.end);
}
const REGEX_SPECIAL_CHARS = /[.*+?^${}()|[\]\\]/g;
function compileKeywordMatcher(config) {
  const keywords = [];
  for (const [category, words] of Object.entries(config.categories)) {
    for (const keyword of words) {
      keywords.push({ keyword, category, pattern: new RegExp(`\\b${keyword.replace(REGEX_SPECIAL_CHARS, "\\$&")}\\b`, "gi") });
    }
  }
  const underage = [];
  for (const source of config.underage_patterns) {
    try {
      underage.push(new RegExp(source, "gi"));
    } catch {
    }
  }
  const findHits = (text) => {
    const hits = [];
    if (!text) {
      return hits;
    }
    for (const { keyword, category, pattern } of keywords) {
      pattern.lastIndex = 0;
      for (const match of text.matchAll(pattern)) {
        hits.push({ keyword, category, start: match.index, end: match.index + match[0].length });
      }
    }
    for (const pattern of underage) {
      pattern.lastIndex = 0;
      for (const match of text.matchAll(pattern)) {
        if (match[0].length > 0) {
          hits.push({ keyword: match[0], category: UNDER_AGE_CATEGORY, start: match.index, end: match.index + match[0].length });
        }
      }
    }
    return dropOverlappingHitsPerCategory(hits);
  };
  const scan = (texts) => {
    const existFlags = /* @__PURE__ */ new Set();
    const existKeywords = /* @__PURE__ */ new Set();
    for (const text of texts) {
      if (!text) {
        continue;
      }
      for (const { keyword, category, pattern } of keywords) {
        pattern.lastIndex = 0;
        if (pattern.test(text)) {
          existFlags.add(category);
          existKeywords.add(keyword);
        }
      }
    }
    const joined = texts.join(" ");
    for (const pattern of underage) {
      pattern.lastIndex = 0;
      const match = pattern.exec(joined);
      if (match) {
        existFlags.add(UNDER_AGE_CATEGORY);
        existKeywords.add(match[0]);
      }
    }
    return { existFlags: Array.from(existFlags), existKeywords: Array.from(existKeywords) };
  };
  return { findHits, scan };
}
function toHighlightSegments(text, hits) {
  const segments = [];
  let cursor = 0;
  for (const hit of dropOverlappingHits(hits)) {
    if (hit.start < cursor) {
      continue;
    }
    if (hit.start > cursor) {
      segments.push({ text: text.slice(cursor, hit.start) });
    }
    segments.push({ text: text.slice(hit.start, hit.end), hit });
    cursor = hit.end;
  }
  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor) });
  }
  return segments;
}
function validateNegativeKeywordConfig(value) {
  const issues = [];
  const record = value ?? {};
  const categories = record["categories"];
  if (typeof categories !== "object" || categories === null || Array.isArray(categories)) {
    issues.push({ field: "categories", message: "must be an object of category → string[]" });
  } else {
    const entries = Object.entries(categories);
    if (entries.length === 0) {
      issues.push({ field: "categories", message: "must contain at least one category" });
    }
    for (const [category, words] of entries) {
      if (!Array.isArray(words) || words.some((word) => typeof word !== "string" || word.trim().length === 0)) {
        issues.push({ field: "categories", message: `${category}: must be a list of non-empty strings` });
      }
    }
  }
  const patterns = record["underage_patterns"];
  if (!Array.isArray(patterns)) {
    issues.push({ field: "underage_patterns", message: "must be a list of regex sources" });
  } else {
    patterns.forEach((source, idx) => {
      if (typeof source !== "string") {
        issues.push({ field: "underage_patterns", message: `[${idx}]: must be a string` });
        return;
      }
      try {
        new RegExp(source, "i");
      } catch {
        issues.push({ field: "underage_patterns", message: `[${idx}]: invalid regex` });
      }
    });
  }
  return issues;
}
const isNumber = (value) => typeof value === "number" && Number.isFinite(value);
const isRecord$1 = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
const isWeights = (value) => isRecord$1(value) && Object.values(value).every(isNumber);
function isModerationRiskModel(value) {
  if (!isRecord$1(value)) {
    return false;
  }
  const { category_weights, per_keyword_hit, signals, reports, levels } = value;
  return isWeights(category_weights) && isNumber(per_keyword_hit) && isWeights(signals) && isRecord$1(reports) && isNumber(reports["per_open_report"]) && isWeights(reports["reason_code_weights"]) && isRecord$1(levels) && isNumber(levels["high"]) && isNumber(levels["medium"]);
}
const MODERATION_CONFIG_CODE_VERSION = "code";
const MODERATION_RISK_SIGNALS = ["is_nsfw", "cover_is_nsfw", "cover_minor_over_threshold", "cover_nudity_over_threshold"];
const DEFAULT_MODERATION_RISK_MODEL = {
  category_weights: {
    under_age: 100,
    bestiality: 60,
    incest: 40,
    rape_force: 40,
    mutilation: 30,
    tos: 20,
    irls: 20,
    obscenity: 5,
    franchises: 5
  },
  per_keyword_hit: 2,
  signals: {
    is_nsfw: 5,
    cover_is_nsfw: 5,
    cover_minor_over_threshold: 60,
    cover_nudity_over_threshold: 15
  },
  reports: {
    per_open_report: 5,
    reason_code_weights: {
      "RB-CB042": 60,
      "RB-IA043": 60,
      "RB-YD044": 60,
      "RB-NH045": 60,
      "RB-YP046": 60,
      "RB-NC047": 40,
      "RB-IN048": 40,
      "RB-FR049": 40,
      "RB-EV050": 40,
      "RB-RH051": 30,
      "RB-GL052": 30,
      "RB-CG053": 30,
      "RB-SH054": 30,
      "RB-OI055": 10,
      "RB-DD056": 10,
      "RB-IR057": 10,
      "RB-EC058": 10,
      "RB-UI059": 20,
      "RB-UP060": 20,
      "RB-DX061": 30,
      "RB-NO062": 10,
      "RB-UO063": 10,
      "RB-TM064": 10,
      "RB-SB065": 10,
      "RB-AD066": 10,
      "RB-IP067": 20,
      "RB-EG068": 20,
      "RB-PC069": 20,
      "RB-GM070": 10,
      "RB-HI035": 20,
      "RB-JB036": 20,
      "RB-PI037": 30,
      "RB-IH038": 20,
      "RB-EM039": 20,
      "RB-FS040": 20,
      "RB-NF041": 10
    }
  },
  levels: { high: 60, medium: 25 }
};
const COVER_NUDITY_SCORES = /* @__PURE__ */ new Set(["sexual_activity", "sexual_display", "erotica"]);
const weightOf = (weights, key) => Object.prototype.hasOwnProperty.call(weights, key) ? weights[key] ?? 0 : 0;
const sumDistinct = (keys, weights) => [...new Set(keys ?? [])].reduce((total, key) => total + weightOf(weights, key), 0);
const countOf = (value) => value !== void 0 && Number.isFinite(value) && value > 0 ? value : 0;
function activeSignals(signals) {
  const overThreshold = signals.cover_scores_over_threshold ?? [];
  const active = {
    is_nsfw: signals.is_nsfw === true,
    cover_is_nsfw: signals.cover_is_nsfw === true,
    cover_minor_over_threshold: overThreshold.includes("minor"),
    cover_nudity_over_threshold: overThreshold.some((score) => COVER_NUDITY_SCORES.has(score))
  };
  return MODERATION_RISK_SIGNALS.filter((signal) => active[signal]);
}
function moderationRiskLevel(score, levels = DEFAULT_MODERATION_RISK_MODEL.levels) {
  if (score >= levels.high) {
    return "high";
  }
  if (score >= levels.medium) {
    return "medium";
  }
  return "low";
}
function computeRisk(signals, riskModel = DEFAULT_MODERATION_RISK_MODEL) {
  const model = riskModel ?? DEFAULT_MODERATION_RISK_MODEL;
  const score = sumDistinct(signals.flag_categories, model.category_weights) + countOf(signals.keyword_hits) * model.per_keyword_hit + sumDistinct(activeSignals(signals), model.signals) + countOf(signals.open_reports) * model.reports.per_open_report + sumDistinct(signals.report_reason_codes, model.reports.reason_code_weights);
  return { score, level: moderationRiskLevel(score, model.levels) };
}
const CYRB53 = {
  SEED_1: 3735928559,
  SEED_2: 1103547991,
  MUL_1: 2654435761,
  MUL_2: 1597334677,
  MIX_1: 2246822507,
  MIX_2: 3266489909,
  SHIFT_HI: 16,
  SHIFT_LO: 13,
  HIGH_MASK: 2097151,
  UINT32_RANGE: 4294967296,
  HEX: 16
};
function hashModerationText(text) {
  let h1 = CYRB53.SEED_1;
  let h2 = CYRB53.SEED_2;
  for (let idx = 0; idx < text.length; idx += 1) {
    const code = text.charCodeAt(idx);
    h1 = Math.imul(h1 ^ code, CYRB53.MUL_1);
    h2 = Math.imul(h2 ^ code, CYRB53.MUL_2);
  }
  h1 = Math.imul(h1 ^ h1 >>> CYRB53.SHIFT_HI, CYRB53.MIX_1) ^ Math.imul(h2 ^ h2 >>> CYRB53.SHIFT_LO, CYRB53.MIX_2);
  h2 = Math.imul(h2 ^ h2 >>> CYRB53.SHIFT_HI, CYRB53.MIX_1) ^ Math.imul(h1 ^ h1 >>> CYRB53.SHIFT_LO, CYRB53.MIX_2);
  return (CYRB53.UINT32_RANGE * (CYRB53.HIGH_MASK & h2) + (h1 >>> 0)).toString(CYRB53.HEX);
}
const MARK_SCOPE_SEPARATOR = "␟";
function reviewMarkContent(text) {
  return text.markScope === void 0 ? text.text : `${text.markScope}${MARK_SCOPE_SEPARATOR}${text.text}`;
}
function isReviewMarkStale(mark, currentText) {
  return currentText === void 0 || mark.text_hash !== hashModerationText(currentText);
}
function currentReviewMark(marks, path, currentText) {
  const mark = marks == null ? void 0 : marks[path];
  if (!mark || isReviewMarkStale(mark, currentText)) {
    return void 0;
  }
  return mark;
}
function currentCoverReviewMark(mark, coverUrl) {
  if (!mark || coverUrl === void 0 || mark.cover_url !== coverUrl) {
    return void 0;
  }
  return mark;
}
function applyReviewMarksPatch(marks, patch) {
  const next = { ...marks };
  for (const [path, mark] of Object.entries(patch)) {
    if (mark === null) {
      delete next[path];
    } else {
      next[path] = mark;
    }
  }
  return next;
}
function fixReasonsFromReviewMarks(marks, textsByPath) {
  var _a;
  const reasons = {};
  for (const [path, mark] of Object.entries(marks ?? {})) {
    const note = (_a = mark.note) == null ? void 0 : _a.trim();
    if (mark.state === "flag" && note && !isReviewMarkStale(mark, textsByPath.get(path))) {
      reasons[path] = note;
    }
  }
  return reasons;
}
function findPublishBlockers(input) {
  var _a, _b, _c;
  const blockers = [];
  for (const text of input.texts) {
    if (text.path.startsWith("tags[")) {
      continue;
    }
    const mark = currentReviewMark(input.marks, text.path, reviewMarkContent(text));
    if ((mark == null ? void 0 : mark.state) === "flag") {
      blockers.push({ kind: "flagged_text", path: text.path });
    } else if (!mark && ((_b = (_a = input.marks) == null ? void 0 : _a[text.path]) == null ? void 0 : _b.state) === "flag") {
      blockers.push({ kind: "stale_flag", path: text.path });
    } else if (!mark && input.findHits(text.text).length > 0) {
      blockers.push({ kind: "unreviewed_hit", path: text.path });
    }
  }
  if (((_c = currentCoverReviewMark(input.coverMark, input.coverUrl)) == null ? void 0 : _c.state) === "flag") {
    blockers.push({ kind: "flagged_cover" });
  }
  return blockers;
}
const plural = (value, word) => `${value} ${word}${value === 1 ? "" : "s"}`;
function describePublishBlockers(blockers) {
  const count = (kind) => blockers.filter((blocker) => blocker.kind === kind).length;
  const flagged = count("flagged_text");
  const unreviewed = count("unreviewed_hit");
  const stale = count("stale_flag");
  return [
    flagged > 0 ? `${plural(flagged, "text")} flagged by a moderator` : "",
    unreviewed > 0 ? `${plural(unreviewed, "flagged text")} not reviewed` : "",
    stale > 0 ? `${plural(stale, "flag")} to review again after an edit` : "",
    count("flagged_cover") > 0 ? "cover image flagged" : ""
  ].filter(Boolean).join(" · ");
}
const PageBlockAudience = {
  Guest: "guest",
  Authenticated: "authenticated"
};
const PAGE_BLOCK_AUDIENCES = Object.values(PageBlockAudience);
const isPageBlockAudience = createAllowlistGuard(PAGE_BLOCK_AUDIENCES);
const PageBlockContentKind = {
  Chatbot: "chatbot"
};
const PAGE_BLOCK_CONTENT_KINDS = Object.values(PageBlockContentKind);
const isPageBlockContentKind = createAllowlistGuard(PAGE_BLOCK_CONTENT_KINDS);
const PageBlockFilterMatch = {
  All: "all",
  Any: "any"
};
const PAGE_BLOCK_FILTER_MATCHES = Object.values(PageBlockFilterMatch);
const isPageBlockFilterMatch = createAllowlistGuard(PAGE_BLOCK_FILTER_MATCHES);
const PageBlockFilterMode = {
  Include: "include",
  Exclude: "exclude"
};
const PAGE_BLOCK_FILTER_MODES = Object.values(PageBlockFilterMode);
const isPageBlockFilterMode = createAllowlistGuard(PAGE_BLOCK_FILTER_MODES);
const PageBlockSortPreset = {
  RatingScore: "rating_score",
  Trending: "trending",
  Latest: "latest",
  Popular: "popular"
};
const PAGE_BLOCK_SORT_PRESETS = Object.values(PageBlockSortPreset);
const isPageBlockSortPreset = createAllowlistGuard(PAGE_BLOCK_SORT_PRESETS);
const PageBlockType = {
  ContentRow: "content-row",
  Recommendation: "recommendation-row"
};
const PAGE_BLOCK_TYPES = Object.values(PageBlockType);
const isPageBlockType = createAllowlistGuard(PAGE_BLOCK_TYPES);
const DISCOVERY_PAGE_KEY = "discover";
const RULEBOOK_MIN_TAGS = 2;
const RULEBOOK_LIMITS = {
  MAX_METERS: 10,
  MAX_CLOCKS: 1,
  MAX_VISIBLE_METERS: 4,
  MAX_PIPS_STEPS: 10,
  MIN_DICE_SIDES: 2,
  MAX_DICE_SIDES: 1e3,
  MAX_AI_ROWS_PER_METER: 6,
  MAX_CONDITION_LENGTH: 300,
  MAX_LEVELS_PER_METER: 12,
  MAX_COMBINED_RULES: 10,
  MAX_CONDITIONS_PER_RULE: 6,
  MAX_KEYWORD_DRIVERS_PER_METER: 20,
  MAX_WORDS_PER_KEYWORD_DRIVER: 50,
  MAX_KEYWORD_CHARS: 64,
  MAX_INSTRUCTION_TOKENS: 1200,
  /** Hard error above this; between MAX_INSTRUCTION_TOKENS and this is the `instruction_tokens` warning. */
  MAX_INSTRUCTION_TOKENS_HARD: 1800,
  MAX_ID_CHARS: 64,
  MAX_LABEL_CHARS: 40,
  MAX_ICON_CHARS: 32,
  MAX_UNIT_CHARS: 16,
  MAX_LEVEL_LABEL_CHARS: 40,
  MAX_CAPTION_CHARS: 120,
  MAX_INSTRUCTION_CHARS: 600,
  MAX_CLOCK_START_CHARS: 16,
  MAX_CLOCK_STEP_MINUTES: 525600,
  MAX_ABS_NUMBER: 1e6,
  MAX_CLOCK_DIMENSIONS: 2,
  /** `MeterAiDriver.extract_hint` length cap. */
  MAX_EXTRACT_HINT_CHARS: 200,
  /** `CounterMeter.decimals` upper bound (fractional digits kept on number meters). */
  MAX_COUNTER_DECIMALS: 2,
  /** Default per-turn caps in extract mode (amounts read from the text need a wide envelope). */
  EXTRACT_PER_TURN_CAP: 1e6,
  /** Default per-turn caps for AI rows in rules mode (each row fires a ±1 gate). */
  RULES_PER_TURN_CAP: 99
};
const RULEBOOK_ID_PATTERN = /^[a-z][a-z0-9_-]{0,63}$/;
const RULEBOOK_RESERVED_IDS = ["constructor", "prototype", "__proto__"];
var MeterType = /* @__PURE__ */ ((MeterType2) => {
  MeterType2["BAR"] = "bar";
  MeterType2["PIPS"] = "pips";
  MeterType2["NUMBER"] = "number";
  MeterType2["CLOCK"] = "clock";
  MeterType2["DICE"] = "dice";
  return MeterType2;
})(MeterType || {});
var RulebookVisibility = /* @__PURE__ */ ((RulebookVisibility2) => {
  RulebookVisibility2["PUBLIC"] = "public";
  RulebookVisibility2["PRIVATE"] = "private";
  RulebookVisibility2["PERMANENTLY_PRIVATE"] = "permanently_private";
  return RulebookVisibility2;
})(RulebookVisibility || {});
var RulebookStatus = /* @__PURE__ */ ((RulebookStatus2) => {
  RulebookStatus2["ACTIVE"] = "active";
  RulebookStatus2["IN_MODERATION"] = "in_moderation";
  RulebookStatus2["MODERATION_FAILED"] = "moderation_failed";
  RulebookStatus2["DRAFT"] = "draft";
  return RulebookStatus2;
})(RulebookStatus || {});
const AI_RULE_COOLDOWN_ONCE = -1;
const MAX_AI_RULE_COOLDOWN = 999;
const MAX_DECAY_EVERY = 99;
var MeterAiMode = /* @__PURE__ */ ((MeterAiMode2) => {
  MeterAiMode2["RULES"] = "rules";
  MeterAiMode2["EXTRACT"] = "extract";
  return MeterAiMode2;
})(MeterAiMode || {});
const DECIMAL_BASE = 10;
const meterDecimals = (meter) => meter.type === MeterType.NUMBER ? meter.decimals ?? 0 : 0;
function roundMeterValue(meter, value) {
  if (meter.type !== MeterType.NUMBER) {
    return value;
  }
  const decimals = meterDecimals(meter);
  const factor = DECIMAL_BASE ** decimals;
  return Math.round(value * factor) / factor;
}
const THOUSANDS = /\B(?=(\d{3})+(?!\d))/g;
function formatMeterValue(meter, value) {
  if (meter.type !== MeterType.NUMBER) {
    return String(value);
  }
  const fixed = roundMeterValue(meter, value).toFixed(meterDecimals(meter));
  const [whole = "", fraction] = fixed.split(".");
  const grouped = whole.replace(THOUSANDS, ",");
  return fraction === void 0 ? grouped : grouped + "." + fraction;
}
function levelStep(meter) {
  return meter.type === MeterType.NUMBER ? 1 / DECIMAL_BASE ** meterDecimals(meter) : 1;
}
function nextLevelFrom(meter, previousTo) {
  return roundMeterValue(meter, previousTo + levelStep(meter));
}
function formatMeterDelta(meter, delta) {
  const text = formatMeterValue(meter, Math.abs(delta));
  if (delta > 0) {
    return "+" + text;
  }
  if (delta < 0) {
    return "-" + text;
  }
  return text;
}
const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const DOWL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const MONL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const MINUTE_MS$1 = 6e4;
const DAY_MS$1 = 864e5;
const MINUTES_PER_DAY$1 = 1440;
const MORNING_MINUTE = 480;
const HOURS_SKIP_MINUTES = 180;
const MINUTES_SKIP_FLOOR = 20;
const DAYS_SKIP_DAYS = 3;
const WEEK_SKIP_DAYS = 7;
const MONTH_SKIP_DAYS = 30;
const DEFAULT_START = "2026-01-01T12:00";
const MINUTES_PER_HOUR$1 = 60;
const PAD_WIDTH = 2;
const pad = (part) => String(part).padStart(PAD_WIDTH, "0");
const TOD_OFFSET_MINUTES = 360;
function clockStartMs(meter) {
  const parts = (meter.start || DEFAULT_START).split(/[-T:]/).map(Number);
  return Date.UTC(Number(parts[0]), (parts[1] || 1) - 1, parts[2] || 1, parts[3] || 0, parts[4] || 0);
}
function clockParts(meter, value) {
  const startMs = clockStartMs(meter);
  const cur = startMs + (value || 0) * MINUTE_MS$1;
  const dateObj = new Date(cur);
  const minuteOfDay = dateObj.getUTCHours() * MINUTES_PER_HOUR$1 + dateObj.getUTCMinutes();
  const day = Math.floor(cur / DAY_MS$1) - Math.floor(startMs / DAY_MS$1) + 1;
  const time = pad(dateObj.getUTCHours()) + ":" + pad(dateObj.getUTCMinutes());
  const date = DOW[dateObj.getUTCDay()] + " " + dateObj.getUTCDate() + " " + MON[dateObj.getUTCMonth()];
  const long = DOWL[dateObj.getUTCDay()] + " " + dateObj.getUTCDate() + " " + MONL[dateObj.getUTCMonth()] + " " + dateObj.getUTCFullYear();
  const isDateMode2 = meter.mode === "date";
  const short = (meter.display === "daycount" ? "Day " + day : date) + (isDateMode2 ? "" : " · " + time);
  const longDate = DOWL[dateObj.getUTCDay()] + " " + dateObj.getUTCDate() + " " + MONL[dateObj.getUTCMonth()];
  let longHead = longDate;
  if (meter.display === "daycount") {
    longHead = "Day " + day;
  } else if (isDateMode2) {
    longHead = long;
  }
  const longLabel = longHead + (isDateMode2 ? "" : " · " + time);
  const sentence = meter.display === "daycount" ? "It is day " + day + " of the story" + (isDateMode2 ? "" : ", " + time) + "." : "It is " + long + (isDateMode2 ? "" : ", " + time) + " (day " + day + " of the story).";
  return { cur, minuteOfDay, day, weekday: DOWL[dateObj.getUTCDay()] ?? "", short, long: longLabel, sentence };
}
function clockWeekday(meter, value) {
  return clockParts(meter, value).weekday;
}
function readClock(meter, value) {
  const parts = clockParts(meter, value);
  return {
    short: parts.short,
    long: parts.long,
    day: parts.day,
    minute_of_day: parts.minuteOfDay,
    sentence: parts.sentence
  };
}
function todLevelIndex(meter, minuteOfDay) {
  var _a;
  const off = (minuteOfDay - TOD_OFFSET_MINUTES + MINUTES_PER_DAY$1) % MINUTES_PER_DAY$1;
  const levels = meter.tod_levels;
  for (let i = 0; i < levels.length; i++) {
    const to = (_a = levels[i]) == null ? void 0 : _a.to;
    if (to === null || to === void 0 || off <= to) {
      return i;
    }
  }
  return levels.length - 1;
}
function dayLevelIndex(meter, day) {
  var _a;
  const levels = meter.day_levels;
  for (let i = 0; i < levels.length; i++) {
    const to = (_a = levels[i]) == null ? void 0 : _a.to;
    if (to === null || to === void 0 || day <= to) {
      return i;
    }
  }
  return levels.length - 1;
}
function clockDimensions(meter) {
  if (meter.rule_dimensions.length) {
    return meter.rule_dimensions;
  }
  const dims = [];
  if (meter.tod_levels.length && meter.mode !== "date") {
    dims.push("tod");
  }
  if (meter.day_levels.length) {
    dims.push("day");
  }
  return dims;
}
const CLOCK_SKIP_BUCKETS = {
  minutes: { description: "a short pause of a few minutes to under an hour", label: "A few minutes later" },
  hours: { description: "one or more hours pass within the same day or night", label: "Hours later" },
  next_morning: { description: "the story jumps to the following morning or the next day", label: "Next morning" },
  days: { description: "several days pass (two to six)", label: "A few days later" },
  week_plus: { description: "about a week to a few weeks pass", label: "A week later" },
  month_plus: { description: "a month or more passes", label: "A month later" }
};
function applyClockSkip(meter, value, skip) {
  const startMs = clockStartMs(meter);
  const cur = startMs + (value || 0) * MINUTE_MS$1;
  const dateObj = new Date(cur);
  const minuteOfDay = dateObj.getUTCHours() * MINUTES_PER_HOUR$1 + dateObj.getUTCMinutes();
  const dayStart = Math.floor(cur / DAY_MS$1) * DAY_MS$1;
  let targetMs;
  if (skip.minutes !== void 0) {
    targetMs = cur + skip.minutes * MINUTE_MS$1;
  } else {
    switch (skip.bucket) {
      case "minutes":
        targetMs = cur + Math.max(2 * meter.step_minutes, MINUTES_SKIP_FLOOR) * MINUTE_MS$1;
        break;
      case "hours":
        targetMs = cur + HOURS_SKIP_MINUTES * MINUTE_MS$1;
        break;
      case "next_morning":
        targetMs = meter.mode === "date" ? dayStart + DAY_MS$1 + minuteOfDay * MINUTE_MS$1 : dayStart + DAY_MS$1 + MORNING_MINUTE * MINUTE_MS$1;
        break;
      case "days":
        targetMs = cur + DAYS_SKIP_DAYS * DAY_MS$1;
        break;
      case "week_plus":
        targetMs = cur + WEEK_SKIP_DAYS * DAY_MS$1;
        break;
      case "month_plus":
        targetMs = cur + MONTH_SKIP_DAYS * DAY_MS$1;
        break;
      default:
        return value;
    }
  }
  return Math.round((targetMs - startMs) / MINUTE_MS$1);
}
function resolveClockSkip(meter, value, ai) {
  if (!meter.detect_skips) {
    return void 0;
  }
  const decision = ai == null ? void 0 : ai.clock_skip;
  if (decision === void 0) {
    return void 0;
  }
  if (decision === null) {
    return void 0;
  }
  if (decision.kind === "minutes") {
    const next2 = applyClockSkip(meter, value, { minutes: decision.minutes });
    return next2 !== value ? { value: next2, label: decision.label } : void 0;
  }
  const chosen = decision.kind === "extract" ? decision.fallback : decision;
  if (!(chosen == null ? void 0 : chosen.bucket)) {
    return void 0;
  }
  const next = applyClockSkip(meter, value, { bucket: chosen.bucket });
  return next !== value ? { value: next, label: chosen.label } : void 0;
}
function stepClock(meter, value, turnAfter) {
  if (meter.mode === "date") {
    if (meter.step_every_messages > 0 && turnAfter % meter.step_every_messages === 0) {
      return { value: value + MINUTES_PER_DAY$1, receipt: "Every " + meter.step_every_messages + " messages" };
    }
    return { value };
  }
  if (meter.step_minutes) {
    return { value: value + meter.step_minutes, receipt: "+" + meter.step_minutes + " min per message" };
  }
  return { value };
}
const MINUTE_MS = 6e4;
const DAY_MS = 864e5;
const MINUTES_PER_DAY = 1440;
const MINUTES_PER_HOUR = 60;
const MAX_CLOCK_SKIP_DAYS = 90;
const MAX_CLOCK_SKIP_MINUTES = MAX_CLOCK_SKIP_DAYS * MINUTES_PER_DAY;
function formatClockSkipLabel(minutes, meter, newValue) {
  if (minutes < MINUTES_PER_HOUR) {
    return `${minutes} ${minutes === 1 ? "minute" : "minutes"} later`;
  }
  if (minutes < MINUTES_PER_DAY) {
    const hours = Math.floor(minutes / MINUTES_PER_HOUR);
    const mins = minutes % MINUTES_PER_HOUR;
    return mins === 0 ? `${hours}h later` : `${hours}h ${mins}m later`;
  }
  return `→ ${readClock(meter, newValue).short}`;
}
const isValidTarget = (target) => target !== null && target !== void 0 && Number.isInteger(target.day_offset) && target.day_offset >= 0 && target.day_offset <= MAX_CLOCK_SKIP_DAYS && Number.isInteger(target.minute_of_day) && target.minute_of_day >= 0 && target.minute_of_day < MINUTES_PER_DAY;
const isDateMode = (meter) => meter.mode === "date";
function targetMinutes(meter, value, target) {
  const cur = clockStartMs(meter) + (value || 0) * MINUTE_MS;
  const dayStart = Math.floor(cur / DAY_MS) * DAY_MS;
  if (isDateMode(meter)) {
    return target.day_offset > 0 ? target.day_offset * MINUTES_PER_DAY : void 0;
  }
  let targetMs = dayStart + target.day_offset * DAY_MS + target.minute_of_day * MINUTE_MS;
  if (targetMs <= cur) {
    targetMs += DAY_MS;
  }
  const minutes = Math.round((targetMs - cur) / MINUTE_MS);
  return minutes > 0 ? minutes : void 0;
}
function elapsedMinutes(meter, elapsed) {
  if (!Number.isFinite(elapsed) || elapsed <= 0) {
    return void 0;
  }
  if (isDateMode(meter)) {
    const days = Math.floor(elapsed / MINUTES_PER_DAY);
    return days > 0 ? days * MINUTES_PER_DAY : void 0;
  }
  return Math.max(1, Math.round(elapsed));
}
function resolveClockExtraction(meter, value, extracted) {
  if (!extracted) {
    return void 0;
  }
  let minutes;
  if (isValidTarget(extracted.target)) {
    minutes = targetMinutes(meter, value, extracted.target);
  }
  if (minutes === void 0 && extracted.elapsed_minutes !== null && extracted.elapsed_minutes !== void 0) {
    minutes = elapsedMinutes(meter, extracted.elapsed_minutes);
  }
  if (minutes === void 0 || minutes <= 0) {
    return void 0;
  }
  const clamped = Math.min(minutes, MAX_CLOCK_SKIP_MINUTES);
  return { minutes: clamped, label: formatClockSkipLabel(clamped, meter, value + clamped) };
}
const clamp$2 = (value, lo, hi) => Math.max(lo, Math.min(hi, value));
const applyNumberTarget = (deltas, meter, target, values) => {
  var _a;
  const total = (_a = values == null ? void 0 : values[target.meter_id]) == null ? void 0 : _a.value;
  if (!meter || total === null || total === void 0 || !Number.isFinite(total) || total < 0) {
    delete deltas[target.meter_id];
    return;
  }
  const driver = meter.ai;
  const change = roundMeterValue(meter, total) - target.current_value;
  const delta = roundMeterValue(meter, driver ? clamp$2(change, driver.per_turn_min, driver.per_turn_max) : change);
  deltas[target.meter_id] = { delta, total: roundMeterValue(meter, target.current_value + delta), receipts: [...target.receipts] };
};
function applyAiExtractedValues(def, ai, targets, values, stateValues = {}) {
  const deltas = { ...ai.deltas };
  let clockSkip = ai.clock_skip;
  const targetIds = new Set(targets.map((target) => target.meter_id));
  targets.forEach((target) => {
    if (target.kind === "number") {
      const meter2 = def.meters.find(
        (candidate) => candidate.id === target.meter_id && candidate.type === MeterType.NUMBER
      );
      applyNumberTarget(deltas, meter2, target, values);
      return;
    }
    const meter = def.meters.find((candidate) => candidate.id === target.meter_id && candidate.type === MeterType.CLOCK);
    const resolved = meter ? resolveClockExtraction(meter, stateValues[meter.id] ?? 0, values == null ? void 0 : values[target.meter_id]) : void 0;
    if (resolved) {
      clockSkip = { kind: "minutes", minutes: resolved.minutes, label: resolved.label };
    }
  });
  def.meters.forEach((meter) => {
    var _a;
    if (meter.type === MeterType.NUMBER && ((_a = meter.ai) == null ? void 0 : _a.enabled) && meter.ai.mode === MeterAiMode.EXTRACT && !targetIds.has(meter.id)) {
      delete deltas[meter.id];
    }
  });
  return { ...ai, deltas, ...clockSkip !== void 0 ? { clock_skip: clockSkip } : {} };
}
const METADATA_GROUP = { groupKey: "metadata", groupLabel: "Public metadata" };
const COMBINED_GROUP = { groupKey: "combined", groupLabel: "Combined" };
const idSegment = (collection, id) => `${collection}[${id}]`;
function levelName(level, idx) {
  return level.label.trim() || `Level ${idx + 1}`;
}
function levelsMarkScope(levels) {
  return hashModerationText(JSON.stringify(levels.map((level) => [level.label, level.instruction ?? null, level.caption ?? null])));
}
function pushLevels(out, scope, collection, levels) {
  const { base, group, userKind } = scope;
  const markScope = levelsMarkScope(levels);
  levels.forEach((level, idx) => {
    const at = `${base}.${collection}[${idx}]`;
    const name = levelName(level, idx);
    out.push({ ...group, path: `${at}.label`, fieldLabel: "Level name", kind: userKind, text: level.label, markScope });
    if (level.instruction !== void 0) {
      out.push({ ...group, path: `${at}.instruction`, fieldLabel: `Instruction · ${name}`, kind: "model", text: level.instruction, markScope });
    }
    if (level.caption !== void 0) {
      out.push({ ...group, path: `${at}.caption`, fieldLabel: `Status line · ${name}`, kind: userKind, text: level.caption, markScope });
    }
  });
}
function pushMeter(out, meter) {
  var _a, _b, _c, _d;
  const base = idSegment("meters", meter.id);
  const group = { groupKey: meter.id, groupLabel: meter.label.trim() || meter.id };
  const userKind = meter.visible ? "user" : "model";
  out.push({ ...group, path: `${base}.label`, fieldLabel: "Meter name", kind: userKind, text: meter.label });
  (_a = meter.tells_users) == null ? void 0 : _a.raises.forEach((text, idx) => {
    out.push({ ...group, path: `${base}.tells_users.raises[${idx}]`, fieldLabel: "Raises it", kind: "user", text });
  });
  (_b = meter.tells_users) == null ? void 0 : _b.lowers.forEach((text, idx) => {
    out.push({ ...group, path: `${base}.tells_users.lowers[${idx}]`, fieldLabel: "Lowers it", kind: "user", text });
  });
  if (meter.type === "number" && meter.unit !== void 0) {
    out.push({ ...group, path: `${base}.unit`, fieldLabel: "Unit", kind: userKind, text: meter.unit });
  }
  if (meter.type === "bar" || meter.type === "pips" || meter.type === "number") {
    meter.keywords.forEach((driver, driverIdx) => {
      driver.words.forEach((text, wordIdx) => {
        out.push({ ...group, path: `${base}.keywords[${driverIdx}].words[${wordIdx}]`, fieldLabel: "Keyword", kind: "rule", text });
      });
    });
    (_c = meter.ai) == null ? void 0 : _c.rows.forEach((row) => {
      out.push({ ...group, path: `${base}.ai.${idSegment("rows", row.id)}.condition`, fieldLabel: "AI rule", kind: "rule", text: row.condition });
    });
    if (((_d = meter.ai) == null ? void 0 : _d.extract_hint) !== void 0) {
      out.push({
        ...group,
        path: `${base}.ai.extract_hint`,
        fieldLabel: "AI rule · detect from messages",
        kind: "rule",
        text: meter.ai.extract_hint
      });
    }
  }
  const scope = { base, group, userKind };
  if (meter.type === "clock") {
    pushLevels(out, scope, "tod_levels", meter.tod_levels);
    pushLevels(out, scope, "day_levels", meter.day_levels);
    return;
  }
  pushLevels(out, scope, "levels", meter.levels);
}
function flattenRulebookTexts(source) {
  var _a;
  const out = [];
  out.push({ ...METADATA_GROUP, path: "name", fieldLabel: "Name", kind: "user", text: source.name });
  if (source.description !== void 0) {
    out.push({ ...METADATA_GROUP, path: "description", fieldLabel: "Description", kind: "user", text: source.description });
  }
  (_a = source.tags) == null ? void 0 : _a.forEach((text, idx) => {
    out.push({ ...METADATA_GROUP, path: `tags[${idx}]`, fieldLabel: "Tag", kind: "user", text });
  });
  for (const meter of source.meters ?? []) {
    pushMeter(out, meter);
  }
  (source.combined_rules ?? []).forEach((rule, idx) => {
    const base = idSegment("combined_rules", rule.id);
    out.push({ ...COMBINED_GROUP, path: `${base}.instruction`, fieldLabel: `Instruction · Rule ${idx + 1}`, kind: "model", text: rule.instruction });
    if (rule.caption !== void 0) {
      out.push({ ...COMBINED_GROUP, path: `${base}.caption`, fieldLabel: `Status line · Rule ${idx + 1}`, kind: "user", text: rule.caption });
    }
  });
  return out.filter((text) => text.text.trim().length > 0);
}
const METER = String.raw`meters\[[^\]]+\]`;
const LEVEL_LIST = String.raw`(?:levels|tod_levels|day_levels)\[\d+\]`;
const dropLastSegment = (path) => path.slice(0, path.lastIndexOf("."));
const REMOVAL_RULES = [
  { pattern: /^tags\[\d+\]$/, removal: "item" },
  { pattern: /^description$/, removal: "field" },
  { pattern: new RegExp(`^${METER}\\.tells_users\\.(?:raises|lowers)\\[\\d+\\]$`), removal: "item" },
  { pattern: new RegExp(`^${METER}\\.unit$`), removal: "field" },
  { pattern: new RegExp(`^${METER}\\.keywords\\[\\d+\\]\\.words\\[\\d+\\]$`), removal: "item" },
  { pattern: new RegExp(`^${METER}\\.ai\\.rows\\[[^\\]]+\\]\\.condition$`), removal: "item", itemPath: dropLastSegment },
  { pattern: new RegExp(`^${METER}\\.${LEVEL_LIST}\\.(?:instruction|caption)$`), removal: "field" },
  { pattern: /^combined_rules\[[^\]]+\]\.instruction$/, removal: "item", itemPath: dropLastSegment },
  { pattern: /^combined_rules\[[^\]]+\]\.caption$/, removal: "field" }
];
function rulebookTextRemoval(path) {
  var _a;
  return (_a = REMOVAL_RULES.find((rule) => rule.pattern.test(path))) == null ? void 0 : _a.removal;
}
const ID_COLLECTIONS = /* @__PURE__ */ new Set(["meters", "rows", "combined_rules"]);
const SEGMENT_PATTERN = /^([a-z_]+)(?:\[([^\]]+)\])?$/;
function parsePath(path) {
  return path.split(".").map((part) => {
    const match = SEGMENT_PATTERN.exec(part);
    return (match == null ? void 0 : match[2]) === void 0 ? { key: (match == null ? void 0 : match[1]) ?? part } : { key: match[1] ?? part, selector: match[2] };
  });
}
function indexIn(list, collection, selector) {
  if (ID_COLLECTIONS.has(collection)) {
    return list.findIndex((entry) => (entry == null ? void 0 : entry.id) === selector);
  }
  return Number(selector);
}
function resolveSlot(root, path) {
  const segments = parsePath(path);
  let current = root;
  for (let idx = 0; idx < segments.length; idx += 1) {
    const { key, selector } = segments[idx];
    const isLast = idx === segments.length - 1;
    if (selector === void 0) {
      if (isLast) {
        return { container: current, key };
      }
      current = current[key];
      continue;
    }
    const list = current[key];
    const position = indexIn(list, key, selector);
    if (isLast) {
      return { container: list, key: position };
    }
    current = list[position];
  }
  return { container: current, key: "" };
}
function setSlot(slot, value) {
  if (Array.isArray(slot.container)) {
    slot.container[slot.key] = value;
    return;
  }
  slot.container[slot.key] = value;
}
const KEYWORD_WORD_PATTERN = /\.keywords\[\d+\]\.words\[\d+\]$/;
function markListRemoval(removals, list, index) {
  const marked = removals.get(list) ?? /* @__PURE__ */ new Set();
  marked.add(index);
  removals.set(list, marked);
}
function dropEmptiedKeywordDrivers(root, emptied) {
  for (const meter of root["meters"] ?? []) {
    if (meter.keywords) {
      meter.keywords = meter.keywords.filter((driver) => !(emptied.has(driver) && driver.words.length === 0));
    }
  }
}
function applyRemovals(root, paths) {
  const listRemovals = /* @__PURE__ */ new Map();
  const touchedDrivers = /* @__PURE__ */ new Set();
  for (const path of paths) {
    const rule = REMOVAL_RULES.find((candidate) => candidate.pattern.test(path));
    const slot = resolveSlot(root, rule.itemPath ? rule.itemPath(path) : path);
    if (!Array.isArray(slot.container)) {
      delete slot.container[slot.key];
      continue;
    }
    markListRemoval(listRemovals, slot.container, slot.key);
    if (KEYWORD_WORD_PATTERN.test(path)) {
      const driver = resolveSlot(root, dropLastSegment(path));
      touchedDrivers.add(driver.container[driver.key]);
    }
  }
  for (const [list, indices] of listRemovals) {
    const kept = list.filter((_entry, index) => !indices.has(index));
    list.splice(0, list.length, ...kept);
  }
  dropEmptiedKeywordDrivers(root, touchedDrivers);
}
function removedTextPaths(path, textPaths) {
  const rule = REMOVAL_RULES.find((candidate) => candidate.pattern.test(path));
  if (!(rule == null ? void 0 : rule.itemPath)) {
    return [path];
  }
  const prefix = `${rule.itemPath(path)}.`;
  return textPaths.filter((textPath) => textPath === path || textPath.startsWith(prefix));
}
function findProblems(texts, changes, removals) {
  const problems = [];
  const removedPaths = /* @__PURE__ */ new Set();
  for (const path of removals) {
    if (!texts.has(path)) {
      problems.push({ path, reason: "unknown_path" });
    } else if (rulebookTextRemoval(path) === void 0) {
      problems.push({ path, reason: "not_removable" });
    } else {
      removedTextPaths(path, [...texts.keys()]).forEach((removed) => removedPaths.add(removed));
    }
  }
  for (const [path, text] of Object.entries(changes)) {
    if (!texts.has(path)) {
      problems.push({ path, reason: "unknown_path" });
    } else if (text.trim().length === 0) {
      problems.push({ path, reason: "empty_text" });
    } else if (removedPaths.has(path)) {
      problems.push({ path, reason: "conflict" });
    }
  }
  return problems;
}
function applyRulebookTextEdits(source, request) {
  const changes = request.changes ?? {};
  const removals = [...new Set(request.remove ?? [])];
  const flattened = flattenRulebookTexts(source);
  const texts = new Map(flattened.map((text) => [text.path, text.text]));
  const problems = findProblems(texts, changes, removals);
  if (problems.length > 0) {
    return { ok: false, problems };
  }
  const copy = JSON.parse(JSON.stringify(source));
  const root = copy;
  const edits = [];
  for (const [path, after] of Object.entries(changes)) {
    const before = texts.get(path);
    if (after !== before) {
      setSlot(resolveSlot(root, path), after);
      edits.push({ path, before, after });
    }
  }
  const allPaths = flattened.map((text) => text.path);
  const removedPaths = new Set(removals.flatMap((path) => removedTextPaths(path, allPaths)));
  applyRemovals(root, removals);
  for (const path of allPaths) {
    if (removedPaths.has(path)) {
      edits.push({ path, before: texts.get(path) });
    }
  }
  return { ok: true, source: copy, edits };
}
const issue = (path, message) => ({ severity: "error", code: "malformed_definition", path, message });
const isObject = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
const isFiniteNumber$1 = (value) => typeof value === "number" && Number.isFinite(value);
const stringField = (value, path, name, required = true) => {
  if (value === void 0) {
    return required ? [issue(path, `${name} must be a string`)] : [];
  }
  return typeof value === "string" ? [] : [issue(path, `${name} must be a string`)];
};
const boolField = (value, path, name, required = true) => {
  if (value === void 0) {
    return required ? [issue(path, `${name} must be a boolean`)] : [];
  }
  return typeof value === "boolean" ? [] : [issue(path, `${name} must be a boolean`)];
};
const numberField = (value, path, name) => isFiniteNumber$1(value) ? [] : [issue(path, `${name} must be a finite number`)];
const integerField = (value, path, name) => Number.isInteger(value) ? [] : [issue(path, `${name} must be an integer`)];
const CLOCK_START_PATTERN = /^(\d{4}(-\d{2}(-\d{2}(T\d{2}(:\d{2})?)?)?)?)?$/;
const MIN_CLOCK_YEAR = 1e3;
const isCalendarValidClockStart = (value) => {
  if (value === "") {
    return true;
  }
  const [year = 0, month = 1, day = 1, hour = 0, minute = 0] = value["split"](/[-T:]/).map(Number);
  if (year < MIN_CLOCK_YEAR) {
    return false;
  }
  const date = new Date(Date.UTC(year, month - 1, day, hour, minute));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day && date.getUTCHours() === hour && date.getUTCMinutes() === minute;
};
const clockStartField = (value, path) => typeof value === "string" && CLOCK_START_PATTERN.test(value) && isCalendarValidClockStart(value) ? [] : [issue(path, "start must be empty or a valid calendar date matching YYYY-MM-DDTHH:mm (prefixes allowed)")];
const enumField = (value, path, name, allowed) => typeof value === "string" && allowed.includes(value) ? [] : [issue(path, `${name} must be one of ${allowed.join("|")}`)];
function checkLevel(value, path) {
  if (!isObject(value)) {
    return [issue(path, "level must be an object")];
  }
  const issues = [
    ...stringField(value["label"], `${path}.label`, "label"),
    ...value["to"] === null ? [] : numberField(value["to"], `${path}.to`, "to"),
    ...boolField(value["revealed"], `${path}.revealed`, "revealed"),
    ...boolField(value["override"], `${path}.override`, "override"),
    ...stringField(value["instruction"], `${path}.instruction`, "instruction", false),
    ...stringField(value["caption"], `${path}.caption`, "caption", false)
  ];
  return issues;
}
const checkLevels$1 = (value, path) => {
  if (!Array.isArray(value)) {
    return [issue(path, "must be an array of levels")];
  }
  return value["flatMap"]((level, idx) => checkLevel(level, `${path}[${idx}]`));
};
function checkKeywords$1(value, path) {
  if (!Array.isArray(value)) {
    return [issue(path, "must be an array of keyword drivers")];
  }
  return value["flatMap"]((driver, driverIdx) => {
    const driverPath = `${path}[${driverIdx}]`;
    if (!isObject(driver)) {
      return [issue(driverPath, "keyword driver must be an object")];
    }
    const issues = numberField(driver["delta"], `${driverPath}.delta`, "delta");
    if (!Array.isArray(driver["words"])) {
      issues.push(issue(`${driverPath}.words`, "must be an array of strings"));
    } else {
      driver["words"].forEach((word, wordIdx) => {
        if (typeof word !== "string") {
          issues.push(issue(`${driverPath}.words[${wordIdx}]`, "must be a string"));
        }
      });
    }
    return issues;
  });
}
function checkAiDriver(value, path) {
  if (value === void 0) {
    return [];
  }
  if (!isObject(value)) {
    return [issue(path, "must be an object")];
  }
  const issues = [
    ...boolField(value["enabled"], `${path}.enabled`, "enabled"),
    ...numberField(value["per_turn_min"], `${path}.per_turn_min`, "per_turn_min"),
    ...numberField(value["per_turn_max"], `${path}.per_turn_max`, "per_turn_max"),
    ...boolField(value["negative_overrides_positive"], `${path}.negative_overrides_positive`, "negative_overrides_positive", false),
    ...stringField(value["extract_hint"], `${path}.extract_hint`, "extract_hint", false),
    ...value["mode"] === void 0 ? [] : enumField(value["mode"], `${path}.mode`, "mode", AI_MODES)
  ];
  if (!Array.isArray(value["rows"])) {
    issues.push(issue(`${path}.rows`, "must be an array"));
  } else {
    value["rows"].forEach((row, rowIdx) => {
      const rowPath = `${path}.rows[${rowIdx}]`;
      if (!isObject(row)) {
        issues.push(issue(rowPath, "ai row must be an object"));
        return;
      }
      issues.push(
        ...stringField(row["id"], `${rowPath}.id`, "id"),
        ...numberField(row["impact"], `${rowPath}.impact`, "impact"),
        ...stringField(row["condition"], `${rowPath}.condition`, "condition"),
        ...row["cooldown"] === void 0 ? [] : numberField(row["cooldown"], `${rowPath}.cooldown`, "cooldown")
      );
    });
  }
  return issues;
}
const METER_TYPES = Object.values(MeterType);
const TRACKS = ["user", "character", "chat"];
const CLOCK_MODES = ["datetime", "date"];
const CLOCK_DISPLAYS = ["calendar", "daycount"];
const CLOCK_DIMENSIONS = ["tod", "day"];
const COUNTER_DISPLAYS = ["number", "level"];
const AI_MODES = Object.values(MeterAiMode);
function checkMeter(value, index) {
  const path = `meters[${index}]`;
  if (!isObject(value)) {
    return [issue(path, "meter must be an object")];
  }
  const issues = [
    ...stringField(value["id"], `${path}.id`, "id"),
    ...stringField(value["label"], `${path}.label`, "label"),
    ...enumField(value["type"], `${path}.type`, "type", METER_TYPES),
    ...enumField(value["tracks"], `${path}.tracks`, "tracks", TRACKS),
    ...boolField(value["visible"], `${path}.visible`, "visible"),
    ...stringField(value["icon"], `${path}.icon`, "icon", false),
    ...stringField(value["color"], `${path}.color`, "color", false)
  ];
  if (value["tells_users"] !== void 0) {
    if (!isObject(value["tells_users"])) {
      issues.push(issue(`${path}.tells_users`, "must be an object"));
    } else {
      for (const key of ["raises", "lowers"]) {
        const list = value["tells_users"][key];
        if (!Array.isArray(list) || list.some((entry) => typeof entry !== "string")) {
          issues.push(issue(`${path}.tells_users.${key}`, "must be an array of strings"));
        }
      }
    }
  }
  const type = value["type"];
  if (type === MeterType.BAR || type === MeterType.PIPS || type === MeterType.NUMBER) {
    issues.push(
      ...checkKeywords$1(value["keywords"], `${path}.keywords`),
      ...checkAiDriver(value["ai"], `${path}.ai`),
      ...checkLevels$1(value["levels"], `${path}.levels`)
    );
  }
  if (type === MeterType.BAR || type === MeterType.PIPS) {
    issues.push(
      ...numberField(value["min"], `${path}.min`, "min"),
      ...numberField(value["max"], `${path}.max`, "max"),
      ...numberField(value["default"], `${path}.default`, "default"),
      ...numberField(value["decay"], `${path}.decay`, "decay"),
      ...value["decay_every"] === void 0 ? [] : integerField(value["decay_every"], `${path}.decay_every`, "decay_every")
    );
  } else if (type === MeterType.NUMBER) {
    issues.push(
      ...numberField(value["default"], `${path}.default`, "default"),
      ...numberField(value["per_message"], `${path}.per_message`, "per_message"),
      ...boolField(value["spendable"], `${path}.spendable`, "spendable"),
      ...boolField(value["tell_model"], `${path}.tell_model`, "tell_model"),
      ...enumField(value["display"], `${path}.display`, "display", COUNTER_DISPLAYS),
      ...stringField(value["unit"], `${path}.unit`, "unit", false),
      ...value["decimals"] === void 0 ? [] : integerField(value["decimals"], `${path}.decimals`, "decimals")
    );
  } else if (type === MeterType.CLOCK) {
    issues.push(
      ...enumField(value["mode"], `${path}.mode`, "mode", CLOCK_MODES),
      ...enumField(value["display"], `${path}.display`, "display", CLOCK_DISPLAYS),
      ...clockStartField(value["start"], `${path}.start`),
      ...numberField(value["step_minutes"], `${path}.step_minutes`, "step_minutes"),
      ...numberField(value["step_every_messages"], `${path}.step_every_messages`, "step_every_messages"),
      ...boolField(value["detect_skips"], `${path}.detect_skips`, "detect_skips"),
      ...value["skip_mode"] === void 0 ? [] : enumField(value["skip_mode"], `${path}.skip_mode`, "skip_mode", AI_MODES),
      ...boolField(value["tell_model"], `${path}.tell_model`, "tell_model"),
      ...checkLevels$1(value["tod_levels"], `${path}.tod_levels`),
      ...checkLevels$1(value["day_levels"], `${path}.day_levels`)
    );
    if (!Array.isArray(value["rule_dimensions"])) {
      issues.push(issue(`${path}.rule_dimensions`, "must be an array"));
    } else {
      value["rule_dimensions"].forEach((dimension, dimIdx) => {
        issues.push(...enumField(dimension, `${path}.rule_dimensions[${dimIdx}]`, "dimension", CLOCK_DIMENSIONS));
      });
    }
  } else if (type === MeterType.DICE) {
    issues.push(...numberField(value["sides"], `${path}.sides`, "sides"), ...checkLevels$1(value["levels"], `${path}.levels`));
  }
  return issues;
}
const NUMERIC_OPS = [">=", "<=", ">", "<", "day>=", "day<="];
const CONDITION_OPS = [...NUMERIC_OPS, "tod_is"];
function checkCombinedRule(value, index) {
  const path = `combined_rules[${index}]`;
  if (!isObject(value)) {
    return [issue(path, "combined rule must be an object")];
  }
  const issues = [
    ...stringField(value["id"], `${path}.id`, "id"),
    ...stringField(value["instruction"], `${path}.instruction`, "instruction"),
    ...stringField(value["caption"], `${path}.caption`, "caption", false)
  ];
  if (!Array.isArray(value["conditions"])) {
    issues.push(issue(`${path}.conditions`, "must be an array"));
    return issues;
  }
  value["conditions"].forEach((condition, condIdx) => {
    const condPath = `${path}.conditions[${condIdx}]`;
    if (!isObject(condition)) {
      issues.push(issue(condPath, "condition must be an object"));
      return;
    }
    issues.push(
      ...stringField(condition["meter_id"], `${condPath}.meter_id`, "meter_id"),
      ...enumField(condition["op"], `${condPath}.op`, "op", CONDITION_OPS)
    );
    if (condition["op"] === "tod_is") {
      issues.push(...integerField(condition["level_index"], `${condPath}.level_index`, "level_index"));
    } else if (typeof condition["op"] === "string" && NUMERIC_OPS.includes(condition["op"])) {
      issues.push(...numberField(condition["value"], `${condPath}.value`, "value"));
    }
  });
  return issues;
}
function checkRulebookShape(input) {
  if (!isObject(input)) {
    return [issue("", "definition must be an object")];
  }
  const issues = [
    ...stringField(input["id"], "id", "id"),
    ...stringField(input["name"], "name", "name"),
    ...stringField(input["description"], "description", "description", false)
  ];
  if (!Array.isArray(input["meters"])) {
    issues.push(issue("meters", "must be an array"));
  } else {
    input["meters"].forEach((meter, index) => issues.push(...checkMeter(meter, index)));
  }
  if (!Array.isArray(input["combined_rules"])) {
    issues.push(issue("combined_rules", "must be an array"));
  } else {
    input["combined_rules"].forEach((rule, index) => issues.push(...checkCombinedRule(rule, index)));
  }
  return issues;
}
function levelIndex(levels, value) {
  var _a;
  for (let i = 0; i < levels.length; i++) {
    const to = (_a = levels[i]) == null ? void 0 : _a.to;
    if (to === null || to === void 0 || value <= to) {
      return i;
    }
  }
  return levels.length - 1;
}
const DICE_FIRST_FACE = 1;
function isLevelReached(meterType, index, revealedTo) {
  return meterType === MeterType.DICE ? index === revealedTo : index <= revealedTo;
}
const TOKEN_RE = /\{\{([^{}]*)\}\}/g;
const PARTS_WITH_SUFFIX = 3;
const NUMERIC_TOKEN_CHARS = 24;
const CLOCK_READOUT_CHARS = 64;
const WORST_CHARS_BY_KIND = {
  value: NUMERIC_TOKEN_CHARS,
  level: RULEBOOK_LIMITS.MAX_LEVEL_LABEL_CHARS,
  clock: CLOCK_READOUT_CHARS,
  caption: RULEBOOK_LIMITS.MAX_CAPTION_CHARS
};
function meterTokenKind(token, def) {
  const parts = token.split(".");
  if (parts[0] !== "meters" || !parts[1]) {
    return void 0;
  }
  const meter = def.meters.find((candidate) => candidate.id === parts[1]);
  if (!meter) {
    return void 0;
  }
  if (parts.length === 2) {
    return { meter, kind: "value" };
  }
  if (parts.length !== PARTS_WITH_SUFFIX) {
    return void 0;
  }
  if (parts[2] === "level" && meter.type !== MeterType.CLOCK && meter.levels.length > 0) {
    return { meter, kind: "level" };
  }
  if (parts[2] === "clock" && meter.type === MeterType.CLOCK) {
    return { meter, kind: "clock" };
  }
  if (parts[2] === "caption") {
    return { meter, kind: "caption" };
  }
  return void 0;
}
function meterTokenValue(token, def, values) {
  var _a, _b, _c, _d;
  const resolved = meterTokenKind(token, def);
  if (!resolved) {
    return void 0;
  }
  const { meter, kind } = resolved;
  const value = values[meter.id] ?? 0;
  if (meter.type === MeterType.DICE && value < DICE_FIRST_FACE) {
    return "";
  }
  if (kind === "value") {
    return formatMeterValue(meter, value);
  }
  if (kind === "level") {
    return (_a = meter.levels[levelIndex(meter.levels, value)]) == null ? void 0 : _a.label;
  }
  if (kind === "clock" && meter.type === MeterType.CLOCK) {
    return readClock(meter, value).short;
  }
  if (meter.type === MeterType.CLOCK) {
    const readout = readClock(meter, value);
    if (meter.tod_levels.length > 0) {
      return (_b = meter.tod_levels[todLevelIndex(meter, readout.minute_of_day)]) == null ? void 0 : _b.caption;
    }
    return (_c = meter.day_levels[dayLevelIndex(meter, readout.day)]) == null ? void 0 : _c.caption;
  }
  return (_d = meter.levels[levelIndex(meter.levels, value)]) == null ? void 0 : _d.caption;
}
function renderMeterTokens(text, def, values) {
  return text.replace(TOKEN_RE, (match, token) => {
    const rendered = meterTokenValue(token.trim(), def, values);
    return rendered !== void 0 ? rendered : match;
  });
}
function estimateRenderedChars(text, def) {
  let rendered = text.length;
  for (const match of text.matchAll(TOKEN_RE)) {
    const token = (match[1] ?? "").trim();
    const resolved = meterTokenKind(token, def);
    const worst = resolved ? WORST_CHARS_BY_KIND[resolved.kind] : 0;
    rendered += worst - (worst > 0 ? match[0].length : 0);
  }
  return rendered;
}
function findUnknownTokens(text, def) {
  const unknown = [];
  for (const match of text.matchAll(TOKEN_RE)) {
    const token = (match[1] ?? "").trim();
    if (token === "user" || token === "char") {
      continue;
    }
    if (!meterTokenKind(token, def)) {
      unknown.push(match[0]);
    }
  }
  return unknown;
}
const clockSkipInstruction = (meter, values) => "Story clock — it currently reads " + readClock(meter, (values == null ? void 0 : values[meter.id]) ?? 0).sentence + `. Judging only new_messages (earlier_messages_already_evaluated are background), has in-story time moved past that within the story itself — stated as elapsed time ("two hours later", "the next morning", "a week passed"), stated as a later current time or moment of day ("it's 8pm now", "by noon", "as the sun sets"), or clearly implied? Implied counts when the scene has cut ahead: the characters are now at a place or moment that was only planned or upcoming before (arriving somewhere they agreed to meet later, the end of a shift or a day that was just starting), waking up, a new scene opening after the previous one ended, or the characters have arrived somewhere that takes real travel to reach from where they were (another part of town, another city or country, the top of a hike) — that counts even with no time words. Moving within the same place (another room, the porch, an elevator ride) does not. Answer no if the new messages only talk about, plan or imagine another time or place without the story being there ("see you tomorrow", "yesterday I…", "picture it: tonight at the pier…", "the movie is two hours long", "two hours until…"), if the stated time is the same as or earlier than the clock, or if the only signal is an instruction to the narrator or system (e.g. bracketed or out-of-character requests to change the time) rather than something happening in the story.`;
const CLOCK_BUCKET_INSTRUCTION = "If in-story time jumped ahead in new_messages, how much time passed?";
function subjectFor(tracks, names) {
  if (tracks === "user") {
    return names.userName + "'s latest message";
  }
  if (tracks === "character") {
    return names.charName + "'s latest reply";
  }
  return "the latest exchange (" + names.userName + "'s latest message and " + names.charName + "'s latest reply)";
}
function renderCondition(condition, def, names, values) {
  const withMeters = values ? renderMeterTokens(condition, def, values) : condition;
  return withMeters.split("{{user}}").join(names.userName).split("{{char}}").join(names.charName);
}
const DETECT_QUESTION_ID = "detect";
function detectClause(meter, hint, subject, render) {
  const unit = meter.type === MeterType.NUMBER && meter.unit ? " (" + meter.unit + ")" : "";
  const what = (hint == null ? void 0 : hint.trim()) ? " It tracks: " + render(hint) + "." : "";
  return meter.label + unit + " meter." + what + " Does " + subject + " state or clearly show a new amount for it, or something that adds to or takes from it (earned, paid, spent, lost, given)? Judge only new_messages; earlier_messages_already_evaluated were scored on previous turns and are background. Answer no if the amount is only discussed, hypothetical, or unchanged, or if the new messages merely refer back to an amount already counted.";
}
function clockQuestions(meter, values) {
  const questions = {};
  if (meter.detect_skips) {
    questions[meter.id + ".skip"] = { type: "noul", instructions: clockSkipInstruction(meter, values) };
    questions[meter.id + ".bucket"] = {
      type: "choice",
      instructions: CLOCK_BUCKET_INSTRUCTION,
      criteria: Object.fromEntries(Object.entries(CLOCK_SKIP_BUCKETS).map(([bucket, info]) => [bucket, info.description]))
    };
  }
  return questions;
}
function meterQuestions(meter, def, names, values) {
  var _a;
  const questions = {};
  const ai = meter.type !== MeterType.CLOCK && meter.type !== MeterType.DICE && ((_a = meter.ai) == null ? void 0 : _a.enabled) ? meter.ai : void 0;
  const subject = subjectFor(meter.tracks, names);
  if ((ai == null ? void 0 : ai.mode) === MeterAiMode.EXTRACT) {
    questions[meter.id + "." + DETECT_QUESTION_ID] = {
      type: "noul",
      instructions: detectClause(meter, ai.extract_hint, subject, (text) => renderCondition(text, def, names, values))
    };
    return questions;
  }
  const rows = (ai == null ? void 0 : ai.rows) ?? [];
  rows.forEach((row) => {
    const clause = meter.label + " meter. Condition: " + renderCondition(row.condition, def, names, values) + ". Does " + subject + " show this happening — stated outright or clearly shown in action or dialogue? Judge only new_messages; earlier_messages_already_evaluated were scored on previous turns and are background so you can understand the new ones. A fresh occurrence in new_messages counts even if something similar happened before. Merely mentioning, thanking for, reacting to or discussing an earlier occurrence does not count, nor does something hypothetical or done by someone else.";
    questions[meter.id + "." + row.id] = { type: "noul", instructions: clause };
  });
  return questions;
}
function compileAiQuestions(def, names, values) {
  const questions = {};
  const meterIds = [];
  let clockMeterId;
  def.meters.forEach((meter) => {
    Object.assign(questions, meterQuestions(meter, def, names, values));
    if (meter.type === MeterType.CLOCK) {
      Object.assign(questions, clockQuestions(meter, values));
      if (meter.detect_skips) {
        clockMeterId = meter.id;
      }
    }
    const ai = meter.type === MeterType.CLOCK || meter.type === MeterType.DICE ? void 0 : meter.ai;
    const hasAiQuestions = ((ai == null ? void 0 : ai.enabled) ?? false) && ((ai == null ? void 0 : ai.mode) === MeterAiMode.EXTRACT || ((ai == null ? void 0 : ai.rows.length) ?? 0) > 0);
    if (hasAiQuestions || meter.type === MeterType.CLOCK && meter.detect_skips) {
      meterIds.push(meter.id);
    }
  });
  const compiled = { questions, meter_ids: meterIds };
  if (clockMeterId) {
    compiled.clock_meter_id = clockMeterId;
  }
  return compiled;
}
function cureFiredStamps(def, fired, turn) {
  if (!fired) {
    return void 0;
  }
  const cured = {};
  Object.entries(fired).forEach(([key, stamp]) => {
    if (!Number.isInteger(stamp) || stamp < 0 || stamp > turn) {
      return;
    }
    const dotIndex = key.indexOf(".");
    const meter = def.meters.find((candidate) => candidate.id === key.slice(0, dotIndex));
    const ai = meter && meter.type !== MeterType.CLOCK && meter.type !== MeterType.DICE ? meter.ai : void 0;
    const row = (ai == null ? void 0 : ai.enabled) && ai.mode !== MeterAiMode.EXTRACT ? ai.rows.find((candidate) => candidate.id === key.slice(dotIndex + 1)) : void 0;
    if ((row == null ? void 0 : row.cooldown) !== void 0 && row.cooldown !== 0) {
      cured[key] = stamp;
    }
  });
  return Object.keys(cured).length ? cured : void 0;
}
function cureQuietCounts(def, quiet) {
  if (!quiet) {
    return void 0;
  }
  const cured = {};
  Object.entries(quiet).forEach(([meterId, count]) => {
    const meter = def.meters.find((candidate) => candidate.id === meterId);
    const decayEvery = meter && (meter.type === MeterType.BAR || meter.type === MeterType.PIPS) ? meter.decay_every ?? 1 : 1;
    if (decayEvery > 1 && Number.isInteger(count) && count > 0) {
      cured[meterId] = count;
    }
  });
  return Object.keys(cured).length ? cured : void 0;
}
function cureRulebookState(def, snapshot) {
  if (!snapshot || snapshot.rulebook_id !== def.id) {
    const values2 = {};
    def.meters.forEach((meter) => {
      if (meter.type === MeterType.CLOCK || meter.type === MeterType.DICE) {
        values2[meter.id] = 0;
      } else if (meter.type === MeterType.NUMBER) {
        values2[meter.id] = roundMeterValue(meter, Math.max(0, meter.default));
      } else {
        values2[meter.id] = meter.default;
      }
    });
    return { rulebook_id: def.id, values: values2, turn: 0 };
  }
  const values = {};
  def.meters.forEach((meter) => {
    var _a;
    const raw = (_a = snapshot.values) == null ? void 0 : _a[meter.id];
    const base = typeof raw === "number" && Number.isFinite(raw) ? raw : void 0;
    if (meter.type === MeterType.CLOCK) {
      values[meter.id] = base !== void 0 ? Math.max(0, base) : 0;
    } else if (meter.type === MeterType.DICE) {
      values[meter.id] = base !== void 0 ? Math.max(0, Math.min(meter.sides, Math.round(base))) : 0;
    } else if (meter.type === MeterType.NUMBER) {
      values[meter.id] = base !== void 0 ? roundMeterValue(meter, Math.max(0, base)) : roundMeterValue(meter, Math.max(0, meter.default));
    } else {
      values[meter.id] = base !== void 0 ? Math.max(meter.min, Math.min(meter.max, base)) : meter.default;
    }
  });
  const turn = snapshot.turn;
  const result = {
    rulebook_id: def.id,
    values,
    turn: Number.isInteger(turn) && (turn ?? 0) >= 0 ? turn : 0
  };
  const fired = cureFiredStamps(def, snapshot.fired, result.turn);
  if (fired) {
    result.fired = fired;
  }
  const quiet = cureQuietCounts(def, snapshot.quiet);
  if (quiet) {
    result.quiet = quiet;
  }
  return result;
}
const WORD_CHAR = "\\p{L}\\p{N}_";
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
function matchKeyword(text, keyword) {
  const trimmed = keyword.trim().toLowerCase();
  const hasWildcard = trimmed.endsWith("*");
  const body = (hasWildcard ? trimmed.slice(0, -1) : trimmed).trimEnd();
  if (body === "") {
    return false;
  }
  const pattern = hasWildcard ? new RegExp(`(?<![${WORD_CHAR}])${escapeRegExp(body)}[${WORD_CHAR}]*`, "u") : new RegExp(`(?<![${WORD_CHAR}])${escapeRegExp(body)}(?![${WORD_CHAR}])`, "u");
  return pattern.test(text.toLowerCase());
}
const READS_BY_TRACKS = { user: "user", character: "bot", chat: "all" };
function meterReads(meter) {
  return READS_BY_TRACKS[meter.tracks] ?? "all";
}
const readsUserMessage = (meter) => meterReads(meter) !== "bot";
const readsBotReply = (meter) => meterReads(meter) !== "user";
function matchMeterKeywords(meter, text, skip) {
  const match = { sum: 0, receipts: [], fired: /* @__PURE__ */ new Set() };
  if (!text) {
    return match;
  }
  meter.keywords.forEach((driver, index) => {
    if (skip == null ? void 0 : skip.has(index)) {
      return;
    }
    const hit = driver.words.find((word) => matchKeyword(text, word));
    if (hit !== void 0) {
      match.sum += driver.delta;
      match.receipts.push("Keyword “" + hit + "”");
      match.fired.add(index);
    }
  });
  return match;
}
const MAX_TURN_DELTA$1 = 100;
const clamp$1 = (value, lo, hi) => Math.max(lo, Math.min(hi, value));
function replyKeywordDelta(meter, current, match, priorKeywordMove) {
  let sum = match.sum;
  let rejected;
  let next;
  if (meter.type === MeterType.NUMBER) {
    if (sum < 0 && !meter.spendable) {
      sum = 0;
    }
    next = roundMeterValue(meter, current + sum);
    if (next < 0) {
      rejected = "insufficient_funds";
      next = current;
    }
  } else {
    next = clamp$1(current + clamp$1(sum, -MAX_TURN_DELTA$1 - priorKeywordMove, MAX_TURN_DELTA$1 - priorKeywordMove), meter.min, meter.max);
  }
  if (next === current && !rejected) {
    return void 0;
  }
  const delta = {
    meter_id: meter.id,
    delta: meter.type === MeterType.NUMBER ? roundMeterValue(meter, next - current) : next - current,
    sources: ["keyword"],
    receipts: match.receipts
  };
  if (rejected) {
    delta.rejected = rejected;
  }
  return { next, delta };
}
const detectedMeters = (deltas) => new Set(deltas.filter((delta) => delta.detected).map((delta) => delta.meter_id));
const isDecayOnly = (delta) => delta.sources.length === 1 && delta.sources[0] === "decay";
function recordReplyDelta(args) {
  const { meter, values, deltas, quiet, match, outcome, decay, current } = args;
  const replyDelta = (outcome == null ? void 0 : outcome.delta) ?? { meter_id: meter.id, delta: 0, sources: ["keyword"], receipts: match.receipts };
  let kept = deltas;
  if (decay) {
    kept = kept.filter((delta) => delta !== decay);
    replyDelta.undone_decay = decay;
  }
  const didMove = match.sum !== 0 || decay !== void 0;
  const quietCount = quiet == null ? void 0 : quiet[meter.id];
  if (didMove && quietCount !== void 0) {
    replyDelta.undone_quiet = quietCount;
    quiet == null ? true : delete quiet[meter.id];
  }
  values[meter.id] = (outcome == null ? void 0 : outcome.next) ?? current;
  replyDelta.reply = true;
  kept.push(replyDelta);
  return kept;
}
function applyReplyKeywords(def, values, priorDeltas, options) {
  const { userText, quiet } = options;
  let deltas = [...priorDeltas];
  const settled = detectedMeters(priorDeltas);
  def.meters.forEach((meter) => {
    if (meter.type === MeterType.CLOCK || meter.type === MeterType.DICE || !readsBotReply(meter) || !meter.keywords.length || settled.has(meter.id)) {
      return;
    }
    const userMatch = readsUserMessage(meter) ? matchMeterKeywords(meter, userText) : void 0;
    const match = matchMeterKeywords(meter, options.replyText, userMatch == null ? void 0 : userMatch.fired);
    if (!match.fired.size) {
      return;
    }
    const decay = match.sum === 0 ? void 0 : deltas.find((delta) => delta.meter_id === meter.id && isDecayOnly(delta));
    const current = (values[meter.id] ?? meter.default) - ((decay == null ? void 0 : decay.delta) ?? 0);
    const priorKeywordMove = clamp$1((userMatch == null ? void 0 : userMatch.sum) ?? 0, -MAX_TURN_DELTA$1, MAX_TURN_DELTA$1);
    const outcome = replyKeywordDelta(meter, current, match, priorKeywordMove);
    if (!outcome && !decay && !(match.sum !== 0 && (quiet == null ? void 0 : quiet[meter.id]) !== void 0)) {
      return;
    }
    deltas = recordReplyDelta({ meter, values, deltas, quiet, match, outcome, decay, current });
  });
  return deltas;
}
function revertReplyKeywords(values, deltas, quiet) {
  const kept = [];
  const settled = detectedMeters(deltas);
  deltas.forEach((delta) => {
    if (!delta.reply || settled.has(delta.meter_id)) {
      kept.push(delta);
      return;
    }
    const undone = delta.undone_decay;
    values[delta.meter_id] = (values[delta.meter_id] ?? 0) - delta.delta + ((undone == null ? void 0 : undone.delta) ?? 0);
    if (undone) {
      kept.push(undone);
    }
    if (quiet && delta.undone_quiet !== void 0) {
      quiet[delta.meter_id] = delta.undone_quiet;
    }
  });
  return kept;
}
const isBlank$1 = (text) => !text || !text.trim();
const nonBlank$1 = (text) => isBlank$1(text) ? void 0 : text;
function levelFrom(meter, i) {
  var _a, _b;
  if (i === 0) {
    if (meter.type === MeterType.NUMBER) {
      return 0;
    }
    return meter.type === MeterType.DICE ? DICE_FIRST_FACE : meter.min;
  }
  if (meter.type === MeterType.NUMBER) {
    return nextLevelFrom(meter, ((_a = meter.levels[i - 1]) == null ? void 0 : _a.to) ?? -levelStep(meter));
  }
  return (((_b = meter.levels[i - 1]) == null ? void 0 : _b.to) ?? -1) + 1;
}
function testCondition(cond, def, values) {
  const value = values[cond.meter_id];
  if (value === null || value === void 0) {
    return false;
  }
  const meter = def.meters.find((candidate) => candidate.id === cond.meter_id);
  if ((meter == null ? void 0 : meter.type) === MeterType.DICE && value < DICE_FIRST_FACE) {
    return false;
  }
  if ((meter == null ? void 0 : meter.type) === MeterType.CLOCK) {
    const readout = readClock(meter, value);
    if (cond.op === "tod_is") {
      return meter.mode !== "date" && todLevelIndex(meter, readout.minute_of_day) === cond.level_index;
    }
    if (cond.op === "day>=") {
      return readout.day >= cond.value;
    }
    if (cond.op === "day<=") {
      return readout.day <= cond.value;
    }
    return false;
  }
  if (cond.op === "tod_is" || cond.op === "day>=" || cond.op === "day<=") {
    return false;
  }
  if (cond.op === ">=") {
    return value >= cond.value;
  }
  if (cond.op === "<=") {
    return value <= cond.value;
  }
  if (cond.op === ">") {
    return value > cond.value;
  }
  return value < cond.value;
}
function counterValueLine(meter, value) {
  const unit = meter.unit ? " " + meter.unit : "";
  const text = formatMeterValue(meter, value) + unit;
  if (meter.display === "level") {
    const i = levelIndex(meter.levels, value);
    const level = meter.levels[i];
    return meter.label + ": level " + (i + 1) + " (" + ((level == null ? void 0 : level.label) ?? "") + "), " + text + ".";
  }
  return meter.label + ": " + text + ".";
}
function resolveActiveRules(def, values) {
  const rules = [];
  def.meters.forEach((meter) => {
    if (meter.type !== MeterType.CLOCK) {
      return;
    }
    const readout = readClock(meter, values[meter.id] ?? 0);
    if (meter.tell_model) {
      rules.push({
        key: meter.id + ":now",
        kind: "now",
        meter_id: meter.id,
        instruction: readout.sentence,
        tag: meter.label
      });
    }
    const dims = clockDimensions(meter);
    if (meter.mode !== "date" && dims.includes("tod") && meter.tod_levels.length) {
      const i = todLevelIndex(meter, readout.minute_of_day);
      meter.tod_levels.slice(i, i + 1).forEach((level) => {
        const instruction = nonBlank$1(level.instruction);
        const caption = nonBlank$1(level.caption);
        rules.push({
          key: meter.id + ":tod" + i,
          kind: "level",
          meter_id: meter.id,
          ...instruction !== void 0 ? { instruction } : {},
          ...caption !== void 0 ? { caption } : {},
          override: level.override,
          tag: level.label
        });
      });
    }
    if (dims.includes("day") && meter.day_levels.length) {
      const i = dayLevelIndex(meter, readout.day);
      meter.day_levels.slice(i, i + 1).forEach((level) => {
        const instruction = nonBlank$1(level.instruction);
        const caption = nonBlank$1(level.caption);
        rules.push({
          key: meter.id + ":day" + i,
          kind: "level",
          meter_id: meter.id,
          ...instruction !== void 0 ? { instruction } : {},
          ...caption !== void 0 ? { caption } : {},
          override: level.override,
          tag: level.label
        });
      });
    }
  });
  def.meters.forEach((meter) => {
    if (meter.type === MeterType.NUMBER && meter.tell_model) {
      const value = values[meter.id] ?? 0;
      rules.push({
        key: meter.id + ":now",
        kind: "now",
        meter_id: meter.id,
        instruction: counterValueLine(meter, value),
        tag: meter.label
      });
    }
  });
  def.meters.forEach((meter) => {
    if (meter.type === MeterType.CLOCK) {
      return;
    }
    if (meter.type === MeterType.DICE && (values[meter.id] ?? 0) < DICE_FIRST_FACE) {
      return;
    }
    const i = levelIndex(meter.levels, values[meter.id] ?? 0);
    meter.levels.slice(i, i + 1).forEach((level) => {
      const instruction = nonBlank$1(level.instruction);
      const caption = nonBlank$1(level.caption);
      rules.push({
        key: meter.id + ":" + i,
        kind: "level",
        meter_id: meter.id,
        ...instruction !== void 0 ? { instruction } : {},
        ...caption !== void 0 ? { caption } : {},
        override: level.override,
        tag: meter.label + " · " + level.label
      });
    });
  });
  def.combined_rules.forEach((rule, ruleIndex) => {
    if (rule.conditions.length && rule.conditions.every((cond) => testCondition(cond, def, values))) {
      const instruction = nonBlank$1(rule.instruction);
      const caption = nonBlank$1(rule.caption);
      rules.push({
        key: "combined:" + rule.id,
        kind: "combined",
        rule_id: rule.id,
        ...instruction !== void 0 ? { instruction } : {},
        ...caption !== void 0 ? { caption } : {},
        tag: "Rule " + (ruleIndex + 1)
      });
    }
  });
  return rules.map((rule) => rule.instruction ? { ...rule, instruction: renderMeterTokens(rule.instruction, def, values) } : rule);
}
function resolveCaption(active) {
  var _a;
  return (_a = resolveCaptionSource(active)) == null ? void 0 : _a.caption;
}
function resolveCaptionSource(active) {
  const combined = active.find((rule) => rule.kind === "combined" && rule.caption);
  if (combined == null ? void 0 : combined.caption) {
    return { caption: combined.caption, meter_id: null };
  }
  const level = active.find((rule) => rule.kind === "level" && rule.override && rule.caption) ?? active.find((rule) => rule.kind === "level" && rule.caption);
  return (level == null ? void 0 : level.caption) ? { caption: level.caption, meter_id: level.meter_id ?? null } : void 0;
}
function instructionLines(active) {
  return active.filter((rule) => rule.instruction && rule.instruction.trim()).map((rule) => ({ key: rule.key, text: rule.instruction, tag: rule.tag }));
}
const clamp = (value, lo, hi) => Math.max(lo, Math.min(hi, value));
const MAX_TURN_DELTA = 100;
const rollDieUniformly = (sides) => 1 + Math.floor(Math.random() * sides);
function rollDiceMeter(meter, value, input) {
  const rolled = Math.max(1, Math.min(meter.sides, Math.round((input.rollDie ?? rollDieUniformly)(meter.sides))));
  return {
    value: rolled,
    delta: { meter_id: meter.id, delta: rolled - value, sources: ["roll"], receipts: ["Rolled " + rolled + " on d" + meter.sides] },
    skippedBy: void 0
  };
}
function clockDelta(meter, delta, source, receipt) {
  return { meter_id: meter.id, delta, sources: [source], receipts: receipt ? [receipt] : [] };
}
function advanceClock(meter, value, input, turnAfter) {
  const empty = { value, delta: void 0, skippedBy: void 0 };
  const skip = resolveClockSkip(meter, value, input.ai);
  if (skip) {
    return { value: skip.value, delta: clockDelta(meter, skip.value - value, "skip", skip.label), skippedBy: skip.label };
  }
  const step = stepClock(meter, value, turnAfter);
  if (step.value === value) {
    return empty;
  }
  return {
    value: step.value,
    delta: clockDelta(meter, step.value - value, "step", step.receipt),
    skippedBy: void 0
  };
}
function cooldownFiredKey(meter, aiRowKey, next, nextWithoutAi, rejected) {
  var _a;
  if (rejected || next === nextWithoutAi || aiRowKey === void 0) {
    return void 0;
  }
  const row = (_a = meter.ai) == null ? void 0 : _a.rows.find((candidate) => candidate.id === aiRowKey.slice(meter.id.length + 1));
  return (row == null ? void 0 : row.cooldown) ? aiRowKey : void 0;
}
function collectAiContribution(meter, input) {
  var _a, _b;
  if (!((_a = meter.ai) == null ? void 0 : _a.enabled)) {
    return void 0;
  }
  const inputDelta = (_b = input.ai) == null ? void 0 : _b.deltas[meter.id];
  if (!inputDelta) {
    return void 0;
  }
  if (inputDelta.delta === 0 && inputDelta.row_id === void 0 && inputDelta.total === void 0) {
    return void 0;
  }
  const amount = clamp(inputDelta.delta, meter.ai.per_turn_min, meter.ai.per_turn_max);
  if (!amount) {
    return void 0;
  }
  return { amount, receipts: inputDelta.receipts, rowKey: inputDelta.row_id !== void 0 ? meter.id + "." + inputDelta.row_id : void 0 };
}
function applyMeterMechanics(meter, sum, value, quietBefore) {
  const sources = [];
  const receipts = [];
  let rejected;
  let quiet;
  if (meter.type === MeterType.NUMBER) {
    if (meter.per_message) {
      sum += meter.per_message;
      sources.push("per_message");
      receipts.push("+" + meter.per_message + " per message");
    }
    if (sum < 0 && !meter.spendable) {
      sum = 0;
    }
    if (roundMeterValue(meter, value + sum) < 0) {
      rejected = "insufficient_funds";
      sum = 0;
    }
  } else {
    if (sum === 0 && meter.decay) {
      const every = meter.decay_every ?? 1;
      const quietNow = quietBefore + 1;
      if (quietNow >= every) {
        sum = meter.decay;
        sources.push("decay");
        receipts.push("Decay " + (meter.decay > 0 ? "+" : "") + meter.decay);
      } else {
        quiet = quietNow;
      }
    }
    sum = clamp(sum, -MAX_TURN_DELTA, MAX_TURN_DELTA);
  }
  return { sum, rejected, sources, receipts, ...quiet !== void 0 ? { quiet } : {} };
}
function advanceValueMeter(meter, value, input, quietBefore) {
  const sources = /* @__PURE__ */ new Set();
  const receipts = [];
  let sum = 0;
  const keywords = matchMeterKeywords(meter, readsUserMessage(meter) ? input.text : "");
  if (keywords.fired.size) {
    sum += keywords.sum;
    sources.add("keyword");
    receipts.push(...keywords.receipts);
  }
  const keywordSum = sum;
  const aiContribution = collectAiContribution(meter, input);
  let aiRowKey;
  if (aiContribution) {
    sum += aiContribution.amount;
    sources.add("ai");
    receipts.push(...aiContribution.receipts);
    aiRowKey = aiContribution.rowKey;
  }
  const mechanics = applyMeterMechanics(meter, sum, value, quietBefore);
  sum = mechanics.sum;
  const { rejected } = mechanics;
  mechanics.sources.forEach((source) => sources.add(source));
  receipts.push(...mechanics.receipts);
  if (rejected) {
    aiRowKey = void 0;
  }
  const boundValue = (total) => meter.type === MeterType.NUMBER ? roundMeterValue(meter, Math.max(0, value + total)) : clamp(value + total, meter.min, meter.max);
  const next = boundValue(sum);
  const nextWithoutAi = aiContribution && aiRowKey !== void 0 ? boundValue(applyMeterMechanics(meter, keywordSum, value, quietBefore).sum) : next;
  const firedKey = cooldownFiredKey(meter, aiRowKey, next, nextWithoutAi, rejected);
  const outcome = {
    value: next,
    delta: void 0,
    skippedBy: void 0,
    ...firedKey ? { firedKey } : {},
    ...mechanics.quiet !== void 0 ? { quiet: mechanics.quiet } : {}
  };
  if (next === value && !rejected) {
    return outcome;
  }
  const delta = {
    meter_id: meter.id,
    delta: meter.type === MeterType.NUMBER ? roundMeterValue(meter, next - value) : next - value,
    sources: [...sources],
    receipts
  };
  if (rejected) {
    delta.rejected = rejected;
  }
  outcome.delta = delta;
  return outcome;
}
function evaluateRulebookTurn(def, prev, input) {
  const values = {};
  const deltas = [];
  const turnAfter = prev.turn + 1;
  const fired = { ...prev.fired };
  const quiet = { ...prev.quiet };
  let skippedBy;
  const clockMeter = def.meters.find((meter) => meter.type === MeterType.CLOCK);
  if (clockMeter) {
    const outcome = advanceClock(clockMeter, prev.values[clockMeter.id] ?? 0, input, turnAfter);
    values[clockMeter.id] = outcome.value;
    if (outcome.delta) {
      deltas.push(outcome.delta);
    }
    skippedBy = outcome.skippedBy;
  }
  def.meters.forEach((meter) => {
    var _a;
    if (meter.type === MeterType.CLOCK) {
      return;
    }
    const outcome = meter.type === MeterType.DICE ? rollDiceMeter(meter, prev.values[meter.id] ?? 0, input) : advanceValueMeter(meter, prev.values[meter.id] ?? meter.default, input, ((_a = prev.quiet) == null ? void 0 : _a[meter.id]) ?? 0);
    values[meter.id] = outcome.value;
    if (outcome.delta) {
      deltas.push(outcome.delta);
    }
    if (outcome.firedKey) {
      fired[outcome.firedKey] = turnAfter;
    }
    const decayEvery = meter.type === MeterType.BAR || meter.type === MeterType.PIPS ? meter.decay_every ?? 1 : 1;
    if (outcome.quiet !== void 0 && decayEvery > 1) {
      quiet[meter.id] = outcome.quiet;
    } else {
      delete quiet[meter.id];
    }
  });
  const active = resolveActiveRules(def, values);
  const prevActive = resolveActiveRules(def, prev.values);
  const nextKeys = instructionLines(active).map((line) => line.key);
  const prevKeys = instructionLines(prevActive).map((line) => line.key);
  const added = nextKeys.filter((key) => !prevKeys.includes(key));
  const removed = prevKeys.filter((key) => !nextKeys.includes(key));
  const clock = clockMeter ? readClock(clockMeter, values[clockMeter.id] ?? 0) : void 0;
  if (clock && skippedBy) {
    clock.skipped_by = skippedBy;
  }
  const result = {
    state: {
      rulebook_id: def.id,
      values,
      turn: turnAfter,
      ...Object.keys(fired).length ? { fired } : {},
      ...Object.keys(quiet).length ? { quiet } : {}
    },
    deltas,
    active,
    added,
    removed
  };
  const captionSource = resolveCaptionSource(active);
  if (captionSource !== void 0) {
    result.caption = captionSource.caption;
    result.caption_meter_id = captionSource.meter_id;
  }
  if (clock) {
    result.clock = clock;
  }
  return result;
}
function hasUserTrackedAiMeter(definition) {
  return definition.meters.some(
    (meter) => meter.type !== MeterType.CLOCK && meter.type !== MeterType.DICE && meter.tracks !== "character" && meter.ai !== void 0 && meter.ai.enabled && (meter.ai.mode === MeterAiMode.EXTRACT || meter.ai.rows.length > 0)
  );
}
const isFiniteNumber = (value) => typeof value === "number" && Number.isFinite(value);
function meterNeverMoves(meter) {
  var _a;
  if (meter.type === MeterType.DICE || meter.type === MeterType.CLOCK) {
    return false;
  }
  if (!Array.isArray(meter.keywords)) {
    return false;
  }
  if (meter.keywords.length > 0 || ((_a = meter.ai) == null ? void 0 : _a.enabled) === true) {
    return false;
  }
  if (meter.type === MeterType.NUMBER) {
    return !meter.per_message;
  }
  if (!isFiniteNumber(meter.decay) || !isFiniteNumber(meter.default) || !isFiniteNumber(meter.min) || !isFiniteNumber(meter.max)) {
    return false;
  }
  const isDecayStuckAtBound = meter.decay < 0 && meter.default <= meter.min || meter.decay > 0 && meter.default >= meter.max;
  return !meter.decay || isDecayStuckAtBound;
}
const LEGACY_BOT_TOKEN_RE = /\{\{\s*bot\s*\}\}/gi;
function normalizeLegacyRulebookTokens(text) {
  return text.replace(LEGACY_BOT_TOKEN_RE, "{{char}}");
}
const METER_COLOR_KEYS = [
  "magenta",
  "pink",
  "red",
  "orange",
  "amber",
  "lime",
  "green",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "gray",
  "contrast"
];
const METER_COLOR_PALETTE = {
  magenta: { light: "#B7318E", dark: "#D65DB1" },
  pink: { light: "#F43F7A", dark: "#F76A98" },
  red: { light: "#E62C26", dark: "#F0554F" },
  orange: { light: "#F97316", dark: "#FB923C" },
  amber: { light: "#F5A524", dark: "#F7B955" },
  lime: { light: "#84CC16", dark: "#A3E635" },
  green: { light: "#17C964", dark: "#3ED97F" },
  teal: { light: "#0FA88A", dark: "#2DD4B0" },
  cyan: { light: "#14B8C4", dark: "#3FD0DA" },
  blue: { light: "#2B8EFF", dark: "#5CA8FF" },
  indigo: { light: "#6366F1", dark: "#818CF8" },
  purple: { light: "#9750DD", dark: "#B07CE8" },
  gray: { light: "#8F8F8F", dark: "#A3A3A3" },
  /** Near-black on light, near-white on dark: the prototype's white swatch, readable in both themes. */
  contrast: { light: "#3F3F46", dark: "#F2F2F2" }
};
function isMeterColorKey(value) {
  return typeof value === "string" && METER_COLOR_KEYS.includes(value);
}
const LEGACY_HEX_TO_KEY = Object.fromEntries(
  METER_COLOR_KEYS.flatMap((key) => [
    [METER_COLOR_PALETTE[key].dark.toLowerCase(), key],
    [METER_COLOR_PALETTE[key].light.toLowerCase(), key]
  ])
);
function meterColorKeyFromLegacyHex(value) {
  const lowered = value.toLowerCase();
  return Object.hasOwn(LEGACY_HEX_TO_KEY, lowered) ? LEGACY_HEX_TO_KEY[lowered] : void 0;
}
const RULEBOOK_EXPORT_SCHEMA_V1_DRAFT = "rulebook/v1-draft";
const DEFAULT_MIN = 0;
const DEFAULT_MAX = 100;
const DEFAULT_AI_MIN = -99;
const DEFAULT_AI_MAX = 99;
const DEFAULT_CLOCK_START = "2026-01-01T12:00";
const DEFAULT_DICE_SIDES = 20;
const DICE_TRACKS = "chat";
class RulebookExportError extends Error {
  /** @param message human-readable reason the envelope was rejected. */
  constructor(message) {
    super(message);
    this.name = "RulebookExportError";
  }
}
const isRecord = (value) => typeof value === "object" && value !== null;
function isRulebookExportEnvelope(value) {
  return isRecord(value) && value["schema"] === RULEBOOK_EXPORT_SCHEMA_V1_DRAFT && isRecord(value["rulebook"]);
}
const isBlank = (text) => !text || !text.trim();
const nonBlank = (text) => isBlank(text) ? void 0 : text;
const nonBlankTokens = (text) => {
  const value = nonBlank(text);
  return value === void 0 ? void 0 : normalizeLegacyRulebookTokens(value);
};
function normalizeLevel(level, meterId) {
  if (isRecord(level) && level["mood"] !== void 0) {
    throw new RulebookExportError(`Meter ${meterId} level uses the removed "mood" key (renamed to "caption")`);
  }
  const instruction = nonBlankTokens(level.instr);
  const caption = nonBlankTokens(level.caption);
  return {
    label: level.label,
    to: level.to ?? null,
    ...instruction !== void 0 ? { instruction } : {},
    ...caption !== void 0 ? { caption } : {},
    revealed: level.revealed ?? true,
    override: level.override ?? false
  };
}
function normalizeTracks(raw, meterId) {
  if (raw === "user" || raw === "character" || raw === "chat") {
    return raw;
  }
  if (raw === void 0) {
    throw new RulebookExportError(`Meter ${meterId} is missing "tracks"`);
  }
  throw new RulebookExportError(`Meter ${meterId} has an unknown "tracks" value ${JSON.stringify(raw)}`);
}
function normalizeCondition(cond) {
  switch (cond.op) {
    case "tod":
      return { meter_id: cond.m, op: "tod_is", level_index: cond.v };
    case "day≥":
    case "day>=":
      return { meter_id: cond.m, op: "day>=", value: cond.v };
    case "day≤":
    case "day<=":
      return { meter_id: cond.m, op: "day<=", value: cond.v };
    case "≥":
    case ">=":
      return { meter_id: cond.m, op: ">=", value: cond.v };
    case "≤":
    case "<=":
      return { meter_id: cond.m, op: "<=", value: cond.v };
    case ">":
      return { meter_id: cond.m, op: ">", value: cond.v };
    case "<":
      return { meter_id: cond.m, op: "<", value: cond.v };
    default:
      throw new RulebookExportError(`Condition for meter ${cond.m} has an unknown operator ${JSON.stringify(cond.op)}`);
  }
}
function normalizeMeterColor(color) {
  if (color === void 0) {
    return void 0;
  }
  return isMeterColorKey(color) ? color : meterColorKeyFromLegacyHex(color);
}
function meterCommon(raw) {
  const color = normalizeMeterColor(raw.color);
  return {
    id: raw.id,
    label: raw.label,
    ...raw.icon !== void 0 ? { icon: raw.icon } : {},
    ...color !== void 0 ? { color } : {},
    tracks: normalizeTracks(raw.tracks, raw.id),
    visible: raw.visible ?? true,
    ...raw.raises || raw.lowers ? {
      tells_users: {
        raises: (raw.raises ?? []).map(normalizeLegacyRulebookTokens),
        lowers: (raw.lowers ?? []).map(normalizeLegacyRulebookTokens)
      }
    } : {}
  };
}
function normalizeClock(raw, common) {
  const todLevels = (raw.todBands ?? []).map((level) => normalizeLevel(level, raw.id));
  const dayLevels = (raw.dayBands ?? []).map((level) => normalizeLevel(level, raw.id));
  const derived = [];
  if (todLevels.length && (raw.mode ?? "datetime") !== "date") {
    derived.push("tod");
  }
  if (dayLevels.length) {
    derived.push("day");
  }
  return {
    ...common,
    type: MeterType.CLOCK,
    mode: raw.mode ?? "datetime",
    display: raw.display === "daycount" ? "daycount" : "calendar",
    start: raw.start ?? DEFAULT_CLOCK_START,
    step_minutes: raw.stepMin ?? 0,
    step_every_messages: raw.stepEvery ?? 0,
    detect_skips: raw.skips ?? false,
    ...raw.skipMode !== void 0 ? { skip_mode: raw.skipMode } : {},
    tell_model: raw.tellModel ?? false,
    rule_dimensions: raw.ruleDims && raw.ruleDims.length ? raw.ruleDims : derived,
    tod_levels: todLevels,
    day_levels: dayLevels
  };
}
function normalizeDice(raw, common) {
  return {
    ...common,
    type: MeterType.DICE,
    sides: raw.sides ?? raw.max ?? DEFAULT_DICE_SIDES,
    levels: (raw.bands ?? []).map((level) => normalizeLevel(level, raw.id))
  };
}
function normalizeCounter(raw, common, keywords, ai) {
  return {
    ...common,
    type: MeterType.NUMBER,
    default: raw.def ?? 0,
    ...raw.decimals !== void 0 ? { decimals: raw.decimals } : {},
    ...raw.unit !== void 0 ? { unit: raw.unit } : {},
    display: raw.display === "level" ? "level" : "number",
    per_message: raw.perMsg ?? 0,
    spendable: raw.spend ?? false,
    tell_model: raw.tellModel ?? false,
    keywords,
    ...ai !== void 0 ? { ai } : {},
    levels: (raw.bands ?? []).map((level) => normalizeLevel(level, raw.id))
  };
}
function normalizeBounded(raw, common, type, keywords, ai) {
  return {
    ...common,
    type,
    min: raw.min ?? DEFAULT_MIN,
    max: raw.max ?? DEFAULT_MAX,
    default: raw.def ?? raw.min ?? DEFAULT_MIN,
    decay: raw.decay ?? 0,
    // Keep every supplied value except the default `1` so shape/semantic validation can reject out-of-range ones.
    ...raw.decay_every !== void 0 && raw.decay_every !== 1 ? { decay_every: raw.decay_every } : {},
    keywords,
    ...ai !== void 0 ? { ai } : {},
    levels: (raw.bands ?? []).map((level) => normalizeLevel(level, raw.id))
  };
}
function normalizeMeter(raw) {
  const record = raw;
  if (record["style"] !== void 0) {
    throw new RulebookExportError(`Meter ${raw.id} uses the removed "style" key (set "type" instead)`);
  }
  if (record["owner"] !== void 0) {
    throw new RulebookExportError(`Meter ${raw.id} uses the removed "owner" key (set "tracks" instead)`);
  }
  if (record["type"] === "counter") {
    throw new RulebookExportError(`Meter ${raw.id} uses the removed type "counter" (use "number")`);
  }
  if (raw.type === void 0) {
    throw new RulebookExportError(`Meter ${raw.id} is missing "type"`);
  }
  const type = raw.type;
  if (!Object.values(MeterType).includes(type)) {
    throw new RulebookExportError(`Meter ${raw.id} has an unknown "type" ${JSON.stringify(record["type"])}`);
  }
  if (type === MeterType.DICE) {
    return normalizeDice(raw, meterCommon({ ...raw, tracks: raw.tracks ?? DICE_TRACKS }));
  }
  const common = meterCommon(raw);
  const ai = normalizeAi(raw);
  const keywords = (raw.keywords ?? []).map((driver) => ({
    words: driver.words ?? [],
    delta: driver.delta ?? 0
  }));
  if (type === MeterType.CLOCK) {
    return normalizeClock(raw, common);
  }
  if (type === MeterType.NUMBER) {
    return normalizeCounter(raw, common, keywords, ai);
  }
  return normalizeBounded(raw, common, type, keywords, ai);
}
function normalizeAi(raw) {
  const ai = raw.ai;
  if (!ai) {
    return void 0;
  }
  const record = ai;
  if (record["rule"] !== void 0 || record["window"] !== void 0 || record["state"] !== void 0) {
    throw new RulebookExportError(`Meter ${raw.id} ai uses removed keys ("rule"/"window"/"state")`);
  }
  const rows = (ai.rules ?? []).map((row, idx) => ({
    id: row.id ?? "r" + (idx + 1),
    impact: row.d,
    ...row.when !== void 0 ? { condition: normalizeLegacyRulebookTokens(row.when) } : { condition: row.when },
    ...row.cooldown !== void 0 && row.cooldown !== 0 ? { cooldown: row.cooldown } : {}
  }));
  const isOn = ai.on ?? false;
  if (!rows.length && !isOn) {
    return void 0;
  }
  return {
    enabled: isOn,
    rows,
    per_turn_min: ai.lo ?? DEFAULT_AI_MIN,
    per_turn_max: ai.hi ?? DEFAULT_AI_MAX,
    ...ai.negOverrides !== void 0 ? { negative_overrides_positive: ai.negOverrides } : {},
    ...ai.mode !== void 0 ? { mode: ai.mode } : {},
    ...ai.extractHint !== void 0 ? { extract_hint: normalizeLegacyRulebookTokens(ai.extractHint) } : {}
  };
}
function capVisibleMeters(meters) {
  let visibleCount = 0;
  return meters.map((meter) => {
    if (!meter.visible) {
      return meter;
    }
    visibleCount += 1;
    return visibleCount > RULEBOOK_LIMITS.MAX_VISIBLE_METERS ? { ...meter, visible: false } : meter;
  });
}
function normalizeRulebookExport(envelope) {
  if (!isRulebookExportEnvelope(envelope)) {
    throw new RulebookExportError("Not a rulebook export envelope (expected schema " + RULEBOOK_EXPORT_SCHEMA_V1_DRAFT + ")");
  }
  const body = envelope.rulebook;
  const record = body;
  if (typeof record["id"] !== "string" || record["id"] === "") {
    throw new RulebookExportError("Rulebook export is missing id");
  }
  if (!Array.isArray(body.meters)) {
    throw new RulebookExportError("Rulebook export is missing meters");
  }
  if (record["combos"] !== void 0) {
    throw new RulebookExportError('Rulebook export uses the removed "combos" key (use "combined_rules")');
  }
  if (body.combined_rules !== void 0 && !Array.isArray(body.combined_rules)) {
    throw new RulebookExportError('Rulebook export "combined_rules" must be an array');
  }
  const meters = capVisibleMeters(body.meters.map(normalizeMeter));
  const rawRules = body.combined_rules ?? [];
  const combinedRules = rawRules.map((rule, idx) => {
    if (rule["mood"] !== void 0) {
      throw new RulebookExportError(`Combined rule ${rule.id ?? idx + 1} uses the removed "mood" key (renamed to "caption")`);
    }
    const caption = nonBlankTokens(rule.caption);
    return {
      id: rule.id ?? "c" + (idx + 1),
      conditions: (rule.conds ?? []).map(normalizeCondition),
      instruction: normalizeLegacyRulebookTokens(rule.instr ?? ""),
      ...caption !== void 0 ? { caption } : {}
    };
  });
  return {
    id: body.id,
    name: typeof record["name"] === "string" ? record["name"] : "",
    // An omitted description stays absent — normalizing it to "" would make the draft differ from the export.
    ...record["description"] === void 0 ? {} : { description: typeof record["description"] === "string" ? record["description"] : "" },
    meters,
    combined_rules: combinedRules
  };
}
const DEFAULT_THRESHOLD = 0.7;
const DETECT_RECEIPT = "AI · " + DETECT_QUESTION_ID;
const isBucket = (choice) => choice in CLOCK_SKIP_BUCKETS;
function appliedAiRows(ai, fired) {
  const isOverrideEngaged = fired.some((row) => row.impact < 0) && ai.negative_overrides_positive === true;
  if (!isOverrideEngaged) {
    return { applied: fired, dropped: [] };
  }
  return {
    applied: fired.filter((row) => row.impact < 0),
    dropped: fired.filter((row) => row.impact >= 0).map((row) => ({ id: row.id, reason: "override" }))
  };
}
function winningAiRow(rows) {
  return rows.reduce(
    (best, row) => Math.abs(row.impact) > Math.abs(best.impact) || Math.abs(row.impact) === Math.abs(best.impact) && row.impact < 0 && best.impact >= 0 ? row : best
  );
}
function cooldownDrops(meterId, fired, state) {
  if (!(state == null ? void 0 : state.fired)) {
    return { eligible: fired, dropped: [] };
  }
  const turnNow = state.turn;
  const eligible = [];
  const dropped = [];
  fired.forEach((row) => {
    var _a;
    const firedTurn = (_a = state.fired) == null ? void 0 : _a[meterId + "." + row.id];
    const cooldown = row.cooldown;
    const isBlocked = firedTurn !== void 0 && cooldown !== void 0 && cooldown !== 0 && (cooldown === AI_RULE_COOLDOWN_ONCE || turnNow - firedTurn <= cooldown);
    if (isBlocked) {
      dropped.push({ id: row.id, reason: "cooldown", fired_turn: firedTurn });
    } else {
      eligible.push(row);
    }
  });
  return { eligible, dropped };
}
function readOutMeterRows(meterId, ai, answers, tau, state) {
  const appliedIds = /* @__PURE__ */ new Set();
  const fired = ai.rows.filter((row) => {
    const questionId = meterId + "." + row.id;
    if (appliedIds.has(questionId)) {
      return false;
    }
    const noul = noulOf(answers, questionId);
    if (noul === void 0 || noul < tau) {
      return false;
    }
    appliedIds.add(questionId);
    return true;
  });
  if (!fired.length) {
    return void 0;
  }
  const { eligible, dropped: blockedRows } = cooldownDrops(meterId, fired, state);
  if (!eligible.length) {
    return { delta: 0, receipts: [], dropped: blockedRows };
  }
  const { applied, dropped: overrideDrops } = appliedAiRows(ai, eligible);
  const winner = winningAiRow(applied);
  const magnitudeDrops = applied.filter((row) => row !== winner).map((row) => ({ id: row.id, reason: "lower_magnitude" }));
  const dropped = [...blockedRows, ...overrideDrops, ...magnitudeDrops];
  const raw = winner.impact;
  const delta = Math.max(ai.per_turn_min, Math.min(ai.per_turn_max, raw));
  if (delta === 0 && raw === delta && dropped.length === 0) {
    return void 0;
  }
  return {
    delta,
    receipts: ["AI · " + winner.id],
    row_id: winner.id,
    ...dropped.length > 0 ? { dropped } : {},
    ...raw !== delta ? { requested: raw } : {}
  };
}
function noulOf(answers, id) {
  const answer = answers[id];
  if ((answer == null ? void 0 : answer.type) !== "noul" || !Number.isFinite(answer.noul)) {
    return void 0;
  }
  return answer.noul;
}
function readOutAiAnswers(def, answers, options) {
  const tau = (options == null ? void 0 : options.threshold) ?? DEFAULT_THRESHOLD;
  const deltas = {};
  let clockSkip;
  def.meters.forEach((meter) => {
    const ai = meter.type === MeterType.CLOCK || meter.type === MeterType.DICE ? void 0 : meter.ai;
    if ((ai == null ? void 0 : ai.enabled) && ai.mode === MeterAiMode.EXTRACT) {
      const noul = noulOf(answers, meter.id + "." + DETECT_QUESTION_ID);
      if (noul !== void 0 && noul >= tau) {
        deltas[meter.id] = { delta: 1, receipts: [DETECT_RECEIPT] };
      }
    } else if (ai == null ? void 0 : ai.enabled) {
      const rowsDelta = readOutMeterRows(meter.id, ai, answers, tau, options == null ? void 0 : options.state);
      if (rowsDelta !== void 0) {
        deltas[meter.id] = rowsDelta;
      }
    }
    if (meter.type === MeterType.CLOCK && meter.detect_skips) {
      const skipNoul = noulOf(answers, meter.id + ".skip");
      const bucketAnswer = answers[meter.id + ".bucket"];
      if (skipNoul !== void 0) {
        const chosen = (bucketAnswer == null ? void 0 : bucketAnswer.type) === "choice" && isBucket(bucketAnswer.choice) ? { bucket: bucketAnswer.choice, label: CLOCK_SKIP_BUCKETS[bucketAnswer.choice].label } : void 0;
        if (skipNoul >= tau) {
          clockSkip = { kind: "extract", ...chosen ? { fallback: chosen } : {} };
        } else {
          clockSkip = null;
        }
      }
    }
  });
  const input = { deltas };
  if (clockSkip !== void 0) {
    input.clock_skip = clockSkip;
  }
  return input;
}
const numberTargets = (def, ai, names, values) => {
  const targets = [];
  def.meters.forEach((candidate) => {
    if (candidate.type !== MeterType.NUMBER) {
      return;
    }
    const meter = candidate;
    const driver = meter.ai;
    if (!(driver == null ? void 0 : driver.enabled) || driver.mode !== MeterAiMode.EXTRACT) {
      return;
    }
    const marker = ai == null ? void 0 : ai.deltas[meter.id];
    if (!marker || marker.delta === 0) {
      return;
    }
    const currentValue = values[meter.id] ?? meter.default;
    const unit = meter.unit ? " " + meter.unit : "";
    const target = {
      kind: "number",
      meter_id: meter.id,
      label: meter.label,
      decimals: meter.decimals ?? 0,
      receipts: marker.receipts,
      current_value: currentValue,
      current_value_text: formatMeterValue(meter, currentValue) + unit
    };
    if (meter.unit !== void 0) {
      target.unit = meter.unit;
    }
    if (driver.extract_hint !== void 0) {
      target.hint = renderCondition(driver.extract_hint, def, names, values);
    }
    targets.push(target);
  });
  return targets;
};
const clockTargets = (def, ai, values) => {
  const decision = ai == null ? void 0 : ai.clock_skip;
  if ((decision == null ? void 0 : decision.kind) !== "extract") {
    return [];
  }
  const targets = [];
  def.meters.forEach((candidate) => {
    if (candidate.type !== MeterType.CLOCK) {
      return;
    }
    const meter = candidate;
    if (!meter.detect_skips) {
      return;
    }
    const currentValue = values[meter.id] ?? 0;
    const readout = readClock(meter, currentValue);
    const target = {
      kind: "clock",
      meter_id: meter.id,
      label: meter.label,
      mode: meter.mode,
      current: {
        readout: readout.long ?? readout.sentence,
        day: readout.day,
        minute_of_day: readout.minute_of_day,
        weekday: clockWeekday(meter, currentValue)
      }
    };
    if (decision.fallback) {
      target.fallback_label = decision.fallback.label;
    }
    targets.push(target);
  });
  return targets;
};
function selectAiExtractionTargets(def, ai, charName, userName, values = {}) {
  const names = { charName, userName };
  return [...numberTargets(def, ai, names, values), ...clockTargets(def, ai, values)];
}
function initialMeterValue(meter) {
  if (meter.type === MeterType.CLOCK || meter.type === MeterType.DICE) {
    return 0;
  }
  return meter.type === MeterType.NUMBER ? Math.max(0, meter.default) : meter.default;
}
function reachedLevelTexts(meterType, levels, revealedTo) {
  const texts = [];
  levels.forEach((level, index) => {
    if (!level.revealed && isLevelReached(meterType, index, revealedTo)) {
      texts.push({ index, label: level.label, ...level.caption !== void 0 ? { caption: level.caption } : {} });
    }
  });
  return texts;
}
const AI_RECEIPT = /^AI · /;
const KEYWORD_RECEIPT = /^Keyword [“"].*[”"]$/;
function publicReceipt(receipt) {
  if (KEYWORD_RECEIPT.test(receipt)) {
    return "Keyword";
  }
  if (AI_RECEIPT.test(receipt)) {
    return "AI";
  }
  return receipt;
}
function revealedIndex(meter, meta, value) {
  if (meter.type !== MeterType.DICE) {
    return meta.revealed[meter.id];
  }
  return value < DICE_FIRST_FACE ? void 0 : levelIndex(meter.levels, value);
}
function toHudMeter(meter, meta) {
  var _a, _b, _c;
  const hudMeter = { value: meta.state.values[meter.id] ?? initialMeterValue(meter) };
  const revealed = revealedIndex(meter, meta, hudMeter.value);
  if (revealed !== void 0) {
    hudMeter.revealed = revealed;
  }
  const revealedTod = (_a = meta.revealed_tod) == null ? void 0 : _a[meter.id];
  if (revealedTod !== void 0) {
    hudMeter.revealed_tod = revealedTod;
  }
  const levelTable = meter.type === MeterType.CLOCK ? meter.day_levels : meter.levels;
  const revealedLevels = reachedLevelTexts(meter.type, levelTable, revealed ?? -1);
  if (revealedLevels.length > 0) {
    hudMeter.revealed_levels = revealedLevels;
  }
  if (meter.type === MeterType.CLOCK) {
    const revealedTodLevels = reachedLevelTexts(meter.type, meter.tod_levels, ((_b = meta.revealed_tod) == null ? void 0 : _b[meter.id]) ?? -1);
    if (revealedTodLevels.length > 0) {
      hudMeter.revealed_tod_levels = revealedTodLevels;
    }
  }
  const deltas = meta.deltas.filter((delta) => delta.meter_id === meter.id);
  if (deltas.length === 0) {
    return hudMeter;
  }
  hudMeter.delta = deltas.reduce((sum, delta) => sum + delta.delta, 0);
  hudMeter.receipts = deltas.flatMap((delta) => delta.receipts).map(publicReceipt);
  const rejected = (_c = deltas.find((delta) => delta.rejected !== void 0)) == null ? void 0 : _c.rejected;
  if (rejected !== void 0) {
    hudMeter.rejected = rejected;
  }
  return hudMeter;
}
function captionSourceId(meta, definition) {
  if (meta.caption_meter_id !== void 0) {
    return meta.caption_meter_id;
  }
  const resolved = resolveCaptionSource(resolveActiveRules(definition, meta.state.values));
  return resolved !== void 0 && resolved.caption === meta.caption ? resolved.meter_id : null;
}
function toRulebookHudSnapshot(meta, definition) {
  const visibleMeters = definition.meters.filter((meter) => meter.visible !== false);
  const visibleIds = new Set(visibleMeters.map((meter) => meter.id));
  const snapshot = {
    rulebook_id: meta.state.rulebook_id,
    meters: Object.fromEntries(visibleMeters.map((meter) => [meter.id, toHudMeter(meter, meta)]))
  };
  if (meta.caption) {
    const sourceId = captionSourceId(meta, definition);
    snapshot.caption = { text: meta.caption, meter_id: sourceId !== null && visibleIds.has(sourceId) ? sourceId : null };
  }
  const clockMeter = definition.meters.find((meter) => meter.type === MeterType.CLOCK);
  if (meta.clock && clockMeter && clockMeter.visible !== false) {
    snapshot.clock = { label: meta.clock.short, day: meta.clock.day, minute_of_day: meta.clock.minute_of_day };
  }
  return snapshot;
}
function publicLevels(meterType, levels, fromOf, revealedTo) {
  return levels.map((level, idx) => {
    if (!(level.revealed || isLevelReached(meterType, idx, revealedTo))) {
      return { from: fromOf(idx), to: level.to, revealed: false };
    }
    return {
      label: level.label,
      from: fromOf(idx),
      to: level.to,
      revealed: true,
      ...level.caption !== void 0 ? { caption: level.caption } : {}
    };
  });
}
function toRulebookPublicView(rb, revealed, revealedTod) {
  const meters = rb.meters.filter((meter) => meter.visible !== false).map((meter) => {
    const revealedTo = (revealed == null ? void 0 : revealed[meter.id]) ?? -1;
    const base = {
      id: meter.id,
      type: meter.type,
      label: meter.label,
      ...meter.icon !== void 0 ? { icon: meter.icon } : {},
      ...meter.color !== void 0 ? { color: meter.color } : {},
      tracks: meter.tracks,
      ...meter.tells_users !== void 0 ? { tells_users: meter.tells_users } : {},
      levels: []
    };
    if (meter.type === MeterType.CLOCK) {
      base.display = meter.display;
      base.mode = meter.mode;
      base.tod_levels = publicLevels(
        meter.type,
        meter.tod_levels,
        (idx) => {
          var _a;
          return idx === 0 ? 0 : (((_a = meter.tod_levels[idx - 1]) == null ? void 0 : _a.to) ?? -1) + 1;
        },
        (revealedTod == null ? void 0 : revealedTod[meter.id]) ?? -1
      );
      base.day_levels = publicLevels(meter.type, meter.day_levels, (idx) => {
        var _a;
        return idx === 0 ? 1 : (((_a = meter.day_levels[idx - 1]) == null ? void 0 : _a.to) ?? 0) + 1;
      }, revealedTo);
      return base;
    }
    if (meter.type === MeterType.NUMBER) {
      if (meter.unit !== void 0) {
        base.unit = meter.unit;
      }
      if (meter.decimals !== void 0) {
        base.decimals = meter.decimals;
      }
      base.display = meter.display;
      base.spendable = meter.spendable;
      base.levels = publicLevels(
        meter.type,
        meter.levels,
        (idx) => {
          var _a;
          return idx === 0 ? 0 : nextLevelFrom(meter, ((_a = meter.levels[idx - 1]) == null ? void 0 : _a.to) ?? -levelStep(meter));
        },
        revealedTo
      );
      return base;
    }
    if (meter.type === MeterType.DICE) {
      base.min = 1;
      base.max = meter.sides;
      base.sides = meter.sides;
      base.levels = publicLevels(meter.type, meter.levels, (idx) => {
        var _a;
        return idx === 0 ? 1 : (((_a = meter.levels[idx - 1]) == null ? void 0 : _a.to) ?? 0) + 1;
      }, revealedTo);
      return base;
    }
    base.min = meter.min;
    base.max = meter.max;
    base.levels = publicLevels(
      meter.type,
      meter.levels,
      (idx) => {
        var _a;
        return idx === 0 ? meter.min : (((_a = meter.levels[idx - 1]) == null ? void 0 : _a.to) ?? meter.min - 1) + 1;
      },
      revealedTo
    );
    return base;
  });
  return {
    id: rb.id,
    name: rb.name,
    version: rb.version,
    ...rb.creator_username !== void 0 ? { creator_username: rb.creator_username } : {},
    meters,
    ...rb.meters.some((meter) => meter.visible === false) ? { has_hidden_meters: true } : {}
  };
}
function toPublicRulebookState(state, definition) {
  const visibleIds = new Set(definition.meters.filter((meter) => meter.visible !== false).map((meter) => meter.id));
  const values = Object.fromEntries(Object.entries(state.values).filter(([meterId]) => visibleIds.has(meterId)));
  return { rulebook_id: state.rulebook_id, turn: state.turn, values };
}
function looserLo(first, second) {
  if (first.value !== second.value) {
    return first.value > second.value ? first : second;
  }
  return first.inclusive ? second : first;
}
function looserHi(first, second) {
  if (first.value !== second.value) {
    return first.value < second.value ? first : second;
  }
  return first.inclusive ? second : first;
}
const TOD_LAST_BOUND = 1439;
const CHARS_PER_TOKEN = 4;
function err(ctx, code, path, message) {
  ctx.issues.push({ severity: "error", code, path, message });
}
function warn(ctx, code, path, message) {
  ctx.issues.push({ severity: "warning", code, path, message });
}
function checkChars(ctx, text, max, path) {
  if (text !== void 0 && text.length > max) {
    err(ctx, "too_long", path, "Longer than " + max + " chars");
  }
}
function checkId(ctx, id, path) {
  if (id.length > RULEBOOK_LIMITS.MAX_ID_CHARS) {
    err(ctx, "too_long", path, "Id longer than " + RULEBOOK_LIMITS.MAX_ID_CHARS + " chars");
  }
  if (!RULEBOOK_ID_PATTERN.test(id) || RULEBOOK_RESERVED_IDS.includes(id)) {
    err(ctx, "invalid_id", path, "Id '" + id + "' is not a valid identifier");
  }
}
function checkNumber(ctx, value, path) {
  if (!Number.isFinite(value) || Math.abs(value) > RULEBOOK_LIMITS.MAX_ABS_NUMBER) {
    err(ctx, "number_out_of_range", path, "Number must be finite and within ±" + RULEBOOK_LIMITS.MAX_ABS_NUMBER);
  }
}
function checkLevels(ctx, levels, path, opts) {
  if (!levels.length) {
    err(ctx, "no_levels", path, "Meter has no levels");
    return;
  }
  if (levels.length > RULEBOOK_LIMITS.MAX_LEVELS_PER_METER) {
    err(ctx, "too_many_levels", path, "More than " + RULEBOOK_LIMITS.MAX_LEVELS_PER_METER + " levels");
  }
  let prevTo = null;
  levels.forEach((level, idx) => {
    const boundPath = path + "[" + idx + "].to";
    checkChars(ctx, level.label, RULEBOOK_LIMITS.MAX_LEVEL_LABEL_CHARS, path + "[" + idx + "].label");
    checkChars(ctx, level.caption, RULEBOOK_LIMITS.MAX_CAPTION_CHARS, path + "[" + idx + "].caption");
    checkChars(ctx, level.instruction, RULEBOOK_LIMITS.MAX_INSTRUCTION_CHARS, path + "[" + idx + "].instruction");
    const isLast = idx === levels.length - 1;
    if (level.to === null) {
      if (opts.allowNull === "none" || !isLast) {
        err(ctx, "level_open_bound", boundPath, "Only the last level may have an open upper bound, and only on counters and day levels");
      }
    } else {
      if (prevTo !== null && level.to <= prevTo) {
        err(ctx, "level_order", boundPath, "Level upper bounds must be strictly increasing");
      }
      if (opts.allowNull === "none" && isLast && opts.lastTo !== void 0 && level.to !== opts.lastTo) {
        err(ctx, "level_order", boundPath, "Last level upper bound must be " + opts.lastTo);
      }
      if (opts.max !== void 0 && idx > 0 && (prevTo ?? -Infinity) + 1 > opts.max) {
        warn(ctx, "unreachable_level", path + "[" + idx + "]", "Level can never be reached (starts above max)");
      }
      checkNumber(ctx, level.to, boundPath);
      prevTo = level.to;
    }
  });
}
function tokensUnknown(ctx, text, path) {
  if (!text) {
    return;
  }
  findUnknownTokens(text, ctx.def).forEach((tok) => {
    warn(ctx, "unknown_token", path, "Unknown token " + tok);
  });
}
function checkCounterDecimals(ctx, meter, path) {
  const decimals = meter.decimals ?? 0;
  if (meter.decimals !== void 0 && (!Number.isInteger(meter.decimals) || meter.decimals < 0 || meter.decimals > RULEBOOK_LIMITS.MAX_COUNTER_DECIMALS)) {
    err(ctx, "invalid_decimals", path + ".decimals", "decimals must be an integer between 0 and " + RULEBOOK_LIMITS.MAX_COUNTER_DECIMALS);
    return;
  }
  const target = { type: MeterType.NUMBER, decimals };
  const checkValue = (value, valuePath) => {
    if (Number.isFinite(value) && roundMeterValue(target, value) !== value) {
      err(ctx, "too_many_decimals", valuePath, "Value has more fractional digits than the meter's decimals (" + decimals + ")");
    }
  };
  checkValue(meter.default, path + ".default");
  checkValue(meter.per_message, path + ".per_message");
  meter.keywords.forEach((driver, driverIdx) => checkValue(driver.delta, path + ".keywords[" + driverIdx + "].delta"));
  meter.levels.forEach((level, levelIdx) => {
    if (level.to !== null && Number.isFinite(level.to) && roundMeterValue(target, level.to) !== level.to) {
      err(ctx, "level_bound_precision", path + ".levels[" + levelIdx + "].to", "Level bound has more decimals than the meter allows");
    }
  });
  if (meter.ai) {
    checkValue(meter.ai.per_turn_min, path + ".ai.per_turn_min");
    checkValue(meter.ai.per_turn_max, path + ".ai.per_turn_max");
  }
}
function checkAi(ctx, meter, path) {
  var _a;
  if (meter.type === MeterType.CLOCK || meter.type === MeterType.DICE || !meter.ai) {
    return;
  }
  const isExtract = meter.ai.mode === MeterAiMode.EXTRACT;
  if (isExtract && meter.type !== MeterType.NUMBER) {
    err(ctx, "invalid_ai_mode", path + ".ai.mode", "Detect mode is only supported on number meters");
  }
  tokensUnknown(ctx, meter.ai.extract_hint, path + ".ai.extract_hint");
  if (meter.ai.extract_hint !== void 0 && meter.ai.extract_hint.length > RULEBOOK_LIMITS.MAX_EXTRACT_HINT_CHARS) {
    err(ctx, "extract_hint_too_long", path + ".ai.extract_hint", "extract_hint longer than " + RULEBOOK_LIMITS.MAX_EXTRACT_HINT_CHARS + " chars");
  }
  if (isExtract && !((_a = meter.ai.extract_hint) == null ? void 0 : _a.trim())) {
    warn(ctx, "extract_hint_missing", path + ".ai.extract_hint", "Detect mode should say which value to read (extract_hint)");
  }
  if (!isExtract && meter.ai.enabled && meter.ai.rows.length === 0) {
    err(ctx, "ai_rows_missing", path + ".ai.rows", "AI evaluation is on but has no rules — add a rule or turn it off");
  }
  if (meter.ai.rows.length > RULEBOOK_LIMITS.MAX_AI_ROWS_PER_METER) {
    err(ctx, "too_many_ai_rows", path + ".ai", "More than " + RULEBOOK_LIMITS.MAX_AI_ROWS_PER_METER + " AI rows");
  }
  const seenRowIds = /* @__PURE__ */ new Set();
  meter.ai.rows.forEach((row, rowIdx) => {
    checkId(ctx, row.id, path + ".ai.rows[" + rowIdx + "].id");
    if (seenRowIds.has(row.id)) {
      err(ctx, "duplicate_row_id", path + ".ai.rows[" + rowIdx + "].id", "Duplicate AI row id '" + row.id + "'");
    }
    seenRowIds.add(row.id);
    checkNumber(ctx, row.impact, path + ".ai.rows[" + rowIdx + "].impact");
    if (row.cooldown !== void 0) {
      const isValidCooldown = Number.isInteger(row.cooldown) && (row.cooldown === AI_RULE_COOLDOWN_ONCE || row.cooldown >= 0 && row.cooldown <= MAX_AI_RULE_COOLDOWN);
      if (!isValidCooldown) {
        err(
          ctx,
          "invalid_cooldown",
          path + ".ai.rows[" + rowIdx + "].cooldown",
          "cooldown must be " + AI_RULE_COOLDOWN_ONCE + " (once) or an integer between 0 and " + MAX_AI_RULE_COOLDOWN
        );
      }
    }
    if (row.condition.length > RULEBOOK_LIMITS.MAX_CONDITION_LENGTH) {
      err(
        ctx,
        "condition_too_long",
        path + ".ai.rows[" + rowIdx + "].condition",
        "Condition longer than " + RULEBOOK_LIMITS.MAX_CONDITION_LENGTH + " chars"
      );
    }
    tokensUnknown(ctx, row.condition, path + ".ai.rows[" + rowIdx + "].condition");
  });
  checkNumber(ctx, meter.ai.per_turn_min, path + ".ai.per_turn_min");
  checkNumber(ctx, meter.ai.per_turn_max, path + ".ai.per_turn_max");
  if (meter.ai.per_turn_min > meter.ai.per_turn_max) {
    err(ctx, "invalid_ai_range", path + ".ai", "per_turn_min is greater than per_turn_max");
  }
}
function checkClock(ctx, meter, path) {
  if (meter.tod_levels.length) {
    const lastLevel = meter.tod_levels[meter.tod_levels.length - 1];
    if ((lastLevel == null ? void 0 : lastLevel.to) !== TOD_LAST_BOUND) {
      err(ctx, "tod_level_bounds", path + ".tod_levels", "Last time-of-day level must end at " + TOD_LAST_BOUND);
    }
    checkLevels(ctx, meter.tod_levels, path + ".tod_levels", { allowNull: "none", lastTo: TOD_LAST_BOUND });
  }
  if (meter.day_levels.length) {
    checkLevels(ctx, meter.day_levels, path + ".day_levels", { allowNull: "last" });
  }
  if (!meter.tod_levels.length && !meter.day_levels.length) {
    err(ctx, "no_levels", path, "Clock has no time-of-day or day levels");
  }
  if (meter.rule_dimensions.includes("tod") && !meter.tod_levels.length) {
    err(ctx, "missing_dimension_levels", path + ".tod_levels", "rule_dimensions includes 'tod' but tod_levels is empty");
  }
  if (meter.mode === "date" && meter.rule_dimensions.includes("tod")) {
    warn(ctx, "tod_in_date_mode", path + ".rule_dimensions", "A date-only clock has no time of day, so time-of-day levels never apply");
  }
  if (meter.rule_dimensions.includes("day") && !meter.day_levels.length) {
    err(ctx, "missing_dimension_levels", path + ".day_levels", "rule_dimensions includes 'day' but day_levels is empty");
  }
  if (meter.rule_dimensions.length > RULEBOOK_LIMITS.MAX_CLOCK_DIMENSIONS) {
    err(ctx, "too_many_dimensions", path + ".rule_dimensions", "More than " + RULEBOOK_LIMITS.MAX_CLOCK_DIMENSIONS + " rule dimensions");
  }
  checkChars(ctx, meter.start, RULEBOOK_LIMITS.MAX_CLOCK_START_CHARS, path + ".start");
  if (!Number.isInteger(meter.step_minutes) || meter.step_minutes < 0 || meter.step_minutes > RULEBOOK_LIMITS.MAX_CLOCK_STEP_MINUTES) {
    err(
      ctx,
      "number_out_of_range",
      path + ".step_minutes",
      "step_minutes must be an integer between 0 and " + RULEBOOK_LIMITS.MAX_CLOCK_STEP_MINUTES
    );
  }
  if (!Number.isInteger(meter.step_every_messages) || meter.step_every_messages < 0) {
    err(ctx, "invalid_clock_step", path + ".step_every_messages", "step_every_messages must be an integer >= 0");
  }
  if (meter.skip_mode !== void 0 && meter.skip_mode !== MeterAiMode.RULES && meter.skip_mode !== MeterAiMode.EXTRACT) {
    err(ctx, "invalid_clock_skip_mode", path + ".skip_mode", 'skip_mode must be "rules" or "extract"');
  }
  const longestTod = Math.max(0, ...meter.tod_levels.map((level) => estimateRenderedChars(level.instruction ?? "", ctx.def)));
  const longestDay = Math.max(0, ...meter.day_levels.map((level) => estimateRenderedChars(level.instruction ?? "", ctx.def)));
  const chars = longestTod + longestDay + (meter.tell_model ? readClock(meter, 0).sentence.length : 0);
  meter.tod_levels.forEach((level, idx) => {
    tokensUnknown(ctx, level.instruction, path + ".tod_levels[" + idx + "].instruction");
    tokensUnknown(ctx, level.caption, path + ".tod_levels[" + idx + "].caption");
  });
  meter.day_levels.forEach((level, idx) => {
    tokensUnknown(ctx, level.instruction, path + ".day_levels[" + idx + "].instruction");
    tokensUnknown(ctx, level.caption, path + ".day_levels[" + idx + "].caption");
  });
  return chars;
}
function checkKeywords(ctx, meter, path) {
  if (meter.keywords.length > RULEBOOK_LIMITS.MAX_KEYWORD_DRIVERS_PER_METER) {
    err(ctx, "too_many_keywords", path + ".keywords", "More than " + RULEBOOK_LIMITS.MAX_KEYWORD_DRIVERS_PER_METER + " keyword drivers");
  }
  meter.keywords.forEach((driver, driverIdx) => {
    const driverPath = path + ".keywords[" + driverIdx + "]";
    const wordsPath = driverPath + ".words";
    checkNumber(ctx, driver.delta, driverPath + ".delta");
    if (driver.words.length > RULEBOOK_LIMITS.MAX_WORDS_PER_KEYWORD_DRIVER) {
      err(ctx, "too_many_keyword_words", wordsPath, "More than " + RULEBOOK_LIMITS.MAX_WORDS_PER_KEYWORD_DRIVER + " words in one keyword driver");
    }
    driver.words.forEach((word, wordIdx) => {
      const wordPath = wordsPath + "[" + wordIdx + "]";
      if (word.length > RULEBOOK_LIMITS.MAX_KEYWORD_CHARS) {
        err(ctx, "keyword_too_long", wordPath, "Keyword longer than " + RULEBOOK_LIMITS.MAX_KEYWORD_CHARS + " chars");
      } else if (word.trim().length === 0) {
        warn(ctx, "empty_keyword", wordPath, "Keyword is empty");
      } else if (word.includes("*") && !word.endsWith("*")) {
        warn(ctx, "keyword_wildcard_position", wordPath, "Only a trailing * acts as a wildcard");
      }
    });
  });
}
function checkDiceMeter(ctx, meter, path) {
  var _a;
  const isValidSides = Number.isInteger(meter.sides) && meter.sides >= RULEBOOK_LIMITS.MIN_DICE_SIDES && meter.sides <= RULEBOOK_LIMITS.MAX_DICE_SIDES;
  if (!isValidSides) {
    err(
      ctx,
      "invalid_dice_sides",
      path + ".sides",
      "Dice must have " + RULEBOOK_LIMITS.MIN_DICE_SIDES + " to " + RULEBOOK_LIMITS.MAX_DICE_SIDES + " sides"
    );
  }
  checkLevels(ctx, meter.levels, path + ".levels", { allowNull: "none", lastTo: meter.sides, max: meter.sides });
  const firstLevelTo = (_a = meter.levels[0]) == null ? void 0 : _a.to;
  if (firstLevelTo !== null && firstLevelTo !== void 0 && firstLevelTo < DICE_FIRST_FACE) {
    err(ctx, "level_order", path + ".levels[0].to", "First dice level must end at face 1 or higher");
  }
}
function checkDecayEvery(ctx, every, path) {
  if (every !== void 0 && (!Number.isInteger(every) || every < 1 || every > MAX_DECAY_EVERY)) {
    err(ctx, "invalid_decay_every", path, "decay_every must be an integer between 1 and " + MAX_DECAY_EVERY);
  }
}
function checkValueMeter(ctx, meter, path) {
  let chars = 0;
  if (meter.type === MeterType.DICE) {
    checkDiceMeter(ctx, meter, path);
  } else {
    checkKeywords(ctx, meter, path);
    if (meter.type === MeterType.NUMBER) {
      checkNumber(ctx, meter.default, path + ".default");
      checkNumber(ctx, meter.per_message, path + ".per_message");
      if (meter.default < 0) {
        err(ctx, "default_out_of_range", path + ".default", "Counter default must be >= 0");
      }
      checkCounterDecimals(ctx, meter, path);
      checkLevels(ctx, meter.levels, path + ".levels", { allowNull: "last" });
      if (meter.tell_model) {
        chars += estimateRenderedChars(counterValueLine(meter, meter.default), ctx.def);
      }
      if (meterNeverMoves(meter)) {
        warn(ctx, "never_moves", path, "Meter has no keywords, no AI, and no per-message gain");
      }
    } else {
      checkNumber(ctx, meter.min, path + ".min");
      checkNumber(ctx, meter.max, path + ".max");
      checkNumber(ctx, meter.default, path + ".default");
      checkNumber(ctx, meter.decay, path + ".decay");
      checkDecayEvery(ctx, meter.decay_every, path + ".decay_every");
      if (meter.min >= meter.max) {
        err(ctx, "invalid_range", path, "min must be less than max");
      }
      if (meter.default < meter.min || meter.default > meter.max) {
        err(ctx, "default_out_of_range", path + ".default", "default must be inside [min, max]");
      }
      if (meter.type === MeterType.PIPS && meter.max - meter.min > RULEBOOK_LIMITS.MAX_PIPS_STEPS) {
        err(ctx, "pips_range", path, "pips meters may span at most " + RULEBOOK_LIMITS.MAX_PIPS_STEPS + " steps");
      }
      checkLevels(ctx, meter.levels, path + ".levels", { allowNull: "none", lastTo: meter.max, max: meter.max });
      if (meterNeverMoves(meter)) {
        warn(ctx, "never_moves", path, "Meter has no keywords, no AI, and no effective decay");
      }
    }
  }
  chars += Math.max(0, ...meter.levels.map((level) => estimateRenderedChars(level.instruction ?? "", ctx.def)));
  meter.levels.forEach((level, idx) => {
    tokensUnknown(ctx, level.instruction, path + ".levels[" + idx + "].instruction");
    tokensUnknown(ctx, level.caption, path + ".levels[" + idx + "].caption");
  });
  return chars;
}
function checkClockCondition(ctx, cond, meter, condPath) {
  if (cond.op === "tod_is") {
    if (meter.mode === "date") {
      err(ctx, "invalid_condition", condPath, "tod_is on a date-mode clock never matches");
    } else if (cond.level_index < 0 || cond.level_index >= meter.tod_levels.length) {
      err(ctx, "rule_never_matches", condPath, "tod_is level index out of range");
    }
  } else if (cond.op === "day>=" || cond.op === "day<=") {
    if (cond.op === "day<=" && cond.value < 1) {
      err(ctx, "rule_never_matches", condPath, "Day condition value out of range");
    }
  } else {
    err(ctx, "invalid_condition", condPath, "Numeric comparisons are not valid on clock meters");
  }
}
function checkBoundedCondition(ctx, cond, meter, condPath) {
  if (meter.type === MeterType.NUMBER) {
    return true;
  }
  const min = meter.type === MeterType.DICE ? 1 : meter.min;
  const max = meter.type === MeterType.DICE ? meter.sides : meter.max;
  const isUnsatisfiable = cond.op === ">=" && cond.value > max || cond.op === ">" && cond.value >= max || cond.op === "<=" && cond.value < min || cond.op === "<" && cond.value <= min;
  if (isUnsatisfiable) {
    err(ctx, "rule_never_matches", condPath, "Value outside meter range [" + min + ", " + max + "]");
    return false;
  }
  const isAlwaysTrue = cond.op === ">=" && cond.value <= min || cond.op === ">" && cond.value < min || cond.op === "<=" && cond.value >= max || cond.op === "<" && cond.value > max;
  if (isAlwaysTrue) {
    warn(ctx, "rule_always_true", condPath, "Condition is always satisfied");
  }
  return true;
}
function checkCombinedConditions(ctx, conds, path) {
  if (conds.length === 0) {
    err(ctx, "empty_conditions", path + ".conditions", "Combined rule must have at least one condition");
  }
  if (conds.length > RULEBOOK_LIMITS.MAX_CONDITIONS_PER_RULE) {
    err(ctx, "too_many_conditions", path + ".conditions", "More than " + RULEBOOK_LIMITS.MAX_CONDITIONS_PER_RULE + " conditions on one rule");
  }
  const ranges = /* @__PURE__ */ new Map();
  conds.forEach((cond, condIdx) => {
    const condPath = path + ".conditions[" + condIdx + "]";
    const meter = ctx.def.meters.find((candidate) => candidate.id === cond.meter_id);
    if (!meter) {
      err(ctx, "unknown_meter", condPath, "Condition references unknown meter '" + cond.meter_id + "'");
      return;
    }
    if (meter.type === MeterType.CLOCK) {
      checkClockCondition(ctx, cond, meter, condPath);
      return;
    }
    if (cond.op === "tod_is" || cond.op === "day>=" || cond.op === "day<=") {
      err(ctx, "invalid_condition", condPath, "Clock-only operator on a non-clock meter");
      return;
    }
    if (!checkBoundedCondition(ctx, cond, meter, condPath)) {
      return;
    }
    const range = ranges.get(cond.meter_id) ?? {};
    const bound = { value: cond.value, inclusive: cond.op === ">=" || cond.op === "<=" };
    if (cond.op === ">=" || cond.op === ">") {
      range.lo = range.lo ? looserLo(range.lo, bound) : bound;
    } else {
      range.hi = range.hi ? looserHi(range.hi, bound) : bound;
    }
    ranges.set(cond.meter_id, range);
  });
  ranges.forEach((range, meterId) => {
    if (!range.lo || !range.hi) {
      return;
    }
    const isImpossible = range.lo.value > range.hi.value || range.lo.value === range.hi.value && !(range.lo.inclusive && range.hi.inclusive);
    if (isImpossible) {
      err(ctx, "rule_never_matches", path, "Contradictory conditions on meter '" + meterId + "' can never all hold");
    }
  });
}
function validateRulebook(def) {
  const shapeIssues = checkRulebookShape(def);
  if (shapeIssues.length > 0) {
    return { valid: false, issues: shapeIssues, estimated_instruction_tokens: 0 };
  }
  const ctx = { def, issues: [] };
  const limits = RULEBOOK_LIMITS;
  if (def.meters.length > limits.MAX_METERS) {
    err(ctx, "too_many_meters", "meters", "More than " + limits.MAX_METERS + " meters");
  }
  const seen = /* @__PURE__ */ new Set();
  def.meters.forEach((meter, idx) => {
    checkId(ctx, meter.id, "meters[" + idx + "].id");
    checkChars(ctx, meter.label, limits.MAX_LABEL_CHARS, "meters[" + idx + "].label");
    checkChars(ctx, meter.icon, limits.MAX_ICON_CHARS, "meters[" + idx + "].icon");
    if (meter.color !== void 0 && !isMeterColorKey(meter.color)) {
      err(ctx, "invalid_color", "meters[" + idx + "].color", "Color must be a palette key");
    }
    if (meter.type === MeterType.NUMBER) {
      checkChars(ctx, meter.unit, limits.MAX_UNIT_CHARS, "meters[" + idx + "].unit");
    }
    if (seen.has(meter.id)) {
      err(ctx, "duplicate_meter_id", "meters[" + idx + "].id", "Duplicate meter id '" + meter.id + "'");
    }
    seen.add(meter.id);
  });
  if (def.meters.filter((meter) => meter.type === MeterType.CLOCK).length > limits.MAX_CLOCKS) {
    err(ctx, "too_many_clocks", "meters", "At most one clock meter");
  }
  if (def.meters.filter((meter) => meter.visible).length > limits.MAX_VISIBLE_METERS) {
    err(ctx, "too_many_visible", "meters", "More than " + limits.MAX_VISIBLE_METERS + " visible meters");
  }
  if (def.combined_rules.length > limits.MAX_COMBINED_RULES) {
    err(ctx, "too_many_rules", "combined_rules", "More than " + limits.MAX_COMBINED_RULES + " combined rules");
  }
  let instructionChars = 0;
  def.meters.forEach((meter, meterIdx) => {
    const path = "meters[" + meterIdx + "]";
    checkAi(ctx, meter, path);
    instructionChars += meter.type === MeterType.CLOCK ? checkClock(ctx, meter, path) : checkValueMeter(ctx, meter, path);
  });
  const seenRuleIds = /* @__PURE__ */ new Set();
  def.combined_rules.forEach((rule, ruleIdx) => {
    const path = "combined_rules[" + ruleIdx + "]";
    checkId(ctx, rule.id, path + ".id");
    checkChars(ctx, rule.instruction, limits.MAX_INSTRUCTION_CHARS, path + ".instruction");
    checkChars(ctx, rule.caption, limits.MAX_CAPTION_CHARS, path + ".caption");
    if (seenRuleIds.has(rule.id)) {
      err(ctx, "duplicate_rule_id", path + ".id", "Duplicate combined rule id '" + rule.id + "'");
    }
    seenRuleIds.add(rule.id);
    instructionChars += estimateRenderedChars(rule.instruction, ctx.def);
    tokensUnknown(ctx, rule.instruction, path + ".instruction");
    tokensUnknown(ctx, rule.caption, path + ".caption");
    checkCombinedConditions(ctx, rule.conditions, path);
  });
  const estimatedInstructionTokens = Math.ceil(instructionChars / CHARS_PER_TOKEN);
  if (estimatedInstructionTokens > limits.MAX_INSTRUCTION_TOKENS_HARD) {
    err(ctx, "instruction_tokens_exceeded", "meters", "Worst-case instruction set is ~" + estimatedInstructionTokens + " tokens");
  } else if (estimatedInstructionTokens > limits.MAX_INSTRUCTION_TOKENS) {
    warn(ctx, "instruction_tokens", "meters", "Worst-case instruction set is ~" + estimatedInstructionTokens + " tokens");
  }
  return {
    valid: !ctx.issues.some((issue2) => issue2.severity === "error"),
    issues: ctx.issues,
    estimated_instruction_tokens: estimatedInstructionTokens
  };
}
const RULEBOOK_OWNER_TYPES = ["character", "persona"];
const buildAttachedTo = (ownerType, ownerId) => `${ownerType}#${ownerId}`;
const RULEBOOK_PLAYTEST_MAX_HISTORY = 20;
const RULEBOOK_PLAYTEST_MAX_MESSAGE_CHARS = 4e3;
function resolveRulebookPlaytestTurn(request) {
  const batch = request.since_last_evaluation;
  if (batch && batch.length > 0) {
    const userMessages = batch.filter((message) => message.role === "user").map((message) => message.content);
    const characterMessages = batch.filter((message) => message.role === "character").map((message) => message.content);
    return {
      user_text: userMessages.join("\n"),
      latest_user_message: userMessages[userMessages.length - 1] ?? "",
      character_text: characterMessages.join("\n"),
      messages: batch
    };
  }
  const userMessage = request.user_message ?? "";
  const reply = request.character_reply ?? "";
  const messages = [{ role: "user", content: userMessage }];
  if (reply) {
    messages.push({ role: "character", content: reply });
  }
  return { user_text: userMessage, latest_user_message: userMessage, character_text: reply, messages };
}
var PlaytestAiNoteKind = /* @__PURE__ */ ((PlaytestAiNoteKind2) => {
  PlaytestAiNoteKind2["NEGATIVE_OVERRIDE"] = "negative_override";
  PlaytestAiNoteKind2["LOWER_MAGNITUDE"] = "lower_magnitude";
  PlaytestAiNoteKind2["COOLDOWN"] = "cooldown";
  PlaytestAiNoteKind2["CLAMPED_MIN"] = "clamped_min";
  PlaytestAiNoteKind2["CLAMPED_MAX"] = "clamped_max";
  PlaytestAiNoteKind2["PER_TURN_CAP"] = "per_turn_cap";
  PlaytestAiNoteKind2["SPEND_REJECTED"] = "spend_rejected";
  return PlaytestAiNoteKind2;
})(PlaytestAiNoteKind || {});
var RulebookModerationAction = /* @__PURE__ */ ((RulebookModerationAction2) => {
  RulebookModerationAction2["MARK_REVIEWED"] = "Mark_Reviewed";
  RulebookModerationAction2["APPROVE_PENDING"] = "Approve_Pending";
  RulebookModerationAction2["FIX_REQUIRED"] = "Fix_Required";
  RulebookModerationAction2["MAKE_NSFW"] = "Make_NSFW";
  RulebookModerationAction2["SET_COVER_NSFW"] = "Set_Cover_NSFW";
  RulebookModerationAction2["PERMANENTLY_PRIVATE"] = "Permanently_Private";
  RulebookModerationAction2["DELETE"] = "Delete";
  RulebookModerationAction2["CLOSE_REPORT"] = "Close_Report";
  RulebookModerationAction2["UNPUBLISH_FIX_REQUIRED"] = "Unpublish_Fix_Required";
  RulebookModerationAction2["WARN_CREATOR"] = "Warn_Creator";
  RulebookModerationAction2["REVERT_FIX_REQUIRED"] = "Revert_Fix_Required";
  return RulebookModerationAction2;
})(RulebookModerationAction || {});
const RULEBOOK_CREATOR_SANCTION_ACTIONS = /* @__PURE__ */ new Set([
  "Fix_Required",
  "Permanently_Private",
  "Delete",
  "Unpublish_Fix_Required",
  "Warn_Creator",
  "Revert_Fix_Required"
  /* REVERT_FIX_REQUIRED */
]);
function countInstructions(levels) {
  if (!Array.isArray(levels)) {
    return 0;
  }
  return levels.filter(
    (level) => typeof (level == null ? void 0 : level.instruction) === "string" && level.instruction.trim() !== ""
  ).length;
}
function countRulebookRules(definition) {
  var _a;
  let count = Array.isArray(definition.combined_rules) ? definition.combined_rules.length : 0;
  if (!Array.isArray(definition.meters)) {
    return count;
  }
  for (const meter of definition.meters) {
    count += countInstructions(meter == null ? void 0 : meter.levels);
    count += countInstructions(meter == null ? void 0 : meter.tod_levels);
    count += countInstructions(meter == null ? void 0 : meter.day_levels);
    if (((_a = meter == null ? void 0 : meter.ai) == null ? void 0 : _a.enabled) === true && meter.ai.mode !== MeterAiMode.EXTRACT && Array.isArray(meter.ai.rows)) {
      count += meter.ai.rows.length;
    }
  }
  return count;
}
function toMeterChips(meters) {
  if (!Array.isArray(meters)) {
    return [];
  }
  const chips = [];
  for (const meter of meters) {
    if ((meter == null ? void 0 : meter.visible) !== true || typeof meter.label !== "string" || typeof meter.type !== "string") {
      continue;
    }
    chips.push({
      label: meter.label,
      ...meter.icon !== void 0 && { icon: meter.icon },
      ...meter.color !== void 0 && { color: meter.color },
      type: meter.type
    });
  }
  return chips;
}
function countHiddenMeters(meters) {
  if (!Array.isArray(meters)) {
    return 0;
  }
  return meters.filter((meter) => (meter == null ? void 0 : meter.visible) === false).length;
}
function deriveRulebookSummaryFields(definition) {
  return {
    num_meters: Array.isArray(definition.meters) ? definition.meters.length : 0,
    num_rules: countRulebookRules(definition),
    num_hidden_meters: countHiddenMeters(definition.meters),
    meter_chips: toMeterChips(definition.meters)
  };
}
var LorebookVisibility = /* @__PURE__ */ ((LorebookVisibility2) => {
  LorebookVisibility2["PUBLIC"] = "public";
  LorebookVisibility2["PRIVATE"] = "private";
  LorebookVisibility2["HIDDEN"] = "hidden";
  LorebookVisibility2["PERMANENTLY_PRIVATE"] = "permanently_private";
  return LorebookVisibility2;
})(LorebookVisibility || {});
var LorebookStatus = /* @__PURE__ */ ((LorebookStatus2) => {
  LorebookStatus2["ACTIVE"] = "active";
  LorebookStatus2["IN_MODERATION"] = "in_moderation";
  LorebookStatus2["MODERATION_FAILED"] = "moderation_failed";
  LorebookStatus2["DRAFT"] = "draft";
  LorebookStatus2["NEEDS_REVIEW"] = "needs_review";
  return LorebookStatus2;
})(LorebookStatus || {});
var LorebookEntryStatus = /* @__PURE__ */ ((LorebookEntryStatus2) => {
  LorebookEntryStatus2["UNMODERATED"] = "unmoderated";
  LorebookEntryStatus2["ACTIVE"] = "active";
  LorebookEntryStatus2["REJECTED"] = "rejected";
  LorebookEntryStatus2["NEEDS_REVIEW"] = "needs_review";
  return LorebookEntryStatus2;
})(LorebookEntryStatus || {});
var LorebookEntryModerationActions = /* @__PURE__ */ ((LorebookEntryModerationActions2) => {
  LorebookEntryModerationActions2["FLAG"] = "Flag";
  LorebookEntryModerationActions2["DELETE"] = "Delete";
  LorebookEntryModerationActions2["REVIEW"] = "Review";
  return LorebookEntryModerationActions2;
})(LorebookEntryModerationActions || {});
var LorebookEntryOpType = /* @__PURE__ */ ((LorebookEntryOpType2) => {
  LorebookEntryOpType2["CREATE"] = "create";
  LorebookEntryOpType2["UPDATE"] = "update";
  LorebookEntryOpType2["DELETE"] = "delete";
  return LorebookEntryOpType2;
})(LorebookEntryOpType || {});
var LorebookEntryFixStatus = /* @__PURE__ */ ((LorebookEntryFixStatus2) => {
  LorebookEntryFixStatus2["NEEDS_FIX"] = "needs_fix";
  return LorebookEntryFixStatus2;
})(LorebookEntryFixStatus || {});
var LorebookModerationActions = /* @__PURE__ */ ((LorebookModerationActions2) => {
  LorebookModerationActions2["MARK_REVIEWED"] = "Mark_Reviewed";
  LorebookModerationActions2["MAKE_NSFW"] = "Make_NSFW";
  LorebookModerationActions2["SET_AVATAR_NSFW"] = "Set_Avatar_NSFW";
  LorebookModerationActions2["PUBLIC"] = "Public";
  LorebookModerationActions2["MARK_NEWLY_PUBLIC_REVIEWED"] = "Mark_Newly_Public_Reviewed";
  LorebookModerationActions2["FIX_REQUIRED"] = "Fix_Required";
  LorebookModerationActions2["PERMANENTLY_PRIVATE"] = "Permanently_Private";
  LorebookModerationActions2["DELETE"] = "Delete";
  LorebookModerationActions2["CLOSE_REPORT"] = "Close_Report";
  LorebookModerationActions2["MARK_PENDING_UPDATE_APPROVED"] = "Mark_Pending_Update_Approved";
  LorebookModerationActions2["PENDING_UPDATE_SUBMITTED"] = "Pending_Update_Submitted";
  return LorebookModerationActions2;
})(LorebookModerationActions || {});
var HttpStatusCode = /* @__PURE__ */ ((HttpStatusCode2) => {
  HttpStatusCode2[HttpStatusCode2["OK"] = 200] = "OK";
  HttpStatusCode2[HttpStatusCode2["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
  HttpStatusCode2[HttpStatusCode2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatusCode2[HttpStatusCode2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatusCode2[HttpStatusCode2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatusCode2[HttpStatusCode2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HttpStatusCode2[HttpStatusCode2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatusCode2[HttpStatusCode2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatusCode2[HttpStatusCode2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatusCode2[HttpStatusCode2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatusCode2[HttpStatusCode2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HttpStatusCode2[HttpStatusCode2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HttpStatusCode2[HttpStatusCode2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  return HttpStatusCode2;
})(HttpStatusCode || {});
const ERROR_CODE_PREFIX = "SC-001";
const UNKNOWN_ERROR_CODE = 9999;
const _SCError = class _SCError extends Error {
  /**
   * Creates an instance of SCError.
   *
   * @param errorCode Error code used to identify the error
   * @param name Error name used to identify the error
   * @param data Optional additional data object
   */
  constructor(errorCode, name, data) {
    super(`${name}
Error code: ${errorCode}`);
    __publicField(this, "document");
    __publicField(this, "errorCode");
    __publicField(this, "errorData");
    this.name = name;
    this.errorCode = errorCode;
    this.errorData = data;
    Object.setPrototypeOf(this, new.target.prototype);
  }
  /**
   * Build the error document for the error.
   */
  build() {
    this.buildErrorDocument(this.errorCode, this.errorData);
  }
  /**
   * Build the error document for the given error code.
   *
   * @param errorCode Error code used to identify the error
   * @param data Optional additional data object
   */
  buildErrorDocument(errorCode, data) {
    const error = this.errorCodeMap[errorCode] ?? _SCError.getFallbackDocument();
    const { message, statusCode } = error;
    this.setErrorDocumentDetails({
      statusCode,
      message,
      data
    });
  }
  /**
   * Get the fallback error document details.
   *
   * @returns The error document details for the fallback error
   */
  static getFallbackDocument() {
    return this.fallbackDocument;
  }
  /**
   * Set the error document details for the error.
   *
   * @param errorDocumentDetails The error document details to set
   */
  setErrorDocumentDetails(errorDocumentDetails) {
    this.document = {
      ...errorDocumentDetails,
      type: this.name,
      code: `${_SCError.ERROR_CODE_PREFIX}-${this.errorCode}`
    };
  }
  /**
   * Set additional data for the error.
   *
   * @param data The data object to set
   */
  setData(data) {
    this.document.data = data;
  }
  /**
   * Get the error document.
   *
   * @returns The error document
   */
  getDocument() {
    return this.document;
  }
  /**
   * Convert the error to a JSON string.
   *
   * @returns The error as a JSON string
   */
  toJSON() {
    const document = this.getDocument();
    return JSON.stringify(document);
  }
};
__publicField(_SCError, "ERROR_CODE_PREFIX", ERROR_CODE_PREFIX);
__publicField(_SCError, "UNKNOWN_ERROR_CODE", UNKNOWN_ERROR_CODE);
__publicField(_SCError, "fallbackDocument", {
  statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
  message: "An unknown error occurred."
});
let SCError = _SCError;
class AdminError extends SCError {
  /**
   * Creates an instance of AdminError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, AdminError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AdminError);
    }
    Object.setPrototypeOf(this, AdminError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        3801
        /* MISSING_CHARACTER_ID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character ID is required"
      },
      [
        3802
        /* INVALID_REQUEST_SCHEMA */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid Request Schema"
      },
      [
        3803
        /* CHARACTER_CREATOR_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Character creator not found"
      },
      [
        3804
        /* MODERATION_EMAIL_ALREADY_SENT */
      ]: {
        statusCode: HttpStatusCode.ALREADY_REPORTED,
        message: "Email already sent to creator"
      },
      [
        3805
        /* CANNOT_UNPUBLISH_PIXEL_CHARACTER */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Cannot unpublish pixel character"
      },
      [
        3806
        /* MISSING_ARGUMENTS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing arguments"
      },
      [
        3807
        /* USER_ALREADY_MODERATED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "User is already moderated with same action"
      },
      [
        3808
        /* TIME_DURATION_REQUIRED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Time duration is required for this action"
      },
      [
        3809
        /* NOT_ALLOWED_TO_MODERATE_USER */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Not allowed to moderate users"
      },
      [
        3810
        /* INVALID_UPDATE_FEATURE_FLAG_REQUEST */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${this.additionalDetails ?? "Error while updating feature flag for the user"}`
      },
      [
        3811
        /* IDENTITY_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Identity not found"
      }
    };
  }
}
var AdminErrorType = /* @__PURE__ */ ((AdminErrorType2) => {
  AdminErrorType2[AdminErrorType2["MISSING_CHARACTER_ID"] = 3801] = "MISSING_CHARACTER_ID";
  AdminErrorType2[AdminErrorType2["INVALID_REQUEST_SCHEMA"] = 3802] = "INVALID_REQUEST_SCHEMA";
  AdminErrorType2[AdminErrorType2["CHARACTER_CREATOR_NOT_FOUND"] = 3803] = "CHARACTER_CREATOR_NOT_FOUND";
  AdminErrorType2[AdminErrorType2["MODERATION_EMAIL_ALREADY_SENT"] = 3804] = "MODERATION_EMAIL_ALREADY_SENT";
  AdminErrorType2[AdminErrorType2["CANNOT_UNPUBLISH_PIXEL_CHARACTER"] = 3805] = "CANNOT_UNPUBLISH_PIXEL_CHARACTER";
  AdminErrorType2[AdminErrorType2["MISSING_ARGUMENTS"] = 3806] = "MISSING_ARGUMENTS";
  AdminErrorType2[AdminErrorType2["USER_ALREADY_MODERATED"] = 3807] = "USER_ALREADY_MODERATED";
  AdminErrorType2[AdminErrorType2["TIME_DURATION_REQUIRED"] = 3808] = "TIME_DURATION_REQUIRED";
  AdminErrorType2[AdminErrorType2["NOT_ALLOWED_TO_MODERATE_USER"] = 3809] = "NOT_ALLOWED_TO_MODERATE_USER";
  AdminErrorType2[AdminErrorType2["INVALID_UPDATE_FEATURE_FLAG_REQUEST"] = 3810] = "INVALID_UPDATE_FEATURE_FLAG_REQUEST";
  AdminErrorType2[AdminErrorType2["IDENTITY_NOT_FOUND"] = 3811] = "IDENTITY_NOT_FOUND";
  return AdminErrorType2;
})(AdminErrorType || {});
class CharacterError extends SCError {
  /**
   * Creates an instance of CharacterError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, CharacterError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CharacterError);
    }
    Object.setPrototypeOf(this, CharacterError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  // eslint-disable-next-line max-lines-per-function -- errorCodeMap must list all error types; splitting it would reduce clarity
  get errorCodeMap() {
    return {
      [
        1201
        /* NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Character not found."
        /* NOT_FOUND */
      },
      [
        1202
        /* NSFW */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character is NSFW."
        /* NSFW */
      },
      [
        1203
        /* CREATE_CHARACTER_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character creation not permitted."
        /* CREATE_CHARACTER_NOT_ALLOWED */
      },
      [
        1204
        /* VIEW_USER_CHARACTER_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Access to view user character denied."
        /* VIEW_USER_CHARACTER_NOT_ALLOWED */
      },
      [
        1205
        /* UPDATE_CHARACTER_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character update operation denied."
        /* UPDATE_CHARACTER_NOT_ALLOWED */
      },
      [
        1206
        /* DELETE_CHARACTER_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character deletion operation denied."
        /* DELETE_CHARACTER_NOT_ALLOWED */
      },
      [
        1207
        /* TRAIN_CHARACTER_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character training operation denied."
        /* TRAIN_CHARACTER_NOT_ALLOWED */
      },
      [
        1208
        /* ALREADY_TRAINED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character already trained."
        /* ALREADY_TRAINED */
      },
      [
        1209
        /* ALREADY_IN_QUEUE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character already in training queue."
        /* ALREADY_IN_QUEUE */
      },
      [
        1210
        /* TRAINING_LIMIT_REACHED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Training limit reached."
        /* TRAINING_LIMIT_REACHED */
      },
      [
        1211
        /* AVATAR_TOO_EXPLICIT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Avatar flagged as too explicit for public chatbot."
        /* AVATAR_TOO_EXPLICIT */
      },
      [
        1212
        /* UNDERAGE_AVATAR_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Avatar flagged as portraying potentially underage character."
        /* UNDERAGE_AVATAR_NOT_ALLOWED */
      },
      [
        1213
        /* SEXUAL_MINOR_CHARACTER */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Chatbot flagged for inappropriate content: sexual/minor."
        /* SEXUAL_MINOR_CHARACTER */
      },
      [
        1214
        /* UNDERAGE_CHARACTER */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Chatbot flagged as potentially underage. Age must be explicitly defined."
        /* UNDERAGE_CHARACTER */
      },
      [
        1215
        /* CHARACTER_ID_REQUIRED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character ID missing."
        /* CHARACTER_ID_REQUIRED */
      },
      [
        1216
        /* INVALID_UPDATE_NUM_MESSAGE_REQUEST */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing id or num_message in request."
        /* INVALID_UPDATE_NUM_MESSAGE_REQUEST */
      },
      [
        1217
        /* AVATAR_WITH_SEXUAL_ACTIVITIES */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Avatar flagged for depicting sexual activities."
        /* AVATAR_WITH_SEXUAL_ACTIVITIES */
      },
      [
        1218
        /* UPDATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Character update failed."
        /* UPDATE_FAILED */
      },
      [
        1219
        /* SUGGEST_CHARACTER_FIELD_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Suggest character field not allowed."
        /* SUGGEST_CHARACTER_FIELD_NOT_ALLOWED */
      },
      [
        1220
        /* FIELD_SUGGESTION_FAILED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: this.additionalDetails ?? "Field suggestion failed."
        /* FIELD_SUGGESTION_FAILED */
      },
      [
        1221
        /* FIELD_SUGGESTION_INVALID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: this.additionalDetails ?? "Field suggestion is invalid."
        /* FIELD_SUGGESTION_INVALID */
      },
      [
        1222
        /* SUGGEST_CHARACTER_TAGS_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Suggest character tags not allowed."
        /* SUGGEST_CHARACTER_TAGS_NOT_ALLOWED */
      },
      [
        1223
        /* CHARACTER_TAGS_SUGGESTION_FAILED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Character tags suggestion failed."} ${this.additionalDetails ?? ""}`
      },
      [
        1224
        /* TOKEN_COUNT_EXCEEDS_MAX_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Chatbots must not exceed 2400 tokens, streamline your definition to make it public."
        /* TOKEN_COUNT_EXCEEDS_MAX_ALLOWED */
      },
      [
        1225
        /* TOKEN_COUNT_LESS_THAN_MIN_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Public chatbots must feature at least 100 tokens of content. Improve your persona or greeting."
        /* TOKEN_COUNT_LESS_THAN_MIN_ALLOWED */
      },
      [
        1226
        /* URL_NOT_ALLOWED */
      ]: {
        statusCode: 400,
        message: "URL is not allowed."
        /* URL_NOT_ALLOWED */
      },
      [
        1227
        /* PERSONA_REQUIRED_FOR_STANDARD_CHARACTERS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Persona is required for standard characters."
        /* PERSONA_REQUIRED_FOR_STANDARD_CHARACTERS */
      },
      [
        1228
        /* CHARACTER_TYPE_CANNOT_BE_CHANGED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Character type cannot be changed once set."
        /* CHARACTER_TYPE_CANNOT_BE_CHANGED */
      },
      [
        1229
        /* CHARACTER_ID_REQUIRED_WHEN_SUB_CHARACTERS_NOT_PROVIDED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "If subCharacterIds is not provided, characterId must be provided"
        /* CHARACTER_ID_REQUIRED_WHEN_SUB_CHARACTERS_NOT_PROVIDED */
      }
    };
  }
}
var CharacterErrorType = /* @__PURE__ */ ((CharacterErrorType2) => {
  CharacterErrorType2[CharacterErrorType2["NOT_FOUND"] = 1201] = "NOT_FOUND";
  CharacterErrorType2[CharacterErrorType2["NSFW"] = 1202] = "NSFW";
  CharacterErrorType2[CharacterErrorType2["CREATE_CHARACTER_NOT_ALLOWED"] = 1203] = "CREATE_CHARACTER_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["VIEW_USER_CHARACTER_NOT_ALLOWED"] = 1204] = "VIEW_USER_CHARACTER_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["UPDATE_CHARACTER_NOT_ALLOWED"] = 1205] = "UPDATE_CHARACTER_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["DELETE_CHARACTER_NOT_ALLOWED"] = 1206] = "DELETE_CHARACTER_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["TRAIN_CHARACTER_NOT_ALLOWED"] = 1207] = "TRAIN_CHARACTER_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["ALREADY_TRAINED"] = 1208] = "ALREADY_TRAINED";
  CharacterErrorType2[CharacterErrorType2["ALREADY_IN_QUEUE"] = 1209] = "ALREADY_IN_QUEUE";
  CharacterErrorType2[CharacterErrorType2["TRAINING_LIMIT_REACHED"] = 1210] = "TRAINING_LIMIT_REACHED";
  CharacterErrorType2[CharacterErrorType2["AVATAR_TOO_EXPLICIT"] = 1211] = "AVATAR_TOO_EXPLICIT";
  CharacterErrorType2[CharacterErrorType2["UNDERAGE_AVATAR_NOT_ALLOWED"] = 1212] = "UNDERAGE_AVATAR_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["SEXUAL_MINOR_CHARACTER"] = 1213] = "SEXUAL_MINOR_CHARACTER";
  CharacterErrorType2[CharacterErrorType2["UNDERAGE_CHARACTER"] = 1214] = "UNDERAGE_CHARACTER";
  CharacterErrorType2[CharacterErrorType2["CHARACTER_ID_REQUIRED"] = 1215] = "CHARACTER_ID_REQUIRED";
  CharacterErrorType2[CharacterErrorType2["INVALID_UPDATE_NUM_MESSAGE_REQUEST"] = 1216] = "INVALID_UPDATE_NUM_MESSAGE_REQUEST";
  CharacterErrorType2[CharacterErrorType2["AVATAR_WITH_SEXUAL_ACTIVITIES"] = 1217] = "AVATAR_WITH_SEXUAL_ACTIVITIES";
  CharacterErrorType2[CharacterErrorType2["UPDATE_FAILED"] = 1218] = "UPDATE_FAILED";
  CharacterErrorType2[CharacterErrorType2["SUGGEST_CHARACTER_FIELD_NOT_ALLOWED"] = 1219] = "SUGGEST_CHARACTER_FIELD_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["FIELD_SUGGESTION_FAILED"] = 1220] = "FIELD_SUGGESTION_FAILED";
  CharacterErrorType2[CharacterErrorType2["FIELD_SUGGESTION_INVALID"] = 1221] = "FIELD_SUGGESTION_INVALID";
  CharacterErrorType2[CharacterErrorType2["SUGGEST_CHARACTER_TAGS_NOT_ALLOWED"] = 1222] = "SUGGEST_CHARACTER_TAGS_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["CHARACTER_TAGS_SUGGESTION_FAILED"] = 1223] = "CHARACTER_TAGS_SUGGESTION_FAILED";
  CharacterErrorType2[CharacterErrorType2["TOKEN_COUNT_EXCEEDS_MAX_ALLOWED"] = 1224] = "TOKEN_COUNT_EXCEEDS_MAX_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["TOKEN_COUNT_LESS_THAN_MIN_ALLOWED"] = 1225] = "TOKEN_COUNT_LESS_THAN_MIN_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["URL_NOT_ALLOWED"] = 1226] = "URL_NOT_ALLOWED";
  CharacterErrorType2[CharacterErrorType2["PERSONA_REQUIRED_FOR_STANDARD_CHARACTERS"] = 1227] = "PERSONA_REQUIRED_FOR_STANDARD_CHARACTERS";
  CharacterErrorType2[CharacterErrorType2["CHARACTER_TYPE_CANNOT_BE_CHANGED"] = 1228] = "CHARACTER_TYPE_CANNOT_BE_CHANGED";
  CharacterErrorType2[CharacterErrorType2["CHARACTER_ID_REQUIRED_WHEN_SUB_CHARACTERS_NOT_PROVIDED"] = 1229] = "CHARACTER_ID_REQUIRED_WHEN_SUB_CHARACTERS_NOT_PROVIDED";
  return CharacterErrorType2;
})(CharacterErrorType || {});
class CharacterReportError extends SCError {
  /**
   * Creates an instance of CharacterReportError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, CharacterReportError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CharacterReportError);
    }
    Object.setPrototypeOf(this, CharacterReportError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        1601
        /* MODERATION_REPORT_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "No moderation report found for the given character"
        /* MODERATION_REPORT_NOT_FOUND */
      }
    };
  }
}
var CharacterReportErrorType = /* @__PURE__ */ ((CharacterReportErrorType2) => {
  CharacterReportErrorType2[CharacterReportErrorType2["MODERATION_REPORT_NOT_FOUND"] = 1601] = "MODERATION_REPORT_NOT_FOUND";
  return CharacterReportErrorType2;
})(CharacterReportErrorType || {});
class CharacterTranslationError extends SCError {
  /**
   * Creates an instance of CharacterTranslationError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, CharacterTranslationError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CharacterTranslationError);
    }
    Object.setPrototypeOf(this, CharacterTranslationError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        7701
        /* TASK_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: `Translation task not found. ${this.additionalDetails ?? ""}`
      },
      [
        7702
        /* UNAUTHORIZED */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Not allowed to view this translation task."
      },
      [
        7703
        /* TRANSLATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to translate character. ${this.additionalDetails ?? ""}`
      },
      [
        7704
        /* INVALID_LANGUAGE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Invalid target language: ${this.additionalDetails ?? ""}`
      },
      [
        7705
        /* TRANSLATION_LIMIT_REACHED */
      ]: {
        statusCode: HttpStatusCode.TOO_MANY_REQUESTS,
        message: "Translation limit reached."
      },
      [
        7706
        /* TRANSLATION_IN_PROGRESS */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `Translation in progress. ${this.additionalDetails ?? ""}`
      },
      [
        7707
        /* STATE_MACHINE_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `State machine error. ${this.additionalDetails ?? ""}`
      },
      [
        7708
        /* TRANSLATION_ALREADY_EXISTS */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `Translation already exists. ${this.additionalDetails ?? ""}`
      }
    };
  }
}
var CharacterTranslationErrorType = /* @__PURE__ */ ((CharacterTranslationErrorType2) => {
  CharacterTranslationErrorType2[CharacterTranslationErrorType2["TASK_NOT_FOUND"] = 7701] = "TASK_NOT_FOUND";
  CharacterTranslationErrorType2[CharacterTranslationErrorType2["UNAUTHORIZED"] = 7702] = "UNAUTHORIZED";
  CharacterTranslationErrorType2[CharacterTranslationErrorType2["TRANSLATION_FAILED"] = 7703] = "TRANSLATION_FAILED";
  CharacterTranslationErrorType2[CharacterTranslationErrorType2["INVALID_LANGUAGE"] = 7704] = "INVALID_LANGUAGE";
  CharacterTranslationErrorType2[CharacterTranslationErrorType2["TRANSLATION_LIMIT_REACHED"] = 7705] = "TRANSLATION_LIMIT_REACHED";
  CharacterTranslationErrorType2[CharacterTranslationErrorType2["TRANSLATION_IN_PROGRESS"] = 7706] = "TRANSLATION_IN_PROGRESS";
  CharacterTranslationErrorType2[CharacterTranslationErrorType2["STATE_MACHINE_ERROR"] = 7707] = "STATE_MACHINE_ERROR";
  CharacterTranslationErrorType2[CharacterTranslationErrorType2["TRANSLATION_ALREADY_EXISTS"] = 7708] = "TRANSLATION_ALREADY_EXISTS";
  return CharacterTranslationErrorType2;
})(CharacterTranslationErrorType || {});
class MetaCharacterError extends SCError {
  /**
   * Creates an instance of MetaCharacterError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, MetaCharacterError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MetaCharacterError);
    }
    Object.setPrototypeOf(this, MetaCharacterError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    const baseErrorMap = {
      [
        8001
        /* MINIMUM_SUB_CHARACTERS_REQUIRED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Meta characters must have at least 2 sub-characters."
        /* MINIMUM_SUB_CHARACTERS_REQUIRED */
      },
      [
        8002
        /* GREETING_CHARACTER_NOT_IN_SUB_CHARACTERS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Greeting character must be one of the sub-characters."
        /* GREETING_CHARACTER_NOT_IN_SUB_CHARACTERS */
      },
      [
        8003
        /* NO_SUB_CHARACTERS_FOUND */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "No sub-characters found"
        /* NO_SUB_CHARACTERS_FOUND */
      },
      [
        8004
        /* PRIVATE_GROUP_SUB_CHARACTERS_MUST_BE_OWNED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "All sub-characters must be created by you or be public when creating a private meta character"
        /* PRIVATE_GROUP_SUB_CHARACTERS_MUST_BE_OWNED */
      },
      [
        8005
        /* PUBLIC_GROUP_SUB_CHARACTERS_MUST_BE_PUBLIC */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "All sub-characters must be public when creating a public meta character"
        /* PUBLIC_GROUP_SUB_CHARACTERS_MUST_BE_PUBLIC */
      },
      [
        8006
        /* SUB_CHARACTERS_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "One or more sub-characters not found or deleted"
        /* SUB_CHARACTERS_NOT_FOUND */
      },
      [
        8007
        /* SUB_CHARACTERS_DELETION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to delete one or more sub-characters"
        /* SUB_CHARACTERS_DELETION_FAILED */
      },
      [
        8008
        /* SUB_CHARACTERS_RESTORATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to restore one or more sub-characters"
        /* SUB_CHARACTERS_RESTORATION_FAILED */
      },
      [
        8009
        /* SUB_CHARACTER_NOT_ADDABLE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Sub-character is not marked as group-addable by its owner"
        /* SUB_CHARACTER_NOT_ADDABLE */
      }
    };
    if (this.additionalDetails) {
      Object.keys(baseErrorMap).forEach((key) => {
        const errorCode = parseInt(key);
        const errorEntry = baseErrorMap[errorCode];
        if (errorEntry) {
          errorEntry.message += ` ${this.additionalDetails}`;
        }
      });
    }
    return baseErrorMap;
  }
}
var MetaCharacterErrorType = /* @__PURE__ */ ((MetaCharacterErrorType2) => {
  MetaCharacterErrorType2[MetaCharacterErrorType2["MINIMUM_SUB_CHARACTERS_REQUIRED"] = 8001] = "MINIMUM_SUB_CHARACTERS_REQUIRED";
  MetaCharacterErrorType2[MetaCharacterErrorType2["GREETING_CHARACTER_NOT_IN_SUB_CHARACTERS"] = 8002] = "GREETING_CHARACTER_NOT_IN_SUB_CHARACTERS";
  MetaCharacterErrorType2[MetaCharacterErrorType2["NO_SUB_CHARACTERS_FOUND"] = 8003] = "NO_SUB_CHARACTERS_FOUND";
  MetaCharacterErrorType2[MetaCharacterErrorType2["PRIVATE_GROUP_SUB_CHARACTERS_MUST_BE_OWNED"] = 8004] = "PRIVATE_GROUP_SUB_CHARACTERS_MUST_BE_OWNED";
  MetaCharacterErrorType2[MetaCharacterErrorType2["PUBLIC_GROUP_SUB_CHARACTERS_MUST_BE_PUBLIC"] = 8005] = "PUBLIC_GROUP_SUB_CHARACTERS_MUST_BE_PUBLIC";
  MetaCharacterErrorType2[MetaCharacterErrorType2["SUB_CHARACTERS_NOT_FOUND"] = 8006] = "SUB_CHARACTERS_NOT_FOUND";
  MetaCharacterErrorType2[MetaCharacterErrorType2["SUB_CHARACTERS_DELETION_FAILED"] = 8007] = "SUB_CHARACTERS_DELETION_FAILED";
  MetaCharacterErrorType2[MetaCharacterErrorType2["SUB_CHARACTERS_RESTORATION_FAILED"] = 8008] = "SUB_CHARACTERS_RESTORATION_FAILED";
  MetaCharacterErrorType2[MetaCharacterErrorType2["SUB_CHARACTER_NOT_ADDABLE"] = 8009] = "SUB_CHARACTER_NOT_ADDABLE";
  return MetaCharacterErrorType2;
})(MetaCharacterErrorType || {});
class ChatError extends SCError {
  /**
   * Creates an instance of ChatError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, ChatError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ChatError);
    }
    Object.setPrototypeOf(this, ChatError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        1401
        /* CHAT_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: `The user input is invalid or missing any required field. ${this.additionalDetails ?? ""}`
      },
      [
        1402
        /* TEMPLATE_LOADING_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `${this.additionalDetails ?? "Error while loading template."}`
      },
      [
        1403
        /* INFERENCE_REQUEST_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Error while processing an inference request. ${this.additionalDetails ?? ""}`
      },
      [
        1404
        /* NO_RESPONSE */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: `No response received from the server. ${this.additionalDetails ?? ""}`
      },
      [
        1405
        /* INFERENCE_PROVIDER_PAYMENT_REQUIRED */
      ]: {
        statusCode: HttpStatusCode.SERVICE_UNAVAILABLE,
        message: `Inference provider rejected the request due to insufficient account credits/quota. ${this.additionalDetails ?? ""}`
      },
      [
        1406
        /* CHAT_UNDER_REVIEW */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: `This character is under review and cannot be chatted with. ${this.additionalDetails ?? ""}`
      }
    };
  }
}
var ChatErrorType = /* @__PURE__ */ ((ChatErrorType2) => {
  ChatErrorType2[ChatErrorType2["CHAT_NOT_ALLOWED"] = 1401] = "CHAT_NOT_ALLOWED";
  ChatErrorType2[ChatErrorType2["TEMPLATE_LOADING_ERROR"] = 1402] = "TEMPLATE_LOADING_ERROR";
  ChatErrorType2[ChatErrorType2["INFERENCE_REQUEST_ERROR"] = 1403] = "INFERENCE_REQUEST_ERROR";
  ChatErrorType2[ChatErrorType2["NO_RESPONSE"] = 1404] = "NO_RESPONSE";
  ChatErrorType2[ChatErrorType2["INFERENCE_PROVIDER_PAYMENT_REQUIRED"] = 1405] = "INFERENCE_PROVIDER_PAYMENT_REQUIRED";
  ChatErrorType2[ChatErrorType2["CHAT_UNDER_REVIEW"] = 1406] = "CHAT_UNDER_REVIEW";
  return ChatErrorType2;
})(ChatErrorType || {});
class CmsError extends SCError {
  /**
   * Creates an instance of CmsError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, CmsError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CmsError);
    }
    Object.setPrototypeOf(this, CmsError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        6301
        /* UNABLE_TO_FIND_APPLICATION */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Unable to find application."
        /* UNABLE_TO_FIND_APPLICATION */
      },
      [
        6302
        /* APOLLO_CLIENT_NOT_INITIALIZED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Apollo client not initialized."
        /* APOLLO_CLIENT_NOT_INITIALIZED */
      },
      [
        6303
        /* UNABLE_TO_FIND_USER_ENGAGEMENT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Unable to find user engagement."
        /* UNABLE_TO_FIND_USER_ENGAGEMENT */
      },
      [
        6304
        /* UNABLE_TO_FIND_ROLE_MAPPING */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Unable to find user role to assign to user."
        /* UNABLE_TO_FIND_ROLE_MAPPING */
      },
      [
        6305
        /* MANAGEMENT_TOKEN_UNAVAILABLE */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Contentful management token unavailable. App Identity is not configured."
        /* MANAGEMENT_TOKEN_UNAVAILABLE */
      }
    };
  }
}
var CmsErrorType = /* @__PURE__ */ ((CmsErrorType2) => {
  CmsErrorType2[CmsErrorType2["UNABLE_TO_FIND_APPLICATION"] = 6301] = "UNABLE_TO_FIND_APPLICATION";
  CmsErrorType2[CmsErrorType2["APOLLO_CLIENT_NOT_INITIALIZED"] = 6302] = "APOLLO_CLIENT_NOT_INITIALIZED";
  CmsErrorType2[CmsErrorType2["UNABLE_TO_FIND_USER_ENGAGEMENT"] = 6303] = "UNABLE_TO_FIND_USER_ENGAGEMENT";
  CmsErrorType2[CmsErrorType2["UNABLE_TO_FIND_ROLE_MAPPING"] = 6304] = "UNABLE_TO_FIND_ROLE_MAPPING";
  CmsErrorType2[CmsErrorType2["MANAGEMENT_TOKEN_UNAVAILABLE"] = 6305] = "MANAGEMENT_TOKEN_UNAVAILABLE";
  return CmsErrorType2;
})(CmsErrorType || {});
class CloneConversationError extends SCError {
  /**
   * Creates an instance of CloneConversationError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, CloneConversationError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CloneConversationError);
    }
    Object.setPrototypeOf(this, CloneConversationError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        1901
        /* LAST_MESSAGE_REFERENCE_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "The selected message_id does not exists"
        /* LAST_MESSAGE_REFERENCE_NOT_FOUND */
      },
      [
        1902
        /* NO_MESSAGE_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "The conversation did not have any messages"
        /* NO_MESSAGE_FOUND */
      }
    };
  }
}
var CloneConversationErrorType = /* @__PURE__ */ ((CloneConversationErrorType2) => {
  CloneConversationErrorType2[CloneConversationErrorType2["LAST_MESSAGE_REFERENCE_NOT_FOUND"] = 1901] = "LAST_MESSAGE_REFERENCE_NOT_FOUND";
  CloneConversationErrorType2[CloneConversationErrorType2["NO_MESSAGE_FOUND"] = 1902] = "NO_MESSAGE_FOUND";
  return CloneConversationErrorType2;
})(CloneConversationErrorType || {});
class ConversationError extends SCError {
  /**
   * Creates an instance of ConversationError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, ConversationError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ConversationError);
    }
    Object.setPrototypeOf(this, ConversationError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        1800
        /* NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Conversation not found."
        /* NOT_FOUND */
      },
      [
        1801
        /* ROLE_MUST_BE_USER_OR_BOT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Role must be user or bot."
        /* ROLE_MUST_BE_USER_OR_BOT */
      },
      [
        1802
        /* NO_MESSAGE_PRESENT */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "No message present in conversation."
        /* NO_MESSAGE_PRESENT */
      },
      [
        1803
        /* VIEW_CONVERSATION_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "Conversation view operation denied."
        /* VIEW_CONVERSATION_NOT_ALLOWED */
      },
      [
        1804
        /* DELETE_CONVERSATION_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "Conversation deletion operation denied."
        /* DELETE_CONVERSATION_NOT_ALLOWED */
      },
      [
        1805
        /* MISSING_CONVERSATION_IDS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Conversation IDs missing."
        /* MISSING_CONVERSATION_IDS */
      },
      [
        1806
        /* CANNOT_SET_VOICE_ID */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Voice preference setting failed."
        /* CANNOT_SET_VOICE_ID */
      },
      [
        1807
        /* CONVERSATION_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Conversation not found."
        /* CONVERSATION_NOT_FOUND */
      },
      [
        1808
        /* SEMANTIC_MEMORY_EMBEDDINGS_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `${"Semantic memory embedding error."}. ${this.additionalDetails ?? ""}`
      },
      [
        1809
        /* LAST_MESSAGE_REFERENCE_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "The selected message_id does not exists."
        /* LAST_MESSAGE_REFERENCE_NOT_FOUND */
      },
      [
        1810
        /* CLONE_CONVERSATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Conversation cloning failed."
        /* CLONE_CONVERSATION_FAILED */
      },
      [
        1811
        /* RULEBOOK_ALREADY_PINNED */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: "The conversation already has a pinned rulebook."
        /* RULEBOOK_ALREADY_PINNED */
      }
    };
  }
}
var ConversationErrorType = /* @__PURE__ */ ((ConversationErrorType2) => {
  ConversationErrorType2[ConversationErrorType2["NOT_FOUND"] = 1800] = "NOT_FOUND";
  ConversationErrorType2[ConversationErrorType2["ROLE_MUST_BE_USER_OR_BOT"] = 1801] = "ROLE_MUST_BE_USER_OR_BOT";
  ConversationErrorType2[ConversationErrorType2["NO_MESSAGE_PRESENT"] = 1802] = "NO_MESSAGE_PRESENT";
  ConversationErrorType2[ConversationErrorType2["VIEW_CONVERSATION_NOT_ALLOWED"] = 1803] = "VIEW_CONVERSATION_NOT_ALLOWED";
  ConversationErrorType2[ConversationErrorType2["DELETE_CONVERSATION_NOT_ALLOWED"] = 1804] = "DELETE_CONVERSATION_NOT_ALLOWED";
  ConversationErrorType2[ConversationErrorType2["MISSING_CONVERSATION_IDS"] = 1805] = "MISSING_CONVERSATION_IDS";
  ConversationErrorType2[ConversationErrorType2["CANNOT_SET_VOICE_ID"] = 1806] = "CANNOT_SET_VOICE_ID";
  ConversationErrorType2[ConversationErrorType2["CONVERSATION_NOT_FOUND"] = 1807] = "CONVERSATION_NOT_FOUND";
  ConversationErrorType2[ConversationErrorType2["SEMANTIC_MEMORY_EMBEDDINGS_ERROR"] = 1808] = "SEMANTIC_MEMORY_EMBEDDINGS_ERROR";
  ConversationErrorType2[ConversationErrorType2["LAST_MESSAGE_REFERENCE_NOT_FOUND"] = 1809] = "LAST_MESSAGE_REFERENCE_NOT_FOUND";
  ConversationErrorType2[ConversationErrorType2["CLONE_CONVERSATION_FAILED"] = 1810] = "CLONE_CONVERSATION_FAILED";
  ConversationErrorType2[ConversationErrorType2["RULEBOOK_ALREADY_PINNED"] = 1811] = "RULEBOOK_ALREADY_PINNED";
  return ConversationErrorType2;
})(ConversationErrorType || {});
class ConversationMemoryError extends SCError {
  /**
   * Creates an instance of ConversationMemoryError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, ConversationMemoryError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ConversationMemoryError);
    }
    Object.setPrototypeOf(this, ConversationMemoryError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        4001
        /* CONVERSATION_MEMORY_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Conversation Memory Not Found"
      }
    };
  }
}
var ConversationMemoryErrorType = /* @__PURE__ */ ((ConversationMemoryErrorType2) => {
  ConversationMemoryErrorType2[ConversationMemoryErrorType2["CONVERSATION_MEMORY_NOT_FOUND"] = 4001] = "CONVERSATION_MEMORY_NOT_FOUND";
  return ConversationMemoryErrorType2;
})(ConversationMemoryErrorType || {});
class CrmError extends SCError {
  /**
   * Creates an instance of CrmError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, CrmError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CrmError);
    }
    Object.setPrototypeOf(this, CrmError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        1101
        /* CONTACT_CREATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Contact creation failed."
        /* CONTACT_CREATION_FAILED */
      },
      [
        1102
        /* CONTACT_UPDATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Contact update failed."
        /* CONTACT_UPDATE_FAILED */
      },
      [
        1103
        /* INVALID_APPLICATION_ID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid application ID."
        /* INVALID_APPLICATION_ID */
      }
    };
  }
}
var CrmErrorType = /* @__PURE__ */ ((CrmErrorType2) => {
  CrmErrorType2[CrmErrorType2["CONTACT_CREATION_FAILED"] = 1101] = "CONTACT_CREATION_FAILED";
  CrmErrorType2[CrmErrorType2["CONTACT_UPDATE_FAILED"] = 1102] = "CONTACT_UPDATE_FAILED";
  CrmErrorType2[CrmErrorType2["INVALID_APPLICATION_ID"] = 1103] = "INVALID_APPLICATION_ID";
  return CrmErrorType2;
})(CrmErrorType || {});
class ImageError extends SCError {
  /**
   * Creates an instance of ImageError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, ImageError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ImageError);
    }
    Object.setPrototypeOf(this, ImageError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        6801
        /* UNDER_AGE_CONTENT_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Under age content found in externally moderation response."
      },
      [
        6802
        /* NSFW_CONTENT_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "NSFW content found in externally moderation response"
      },
      [
        6803
        /* NSFW_PUBLIC_FIGURE_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "NSFW sexually explicit images of public figures found in externally moderation response."
      },
      [
        6804
        /* IMAGE_GENERATION_ERROR */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Error from external service while image generation"
      },
      [
        6805
        /* IMAGE_TYPE_NOT_SUPPORTED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Image type not supported"
      },
      [
        6806
        /* IMAGE_REFERENCE_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Image reference not found in S3"
      },
      [
        6807
        /* SIGHT_ENGINE_MODERATION_ERROR */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Either base64 image or url can be sent to sightengine"
      },
      [
        6808
        /* NOT_ALLOWED_TO_GENERATE_IMAGES */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Not allowed to generate images"
      },
      [
        6809
        /* IMAGE_VIOLATE_CONTENT_GUIDELINES */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Image violates content guidelines"
      },
      [
        6810
        /* GENERATED_IMAGE_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Generated image violates content guidelines"
      },
      [
        6811
        /* NOT_ALLOWED_TO_SAVE_IMAGES */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Not allowed to save images"
      },
      [
        6812
        /* IMAGE_PROMPT_GENERATION_ERROR */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Error from external service while generating image prompt"
      },
      [
        6813
        /* INVALID_IMAGE_PATH */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid image path"
      },
      [
        6814
        /* FILE_SIZE_TOO_LARGE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "File size too large"
      },
      [
        6815
        /* UPLOAD_FAILED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Upload failed"
      },
      [
        6816
        /* SIGNED_URL_GENERATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Signed URL error: ${this.additionalDetails ?? ""}`
      },
      [
        6817
        /* DELETE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Deletion failed."
      },
      [
        6818
        /* USER_IMAGE_ANALYSIS_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Unable to analyze user-uploaded image"
      },
      [
        6819
        /* NSFW_CONTENT_NOT_ALLOWED_FOR_UNVERIFIED_USERS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Age verification required for NSFW content"
      },
      [
        6820
        /* PROMPT_VIOLATE_CONTENT_GUIDELINES */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Prompt contains restricted content"
      },
      [
        6821
        /* PHOTOREALISTIC_HUMAN_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Real person photos are not allowed."
      }
    };
  }
}
var ImageErrorType = /* @__PURE__ */ ((ImageErrorType2) => {
  ImageErrorType2[ImageErrorType2["UNDER_AGE_CONTENT_NOT_ALLOWED"] = 6801] = "UNDER_AGE_CONTENT_NOT_ALLOWED";
  ImageErrorType2[ImageErrorType2["NSFW_CONTENT_NOT_ALLOWED"] = 6802] = "NSFW_CONTENT_NOT_ALLOWED";
  ImageErrorType2[ImageErrorType2["NSFW_PUBLIC_FIGURE_NOT_ALLOWED"] = 6803] = "NSFW_PUBLIC_FIGURE_NOT_ALLOWED";
  ImageErrorType2[ImageErrorType2["IMAGE_GENERATION_ERROR"] = 6804] = "IMAGE_GENERATION_ERROR";
  ImageErrorType2[ImageErrorType2["IMAGE_TYPE_NOT_SUPPORTED"] = 6805] = "IMAGE_TYPE_NOT_SUPPORTED";
  ImageErrorType2[ImageErrorType2["IMAGE_REFERENCE_NOT_FOUND"] = 6806] = "IMAGE_REFERENCE_NOT_FOUND";
  ImageErrorType2[ImageErrorType2["SIGHT_ENGINE_MODERATION_ERROR"] = 6807] = "SIGHT_ENGINE_MODERATION_ERROR";
  ImageErrorType2[ImageErrorType2["NOT_ALLOWED_TO_GENERATE_IMAGES"] = 6808] = "NOT_ALLOWED_TO_GENERATE_IMAGES";
  ImageErrorType2[ImageErrorType2["IMAGE_VIOLATE_CONTENT_GUIDELINES"] = 6809] = "IMAGE_VIOLATE_CONTENT_GUIDELINES";
  ImageErrorType2[ImageErrorType2["GENERATED_IMAGE_NOT_ALLOWED"] = 6810] = "GENERATED_IMAGE_NOT_ALLOWED";
  ImageErrorType2[ImageErrorType2["NOT_ALLOWED_TO_SAVE_IMAGES"] = 6811] = "NOT_ALLOWED_TO_SAVE_IMAGES";
  ImageErrorType2[ImageErrorType2["IMAGE_PROMPT_GENERATION_ERROR"] = 6812] = "IMAGE_PROMPT_GENERATION_ERROR";
  ImageErrorType2[ImageErrorType2["INVALID_IMAGE_PATH"] = 6813] = "INVALID_IMAGE_PATH";
  ImageErrorType2[ImageErrorType2["FILE_SIZE_TOO_LARGE"] = 6814] = "FILE_SIZE_TOO_LARGE";
  ImageErrorType2[ImageErrorType2["UPLOAD_FAILED"] = 6815] = "UPLOAD_FAILED";
  ImageErrorType2[ImageErrorType2["SIGNED_URL_GENERATION_FAILED"] = 6816] = "SIGNED_URL_GENERATION_FAILED";
  ImageErrorType2[ImageErrorType2["DELETE_FAILED"] = 6817] = "DELETE_FAILED";
  ImageErrorType2[ImageErrorType2["USER_IMAGE_ANALYSIS_FAILED"] = 6818] = "USER_IMAGE_ANALYSIS_FAILED";
  ImageErrorType2[ImageErrorType2["NSFW_CONTENT_NOT_ALLOWED_FOR_UNVERIFIED_USERS"] = 6819] = "NSFW_CONTENT_NOT_ALLOWED_FOR_UNVERIFIED_USERS";
  ImageErrorType2[ImageErrorType2["PROMPT_VIOLATE_CONTENT_GUIDELINES"] = 6820] = "PROMPT_VIOLATE_CONTENT_GUIDELINES";
  ImageErrorType2[ImageErrorType2["PHOTOREALISTIC_HUMAN_NOT_ALLOWED"] = 6821] = "PHOTOREALISTIC_HUMAN_NOT_ALLOWED";
  return ImageErrorType2;
})(ImageErrorType || {});
class KindeError extends SCError {
  /**
   * Creates an instance of KindeError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, KindeError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, KindeError);
    }
    Object.setPrototypeOf(this, KindeError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        1301
        /* ADD_USER_TO_ORG_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Error while adding user to organization"
      },
      [
        1302
        /* CREATE_USER_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Error while creating user"
      },
      [
        1303
        /* API_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Kinde API error: ${this.additionalDetails ?? ""}`
      }
    };
  }
}
var KindeErrorType = /* @__PURE__ */ ((KindeErrorType2) => {
  KindeErrorType2[KindeErrorType2["ADD_USER_TO_ORG_FAILED"] = 1301] = "ADD_USER_TO_ORG_FAILED";
  KindeErrorType2[KindeErrorType2["CREATE_USER_FAILED"] = 1302] = "CREATE_USER_FAILED";
  KindeErrorType2[KindeErrorType2["API_ERROR"] = 1303] = "API_ERROR";
  return KindeErrorType2;
})(KindeErrorType || {});
class MessageError extends SCError {
  /**
   * Creates an instance of MessageError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, MessageError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MessageError);
    }
    Object.setPrototypeOf(this, MessageError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        4801
        /* VIOLATES_GUIDELINE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Message violates our content guidelines."
      },
      [
        4802
        /* MESSAGE_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Message not found."
      },
      [
        4803
        /* VIEW_MESSAGE_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Not allowed to view this message."
      },
      [
        4804
        /* UPDATE_MESSAGE_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Not allowed to update this message."
      },
      [
        4805
        /* CONVERSATION_ID_MISSING */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Conversation ID is missing."
      },
      [
        4806
        /* MESSAGE_UPDATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Message update failed."
      }
    };
  }
}
var MessageErrorType = /* @__PURE__ */ ((MessageErrorType2) => {
  MessageErrorType2[MessageErrorType2["VIOLATES_GUIDELINE"] = 4801] = "VIOLATES_GUIDELINE";
  MessageErrorType2[MessageErrorType2["MESSAGE_NOT_FOUND"] = 4802] = "MESSAGE_NOT_FOUND";
  MessageErrorType2[MessageErrorType2["VIEW_MESSAGE_NOT_ALLOWED"] = 4803] = "VIEW_MESSAGE_NOT_ALLOWED";
  MessageErrorType2[MessageErrorType2["UPDATE_MESSAGE_NOT_ALLOWED"] = 4804] = "UPDATE_MESSAGE_NOT_ALLOWED";
  MessageErrorType2[MessageErrorType2["CONVERSATION_ID_MISSING"] = 4805] = "CONVERSATION_ID_MISSING";
  MessageErrorType2[MessageErrorType2["MESSAGE_UPDATE_FAILED"] = 4806] = "MESSAGE_UPDATE_FAILED";
  return MessageErrorType2;
})(MessageErrorType || {});
class ModerationError extends SCError {
  /**
   * Creates an instance of ModerationError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, ModerationError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ModerationError);
    }
    Object.setPrototypeOf(this, ModerationError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        7501
        /* SERVER_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Something went wrong. Please try again."
        /* SERVER_ERROR */
      },
      [
        7502
        /* INVALID_REQUEST */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid request. Please try again."
        /* INVALID_REQUEST */
      },
      [
        7503
        /* INVALID_RESPONSE */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Something went wrong, please try again."
        /* INVALID_RESPONSE */
      },
      [
        7507
        /* UNDERAGE_TEXT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Possible underage content detected. Please ensure all characters are clearly 18+ and that any ages mentioned reflect this. Refrain from using underage-related terms or implications. Please edit the character and resubmit."
        /* UNDERAGE_TEXT */
      },
      [
        7513
        /* UNDERAGE_TEXT_LOREBOOK */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Possible underage content detected. Please ensure all fields in the lorebook are clearly 18+ and that any ages mentioned reflect this. Refrain from using underage-related terms or implications. Please edit the lorebook and resubmit."
        /* UNDERAGE_TEXT_LOREBOOK */
      },
      [
        7514
        /* UNDERAGE_TEXT_RULEBOOK */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Possible underage content detected. Please ensure all fields in the Rulebook are clearly 18+ and that any ages mentioned reflect this. Refrain from using underage-related terms or implications. Please edit the Rulebook and resubmit."
        /* UNDERAGE_TEXT_RULEBOOK */
      },
      [
        7504
        /* AVATAR_WITH_SEXUAL_ACTIVITIES */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Avatar flagged for depicting sexual activities."
        /* AVATAR_WITH_SEXUAL_ACTIVITIES */
      },
      [
        7505
        /* AVATAR_TOO_EXPLICIT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Avatar flagged as too explicit for public chatbot."
        /* AVATAR_TOO_EXPLICIT */
      },
      [
        7506
        /* UNDERAGE_AVATAR_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Avatar flagged as portraying potentially underage character."
        /* UNDERAGE_AVATAR_NOT_ALLOWED */
      },
      [
        7508
        /* NSFW_TEXT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "NSFW detected."
        /* NSFW_TEXT */
      },
      [
        7511
        /* BESTIALITY_TEXT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Real animals are not allowed"
        /* BESTIALITY_TEXT */
      },
      [
        7512
        /* COMMUNITY_GUIDELINES_VIOLATION */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Potential community guidelines violation detected. Please review the community guidelines and edit your content before resubmitting."
        /* COMMUNITY_GUIDELINES_VIOLATION */
      },
      [
        7509
        /* IMAGE_MODERATION_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Error while performing image moderation."
        /* IMAGE_MODERATION_ERROR */
      },
      [
        7510
        /* MODERATION_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `${"Error while performing moderation from:"} ${this.additionalDetails ?? ""}`
      }
    };
  }
}
var ModerationErrorType = /* @__PURE__ */ ((ModerationErrorType2) => {
  ModerationErrorType2[ModerationErrorType2["SERVER_ERROR"] = 7501] = "SERVER_ERROR";
  ModerationErrorType2[ModerationErrorType2["INVALID_REQUEST"] = 7502] = "INVALID_REQUEST";
  ModerationErrorType2[ModerationErrorType2["INVALID_RESPONSE"] = 7503] = "INVALID_RESPONSE";
  ModerationErrorType2[ModerationErrorType2["AVATAR_WITH_SEXUAL_ACTIVITIES"] = 7504] = "AVATAR_WITH_SEXUAL_ACTIVITIES";
  ModerationErrorType2[ModerationErrorType2["AVATAR_TOO_EXPLICIT"] = 7505] = "AVATAR_TOO_EXPLICIT";
  ModerationErrorType2[ModerationErrorType2["UNDERAGE_AVATAR_NOT_ALLOWED"] = 7506] = "UNDERAGE_AVATAR_NOT_ALLOWED";
  ModerationErrorType2[ModerationErrorType2["UNDERAGE_TEXT"] = 7507] = "UNDERAGE_TEXT";
  ModerationErrorType2[ModerationErrorType2["NSFW_TEXT"] = 7508] = "NSFW_TEXT";
  ModerationErrorType2[ModerationErrorType2["IMAGE_MODERATION_ERROR"] = 7509] = "IMAGE_MODERATION_ERROR";
  ModerationErrorType2[ModerationErrorType2["MODERATION_ERROR"] = 7510] = "MODERATION_ERROR";
  ModerationErrorType2[ModerationErrorType2["BESTIALITY_TEXT"] = 7511] = "BESTIALITY_TEXT";
  ModerationErrorType2[ModerationErrorType2["COMMUNITY_GUIDELINES_VIOLATION"] = 7512] = "COMMUNITY_GUIDELINES_VIOLATION";
  ModerationErrorType2[ModerationErrorType2["UNDERAGE_TEXT_LOREBOOK"] = 7513] = "UNDERAGE_TEXT_LOREBOOK";
  ModerationErrorType2[ModerationErrorType2["UNDERAGE_TEXT_RULEBOOK"] = 7514] = "UNDERAGE_TEXT_RULEBOOK";
  return ModerationErrorType2;
})(ModerationErrorType || {});
class CheckoutError extends SCError {
  /**
   * Creates an instance of CheckoutError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, CheckoutError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CheckoutError);
    }
    Object.setPrototypeOf(this, CheckoutError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        4601
        /* INVALID_PLAN_ID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "The plan id provided is invalid."
        /* INVALID_PLAN_ID */
      },
      [
        4602
        /* ERROR_CALCULATING_TOTAL */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "An error occurred while calculating the order total. Please try again."
        /* ERROR_CALCULATING_TOTAL */
      },
      [
        4603
        /* ERROR_NEW_ORDER */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "An error occurred while processing your order. Please try again or contact support."
        /* ERROR_NEW_ORDER */
      },
      [
        4604
        /* MISSING_PAYMENT_TOKEN */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "A valid credit card is required to complete the order, edit your payment method."
        /* MISSING_PAYMENT_TOKEN */
      },
      [
        4605
        /* TOO_MANY_SUBSCRIPTIONS */
      ]: {
        statusCode: HttpStatusCode.TOO_MANY_REQUESTS,
        message: "You already have a subscription, you can upgrade from your profile page."
        /* TOO_MANY_SUBSCRIPTIONS */
      },
      [
        4606
        /* VALIDATION_ERROR */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: this.additionalDetails ?? "An error occurred while validating the order. Please try again."
        /* VALIDATION_ERROR */
      },
      [
        4607
        /* ERROR_GETTING_EXCHANGE_RATE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "An error occurred while getting the exchange rate. Please try again."
        /* ERROR_GETTING_EXCHANGE_RATE */
      },
      [
        4608
        /* NO_REDIRECT_URL */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "An error occurred while getting the payment redirect URL. Please try again."
        /* NO_REDIRECT_URL */
      },
      [
        4609
        /* ERROR_PROCESSING_PAYMENT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "An error occurred while processing the payment. Please try again."
        /* ERROR_PROCESSING_PAYMENT */
      },
      [
        4610
        /* ERROR_NEW_PAYMENT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: this.additionalDetails ?? "An error occurred while creating the payment. Please try again."
        /* ERROR_NEW_PAYMENT */
      },
      [
        4611
        /* MISSING_API_KEY */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "An error occurred while creating the payment. Please try again."
        /* MISSING_API_KEY */
      }
    };
  }
}
var CheckoutErrorType = /* @__PURE__ */ ((CheckoutErrorType2) => {
  CheckoutErrorType2[CheckoutErrorType2["INVALID_PLAN_ID"] = 4601] = "INVALID_PLAN_ID";
  CheckoutErrorType2[CheckoutErrorType2["ERROR_CALCULATING_TOTAL"] = 4602] = "ERROR_CALCULATING_TOTAL";
  CheckoutErrorType2[CheckoutErrorType2["ERROR_NEW_ORDER"] = 4603] = "ERROR_NEW_ORDER";
  CheckoutErrorType2[CheckoutErrorType2["MISSING_PAYMENT_TOKEN"] = 4604] = "MISSING_PAYMENT_TOKEN";
  CheckoutErrorType2[CheckoutErrorType2["TOO_MANY_SUBSCRIPTIONS"] = 4605] = "TOO_MANY_SUBSCRIPTIONS";
  CheckoutErrorType2[CheckoutErrorType2["VALIDATION_ERROR"] = 4606] = "VALIDATION_ERROR";
  CheckoutErrorType2[CheckoutErrorType2["ERROR_GETTING_EXCHANGE_RATE"] = 4607] = "ERROR_GETTING_EXCHANGE_RATE";
  CheckoutErrorType2[CheckoutErrorType2["NO_REDIRECT_URL"] = 4608] = "NO_REDIRECT_URL";
  CheckoutErrorType2[CheckoutErrorType2["ERROR_PROCESSING_PAYMENT"] = 4609] = "ERROR_PROCESSING_PAYMENT";
  CheckoutErrorType2[CheckoutErrorType2["ERROR_NEW_PAYMENT"] = 4610] = "ERROR_NEW_PAYMENT";
  CheckoutErrorType2[CheckoutErrorType2["MISSING_API_KEY"] = 4611] = "MISSING_API_KEY";
  return CheckoutErrorType2;
})(CheckoutErrorType || {});
class PageError extends SCError {
  /**
   * Creates an instance of PageError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, PageError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PageError);
    }
    Object.setPrototypeOf(this, PageError.prototype);
    this.build();
  }
  get errorCodeMap() {
    return {
      [
        8101
        /* PAGE_BLOCK_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: `${"Page block not found."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8102
        /* CONFIGURATION_ERROR */
      ]: {
        statusCode: HttpStatusCode.SERVICE_UNAVAILABLE,
        message: `${"Page block content is unavailable due to a configuration issue."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      }
    };
  }
}
var PageErrorType = /* @__PURE__ */ ((PageErrorType2) => {
  PageErrorType2[PageErrorType2["PAGE_BLOCK_NOT_FOUND"] = 8101] = "PAGE_BLOCK_NOT_FOUND";
  PageErrorType2[PageErrorType2["CONFIGURATION_ERROR"] = 8102] = "CONFIGURATION_ERROR";
  return PageErrorType2;
})(PageErrorType || {});
class UserPersonaError extends SCError {
  /**
   * Creates an instance of UserPersonaError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, UserPersonaError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UserPersonaError);
    }
    Object.setPrototypeOf(this, UserPersonaError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        4201
        /* INVALID_REQUEST_SCHEMA */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid Request Schema"
      },
      [
        4202
        /* NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Persona Not Found"
      },
      [
        4203
        /* PERSONA_ID_REQUIRED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Persona Id Required"
      },
      [
        4204
        /* PERSONA_LIMIT_REACHED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Persona Creation/Updation Limit Reached"
      },
      [
        4205
        /* CANNOT_DELETE_DEFAULT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Default User Persona Can't Be Deleted"
      },
      [
        4206
        /* CANNOT_DELETE_PROFILE_PERSONA */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "User Profile Persona Can't Be Deleted"
      },
      [
        4207
        /* UNDER_AGE_CONTENT_FOUND */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Underage content was present in create/update persona request"
      },
      [
        4209
        /* INVALID_AVATAR_REFERENCE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Persona Avatar should either be S3 reference or base64 image"
      },
      [
        4208
        /* NSFW_CONTENT_FOUND */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "NSFW content found in create/update persona"
      }
    };
  }
}
var UserPersonaErrorType = /* @__PURE__ */ ((UserPersonaErrorType2) => {
  UserPersonaErrorType2[UserPersonaErrorType2["INVALID_REQUEST_SCHEMA"] = 4201] = "INVALID_REQUEST_SCHEMA";
  UserPersonaErrorType2[UserPersonaErrorType2["NOT_FOUND"] = 4202] = "NOT_FOUND";
  UserPersonaErrorType2[UserPersonaErrorType2["PERSONA_ID_REQUIRED"] = 4203] = "PERSONA_ID_REQUIRED";
  UserPersonaErrorType2[UserPersonaErrorType2["PERSONA_LIMIT_REACHED"] = 4204] = "PERSONA_LIMIT_REACHED";
  UserPersonaErrorType2[UserPersonaErrorType2["CANNOT_DELETE_DEFAULT"] = 4205] = "CANNOT_DELETE_DEFAULT";
  UserPersonaErrorType2[UserPersonaErrorType2["CANNOT_DELETE_PROFILE_PERSONA"] = 4206] = "CANNOT_DELETE_PROFILE_PERSONA";
  UserPersonaErrorType2[UserPersonaErrorType2["UNDER_AGE_CONTENT_FOUND"] = 4207] = "UNDER_AGE_CONTENT_FOUND";
  UserPersonaErrorType2[UserPersonaErrorType2["NSFW_CONTENT_FOUND"] = 4208] = "NSFW_CONTENT_FOUND";
  UserPersonaErrorType2[UserPersonaErrorType2["INVALID_AVATAR_REFERENCE"] = 4209] = "INVALID_AVATAR_REFERENCE";
  return UserPersonaErrorType2;
})(UserPersonaErrorType || {});
class QueueError extends SCError {
  /**
   * Creates an instance of QueueError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, QueueError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, QueueError);
    }
    Object.setPrototypeOf(this, QueueError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        2601
        /* MISSING_QUEUE_URL */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing queue URL."
        /* MISSING_QUEUE_URL */
      },
      [
        2602
        /* INVALID_QUEUE_PAYLOAD */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid queue payload."
        /* INVALID_QUEUE_PAYLOAD */
      }
    };
  }
}
var QueueErrorType = /* @__PURE__ */ ((QueueErrorType2) => {
  QueueErrorType2[QueueErrorType2["MISSING_QUEUE_URL"] = 2601] = "MISSING_QUEUE_URL";
  QueueErrorType2[QueueErrorType2["INVALID_QUEUE_PAYLOAD"] = 2602] = "INVALID_QUEUE_PAYLOAD";
  return QueueErrorType2;
})(QueueErrorType || {});
class SubscriptionError extends SCError {
  /**
   * Creates an instance of SubscriptionError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, SubscriptionError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SubscriptionError);
    }
    Object.setPrototypeOf(this, SubscriptionError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  // eslint-disable-next-line max-lines-per-function -- errorCodeMap must list all error types; splitting it would reduce clarity
  get errorCodeMap() {
    return {
      [
        4401
        /* USER_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "User not found."
        /* USER_NOT_FOUND */
      },
      [
        4402
        /* USER_ROLE_UNKNOWN */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"User role unknown."}${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        4403
        /* UNABLE_TO_CREATE_SUBSCRIPTION */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Unable to create subscription."
        /* UNABLE_TO_CREATE_SUBSCRIPTION */
      },
      [
        4404
        /* SUBSCRIPTION_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Subscription not found."
        /* SUBSCRIPTION_NOT_FOUND */
      },
      [
        4405
        /* SUBSCRIPTION_NOT_ACTIVE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Subscription not active."
        /* SUBSCRIPTION_NOT_ACTIVE */
      },
      [
        4406
        /* CAMPAIGN_ID_MISSING */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Campaign ID missing."
        /* CAMPAIGN_ID_MISSING */
      },
      [
        4407
        /* UNKNOWN_ACTION_TYPE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Unknown action type."
        /* UNKNOWN_ACTION_TYPE */
      },
      [
        4408
        /* TRANSACTION_DETAILS_INCORRECT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Transaction details incorrect."
        /* TRANSACTION_DETAILS_INCORRECT */
      },
      [
        4409
        /* SUBSCRIPTION_NOT_EXPIRED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Subscription not expired."
        /* SUBSCRIPTION_NOT_EXPIRED */
      },
      [
        4410
        /* INVALID_SIGNATURE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid signature."
        /* INVALID_SIGNATURE */
      },
      [
        4411
        /* ID_NOT_PROVIDED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "ID not provided."
        /* ID_NOT_PROVIDED */
      },
      [
        4412
        /* USER_ID_NOT_PROVIDED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "User ID not provided."
        /* USER_ID_NOT_PROVIDED */
      },
      [
        4413
        /* EXTERNAL_SUBSCRIPTION_ID_NOT_PROVIDED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "External subscription ID not provided."
        /* EXTERNAL_SUBSCRIPTION_ID_NOT_PROVIDED */
      },
      [
        4414
        /* PLATFORM_NOT_PROVIDED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Platform not provided."
        /* PLATFORM_NOT_PROVIDED */
      },
      [
        4415
        /* SUBSCRIPTION_ALREADY_EXISTS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Subscription already exists."
        /* SUBSCRIPTION_ALREADY_EXISTS */
      },
      [
        4416
        /* PRODUCT_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Product not found."
        /* PRODUCT_NOT_FOUND */
      },
      [
        4417
        /* UNABLE_TO_RETRIEVE_SUBSCRIPTION */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Unable to retrieve subscription."
        /* UNABLE_TO_RETRIEVE_SUBSCRIPTION */
      },
      [
        4418
        /* MISSING_APPLICATION_ID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing application ID."
        /* MISSING_APPLICATION_ID */
      },
      [
        4419
        /* OLD_USER_SUBSCRIPTION_NOT_ACTIVE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Old user subscription not active."
        /* OLD_USER_SUBSCRIPTION_NOT_ACTIVE */
      },
      [
        4420
        /* MISSING_RETURN_URL */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing return URL."
        /* MISSING_RETURN_URL */
      },
      [
        4421
        /* VIEW_SUBSCRIPTION_OPTIONS_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "View subscription options not allowed."
        /* VIEW_SUBSCRIPTION_OPTIONS_NOT_ALLOWED */
      },
      [
        4422
        /* MISSING_SUBSCRIPTION_OR_PLAN_OR_ACTION */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing subscription or plan or action."
        /* MISSING_SUBSCRIPTION_OR_PLAN_OR_ACTION */
      },
      [
        4423
        /* MISSING_PLAN */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing plan."
        /* MISSING_PLAN */
      },
      [
        4424
        /* MISSING_PAYMENT_CARD */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing payment card."
        /* MISSING_PAYMENT_CARD */
      },
      [
        4425
        /* SUBSCRIPTION_PLAN_SAME */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Subscription plan same."
        /* SUBSCRIPTION_PLAN_SAME */
      },
      [
        4426
        /* INVALID_IP_ADDRESS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid IP address."
        /* INVALID_IP_ADDRESS */
      },
      [
        4427
        /* INVALID_REQUEST_BODY */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid request body."
        /* INVALID_REQUEST_BODY */
      },
      [
        4428
        /* REFUND_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Refund failed."
        /* REFUND_FAILED */
      },
      [
        4429
        /* MISSING_SIGNATURE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing signature."
        /* MISSING_SIGNATURE */
      },
      [
        4430
        /* INVALID_MERCHANT_ID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid merchant ID."
        /* INVALID_MERCHANT_ID */
      },
      [
        4431
        /* MISSING_REQUEST_BODY */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Missing request body."
        /* MISSING_REQUEST_BODY */
      },
      [
        4432
        /* TRANSIENT_DATA_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Transient data not found."
        /* TRANSIENT_DATA_NOT_FOUND */
      },
      [
        4433
        /* TRANSACTION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `${"An error occurred processing the transaction."}${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        4434
        /* UNABLE_TO_CHANGE_PRODUCT */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Unable to change product."
        /* UNABLE_TO_CHANGE_PRODUCT */
      },
      [
        4435
        /* CALLBACK_TIMESTAMP_EXPIRED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Callback timestamp is outside the accepted freshness window."}${this.additionalDetails ? " " + this.additionalDetails : ""}`
      }
    };
  }
}
var SubscriptionErrorType = /* @__PURE__ */ ((SubscriptionErrorType2) => {
  SubscriptionErrorType2[SubscriptionErrorType2["USER_NOT_FOUND"] = 4401] = "USER_NOT_FOUND";
  SubscriptionErrorType2[SubscriptionErrorType2["USER_ROLE_UNKNOWN"] = 4402] = "USER_ROLE_UNKNOWN";
  SubscriptionErrorType2[SubscriptionErrorType2["UNABLE_TO_CREATE_SUBSCRIPTION"] = 4403] = "UNABLE_TO_CREATE_SUBSCRIPTION";
  SubscriptionErrorType2[SubscriptionErrorType2["SUBSCRIPTION_NOT_FOUND"] = 4404] = "SUBSCRIPTION_NOT_FOUND";
  SubscriptionErrorType2[SubscriptionErrorType2["SUBSCRIPTION_NOT_ACTIVE"] = 4405] = "SUBSCRIPTION_NOT_ACTIVE";
  SubscriptionErrorType2[SubscriptionErrorType2["CAMPAIGN_ID_MISSING"] = 4406] = "CAMPAIGN_ID_MISSING";
  SubscriptionErrorType2[SubscriptionErrorType2["UNKNOWN_ACTION_TYPE"] = 4407] = "UNKNOWN_ACTION_TYPE";
  SubscriptionErrorType2[SubscriptionErrorType2["TRANSACTION_DETAILS_INCORRECT"] = 4408] = "TRANSACTION_DETAILS_INCORRECT";
  SubscriptionErrorType2[SubscriptionErrorType2["SUBSCRIPTION_NOT_EXPIRED"] = 4409] = "SUBSCRIPTION_NOT_EXPIRED";
  SubscriptionErrorType2[SubscriptionErrorType2["INVALID_SIGNATURE"] = 4410] = "INVALID_SIGNATURE";
  SubscriptionErrorType2[SubscriptionErrorType2["ID_NOT_PROVIDED"] = 4411] = "ID_NOT_PROVIDED";
  SubscriptionErrorType2[SubscriptionErrorType2["USER_ID_NOT_PROVIDED"] = 4412] = "USER_ID_NOT_PROVIDED";
  SubscriptionErrorType2[SubscriptionErrorType2["EXTERNAL_SUBSCRIPTION_ID_NOT_PROVIDED"] = 4413] = "EXTERNAL_SUBSCRIPTION_ID_NOT_PROVIDED";
  SubscriptionErrorType2[SubscriptionErrorType2["PLATFORM_NOT_PROVIDED"] = 4414] = "PLATFORM_NOT_PROVIDED";
  SubscriptionErrorType2[SubscriptionErrorType2["SUBSCRIPTION_ALREADY_EXISTS"] = 4415] = "SUBSCRIPTION_ALREADY_EXISTS";
  SubscriptionErrorType2[SubscriptionErrorType2["PRODUCT_NOT_FOUND"] = 4416] = "PRODUCT_NOT_FOUND";
  SubscriptionErrorType2[SubscriptionErrorType2["UNABLE_TO_RETRIEVE_SUBSCRIPTION"] = 4417] = "UNABLE_TO_RETRIEVE_SUBSCRIPTION";
  SubscriptionErrorType2[SubscriptionErrorType2["MISSING_APPLICATION_ID"] = 4418] = "MISSING_APPLICATION_ID";
  SubscriptionErrorType2[SubscriptionErrorType2["OLD_USER_SUBSCRIPTION_NOT_ACTIVE"] = 4419] = "OLD_USER_SUBSCRIPTION_NOT_ACTIVE";
  SubscriptionErrorType2[SubscriptionErrorType2["MISSING_RETURN_URL"] = 4420] = "MISSING_RETURN_URL";
  SubscriptionErrorType2[SubscriptionErrorType2["VIEW_SUBSCRIPTION_OPTIONS_NOT_ALLOWED"] = 4421] = "VIEW_SUBSCRIPTION_OPTIONS_NOT_ALLOWED";
  SubscriptionErrorType2[SubscriptionErrorType2["MISSING_SUBSCRIPTION_OR_PLAN_OR_ACTION"] = 4422] = "MISSING_SUBSCRIPTION_OR_PLAN_OR_ACTION";
  SubscriptionErrorType2[SubscriptionErrorType2["MISSING_PLAN"] = 4423] = "MISSING_PLAN";
  SubscriptionErrorType2[SubscriptionErrorType2["MISSING_PAYMENT_CARD"] = 4424] = "MISSING_PAYMENT_CARD";
  SubscriptionErrorType2[SubscriptionErrorType2["SUBSCRIPTION_PLAN_SAME"] = 4425] = "SUBSCRIPTION_PLAN_SAME";
  SubscriptionErrorType2[SubscriptionErrorType2["INVALID_IP_ADDRESS"] = 4426] = "INVALID_IP_ADDRESS";
  SubscriptionErrorType2[SubscriptionErrorType2["INVALID_REQUEST_BODY"] = 4427] = "INVALID_REQUEST_BODY";
  SubscriptionErrorType2[SubscriptionErrorType2["REFUND_FAILED"] = 4428] = "REFUND_FAILED";
  SubscriptionErrorType2[SubscriptionErrorType2["MISSING_SIGNATURE"] = 4429] = "MISSING_SIGNATURE";
  SubscriptionErrorType2[SubscriptionErrorType2["INVALID_MERCHANT_ID"] = 4430] = "INVALID_MERCHANT_ID";
  SubscriptionErrorType2[SubscriptionErrorType2["MISSING_REQUEST_BODY"] = 4431] = "MISSING_REQUEST_BODY";
  SubscriptionErrorType2[SubscriptionErrorType2["TRANSIENT_DATA_NOT_FOUND"] = 4432] = "TRANSIENT_DATA_NOT_FOUND";
  SubscriptionErrorType2[SubscriptionErrorType2["TRANSACTION_FAILED"] = 4433] = "TRANSACTION_FAILED";
  SubscriptionErrorType2[SubscriptionErrorType2["UNABLE_TO_CHANGE_PRODUCT"] = 4434] = "UNABLE_TO_CHANGE_PRODUCT";
  SubscriptionErrorType2[SubscriptionErrorType2["CALLBACK_TIMESTAMP_EXPIRED"] = 4435] = "CALLBACK_TIMESTAMP_EXPIRED";
  return SubscriptionErrorType2;
})(SubscriptionErrorType || {});
class GenerationPresetError extends SCError {
  /**
   * Creates an instance of GenerationPresetError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, GenerationPresetError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GenerationPresetError);
    }
    Object.setPrototypeOf(this, GenerationPresetError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        3501
        /* GENERATION_PRESET_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Generation preset not found"
      },
      [
        3502
        /* GENERATION_PRESET_LIMIT_EXCEEDED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Maximum generation preset limit exceeded"
      },
      [
        3503
        /* GENERATION_PRESET_CREATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to create generation preset"
      },
      [
        3504
        /* GENERATION_PRESET_UPDATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to update generation preset"
      },
      [
        3505
        /* GENERATION_PRESET_DELETE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to delete generation preset"
      },
      [
        3506
        /* GENERATION_PRESET_ALREADY_EXISTS */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: "Generation preset with this ID already exists"
      }
    };
  }
}
var GenerationPresetErrorType = /* @__PURE__ */ ((GenerationPresetErrorType2) => {
  GenerationPresetErrorType2[GenerationPresetErrorType2["GENERATION_PRESET_NOT_FOUND"] = 3501] = "GENERATION_PRESET_NOT_FOUND";
  GenerationPresetErrorType2[GenerationPresetErrorType2["GENERATION_PRESET_LIMIT_EXCEEDED"] = 3502] = "GENERATION_PRESET_LIMIT_EXCEEDED";
  GenerationPresetErrorType2[GenerationPresetErrorType2["GENERATION_PRESET_CREATE_FAILED"] = 3503] = "GENERATION_PRESET_CREATE_FAILED";
  GenerationPresetErrorType2[GenerationPresetErrorType2["GENERATION_PRESET_UPDATE_FAILED"] = 3504] = "GENERATION_PRESET_UPDATE_FAILED";
  GenerationPresetErrorType2[GenerationPresetErrorType2["GENERATION_PRESET_DELETE_FAILED"] = 3505] = "GENERATION_PRESET_DELETE_FAILED";
  GenerationPresetErrorType2[GenerationPresetErrorType2["GENERATION_PRESET_ALREADY_EXISTS"] = 3506] = "GENERATION_PRESET_ALREADY_EXISTS";
  return GenerationPresetErrorType2;
})(GenerationPresetErrorType || {});
class UserError extends SCError {
  /**
   * Creates an instance of UserError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, UserError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UserError);
    }
    Object.setPrototypeOf(this, UserError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        3201
        /* NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "User not found."
        /* NOT_FOUND */
      },
      [
        3202
        /* USERNAME_DUPLICATED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Username duplicated."
        /* USERNAME_DUPLICATED */
      },
      [
        3203
        /* CHARACTER_UPDATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Character update failed."
        /* CHARACTER_UPDATE_FAILED */
      },
      [
        3204
        /* CANT_ASSIGN_ROLE */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Can't assign role."
        /* CANT_ASSIGN_ROLE */
      },
      [
        3205
        /* INVALID_UPDATE_NUM_MESSAGE_REQUEST */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid update num message request."
        /* INVALID_UPDATE_NUM_MESSAGE_REQUEST */
      },
      [
        3206
        /* INVALID_USERNAME */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid username."
        /* INVALID_USERNAME */
      },
      [
        3207
        /* NO_EMAIL_PROVIDED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "No email provided."
        /* NO_EMAIL_PROVIDED */
      },
      [
        3208
        /* MISSING_GPTGF_API_KEY */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Missing GPTGF API key."
        /* MISSING_GPTGF_API_KEY */
      },
      [
        3209
        /* INVALID_INPUT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid input."
        /* INVALID_INPUT */
      },
      [
        3210
        /* USER_IS_DELETED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "User is deleted."
        /* USER_IS_DELETED */
      },
      [
        3211
        /* NOT_ALLOWED_TO_CREATE_USER */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Not allowed to create user."
        /* NOT_ALLOWED_TO_CREATE_USER */
      },
      [
        3212
        /* CREATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `${"Failed to create user:"} ${this.additionalDetails ?? ""}`
      },
      [
        3213
        /* EMAIL_DUPLICATED */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: "Email address already in use by another account."
        /* EMAIL_DUPLICATED */
      },
      [
        3214
        /* EMAIL_CHANGE_REQUIRES_VERIFICATION */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Email change requires ownership verification."
        /* EMAIL_CHANGE_REQUIRES_VERIFICATION */
      },
      [
        3215
        /* EMAIL_VERIFICATION_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "No pending email change found, or it has expired."
        /* EMAIL_VERIFICATION_NOT_FOUND */
      },
      [
        3216
        /* EMAIL_VERIFICATION_CODE_INVALID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid verification code."
        /* EMAIL_VERIFICATION_CODE_INVALID */
      },
      [
        3217
        /* EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS */
      ]: {
        statusCode: HttpStatusCode.TOO_MANY_REQUESTS,
        message: "Too many verification attempts; pending email change discarded."
        /* EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS */
      },
      [
        3218
        /* EMAIL_UNCHANGED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Email unchanged."
        /* EMAIL_UNCHANGED */
      }
    };
  }
}
var UserErrorType = /* @__PURE__ */ ((UserErrorType2) => {
  UserErrorType2[UserErrorType2["NOT_FOUND"] = 3201] = "NOT_FOUND";
  UserErrorType2[UserErrorType2["USERNAME_DUPLICATED"] = 3202] = "USERNAME_DUPLICATED";
  UserErrorType2[UserErrorType2["CHARACTER_UPDATE_FAILED"] = 3203] = "CHARACTER_UPDATE_FAILED";
  UserErrorType2[UserErrorType2["CANT_ASSIGN_ROLE"] = 3204] = "CANT_ASSIGN_ROLE";
  UserErrorType2[UserErrorType2["INVALID_UPDATE_NUM_MESSAGE_REQUEST"] = 3205] = "INVALID_UPDATE_NUM_MESSAGE_REQUEST";
  UserErrorType2[UserErrorType2["INVALID_USERNAME"] = 3206] = "INVALID_USERNAME";
  UserErrorType2[UserErrorType2["NO_EMAIL_PROVIDED"] = 3207] = "NO_EMAIL_PROVIDED";
  UserErrorType2[UserErrorType2["MISSING_GPTGF_API_KEY"] = 3208] = "MISSING_GPTGF_API_KEY";
  UserErrorType2[UserErrorType2["INVALID_INPUT"] = 3209] = "INVALID_INPUT";
  UserErrorType2[UserErrorType2["USER_IS_DELETED"] = 3210] = "USER_IS_DELETED";
  UserErrorType2[UserErrorType2["NOT_ALLOWED_TO_CREATE_USER"] = 3211] = "NOT_ALLOWED_TO_CREATE_USER";
  UserErrorType2[UserErrorType2["CREATION_FAILED"] = 3212] = "CREATION_FAILED";
  UserErrorType2[UserErrorType2["EMAIL_DUPLICATED"] = 3213] = "EMAIL_DUPLICATED";
  UserErrorType2[UserErrorType2["EMAIL_CHANGE_REQUIRES_VERIFICATION"] = 3214] = "EMAIL_CHANGE_REQUIRES_VERIFICATION";
  UserErrorType2[UserErrorType2["EMAIL_VERIFICATION_NOT_FOUND"] = 3215] = "EMAIL_VERIFICATION_NOT_FOUND";
  UserErrorType2[UserErrorType2["EMAIL_VERIFICATION_CODE_INVALID"] = 3216] = "EMAIL_VERIFICATION_CODE_INVALID";
  UserErrorType2[UserErrorType2["EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS"] = 3217] = "EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS";
  UserErrorType2[UserErrorType2["EMAIL_UNCHANGED"] = 3218] = "EMAIL_UNCHANGED";
  return UserErrorType2;
})(UserErrorType || {});
class UserSettingsError extends SCError {
  /**
   * Creates an instance of UserSettingsError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, UserSettingsError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UserSettingsError);
    }
    Object.setPrototypeOf(this, UserSettingsError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        3401
        /* SETTING_UPDATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Updating user settings failed"
      }
    };
  }
}
var UserSettingsErrorType = /* @__PURE__ */ ((UserSettingsErrorType2) => {
  UserSettingsErrorType2[UserSettingsErrorType2["SETTING_UPDATE_FAILED"] = 3401] = "SETTING_UPDATE_FAILED";
  return UserSettingsErrorType2;
})(UserSettingsErrorType || {});
class TextToSpeechError extends SCError {
  /**
   * Creates an instance of TextToSpeechError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, TextToSpeechError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, TextToSpeechError);
    }
    Object.setPrototypeOf(this, TextToSpeechError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        6501
        /* TTS_FAILED_FETCHING_ALL_VOICES */
      ]: {
        message: "Failed fetching all voices from Cartesia",
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR
      },
      [
        6502
        /* TTS_FAILED_FETCHING_VOICE_SAMPLE */
      ]: {
        message: "Failed fetching voice sample from Cartesia",
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR
      },
      [
        6503
        /* TTS_WEBSOCKET_NOT_INITIALIZED */
      ]: {
        message: "Websocket not initialized",
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR
      },
      [
        6504
        /* TTS_PARTNER_ERROR_CHUNK */
      ]: {
        message: "Error from partner web socket",
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR
      },
      [
        6505
        /* TTS_PARTNER_CONCURRENCY_LIMIT_REACHED */
      ]: {
        message: "Partner concurrency limit reached",
        statusCode: HttpStatusCode.TOO_MANY_REQUESTS
      },
      [
        6506
        /* TTS_INVALID_TRANSCRIPT */
      ]: {
        message: "Couldn't find any speech to extract from this message.",
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR
      },
      [
        6507
        /* TTS_PARTNER_CONNECTION_TIMEOUT */
      ]: {
        message: "Websocket timeout while connecting to TTS Partner.",
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR
      },
      [
        6508
        /* TTS_PARTNER_CONNECTION_LIMIT_REACHED */
      ]: {
        message: "Websocket connection limit reached with the TTS partner.",
        statusCode: HttpStatusCode.TOO_MANY_REQUESTS
      },
      [
        6509
        /* TTS_PARTNER_CONNECTION_ERROR */
      ]: {
        message: "Unable to make websocket connection with TTS partner.",
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR
      },
      [
        6510
        /* TTS_CONNECTION_POOL_EXHAUSTED */
      ]: {
        message: "All the websocket connections with TTS Provider are busy or closed.",
        statusCode: HttpStatusCode.SERVICE_UNAVAILABLE
      },
      [
        6511
        /* TTS_PARTNER_KEY_NOT_FOUND */
      ]: {
        message: "TTS Provider API key not found",
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR
      }
    };
  }
}
var TextToSpeechErrorType = /* @__PURE__ */ ((TextToSpeechErrorType2) => {
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_FAILED_FETCHING_ALL_VOICES"] = 6501] = "TTS_FAILED_FETCHING_ALL_VOICES";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_FAILED_FETCHING_VOICE_SAMPLE"] = 6502] = "TTS_FAILED_FETCHING_VOICE_SAMPLE";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_WEBSOCKET_NOT_INITIALIZED"] = 6503] = "TTS_WEBSOCKET_NOT_INITIALIZED";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_PARTNER_ERROR_CHUNK"] = 6504] = "TTS_PARTNER_ERROR_CHUNK";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_PARTNER_CONCURRENCY_LIMIT_REACHED"] = 6505] = "TTS_PARTNER_CONCURRENCY_LIMIT_REACHED";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_INVALID_TRANSCRIPT"] = 6506] = "TTS_INVALID_TRANSCRIPT";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_PARTNER_CONNECTION_TIMEOUT"] = 6507] = "TTS_PARTNER_CONNECTION_TIMEOUT";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_PARTNER_CONNECTION_LIMIT_REACHED"] = 6508] = "TTS_PARTNER_CONNECTION_LIMIT_REACHED";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_PARTNER_CONNECTION_ERROR"] = 6509] = "TTS_PARTNER_CONNECTION_ERROR";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_CONNECTION_POOL_EXHAUSTED"] = 6510] = "TTS_CONNECTION_POOL_EXHAUSTED";
  TextToSpeechErrorType2[TextToSpeechErrorType2["TTS_PARTNER_KEY_NOT_FOUND"] = 6511] = "TTS_PARTNER_KEY_NOT_FOUND";
  return TextToSpeechErrorType2;
})(TextToSpeechErrorType || {});
class VoiceError extends SCError {
  /**
   * Creates an instance of VoiceError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, VoiceError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, VoiceError);
    }
    Object.setPrototypeOf(this, VoiceError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        6601
        /* VOICE_UPLOAD_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to upload voice sample to S3"
      },
      [
        6602
        /* VOICE_DELETION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to delete voice sample from S3"
      },
      [
        6603
        /* VOICE_DELETE_ALL_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to delete all voice samples from S3"
      },
      [
        6604
        /* VOICE_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: "Voice not found"
      },
      [
        6605
        /* VOICE_DELETION_FAILED_FROM_S3 */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to delete voice sample from S3"
      },
      [
        6606
        /* VOICE_DELETE_ALL_FAILED_FROM_S3 */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to delete all voice samples from S3"
      },
      [
        6607
        /* VOICE_CREATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to create voice sample"
      },
      [
        6608
        /* INVALID_FILE_TYPE */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Invalid file type"
      },
      [
        6609
        /* VOICE_GET_SIGNED_URL_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to get signed URL for voice sample"
      },
      [
        6611
        /* VOICE_ALREADY_GENERATED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Voice already generated"
      },
      [
        6610
        /* VOICE_ID_REQUIRED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Voice ID is required"
      },
      [
        6612
        /* RATE_VOICE_INVALID_INPUT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Message ID and rating are required"
      },
      [
        6613
        /* RATE_AUDIO_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Rating audio failed"
      },
      [
        6614
        /* UPDATE_VOICE_ERROR */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Updating voices failed"
      },
      [
        6615
        /* VOICE_FETCH_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Failed to fetch voice"
      },
      [
        6616
        /* VOICE_CLONING_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Voice cloning failed"
      },
      [
        6617
        /* INVALID_SAMPLE_FILE_FORMAT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Invalid sample file format"
      },
      [
        6618
        /* VOICE_CLONING_QUALITY_ERROR */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Audio quality does not meet the requirements for voice cloning"
      },
      [
        6619
        /* VOICE_SAMPLE_VALIDATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "Voice sample validation failed"
      },
      [
        6620
        /* VOICE_PROCESSING_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Voice processing failed"
      },
      [
        6621
        /* CUSTOM_VOICES_LIMIT_REACHED */
      ]: {
        statusCode: HttpStatusCode.TOO_MANY_REQUESTS,
        message: "Custom voices limit reached"
      }
    };
  }
}
var VoiceErrorType = /* @__PURE__ */ ((VoiceErrorType2) => {
  VoiceErrorType2[VoiceErrorType2["VOICE_UPLOAD_FAILED"] = 6601] = "VOICE_UPLOAD_FAILED";
  VoiceErrorType2[VoiceErrorType2["VOICE_DELETION_FAILED"] = 6602] = "VOICE_DELETION_FAILED";
  VoiceErrorType2[VoiceErrorType2["VOICE_DELETE_ALL_FAILED"] = 6603] = "VOICE_DELETE_ALL_FAILED";
  VoiceErrorType2[VoiceErrorType2["VOICE_NOT_FOUND"] = 6604] = "VOICE_NOT_FOUND";
  VoiceErrorType2[VoiceErrorType2["VOICE_DELETION_FAILED_FROM_S3"] = 6605] = "VOICE_DELETION_FAILED_FROM_S3";
  VoiceErrorType2[VoiceErrorType2["VOICE_DELETE_ALL_FAILED_FROM_S3"] = 6606] = "VOICE_DELETE_ALL_FAILED_FROM_S3";
  VoiceErrorType2[VoiceErrorType2["VOICE_CREATION_FAILED"] = 6607] = "VOICE_CREATION_FAILED";
  VoiceErrorType2[VoiceErrorType2["INVALID_FILE_TYPE"] = 6608] = "INVALID_FILE_TYPE";
  VoiceErrorType2[VoiceErrorType2["VOICE_GET_SIGNED_URL_FAILED"] = 6609] = "VOICE_GET_SIGNED_URL_FAILED";
  VoiceErrorType2[VoiceErrorType2["VOICE_ID_REQUIRED"] = 6610] = "VOICE_ID_REQUIRED";
  VoiceErrorType2[VoiceErrorType2["VOICE_ALREADY_GENERATED"] = 6611] = "VOICE_ALREADY_GENERATED";
  VoiceErrorType2[VoiceErrorType2["RATE_VOICE_INVALID_INPUT"] = 6612] = "RATE_VOICE_INVALID_INPUT";
  VoiceErrorType2[VoiceErrorType2["RATE_AUDIO_ERROR"] = 6613] = "RATE_AUDIO_ERROR";
  VoiceErrorType2[VoiceErrorType2["UPDATE_VOICE_ERROR"] = 6614] = "UPDATE_VOICE_ERROR";
  VoiceErrorType2[VoiceErrorType2["VOICE_FETCH_FAILED"] = 6615] = "VOICE_FETCH_FAILED";
  VoiceErrorType2[VoiceErrorType2["VOICE_CLONING_FAILED"] = 6616] = "VOICE_CLONING_FAILED";
  VoiceErrorType2[VoiceErrorType2["INVALID_SAMPLE_FILE_FORMAT"] = 6617] = "INVALID_SAMPLE_FILE_FORMAT";
  VoiceErrorType2[VoiceErrorType2["VOICE_CLONING_QUALITY_ERROR"] = 6618] = "VOICE_CLONING_QUALITY_ERROR";
  VoiceErrorType2[VoiceErrorType2["VOICE_SAMPLE_VALIDATION_FAILED"] = 6619] = "VOICE_SAMPLE_VALIDATION_FAILED";
  VoiceErrorType2[VoiceErrorType2["VOICE_PROCESSING_FAILED"] = 6620] = "VOICE_PROCESSING_FAILED";
  VoiceErrorType2[VoiceErrorType2["CUSTOM_VOICES_LIMIT_REACHED"] = 6621] = "CUSTOM_VOICES_LIMIT_REACHED";
  return VoiceErrorType2;
})(VoiceErrorType || {});
class ApiError extends SCError {
  /**
   * Creates an instance of ApiError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, ApiError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
    Object.setPrototypeOf(this, ApiError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        5301
        /* UNSUPPORTED_HTTP_METHOD */
      ]: {
        statusCode: HttpStatusCode.METHOD_NOT_ALLOWED,
        message: "The http method is not supported."
      }
    };
  }
}
var ApiErrorType = /* @__PURE__ */ ((ApiErrorType2) => {
  ApiErrorType2[ApiErrorType2["UNSUPPORTED_HTTP_METHOD"] = 5301] = "UNSUPPORTED_HTTP_METHOD";
  return ApiErrorType2;
})(ApiErrorType || {});
class AuthenticationError extends SCError {
  /**
   * Creates an instance of AuthenticationError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, AuthenticationError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthenticationError);
    }
    Object.setPrototypeOf(this, AuthenticationError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        6001
        /* INVALID_REFRESH_TOKEN */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "Refresh Token not found in cookie or bearer header is invalid."
      },
      [
        6002
        /* MISSING_EXTERNAL_USER_ID */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "The URL parameter 'externalUserId' is mandatory and is missing from the request."
      },
      [
        6003
        /* NO_MATCHING_CONFIGURATION */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "Wrong configuration: unable to find permissions configuration for this user."
      },
      [
        6004
        /* INVALID_OR_EXPIRED_TOKEN */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "Invalid or expired token."
      },
      [
        6005
        /* MISSING_APPLICATION_ID */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "The header 'x-app-id' is mandatory and is missing from the request."
      },
      [
        6006
        /* INVALID_OR_MISSING_JWT */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "Invalid or missing JWT in the request"
      },
      [
        6007
        /* MISSING_APPID_APIKEY */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "The header x-app-id and/or x-api-key is/are mandatory and is/are missing from the request."
      },
      [
        6008
        /* EXTERNAL_USER_AUTHENTICATION_FAILED */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "Unable to authenticate external user"
      },
      [
        6009
        /* MISSING_USERNAME */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "The 'username' field is mandatory and is missing from the request."
      },
      [
        6010
        /* MISSING_USER_ROLE */
      ]: {
        statusCode: HttpStatusCode.UNAUTHORIZED,
        message: "The 'userRole' field is mandatory and is missing from the request."
      }
    };
  }
}
var AuthenticationErrorType = /* @__PURE__ */ ((AuthenticationErrorType2) => {
  AuthenticationErrorType2[AuthenticationErrorType2["INVALID_REFRESH_TOKEN"] = 6001] = "INVALID_REFRESH_TOKEN";
  AuthenticationErrorType2[AuthenticationErrorType2["MISSING_EXTERNAL_USER_ID"] = 6002] = "MISSING_EXTERNAL_USER_ID";
  AuthenticationErrorType2[AuthenticationErrorType2["NO_MATCHING_CONFIGURATION"] = 6003] = "NO_MATCHING_CONFIGURATION";
  AuthenticationErrorType2[AuthenticationErrorType2["INVALID_OR_EXPIRED_TOKEN"] = 6004] = "INVALID_OR_EXPIRED_TOKEN";
  AuthenticationErrorType2[AuthenticationErrorType2["MISSING_APPLICATION_ID"] = 6005] = "MISSING_APPLICATION_ID";
  AuthenticationErrorType2[AuthenticationErrorType2["INVALID_OR_MISSING_JWT"] = 6006] = "INVALID_OR_MISSING_JWT";
  AuthenticationErrorType2[AuthenticationErrorType2["MISSING_APPID_APIKEY"] = 6007] = "MISSING_APPID_APIKEY";
  AuthenticationErrorType2[AuthenticationErrorType2["EXTERNAL_USER_AUTHENTICATION_FAILED"] = 6008] = "EXTERNAL_USER_AUTHENTICATION_FAILED";
  AuthenticationErrorType2[AuthenticationErrorType2["MISSING_USERNAME"] = 6009] = "MISSING_USERNAME";
  AuthenticationErrorType2[AuthenticationErrorType2["MISSING_USER_ROLE"] = 6010] = "MISSING_USER_ROLE";
  return AuthenticationErrorType2;
})(AuthenticationErrorType || {});
class AuthorizationError extends SCError {
  /**
   * Creates an instance of AuthorizationError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, AuthorizationError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AuthorizationError);
    }
    Object.setPrototypeOf(this, AuthorizationError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        6201
        /* UNAUTHORIZED */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "The user is not authorized."
      },
      [
        6204
        /* RESOURCE_ACCESS_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Resource access is not allowed."
      },
      [
        6203
        /* NOT_ALLOWED_TO_UPDATE_CONVERSATION */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Not allowed to update this conversation."
      },
      [
        6205
        /* RESOURCE_ACCESS_POLICY_UNDEFINED */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "There is no access policy defined for the resource."
      },
      [
        6206
        /* INVALID_ACCESS_POLICIES_OBJECT */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Access policies not loaded."
      },
      [
        6207
        /* RENEW_TOKEN_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Not allowed to renew this token."
      },
      [
        6208
        /* APPLICATION_ID_UNKNOWN */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Unknown application id."
      },
      [
        6209
        /* APIKEY_FOR_APPID_UNKNOWN */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Unknown api key used for given application id."
      },
      [
        6210
        /* NOT_ALLOWED_TO_VIEW_RESOURCE */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "Not allowed to view this resource."
      },
      [
        6211
        /* CAPABILITY_DISABLED */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: "This capability is disabled for the application."
      }
    };
  }
}
var AuthorizationErrorType = /* @__PURE__ */ ((AuthorizationErrorType2) => {
  AuthorizationErrorType2[AuthorizationErrorType2["UNAUTHORIZED"] = 6201] = "UNAUTHORIZED";
  AuthorizationErrorType2[AuthorizationErrorType2["NOT_ALLOWED_TO_UPDATE_CONVERSATION"] = 6203] = "NOT_ALLOWED_TO_UPDATE_CONVERSATION";
  AuthorizationErrorType2[AuthorizationErrorType2["RESOURCE_ACCESS_NOT_ALLOWED"] = 6204] = "RESOURCE_ACCESS_NOT_ALLOWED";
  AuthorizationErrorType2[AuthorizationErrorType2["RESOURCE_ACCESS_POLICY_UNDEFINED"] = 6205] = "RESOURCE_ACCESS_POLICY_UNDEFINED";
  AuthorizationErrorType2[AuthorizationErrorType2["INVALID_ACCESS_POLICIES_OBJECT"] = 6206] = "INVALID_ACCESS_POLICIES_OBJECT";
  AuthorizationErrorType2[AuthorizationErrorType2["RENEW_TOKEN_NOT_ALLOWED"] = 6207] = "RENEW_TOKEN_NOT_ALLOWED";
  AuthorizationErrorType2[AuthorizationErrorType2["APPLICATION_ID_UNKNOWN"] = 6208] = "APPLICATION_ID_UNKNOWN";
  AuthorizationErrorType2[AuthorizationErrorType2["APIKEY_FOR_APPID_UNKNOWN"] = 6209] = "APIKEY_FOR_APPID_UNKNOWN";
  AuthorizationErrorType2[AuthorizationErrorType2["NOT_ALLOWED_TO_VIEW_RESOURCE"] = 6210] = "NOT_ALLOWED_TO_VIEW_RESOURCE";
  AuthorizationErrorType2[AuthorizationErrorType2["CAPABILITY_DISABLED"] = 6211] = "CAPABILITY_DISABLED";
  return AuthorizationErrorType2;
})(AuthorizationErrorType || {});
class CacheError extends SCError {
  /**
   * Creates an instance of CacheError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, CacheError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CacheError);
    }
    Object.setPrototypeOf(this, CacheError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        6901
        /* IP_TO_COUNTRY_LOOKUP_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: "Error while looking up IP address"
      },
      [
        6902
        /* FETCH_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Error while fetching data.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      }
    };
  }
}
var CacheErrorType = /* @__PURE__ */ ((CacheErrorType2) => {
  CacheErrorType2[CacheErrorType2["IP_TO_COUNTRY_LOOKUP_FAILED"] = 6901] = "IP_TO_COUNTRY_LOOKUP_FAILED";
  CacheErrorType2[CacheErrorType2["FETCH_FAILED"] = 6902] = "FETCH_FAILED";
  return CacheErrorType2;
})(CacheErrorType || {});
class EmailError extends SCError {
  /**
   * Creates an instance of EmailError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, EmailError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, EmailError);
    }
    Object.setPrototypeOf(this, EmailError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        5001
        /* NO_EMAILS_TO_SEND */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "No emails to send."
      }
    };
  }
}
var EmailErrorType = /* @__PURE__ */ ((EmailErrorType2) => {
  EmailErrorType2[EmailErrorType2["NO_EMAILS_TO_SEND"] = 5001] = "NO_EMAILS_TO_SEND";
  return EmailErrorType2;
})(EmailErrorType || {});
class InputValidationError extends SCError {
  /**
   * Creates an instance of InputValidationError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, InputValidationError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, InputValidationError);
    }
    Object.setPrototypeOf(this, InputValidationError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        5500
        /* INVALID_REQUEST */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `The user input is invalid or missing any required field.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        5501
        /* INVALID_MODERATION_ACTION */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: `No handler found for the given action.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        5502
        /* INVALID_PAYLOAD */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Invalid Payload.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        5503
        /* UNKNOWN_PARAMETERS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Unknown parameters.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        5504
        /* INVALID_CONFIGURATION */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Invalid Configuration.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      }
    };
  }
}
var InputValidationErrorType = /* @__PURE__ */ ((InputValidationErrorType2) => {
  InputValidationErrorType2[InputValidationErrorType2["INVALID_REQUEST"] = 5500] = "INVALID_REQUEST";
  InputValidationErrorType2[InputValidationErrorType2["INVALID_MODERATION_ACTION"] = 5501] = "INVALID_MODERATION_ACTION";
  InputValidationErrorType2[InputValidationErrorType2["INVALID_PAYLOAD"] = 5502] = "INVALID_PAYLOAD";
  InputValidationErrorType2[InputValidationErrorType2["UNKNOWN_PARAMETERS"] = 5503] = "UNKNOWN_PARAMETERS";
  InputValidationErrorType2[InputValidationErrorType2["INVALID_CONFIGURATION"] = 5504] = "INVALID_CONFIGURATION";
  return InputValidationErrorType2;
})(InputValidationErrorType || {});
class LorebookError extends SCError {
  /**
   * Creates an instance of AuthenticationError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, LorebookError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, LorebookError);
    }
    Object.setPrototypeOf(this, LorebookError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        7901
        /* NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: `Lorebook not found.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7902
        /* ENTRY_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: `Lorebook entry not found.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7903
        /* EXPORT_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to export Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7904
        /* IMPORT_FAILED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Failed to import Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7905
        /* CREATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to create Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7906
        /* UPDATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to update Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7914
        /* UPDATE_CONFLICT */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `Lorebook changed while saving.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7907
        /* ATTACH_FAILED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Failed to attach Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7908
        /* DETACH_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to detach Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7909
        /* DUPLICATE_REPORT */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `You have already reported this Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7910
        /* CLONE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to clone Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7911
        /* PENDING_SNAPSHOT_TOO_MANY_OPS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Pending edit has too many entry operations.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7912
        /* PENDING_SNAPSHOT_TOO_LARGE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Pending edit payload is too large.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        7913
        /* DELETE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to delete Lorebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      }
    };
  }
}
var LorebookErrorType = /* @__PURE__ */ ((LorebookErrorType2) => {
  LorebookErrorType2[LorebookErrorType2["NOT_FOUND"] = 7901] = "NOT_FOUND";
  LorebookErrorType2[LorebookErrorType2["ENTRY_NOT_FOUND"] = 7902] = "ENTRY_NOT_FOUND";
  LorebookErrorType2[LorebookErrorType2["EXPORT_FAILED"] = 7903] = "EXPORT_FAILED";
  LorebookErrorType2[LorebookErrorType2["IMPORT_FAILED"] = 7904] = "IMPORT_FAILED";
  LorebookErrorType2[LorebookErrorType2["CREATE_FAILED"] = 7905] = "CREATE_FAILED";
  LorebookErrorType2[LorebookErrorType2["UPDATE_FAILED"] = 7906] = "UPDATE_FAILED";
  LorebookErrorType2[LorebookErrorType2["ATTACH_FAILED"] = 7907] = "ATTACH_FAILED";
  LorebookErrorType2[LorebookErrorType2["DETACH_FAILED"] = 7908] = "DETACH_FAILED";
  LorebookErrorType2[LorebookErrorType2["DUPLICATE_REPORT"] = 7909] = "DUPLICATE_REPORT";
  LorebookErrorType2[LorebookErrorType2["CLONE_FAILED"] = 7910] = "CLONE_FAILED";
  LorebookErrorType2[LorebookErrorType2["PENDING_SNAPSHOT_TOO_MANY_OPS"] = 7911] = "PENDING_SNAPSHOT_TOO_MANY_OPS";
  LorebookErrorType2[LorebookErrorType2["PENDING_SNAPSHOT_TOO_LARGE"] = 7912] = "PENDING_SNAPSHOT_TOO_LARGE";
  LorebookErrorType2[LorebookErrorType2["DELETE_FAILED"] = 7913] = "DELETE_FAILED";
  LorebookErrorType2[LorebookErrorType2["UPDATE_CONFLICT"] = 7914] = "UPDATE_CONFLICT";
  return LorebookErrorType2;
})(LorebookErrorType || {});
class MediaError extends SCError {
  /**
   * Creates an instance of MediaError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, MediaError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MediaError);
    }
    Object.setPrototypeOf(this, MediaError.prototype);
    this.build();
  }
  get errorCodeMap() {
    return {
      [
        8201
        /* NOT_IMPLEMENTED */
      ]: {
        statusCode: HttpStatusCode.NOT_IMPLEMENTED,
        message: `${"This media endpoint is not implemented yet."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8202
        /* INVALID_LOCATION */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Media file location must be a canonical S3 key or an ASSETS_URL."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8203
        /* INVALID_CREATE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Media file create payload is invalid."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8204
        /* INVALID_CREATOR */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Media file creator is invalid."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8205
        /* INVALID_DIMENSIONS */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Media file dimensions or size are invalid."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8206
        /* INVALID_CLEANUP_AT */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Media file cleanupAt must be Unix epoch seconds."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8207
        /* INVALID_GENERATION */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Media file generation payload is invalid."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8208
        /* FILE_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: `${"Media file not found."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      },
      [
        8209
        /* INVALID_ATTACH */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `${"Media file cannot be attached to this entity."}${this.additionalDetails ? ` ${this.additionalDetails}` : ""}`
      }
    };
  }
}
var MediaErrorType = /* @__PURE__ */ ((MediaErrorType2) => {
  MediaErrorType2[MediaErrorType2["NOT_IMPLEMENTED"] = 8201] = "NOT_IMPLEMENTED";
  MediaErrorType2[MediaErrorType2["INVALID_LOCATION"] = 8202] = "INVALID_LOCATION";
  MediaErrorType2[MediaErrorType2["INVALID_CREATE"] = 8203] = "INVALID_CREATE";
  MediaErrorType2[MediaErrorType2["INVALID_CREATOR"] = 8204] = "INVALID_CREATOR";
  MediaErrorType2[MediaErrorType2["INVALID_DIMENSIONS"] = 8205] = "INVALID_DIMENSIONS";
  MediaErrorType2[MediaErrorType2["INVALID_CLEANUP_AT"] = 8206] = "INVALID_CLEANUP_AT";
  MediaErrorType2[MediaErrorType2["INVALID_GENERATION"] = 8207] = "INVALID_GENERATION";
  MediaErrorType2[MediaErrorType2["FILE_NOT_FOUND"] = 8208] = "FILE_NOT_FOUND";
  MediaErrorType2[MediaErrorType2["INVALID_ATTACH"] = 8209] = "INVALID_ATTACH";
  return MediaErrorType2;
})(MediaErrorType || {});
var MediaErrorMessage = /* @__PURE__ */ ((MediaErrorMessage2) => {
  MediaErrorMessage2["NOT_IMPLEMENTED"] = "This media endpoint is not implemented yet.";
  MediaErrorMessage2["INVALID_LOCATION"] = "Media file location must be a canonical S3 key or an ASSETS_URL.";
  MediaErrorMessage2["INVALID_CREATE"] = "Media file create payload is invalid.";
  MediaErrorMessage2["INVALID_CREATOR"] = "Media file creator is invalid.";
  MediaErrorMessage2["INVALID_DIMENSIONS"] = "Media file dimensions or size are invalid.";
  MediaErrorMessage2["INVALID_CLEANUP_AT"] = "Media file cleanupAt must be Unix epoch seconds.";
  MediaErrorMessage2["INVALID_GENERATION"] = "Media file generation payload is invalid.";
  MediaErrorMessage2["FILE_NOT_FOUND"] = "Media file not found.";
  MediaErrorMessage2["INVALID_ATTACH"] = "Media file cannot be attached to this entity.";
  return MediaErrorMessage2;
})(MediaErrorMessage || {});
class RateLimitingError extends SCError {
  /**
   * Creates an instance of RateLimitingError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, RateLimitingError.name);
    // @ts-expect-error Remove when used
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RateLimitingError);
    }
    Object.setPrototypeOf(this, RateLimitingError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        5201
        /* RATE_LIMIT_BREACHED */
      ]: {
        statusCode: HttpStatusCode.TOO_MANY_REQUESTS,
        message: "Too many requests."
      },
      [
        5202
        /* TIME_UNIT_MUST_BE_DEFINED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: "At least one time unit (minute, hour, or day) must be defined when building a rate limit."
      }
    };
  }
}
var RateLimitingErrorType = /* @__PURE__ */ ((RateLimitingErrorType2) => {
  RateLimitingErrorType2[RateLimitingErrorType2["RATE_LIMIT_BREACHED"] = 5201] = "RATE_LIMIT_BREACHED";
  RateLimitingErrorType2[RateLimitingErrorType2["TIME_UNIT_MUST_BE_DEFINED"] = 5202] = "TIME_UNIT_MUST_BE_DEFINED";
  return RateLimitingErrorType2;
})(RateLimitingErrorType || {});
class RulebookError extends SCError {
  /**
   * Creates an instance of RulebookError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details appended to the message
   * @param data Optional structured payload carried on the error body (e.g. validation issues)
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails, data) {
    super(errorCode, RulebookError.name, data);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RulebookError);
    }
    Object.setPrototypeOf(this, RulebookError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        8301
        /* NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: `Rulebook not found.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8302
        /* CONFLICT */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `The rulebook was modified by a different writer.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8303
        /* INVALID_DEFINITION */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `The rulebook definition failed validation.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8304
        /* PUBLIC_NOT_AVAILABLE */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Public rulebooks are not available yet; only private rulebooks can be created or updated.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8305
        /* CREATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to create Rulebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8306
        /* UPDATE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to update Rulebook.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8307
        /* INVALID_CURSOR */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Invalid pagination cursor.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8308
        /* ATTACH_FAILED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `Rulebook attachment failed.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8309
        /* ALREADY_REPORTED */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `The rulebook already has an open report from this user for this version.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8310
        /* CLONE_NOT_ALLOWED */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: `This rulebook's definition is not visible to other creators and cannot be cloned.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8311
        /* MODERATION_ACTION_INVALID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `The moderation action is not valid for the rulebook's current state.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8312
        /* REASON_CODES_REQUIRED */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `reason_codes is required for this moderation action.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8313
        /* NO_PENDING_DATA */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `The rulebook has no staged content to approve.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8315
        /* NOT_PUBLIC_FOR_PUBLIC_CHARACTER */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `Only a published public rulebook can be attached to a public character.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8316
        /* PUBLISH_BLOCKED */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `The rulebook can't be published while texts or the cover are flagged or flagged texts are unreviewed.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8317
        /* REVIEW_MARKS_INVALID */
      ]: {
        statusCode: HttpStatusCode.BAD_REQUEST,
        message: `The review marks don't match the submission under review.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8314
        /* PERMANENTLY_PRIVATE */
      ]: {
        statusCode: HttpStatusCode.FORBIDDEN,
        message: `The rulebook was permanently sanctioned and cannot be made public.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8318
        /* IN_REVIEW */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `The rulebook is under review and cannot be edited until a moderator decides.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        8319
        /* FLAGGED_FIELDS_UNRESOLVED */
      ]: {
        statusCode: HttpStatusCode.CONFLICT,
        message: `Flagged fields must be changed before the rulebook can be resubmitted.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      }
    };
  }
}
var RulebookErrorType = /* @__PURE__ */ ((RulebookErrorType2) => {
  RulebookErrorType2[RulebookErrorType2["NOT_FOUND"] = 8301] = "NOT_FOUND";
  RulebookErrorType2[RulebookErrorType2["CONFLICT"] = 8302] = "CONFLICT";
  RulebookErrorType2[RulebookErrorType2["INVALID_DEFINITION"] = 8303] = "INVALID_DEFINITION";
  RulebookErrorType2[RulebookErrorType2["PUBLIC_NOT_AVAILABLE"] = 8304] = "PUBLIC_NOT_AVAILABLE";
  RulebookErrorType2[RulebookErrorType2["CREATE_FAILED"] = 8305] = "CREATE_FAILED";
  RulebookErrorType2[RulebookErrorType2["UPDATE_FAILED"] = 8306] = "UPDATE_FAILED";
  RulebookErrorType2[RulebookErrorType2["INVALID_CURSOR"] = 8307] = "INVALID_CURSOR";
  RulebookErrorType2[RulebookErrorType2["ATTACH_FAILED"] = 8308] = "ATTACH_FAILED";
  RulebookErrorType2[RulebookErrorType2["ALREADY_REPORTED"] = 8309] = "ALREADY_REPORTED";
  RulebookErrorType2[RulebookErrorType2["CLONE_NOT_ALLOWED"] = 8310] = "CLONE_NOT_ALLOWED";
  RulebookErrorType2[RulebookErrorType2["MODERATION_ACTION_INVALID"] = 8311] = "MODERATION_ACTION_INVALID";
  RulebookErrorType2[RulebookErrorType2["REASON_CODES_REQUIRED"] = 8312] = "REASON_CODES_REQUIRED";
  RulebookErrorType2[RulebookErrorType2["NO_PENDING_DATA"] = 8313] = "NO_PENDING_DATA";
  RulebookErrorType2[RulebookErrorType2["PERMANENTLY_PRIVATE"] = 8314] = "PERMANENTLY_PRIVATE";
  RulebookErrorType2[RulebookErrorType2["NOT_PUBLIC_FOR_PUBLIC_CHARACTER"] = 8315] = "NOT_PUBLIC_FOR_PUBLIC_CHARACTER";
  RulebookErrorType2[RulebookErrorType2["PUBLISH_BLOCKED"] = 8316] = "PUBLISH_BLOCKED";
  RulebookErrorType2[RulebookErrorType2["REVIEW_MARKS_INVALID"] = 8317] = "REVIEW_MARKS_INVALID";
  RulebookErrorType2[RulebookErrorType2["IN_REVIEW"] = 8318] = "IN_REVIEW";
  RulebookErrorType2[RulebookErrorType2["FLAGGED_FIELDS_UNRESOLVED"] = 8319] = "FLAGGED_FIELDS_UNRESOLVED";
  return RulebookErrorType2;
})(RulebookErrorType || {});
class StorageError extends SCError {
  /**
   * Creates an instance of StorageError.
   *
   * @param errorCode Error code used to identify the error
   * @param additionalDetails Additional details about the error
   */
  constructor(errorCode = SCError.UNKNOWN_ERROR_CODE, additionalDetails) {
    super(errorCode, StorageError.name);
    __publicField(this, "additionalDetails");
    this.additionalDetails = additionalDetails;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, StorageError);
    }
    Object.setPrototypeOf(this, StorageError.prototype);
    this.build();
  }
  /**
   * Get the error code map for this error.
   *
   * @returns The error code map with error codes and their details
   */
  get errorCodeMap() {
    return {
      [
        6701
        /* UPLOAD_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to upload file to S3.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        6702
        /* DOWNLOAD_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to download file from S3.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        6703
        /* DELETE_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to delete file from S3.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        6704
        /* GET_SIGNED_URL_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to generate signed URL.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        6705
        /* OBJECT_NOT_FOUND */
      ]: {
        statusCode: HttpStatusCode.NOT_FOUND,
        message: `Object not found in S3.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        6706
        /* INVALID_BUCKET */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Invalid or missing S3 bucket configuration.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      },
      [
        6707
        /* STREAM_CONVERSION_FAILED */
      ]: {
        statusCode: HttpStatusCode.INTERNAL_SERVER_ERROR,
        message: `Failed to convert S3 stream to buffer.${this.additionalDetails ? " " + this.additionalDetails : ""}`
      }
    };
  }
}
var StorageErrorType = /* @__PURE__ */ ((StorageErrorType2) => {
  StorageErrorType2[StorageErrorType2["UPLOAD_FAILED"] = 6701] = "UPLOAD_FAILED";
  StorageErrorType2[StorageErrorType2["DOWNLOAD_FAILED"] = 6702] = "DOWNLOAD_FAILED";
  StorageErrorType2[StorageErrorType2["DELETE_FAILED"] = 6703] = "DELETE_FAILED";
  StorageErrorType2[StorageErrorType2["GET_SIGNED_URL_FAILED"] = 6704] = "GET_SIGNED_URL_FAILED";
  StorageErrorType2[StorageErrorType2["OBJECT_NOT_FOUND"] = 6705] = "OBJECT_NOT_FOUND";
  StorageErrorType2[StorageErrorType2["INVALID_BUCKET"] = 6706] = "INVALID_BUCKET";
  StorageErrorType2[StorageErrorType2["STREAM_CONVERSION_FAILED"] = 6707] = "STREAM_CONVERSION_FAILED";
  return StorageErrorType2;
})(StorageErrorType || {});
const ErrorRegistry = [
  InputValidationError,
  AuthorizationError,
  CharacterError,
  ChatError,
  ConversationError,
  RateLimitingError,
  AuthenticationError,
  ImageError,
  MessageError,
  VoiceError,
  TextToSpeechError,
  UserPersonaError,
  UserSettingsError,
  QueueError,
  CrmError,
  UserError,
  AdminError,
  CmsError,
  SubscriptionError,
  ModerationError,
  ApiError,
  StorageError,
  CacheError,
  CharacterReportError,
  CharacterTranslationError,
  CloneConversationError,
  ConversationMemoryError,
  EmailError,
  CheckoutError,
  LorebookError,
  KindeError,
  MetaCharacterError,
  GenerationPresetError,
  PageError,
  MediaError,
  RulebookError
];
const LOREBOOK_VIEW_LIVE = "live";
var ApplicationIds = /* @__PURE__ */ ((ApplicationIds2) => {
  ApplicationIds2["SPICYCHAT"] = "spicychat";
  ApplicationIds2["PIXELCHAT"] = "pixelchat";
  ApplicationIds2["ADULTTIME"] = "adulttime_application";
  ApplicationIds2["GPTGIRLFRIEND"] = "gptgirlfriend";
  ApplicationIds2["EVIL_ANGEL"] = "evil_angel";
  ApplicationIds2["ASG_MAX"] = "asg_max";
  ApplicationIds2["SECRETMATE"] = "secretmate";
  return ApplicationIds2;
})(ApplicationIds || {});
var ApplicationPlatform = /* @__PURE__ */ ((ApplicationPlatform2) => {
  ApplicationPlatform2["SPICYCHAT_IOS"] = "spicychat_ios";
  ApplicationPlatform2["SPICYCHAT_ANDROID"] = "spicychat_android";
  ApplicationPlatform2["PIXELCHAT_IOS"] = "pixelchat_ios";
  ApplicationPlatform2["PIXELCHAT_ANDROID"] = "pixelchat_android";
  ApplicationPlatform2["SECRETMATE_IOS"] = "secretmate_ios";
  ApplicationPlatform2["SECRETMATE_ANDROID"] = "secretmate_android";
  ApplicationPlatform2["BROWSER"] = "browser";
  ApplicationPlatform2["UNRECOGNIZED"] = "unrecognized_user_agent";
  return ApplicationPlatform2;
})(ApplicationPlatform || {});
var CharacterVisibility = /* @__PURE__ */ ((CharacterVisibility2) => {
  CharacterVisibility2["Public"] = "public";
  CharacterVisibility2["Private"] = "private";
  CharacterVisibility2["Hidden"] = "hidden";
  CharacterVisibility2["PermanentlyPrivate"] = "permanently_private";
  return CharacterVisibility2;
})(CharacterVisibility || {});
var ClientHttpHeaders = /* @__PURE__ */ ((ClientHttpHeaders2) => {
  ClientHttpHeaders2["AUTHORIZATION"] = "authorization";
  ClientHttpHeaders2["GUEST_USER_ID"] = "x-guest-userid";
  ClientHttpHeaders2["COUNTRY"] = "x-country";
  ClientHttpHeaders2["IMPERSONATE"] = "x-impersonate";
  ClientHttpHeaders2["APP_ID"] = "x-app-id";
  ClientHttpHeaders2["USER_AGENT"] = "user-agent";
  ClientHttpHeaders2["MOBILE_APP_VERSION"] = "x-mobile-app-version";
  ClientHttpHeaders2["APP_VERSION"] = "x-app-version";
  ClientHttpHeaders2["PLATFORM"] = "x-platform";
  ClientHttpHeaders2["PLATFORM_OS"] = "x-platform-os";
  return ClientHttpHeaders2;
})(ClientHttpHeaders || {});
var ClientPlatform = /* @__PURE__ */ ((ClientPlatform2) => {
  ClientPlatform2["WEB"] = "WEB";
  ClientPlatform2["NATIVE"] = "NATIVE";
  return ClientPlatform2;
})(ClientPlatform || {});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["Male"] = "male";
  Gender2["Female"] = "female";
  return Gender2;
})(Gender || {});
var HttpMethodType = /* @__PURE__ */ ((HttpMethodType2) => {
  HttpMethodType2["OPTIONS"] = "OPTIONS";
  HttpMethodType2["GET"] = "GET";
  HttpMethodType2["PATCH"] = "PATCH";
  HttpMethodType2["POST"] = "POST";
  HttpMethodType2["PUT"] = "PUT";
  HttpMethodType2["DELETE"] = "DELETE";
  HttpMethodType2["ANY"] = "ANY";
  return HttpMethodType2;
})(HttpMethodType || {});
const LANGUAGES = {
  en: "English",
  fr: "French",
  es: "Spanish",
  de: "German",
  ar: "Arabic",
  hi: "Hindi",
  it: "Italian",
  pt: "Portuguese",
  ru: "Russian",
  tr: "Turkish",
  ja: "Japanese",
  zh: "Chinese",
  ko: "Korean",
  pl: "Polish"
};
const LANGUAGE_CODES = Object.keys(LANGUAGES);
const isLanguageCode = createAllowlistGuard(LANGUAGE_CODES);
var LoraStatus = /* @__PURE__ */ ((LoraStatus2) => {
  LoraStatus2["Ready"] = "ready";
  LoraStatus2["Pending"] = "pending";
  return LoraStatus2;
})(LoraStatus || {});
var ModerationStatus = /* @__PURE__ */ ((ModerationStatus2) => {
  ModerationStatus2["Open"] = "open";
  ModerationStatus2["FixRequired"] = "fix_required";
  ModerationStatus2["RereviewRequired"] = "rereview_required";
  ModerationStatus2["Closed"] = "closed";
  ModerationStatus2["Pending"] = "pending";
  ModerationStatus2["Reviewed"] = "reviewed";
  return ModerationStatus2;
})(ModerationStatus || {});
var ServerHttpHeaders = /* @__PURE__ */ ((ServerHttpHeaders2) => {
  ServerHttpHeaders2["API_VERSION"] = "x-api-version";
  ServerHttpHeaders2["ACCESS_CONTROL_ALLOW_HEADERS"] = "access-control-allow-headers";
  ServerHttpHeaders2["CONTENT_TYPE"] = "content-type";
  ServerHttpHeaders2["SET_COOKIE"] = "set-cookie";
  ServerHttpHeaders2["CACHE_CONTROL"] = "cache-control";
  ServerHttpHeaders2["VARY"] = "vary";
  ServerHttpHeaders2["LOCATION"] = "location";
  return ServerHttpHeaders2;
})(ServerHttpHeaders || {});
var NotificationSource = /* @__PURE__ */ ((NotificationSource2) => {
  NotificationSource2["EMAIL"] = "email";
  NotificationSource2["PUSH"] = "push";
  return NotificationSource2;
})(NotificationSource || {});
var CloneType = /* @__PURE__ */ ((CloneType2) => {
  CloneType2["FULL"] = "full";
  CloneType2["PARTIAL"] = "partial";
  return CloneType2;
})(CloneType || {});
var ConversationSortOrder = /* @__PURE__ */ ((ConversationSortOrder2) => {
  ConversationSortOrder2["LATEST"] = "latest";
  ConversationSortOrder2["OLDEST"] = "oldest";
  ConversationSortOrder2["MOST_MESSAGES"] = "most_messages";
  return ConversationSortOrder2;
})(ConversationSortOrder || {});
var MessageContextType = /* @__PURE__ */ ((MessageContextType2) => {
  MessageContextType2["SEARCH"] = "search";
  MessageContextType2["IMAGE"] = "image";
  return MessageContextType2;
})(MessageContextType || {});
const QueueStatus = {
  ACCESS: "access",
  WAITING: "waiting",
  EXPIRED: "expired",
  REFRESH: "refresh"
};
const STORED_QUEUE_STATUSES = [QueueStatus.ACCESS, QueueStatus.WAITING];
const isStoredQueueStatus = createAllowlistGuard(STORED_QUEUE_STATUSES);
var BillingFrequency = /* @__PURE__ */ ((BillingFrequency2) => {
  BillingFrequency2["MONTHLY"] = "monthly";
  BillingFrequency2["QUARTERLY"] = "quarterly";
  BillingFrequency2["ANNUAL"] = "annual";
  BillingFrequency2["INSTANT"] = "instant";
  return BillingFrequency2;
})(BillingFrequency || {});
var BillingType = /* @__PURE__ */ ((BillingType2) => {
  BillingType2["RECURRING"] = "recurring";
  BillingType2["ONE_TIME"] = "one_time";
  return BillingType2;
})(BillingType || {});
var CheckoutAttemptStatus = /* @__PURE__ */ ((CheckoutAttemptStatus2) => {
  CheckoutAttemptStatus2["PENDING"] = "pending";
  CheckoutAttemptStatus2["PAID"] = "paid";
  CheckoutAttemptStatus2["FAILED"] = "failed";
  CheckoutAttemptStatus2["PARTIALLY_REFUNDED"] = "partially_refunded";
  CheckoutAttemptStatus2["REFUNDED"] = "refunded";
  CheckoutAttemptStatus2["CHARGED_BACK"] = "charged_back";
  return CheckoutAttemptStatus2;
})(CheckoutAttemptStatus || {});
var CURRENCIES = /* @__PURE__ */ ((CURRENCIES2) => {
  CURRENCIES2["USD"] = "USD";
  CURRENCIES2["EUR"] = "EUR";
  CURRENCIES2["GBP"] = "GBP";
  CURRENCIES2["RUB"] = "RUB";
  CURRENCIES2["CNY"] = "CNY";
  return CURRENCIES2;
})(CURRENCIES || {});
var SubscriptionPlatform = /* @__PURE__ */ ((SubscriptionPlatform2) => {
  SubscriptionPlatform2["BOOSTY"] = "boosty";
  SubscriptionPlatform2["CHARGE_BEE"] = "chargebee";
  SubscriptionPlatform2["REVENUE_CAT"] = "revenuecat";
  SubscriptionPlatform2["STICKY"] = "sticky";
  SubscriptionPlatform2["SUBSCRIBE_STAR"] = "subscribestar";
  SubscriptionPlatform2["VOLT"] = "volt";
  SubscriptionPlatform2["DIRECTA24"] = "directa24";
  SubscriptionPlatform2["PAYPORT"] = "payport";
  SubscriptionPlatform2["ANTRPAY"] = "antrpay";
  SubscriptionPlatform2["LUXFIN"] = "luxfin";
  SubscriptionPlatform2["PAYOK"] = "payok";
  SubscriptionPlatform2["COINPAYMENTS"] = "coinpayments";
  SubscriptionPlatform2["INWIZO"] = "inwizo";
  SubscriptionPlatform2["UPGATE"] = "upgate";
  SubscriptionPlatform2["OVERPAY"] = "overpay";
  SubscriptionPlatform2["FPAY"] = "fpay";
  SubscriptionPlatform2["PAYSSION"] = "payssion";
  SubscriptionPlatform2["DUKPAY"] = "dukpay";
  SubscriptionPlatform2["STIXRAMP"] = "stixramp";
  return SubscriptionPlatform2;
})(SubscriptionPlatform || {});
var UserAccountStatus = /* @__PURE__ */ ((UserAccountStatus2) => {
  UserAccountStatus2["ACTIVE"] = "ACTIVE";
  UserAccountStatus2["DELETED"] = "DELETED";
  UserAccountStatus2["BANNED"] = "BANNED";
  return UserAccountStatus2;
})(UserAccountStatus || {});
var ActivityQueue = /* @__PURE__ */ ((ActivityQueue2) => {
  ActivityQueue2["NPCQ"] = "npcq";
  ActivityQueue2["AICQ"] = "aicq";
  ActivityQueue2["PECQ"] = "pecq";
  ActivityQueue2["RE_REVIEW"] = "re_review";
  ActivityQueue2["REPORT_QUEUE"] = "report_queue";
  return ActivityQueue2;
})(ActivityQueue || {});
var AvatarModelCapability = /* @__PURE__ */ ((AvatarModelCapability2) => {
  AvatarModelCapability2["NegativePrompt"] = "negative_prompt";
  AvatarModelCapability2["ReferenceImage"] = "reference_image";
  AvatarModelCapability2["PromptStyles"] = "prompt_styles";
  return AvatarModelCapability2;
})(AvatarModelCapability || {});
var AvatarPromptFormat = /* @__PURE__ */ ((AvatarPromptFormat2) => {
  AvatarPromptFormat2["Prose"] = "prose";
  AvatarPromptFormat2["Keywords"] = "keywords";
  return AvatarPromptFormat2;
})(AvatarPromptFormat || {});
const EMPTY_AVATAR_IMAGE_GENERATION_CONFIG = Object.freeze({
  models: Object.freeze([]),
  defaultModelId: "",
  promptStyles: Object.freeze([]),
  defaultPromptStyleId: "",
  editModelId: ""
});
var CharacterDefinitionSizeCategory = /* @__PURE__ */ ((CharacterDefinitionSizeCategory2) => {
  CharacterDefinitionSizeCategory2["MINIMAL"] = "minimal";
  CharacterDefinitionSizeCategory2["LOW"] = "low";
  CharacterDefinitionSizeCategory2["MID"] = "mid";
  CharacterDefinitionSizeCategory2["HIGH"] = "high";
  CharacterDefinitionSizeCategory2["VERY"] = "very";
  return CharacterDefinitionSizeCategory2;
})(CharacterDefinitionSizeCategory || {});
var CharacterFeature = /* @__PURE__ */ ((CharacterFeature2) => {
  CharacterFeature2["LOREBOOK"] = "lorebook";
  CharacterFeature2["RULEBOOK"] = "rulebook";
  CharacterFeature2["VOICE"] = "voice";
  CharacterFeature2["CUSTOM_VOICE"] = "custom_voice";
  return CharacterFeature2;
})(CharacterFeature || {});
var CharacterGroupSizeCategory = /* @__PURE__ */ ((CharacterGroupSizeCategory2) => {
  CharacterGroupSizeCategory2["REGULAR"] = "regular";
  CharacterGroupSizeCategory2["SMALL"] = "small";
  CharacterGroupSizeCategory2["MEDIUM"] = "medium";
  CharacterGroupSizeCategory2["LARGE"] = "large";
  return CharacterGroupSizeCategory2;
})(CharacterGroupSizeCategory || {});
var CharacterSortOrder = /* @__PURE__ */ ((CharacterSortOrder2) => {
  CharacterSortOrder2["Latest"] = "latest";
  CharacterSortOrder2["Oldest"] = "oldest";
  CharacterSortOrder2["TopRated"] = "top_rated";
  CharacterSortOrder2["Name"] = "name";
  return CharacterSortOrder2;
})(CharacterSortOrder || {});
var CharacterType = /* @__PURE__ */ ((CharacterType2) => {
  CharacterType2["STANDARD"] = "STANDARD";
  CharacterType2["META"] = "META";
  return CharacterType2;
})(CharacterType || {});
var ReportType = /* @__PURE__ */ ((ReportType2) => {
  ReportType2["User"] = "User";
  ReportType2["System"] = "System";
  ReportType2["Admin"] = "Admin";
  return ReportType2;
})(ReportType || {});
var UserActionsOnCharacter = /* @__PURE__ */ ((UserActionsOnCharacter2) => {
  UserActionsOnCharacter2["CREATE"] = "create";
  UserActionsOnCharacter2["UPDATE"] = "update";
  UserActionsOnCharacter2["DELETE"] = "delete";
  UserActionsOnCharacter2["PRIVATE"] = "private";
  UserActionsOnCharacter2["PERMANENTLY_PRIVATE"] = "permanently_private";
  UserActionsOnCharacter2["FIX_REQUIRED"] = "fix_required";
  UserActionsOnCharacter2["PUBLIC"] = "public";
  UserActionsOnCharacter2["SET_AVATAR_NSFW"] = "set_avatar_nsfw";
  UserActionsOnCharacter2["SET_AVATAR_SFW"] = "set_avatar_sfw";
  UserActionsOnCharacter2["CLOSE_REPORT"] = "close_report";
  UserActionsOnCharacter2["ADD_STEP_FAMILY_TAG"] = "add_step_family_tag";
  UserActionsOnCharacter2["MARK_REVIEWED"] = "mark_reviewed";
  UserActionsOnCharacter2["SET_CHARACTER_NSFW"] = "set_character_nsfw";
  UserActionsOnCharacter2["SET_CHARACTER_SFW"] = "set_character_sfw";
  UserActionsOnCharacter2["MARK_NEWLY_PUBLIC_REVIEWED"] = "mark_newly_public_reviewed";
  UserActionsOnCharacter2["UNPUBLISHED"] = "unpublished";
  UserActionsOnCharacter2["MARK_AICQ_APPROVED"] = "mark_aicq_approved";
  UserActionsOnCharacter2["MARK_PENDING_UPDATE_APPROVED"] = "mark_pending_update_approved";
  UserActionsOnCharacter2["PENDING_UPDATE_SUBMITTED"] = "pending_update_submitted";
  return UserActionsOnCharacter2;
})(UserActionsOnCharacter || {});
var UserExpectedResolution = /* @__PURE__ */ ((UserExpectedResolution2) => {
  UserExpectedResolution2["Private"] = "private";
  UserExpectedResolution2["PermanentlyPrivate"] = "permanently_private";
  UserExpectedResolution2["Modified"] = "modified";
  UserExpectedResolution2["Deleted"] = "deleted";
  UserExpectedResolution2["Public"] = "public";
  UserExpectedResolution2["None"] = "none";
  return UserExpectedResolution2;
})(UserExpectedResolution || {});
var UserIssueType = /* @__PURE__ */ ((UserIssueType2) => {
  UserIssueType2["Guidelines"] = "Guidelines";
  UserIssueType2["Categorization"] = "Categorization";
  UserIssueType2["IncorrectAuthorization"] = "Incorrect Authorization";
  UserIssueType2["Invalid"] = "Invalid";
  UserIssueType2["NewLorebook"] = "New Lorebook";
  UserIssueType2["New_Character"] = "New Character";
  return UserIssueType2;
})(UserIssueType || {});
var CartesiaModelId = /* @__PURE__ */ ((CartesiaModelId2) => {
  CartesiaModelId2["SONIC_PREVIEW"] = "sonic-preview";
  CartesiaModelId2["SONIC_3"] = "sonic-3";
  CartesiaModelId2["SONIC_3_6"] = "sonic-3.6-2026-08-27";
  return CartesiaModelId2;
})(CartesiaModelId || {});
var Emotion = /* @__PURE__ */ ((Emotion2) => {
  Emotion2["CURIOSITY"] = "curiosity";
  Emotion2["POSITIVITY_HIGH"] = "positivity:high";
  Emotion2["POSITVITY_LOW"] = "positivity:low";
  Emotion2["SADNESS_LOW"] = "sadness:low";
  Emotion2["SURPRISE"] = "surprise";
  Emotion2["SURPRISE_HIGH"] = "surprise:high";
  Emotion2["NEUTRAL"] = "neutral";
  return Emotion2;
})(Emotion || {});
var InWorldModelId = /* @__PURE__ */ ((InWorldModelId2) => {
  InWorldModelId2["TTS_1"] = "inworld-tts-1";
  InWorldModelId2["TTS_1_5_MAX"] = "inworld-tts-1.5-max";
  return InWorldModelId2;
})(InWorldModelId || {});
const INWORLD_VOICE_CLONE_LANGUAGE_CODES = ["en", "zh", "ko", "ja", "ru", "it", "es", "pt", "de", "fr", "ar", "pl", "nl", "hi", "he"];
var ModelId = /* @__PURE__ */ ((ModelId2) => {
  ModelId2["SONIC_PREVIEW"] = "sonic-preview";
  ModelId2["SONIC_3"] = "sonic-3";
  return ModelId2;
})(ModelId || {});
var SampleAudioFileStatus = /* @__PURE__ */ ((SampleAudioFileStatus2) => {
  SampleAudioFileStatus2["PENDING"] = "pending";
  SampleAudioFileStatus2["UPLOADED"] = "uploaded";
  SampleAudioFileStatus2["VALIDATED"] = "validated";
  SampleAudioFileStatus2["INVALID"] = "invalid";
  return SampleAudioFileStatus2;
})(SampleAudioFileStatus || {});
var SampleFileFailureReason = /* @__PURE__ */ ((SampleFileFailureReason2) => {
  SampleFileFailureReason2["EMPTY_FILE"] = "empty_file";
  SampleFileFailureReason2["FILE_TOO_LARGE"] = "file_too_large";
  SampleFileFailureReason2["INVALID_CONTENT_TYPE"] = "invalid_content_type";
  SampleFileFailureReason2["INVALID_FORMAT"] = "invalid_format";
  SampleFileFailureReason2["INVALID_AUDIO_QUALITY"] = "invalid_audio_quality";
  SampleFileFailureReason2["INSUFFICIENT_AUDIO"] = "insufficient_audio";
  SampleFileFailureReason2["UNKNOWN"] = "unknown";
  return SampleFileFailureReason2;
})(SampleFileFailureReason || {});
var Speed = /* @__PURE__ */ ((Speed2) => {
  Speed2["SLOWEST"] = "slowest";
  Speed2["SLOW"] = "slow";
  Speed2["NORMAL"] = "normal";
  Speed2["FAST"] = "fast";
  Speed2["FASTEST"] = "fastest";
  return Speed2;
})(Speed || {});
var TextToSpeechProviderName = /* @__PURE__ */ ((TextToSpeechProviderName2) => {
  TextToSpeechProviderName2["INWORLD"] = "inworld";
  TextToSpeechProviderName2["CARTESIA"] = "cartesia";
  return TextToSpeechProviderName2;
})(TextToSpeechProviderName || {});
var VoiceFailureReason = /* @__PURE__ */ ((VoiceFailureReason2) => {
  VoiceFailureReason2["THIRD_PARTY_UNAVAILABLE"] = "third_party_unavailable";
  VoiceFailureReason2["INVALID_AUDIO_QUALITY"] = "invalid_audio_quality";
  VoiceFailureReason2["INSUFFICIENT_AUDIO"] = "insufficient_audio";
  VoiceFailureReason2["PROCESSING_TIMEOUT"] = "processing_timeout";
  VoiceFailureReason2["INVALID_SAMPLE_FILES"] = "invalid_sample_files";
  VoiceFailureReason2["UNKNOWN_ERROR"] = "unknown_error";
  return VoiceFailureReason2;
})(VoiceFailureReason || {});
var VoiceStatus = /* @__PURE__ */ ((VoiceStatus2) => {
  VoiceStatus2["PENDING_UPLOAD"] = "pending_upload";
  VoiceStatus2["READY_FOR_PROCESSING"] = "ready_for_processing";
  VoiceStatus2["PROCESSING"] = "processing";
  VoiceStatus2["READY_FOR_PREVIEW"] = "ready_for_preview";
  VoiceStatus2["READY_TO_USE"] = "ready_to_use";
  VoiceStatus2["FAILED"] = "failed";
  return VoiceStatus2;
})(VoiceStatus || {});
var VoiceType = /* @__PURE__ */ ((VoiceType2) => {
  VoiceType2["SYSTEM"] = "system";
  VoiceType2["CUSTOM"] = "custom";
  return VoiceType2;
})(VoiceType || {});
var AgeVerificationMethodProviderName = /* @__PURE__ */ ((AgeVerificationMethodProviderName2) => {
  AgeVerificationMethodProviderName2["VERIFY_MY_AGE"] = "VerifyMyAge";
  return AgeVerificationMethodProviderName2;
})(AgeVerificationMethodProviderName || {});
var AgeVerificationMethodType = /* @__PURE__ */ ((AgeVerificationMethodType2) => {
  AgeVerificationMethodType2["FACIAL_AGE_ESTIMATION"] = "FacialAgeEstimation";
  AgeVerificationMethodType2["EMAIL"] = "Email";
  AgeVerificationMethodType2["ID_SCAN"] = "IDScan";
  AgeVerificationMethodType2["ID_SCAN_FACE_MATCH"] = "IDScanFaceMatch";
  AgeVerificationMethodType2["MOBILE"] = "Mobile";
  AgeVerificationMethodType2["CREDIT_CARD"] = "CreditCard";
  AgeVerificationMethodType2["DOUBLE_BLIND"] = "DoubleBlind";
  return AgeVerificationMethodType2;
})(AgeVerificationMethodType || {});
var AgeVerificationMethodPriority = /* @__PURE__ */ ((AgeVerificationMethodPriority2) => {
  AgeVerificationMethodPriority2["PRIMARY"] = "primary";
  AgeVerificationMethodPriority2["FALLBACK"] = "fallback";
  AgeVerificationMethodPriority2["BOTH"] = "both";
  return AgeVerificationMethodPriority2;
})(AgeVerificationMethodPriority || {});
var AgeVerificationStatus = /* @__PURE__ */ ((AgeVerificationStatus2) => {
  AgeVerificationStatus2["DISABLED"] = "disabled";
  AgeVerificationStatus2["INFORM"] = "inform";
  AgeVerificationStatus2["VERIFY"] = "verify";
  AgeVerificationStatus2["VERIFIED"] = "verified";
  AgeVerificationStatus2["REVERIFY"] = "reverify";
  return AgeVerificationStatus2;
})(AgeVerificationStatus || {});
var AgeVerificationTemplateFlow = /* @__PURE__ */ ((AgeVerificationTemplateFlow2) => {
  AgeVerificationTemplateFlow2["DEFAULT"] = "default";
  AgeVerificationTemplateFlow2["TWO_OPTIONS"] = "two_options";
  return AgeVerificationTemplateFlow2;
})(AgeVerificationTemplateFlow || {});
const CapiProviderName = {
  Meta: "meta",
  TikTok: "tiktok",
  Snap: "snap",
  Reddit: "reddit",
  GoogleAds: "googleAds",
  Exoclick: "exoclick",
  TrafficStars: "trafficStars",
  Clickadu: "clickadu",
  Juicyads: "juicyads",
  OnboardingFunnel: "onboardingFunnel",
  Campaignswell: "campaignswell"
};
const CAPI_PROVIDER_NAMES = Object.values(CapiProviderName);
const isCapiProviderName = createAllowlistGuard(CAPI_PROVIDER_NAMES);
const ConsentScope = {
  Marketing: "marketing",
  Analytics: "analytics"
};
const CONSENT_SCOPES = Object.values(ConsentScope);
const isConsentScope = createAllowlistGuard(CONSENT_SCOPES);
const DedupSource = {
  UserId: "userId",
  TransactionId: "transactionId",
  SessionId: "sessionId"
};
const DEDUP_SOURCES = Object.values(DedupSource);
const isDedupSource = createAllowlistGuard(DEDUP_SOURCES);
const EventCategory = {
  Acquisition: "acquisition",
  Intent: "intent",
  Conversion: "conversion",
  PostConversion: "post_conversion"
};
const EVENT_CATEGORIES = Object.values(EventCategory);
const isEventCategory = createAllowlistGuard(EVENT_CATEGORIES);
const TrackingEventKey = {
  // — Acquisition —
  Signup: "signup",
  // — Intent (browser-pixel only; no CAPI producer) —
  PaywallViewed: "paywall_viewed",
  CheckoutStarted: "checkout_started",
  // — Conversion —
  TrialStart: "trial_start",
  Subscribe: "subscribe",
  Purchase: "purchase",
  // — Post-conversion —
  SubscriptionRenewal: "subscription_renewal",
  Refund: "refund"
};
const TRACKING_EVENT_KEYS = Object.values(TrackingEventKey);
const isTrackingEventKey = createAllowlistGuard(TRACKING_EVENT_KEYS);
function resolveProviderPixelIds(config) {
  return (config == null ? void 0 : config.ids) ?? [];
}
const eventCatalog = {
  [TrackingEventKey.Signup]: {
    key: TrackingEventKey.Signup,
    category: EventCategory.Acquisition,
    requiresValue: false,
    dedupSource: DedupSource.UserId,
    defaultConsent: ConsentScope.Marketing
  },
  [TrackingEventKey.PaywallViewed]: {
    key: TrackingEventKey.PaywallViewed,
    category: EventCategory.Intent,
    requiresValue: false,
    dedupSource: DedupSource.SessionId,
    defaultConsent: ConsentScope.Marketing
  },
  [TrackingEventKey.CheckoutStarted]: {
    key: TrackingEventKey.CheckoutStarted,
    category: EventCategory.Intent,
    requiresValue: true,
    dedupSource: DedupSource.SessionId,
    defaultConsent: ConsentScope.Marketing
  },
  [TrackingEventKey.TrialStart]: {
    key: TrackingEventKey.TrialStart,
    category: EventCategory.Conversion,
    requiresValue: false,
    dedupSource: DedupSource.UserId,
    defaultConsent: ConsentScope.Marketing
  },
  [TrackingEventKey.Subscribe]: {
    key: TrackingEventKey.Subscribe,
    category: EventCategory.Conversion,
    requiresValue: true,
    dedupSource: DedupSource.TransactionId,
    defaultConsent: ConsentScope.Marketing
  },
  [TrackingEventKey.SubscriptionRenewal]: {
    key: TrackingEventKey.SubscriptionRenewal,
    category: EventCategory.PostConversion,
    requiresValue: true,
    dedupSource: DedupSource.TransactionId,
    defaultConsent: ConsentScope.Marketing
  },
  [TrackingEventKey.Purchase]: {
    key: TrackingEventKey.Purchase,
    category: EventCategory.Conversion,
    requiresValue: true,
    dedupSource: DedupSource.TransactionId,
    defaultConsent: ConsentScope.Marketing
  },
  [TrackingEventKey.Refund]: {
    key: TrackingEventKey.Refund,
    category: EventCategory.PostConversion,
    requiresValue: true,
    dedupSource: DedupSource.TransactionId,
    defaultConsent: ConsentScope.Marketing
  }
};
export {
  ADMIN_EDITS_MAX_KEPT,
  AI_RULE_COOLDOWN_ONCE,
  ATTRIBUTION_HANDOFF_PARAM,
  ATTRIBUTION_STORAGE_KEY,
  ActivityQueue,
  AdminError,
  AdminErrorType,
  AgeVerificationMethodPriority,
  AgeVerificationMethodProviderName,
  AgeVerificationMethodType,
  AgeVerificationStatus,
  AgeVerificationTemplateFlow,
  ApiError,
  ApiErrorType,
  ApplicationComponentSlot,
  ApplicationDefinitionEncodingVersion,
  ApplicationFeatureFlagKey,
  ApplicationIds,
  ApplicationPlatform,
  AuthenticationError,
  AuthenticationErrorType,
  AuthorizationError,
  AuthorizationErrorType,
  AvatarModelCapability,
  AvatarPromptFormat,
  BillingFrequency,
  BillingType,
  CAPI_PROVIDER_NAMES,
  CLICK_ID_DEFINITIONS,
  CLICK_ID_PARAM_TO_TYPE,
  CLICK_ID_TYPES,
  CLOCK_SKIP_BUCKETS,
  CONSENT_SCOPES,
  CURRENCIES,
  CURRENT_ATTRIBUTION_VERSION,
  CURRENT_HANDOFF_VERSION,
  CacheError,
  CacheErrorType,
  CapabilityKey,
  CapabilityKeyIssueKind,
  CapabilityKeyReference,
  CapabilityKeySource,
  CapabilityResolution,
  CapabilityRuleStatus,
  CapabilityTargetPlatform,
  CapabilityUnavailableBehavior,
  CapiProviderName,
  CartesiaModelId,
  CharacterDefinitionSizeCategory,
  CharacterError,
  CharacterErrorType,
  CharacterFeature,
  CharacterGroupSizeCategory,
  CharacterReportError,
  CharacterReportErrorType,
  CharacterSortOrder,
  CharacterTranslationError,
  CharacterTranslationErrorType,
  CharacterType,
  CharacterVisibility,
  ChatError,
  ChatErrorType,
  CheckoutAttemptStatus,
  CheckoutError,
  CheckoutErrorType,
  ClientHttpHeaders,
  ClientPlatform,
  CloneConversationError,
  CloneConversationErrorType,
  CloneType,
  CmsError,
  CmsErrorType,
  ConsentScope,
  ConversationError,
  ConversationErrorType,
  ConversationMemoryError,
  ConversationMemoryErrorType,
  ConversationSortOrder,
  CrmError,
  CrmErrorType,
  DEDUP_SOURCES,
  DEFAULT_APPLICATION_CONFIG,
  DEFAULT_CAPABILITIES,
  DEFAULT_MODERATION_RISK_MODEL,
  DETECT_QUESTION_ID,
  DETECT_RECEIPT,
  DICE_FIRST_FACE,
  DISCOVERY_FILTER_KEYS,
  DISCOVERY_PAGE_KEY,
  DedupSource,
  DiscoveryFilterKey,
  EMPTY_AVATAR_IMAGE_GENERATION_CONFIG,
  EVENT_CATEGORIES,
  EmailError,
  EmailErrorType,
  Emotion,
  ErrorRegistry,
  EventCategory,
  Gender,
  GenerationPresetError,
  GenerationPresetErrorType,
  HttpMethodType,
  HttpStatusCode,
  IMAGE_MODERATION_SCORES,
  INWORLD_VOICE_CLONE_LANGUAGE_CODES,
  ImageError,
  ImageErrorType,
  InWorldModelId,
  InputValidationError,
  InputValidationErrorType,
  KindeError,
  KindeErrorType,
  LANGUAGE_CODES,
  LOREBOOK_VIEW_LIVE,
  LoraStatus,
  LorebookEntryFixStatus,
  LorebookEntryModerationActions,
  LorebookEntryOpType,
  LorebookEntryStatus,
  LorebookError,
  LorebookErrorType,
  LorebookModerationActions,
  LorebookStatus,
  LorebookVisibility,
  MAX_AI_RULE_COOLDOWN,
  MAX_CLOCK_SKIP_DAYS,
  MAX_CLOCK_SKIP_MINUTES,
  MAX_DECAY_EVERY,
  MAX_ENVELOPE_SIZE_BYTES,
  METER_COLOR_KEYS,
  METER_COLOR_PALETTE,
  MODERATION_CONFIG_CODE_VERSION,
  MODERATION_RISK_SIGNALS,
  MediaError,
  MediaErrorMessage,
  MediaErrorType,
  MediaFileConnectionType,
  MediaFileSource,
  MediaFileStatus,
  MediaFileUsedAs,
  MediaFileVisibility,
  MediaSortOrder,
  MessageContextType,
  MessageError,
  MessageErrorType,
  MetaCharacterError,
  MetaCharacterErrorType,
  MeterAiMode,
  MeterType,
  ModelId,
  ModerationError,
  ModerationErrorType,
  ModerationStatus,
  NETWORKS,
  NON_ROUTABLE_NETWORKS,
  NotificationSource,
  PAGE_BLOCK_AUDIENCES,
  PAGE_BLOCK_CONTENT_KINDS,
  PAGE_BLOCK_FILTER_MATCHES,
  PAGE_BLOCK_FILTER_MODES,
  PAGE_BLOCK_SORT_PRESETS,
  PAGE_BLOCK_TYPES,
  PLATFORM_DETAILS_PARAM_MAP,
  PageBlockAudience,
  PageBlockContentKind,
  PageBlockFilterMatch,
  PageBlockFilterMode,
  PageBlockSortPreset,
  PageBlockType,
  PageError,
  PageErrorType,
  PlaytestAiNoteKind,
  QueueError,
  QueueErrorType,
  QueueStatus,
  RULEBOOK_CREATOR_SANCTION_ACTIONS,
  RULEBOOK_EXPORT_SCHEMA_V1_DRAFT,
  RULEBOOK_ID_PATTERN,
  RULEBOOK_LIMITS,
  RULEBOOK_MIN_TAGS,
  RULEBOOK_OWNER_TYPES,
  RULEBOOK_PLAYTEST_MAX_HISTORY,
  RULEBOOK_PLAYTEST_MAX_MESSAGE_CHARS,
  RULEBOOK_RESERVED_IDS,
  RateLimitingError,
  RateLimitingErrorType,
  ReportType,
  RulebookError,
  RulebookErrorType,
  RulebookExportError,
  RulebookModerationAction,
  RulebookStatus,
  RulebookVisibility,
  SCError,
  STORED_QUEUE_STATUSES,
  SUB_CAPABILITY_DEFAULTS,
  SUB_CAPABILITY_KEYS_BY_PARENT,
  SUB_CAPABILITY_PARENT_MAP,
  SampleAudioFileStatus,
  SampleFileFailureReason,
  ServerHttpHeaders,
  Speed,
  StorageError,
  StorageErrorType,
  SubCapabilityKey,
  SubscriptionError,
  SubscriptionErrorType,
  SubscriptionPlatform,
  TOD_LAST_BOUND,
  TOD_OFFSET_MINUTES,
  TRACKING_EVENT_KEYS,
  TextToSpeechError,
  TextToSpeechErrorType,
  TextToSpeechProviderName,
  TrackingEventKey,
  UNDER_AGE_CATEGORY,
  UTM_PARAM_NAMES,
  UserAccountStatus,
  UserActionsOnCharacter,
  UserError,
  UserErrorType,
  UserExpectedResolution,
  UserIssueType,
  UserPersonaError,
  UserPersonaErrorType,
  UserRole,
  UserSettingsError,
  UserSettingsErrorType,
  VoiceError,
  VoiceErrorType,
  VoiceFailureReason,
  VoiceStatus,
  VoiceType,
  appendAdminEdits,
  applyAiExtractedValues,
  applyClockSkip,
  applyConsent,
  applyReplyKeywords,
  applyReviewMarksPatch,
  applyRulebookTextEdits,
  buildAttachedTo,
  buildHandoffUrl,
  buildTouchPointFromInputs,
  canonicalJsonStringify,
  captureIntoContext,
  checkRulebookShape,
  clockDimensions,
  clockStartMs,
  clockWeekday,
  collectDefaultCapabilityKeyIssues,
  collectOverrideCapabilityKeyIssues,
  compactApplicationDefinition,
  compactApplicationDefinitionFull,
  compactDeep,
  compileAiQuestions,
  compileKeywordMatcher,
  computeRisk,
  consumeHandoffIntoContext,
  countHiddenMeters,
  countRulebookRules,
  counterValueLine,
  createAllowlistGuard,
  cureRulebookState,
  currentAdminEdit,
  currentCoverReviewMark,
  currentReviewMark,
  dayLevelIndex,
  decodeApplicationDefinition,
  decodeBase64Url,
  decodeUtf8,
  decodeUtf8Strict,
  deriveRulebookSummaryFields,
  describePublishBlockers,
  encodeApplicationDefinition,
  encodeBase64Url,
  encodeUtf8,
  estimateRenderedChars,
  evaluateCapabilities,
  evaluateCapability,
  evaluateCapabilityFlags,
  evaluateRulebookTurn,
  evaluateSubCapability,
  eventCatalog,
  extractClickIdsFromUrl,
  extractPixelIdsFromCookies,
  extractPlatformDetailsFromUrl,
  extractUtmFromUrl,
  findPublishBlockers,
  findUnknownTokens,
  fixReasonsFromReviewMarks,
  flattenRulebookTexts,
  formatClockSkipLabel,
  formatMeterDelta,
  formatMeterValue,
  formatModerationTextLabel,
  hasUserTrackedAiMeter,
  hashModerationText,
  idSegment,
  imageScoresOverThreshold,
  indexModerationTexts,
  inferNetwork,
  inferPrimaryClickRef,
  instructionLines,
  isAttributionContext,
  isCapiProviderName,
  isClickIdType,
  isConsentScope,
  isDedupSource,
  isDeepEqual,
  isDiscoveryFilterKey,
  isEncodedApplicationDefinition,
  isEventCategory,
  isLanguageCode,
  isLevelReached,
  isMeterColorKey,
  isModerationRiskModel,
  isNetwork,
  isNewerRecognizedHit,
  isPageBlockAudience,
  isPageBlockContentKind,
  isPageBlockFilterMatch,
  isPageBlockFilterMode,
  isPageBlockSortPreset,
  isPageBlockType,
  isPlainObject,
  isPlatformDetails,
  isRecognizedAcquisitionHit,
  isReviewMarkStale,
  isRulebookExportEnvelope,
  isStoredQueueStatus,
  isTouchPoint,
  isTrackingEventKey,
  isValidApplicationDefinitionOverride,
  levelFrom,
  levelIndex,
  levelStep,
  matchKeyword,
  matchMeterKeywords,
  mergeAttribution,
  mergeAttributionContexts,
  mergePartners,
  meterColorKeyFromLegacyHex,
  meterNeverMoves,
  meterReads,
  moderationRiskLevel,
  nextLevelFrom,
  normalizeApplicationDefinition,
  normalizeLegacyRulebookTokens,
  normalizeRulebookExport,
  originalTextBeforeAdminEdits,
  parseCookieHeader,
  parseHandoffParam,
  readClock,
  readOutAiAnswers,
  readsBotReply,
  readsUserMessage,
  renderCondition,
  renderMeterTokens,
  resolveActiveRules,
  resolveCaption,
  resolveCaptionSource,
  resolveClockExtraction,
  resolveClockSkip,
  resolveProviderPixelIds,
  resolveRulebookPlaytestTurn,
  revertReplyKeywords,
  reviewMarkContent,
  rollDieUniformly,
  roundMeterValue,
  rulebookTextRemoval,
  sanitizeApplicationDefinitionOverride,
  selectAiExtractionTargets,
  serializeHandoffParam,
  stepClock,
  testCondition,
  toCapabilityFlags,
  toHighlightSegments,
  toMeterChips,
  toPublicRulebookState,
  toRulebookHudSnapshot,
  toRulebookPublicView,
  todLevelIndex,
  tryDecodeApplicationDefinition,
  validateApplicationDefinitionOverride,
  validateNegativeKeywordConfig,
  validateRulebook,
  verifyHandoffPayload
};
//# sourceMappingURL=index.es.js.map
